/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `Byte` scalar type represents non-fractional whole numeric values. Byte can represent values between 0 and 255. */
  Byte: { input: any; output: any; }
  /** The `Date` scalar represents an ISO-8601 compliant date type. */
  Date: { input: any; output: any; }
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: { input: any; output: any; }
  /** The `Decimal` scalar type represents a decimal floating-point number. */
  Decimal: { input: any; output: any; }
  /** The `LocalDate` scalar type represents a ISO date string, represented as UTF-8 character sequences YYYY-MM-DD. The scalar follows the specification defined in RFC3339 */
  LocalDate: { input: any; output: any; }
  /** The `Long` scalar type represents non-fractional signed whole 64-bit numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: { input: any; output: any; }
  /** The `TimeSpan` scalar represents an ISO-8601 compliant duration type. */
  TimeSpan: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

export type AbonnementConsultant = {
  __typename?: 'AbonnementConsultant';
  acceptationCGV?: Maybe<Scalars['Boolean']['output']>;
  consultant: Consultant;
  consultantId: Scalars['Long']['output'];
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  dernierPaiement?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  expirationAcces?: Maybe<Scalars['DateTime']['output']>;
  finAbonnement?: Maybe<Scalars['DateTime']['output']>;
  finPeriodeGratuite?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  referenceProduit: Scalars['String']['output'];
};

export type AbonnementConsultantFilterInput = {
  acceptationCGV?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<AbonnementConsultantFilterInput>>;
  consultant?: InputMaybe<ConsultantFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dernierPaiement?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  expirationAcces?: InputMaybe<DateTimeOperationFilterInput>;
  finAbonnement?: InputMaybe<DateTimeOperationFilterInput>;
  finPeriodeGratuite?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<AbonnementConsultantFilterInput>>;
  referenceProduit?: InputMaybe<StringOperationFilterInput>;
};

export type ActionDeFormation = {
  __typename?: 'ActionDeFormation';
  actionDeFormationSession: Array<ActionDeFormationSession>;
  codeFamille?: Maybe<Scalars['Byte']['output']>;
  codeFamilleNavigation?: Maybe<FormationType>;
  codeSaison?: Maybe<Scalars['Byte']['output']>;
  codeSaisonNavigation?: Maybe<FormationSaison>;
  creationDate: Scalars['DateTime']['output'];
  cursusFormation: Array<CursusFormation>;
  dateDebutValidite?: Maybe<Scalars['DateTime']['output']>;
  dateFinValidite?: Maybe<Scalars['DateTime']['output']>;
  dureeHeure?: Maybe<Scalars['Decimal']['output']>;
  dureeJour?: Maybe<Scalars['Decimal']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['Long']['output']>;
  nom: Scalars['String']['output'];
  obligatoire?: Maybe<Scalars['Byte']['output']>;
  origineData?: Maybe<Scalars['Byte']['output']>;
  origineDataNavigation?: Maybe<OrigineData>;
  reference: Scalars['String']['output'];
};


export type ActionDeFormationActionDeFormationSessionArgs = {
  where?: InputMaybe<ActionDeFormationSessionFilterInput>;
};


export type ActionDeFormationCursusFormationArgs = {
  where?: InputMaybe<CursusFormationFilterInput>;
};

export type ActionDeFormationFilterInput = {
  actionDeFormationSession?: InputMaybe<ListFilterInputTypeOfActionDeFormationSessionFilterInput>;
  and?: InputMaybe<Array<ActionDeFormationFilterInput>>;
  codeFamille?: InputMaybe<ByteOperationFilterInput>;
  codeFamilleNavigation?: InputMaybe<FormationTypeFilterInput>;
  codeSaison?: InputMaybe<ByteOperationFilterInput>;
  codeSaisonNavigation?: InputMaybe<FormationSaisonFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  cursusFormation?: InputMaybe<ListFilterInputTypeOfCursusFormationFilterInput>;
  dateDebutValidite?: InputMaybe<DateTimeOperationFilterInput>;
  dateFinValidite?: InputMaybe<DateTimeOperationFilterInput>;
  dureeHeure?: InputMaybe<DecimalOperationFilterInput>;
  dureeJour?: InputMaybe<DecimalOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<LongOperationFilterInput>;
  nom?: InputMaybe<StringOperationFilterInput>;
  obligatoire?: InputMaybe<ByteOperationFilterInput>;
  or?: InputMaybe<Array<ActionDeFormationFilterInput>>;
  origineData?: InputMaybe<ByteOperationFilterInput>;
  origineDataNavigation?: InputMaybe<OrigineDataFilterInput>;
  reference?: InputMaybe<StringOperationFilterInput>;
};

export type ActionDeFormationSession = {
  __typename?: 'ActionDeFormationSession';
  actionDeFormation: ActionDeFormation;
  actionDeFormationId: Scalars['Long']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  session: Session;
  sessionId: Scalars['Long']['output'];
};

export type ActionDeFormationSessionFilterInput = {
  actionDeFormation?: InputMaybe<ActionDeFormationFilterInput>;
  actionDeFormationId?: InputMaybe<LongOperationFilterInput>;
  and?: InputMaybe<Array<ActionDeFormationSessionFilterInput>>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<ActionDeFormationSessionFilterInput>>;
  session?: InputMaybe<SessionFilterInput>;
  sessionId?: InputMaybe<LongOperationFilterInput>;
};

export type ActiviteRattachPartenaire = {
  __typename?: 'ActiviteRattachPartenaire';
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate: Scalars['DateTime']['output'];
  libelle: Scalars['String']['output'];
  partenaire: Array<Partenaire>;
};


export type ActiviteRattachPartenairePartenaireArgs = {
  where?: InputMaybe<PartenaireFilterInput>;
};

export type ActiviteRattachPartenaireFilterInput = {
  and?: InputMaybe<Array<ActiviteRattachPartenaireFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ActiviteRattachPartenaireFilterInput>>;
  partenaire?: InputMaybe<ListFilterInputTypeOfPartenaireFilterInput>;
};

export type ActiviteRattachPartenaireSortInput = {
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type AdditionalDetails = {
  __typename?: 'AdditionalDetails';
  commentaireAllocation?: Maybe<Scalars['String']['output']>;
  commentaireAutre?: Maybe<Scalars['String']['output']>;
  commentaireEnveloppe?: Maybe<Scalars['String']['output']>;
};

export type AdditionalDetailsFilterInput = {
  and?: InputMaybe<Array<AdditionalDetailsFilterInput>>;
  commentaireAllocation?: InputMaybe<StringOperationFilterInput>;
  commentaireAutre?: InputMaybe<StringOperationFilterInput>;
  commentaireEnveloppe?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AdditionalDetailsFilterInput>>;
};

export type AdditionalDetailsInput = {
  commentaireAllocation?: InputMaybe<Scalars['String']['input']>;
  commentaireAutre?: InputMaybe<Scalars['String']['input']>;
  commentaireEnveloppe?: InputMaybe<Scalars['String']['input']>;
};

export type AdditionalDetailsSortInput = {
  commentaireAllocation?: InputMaybe<SortEnumType>;
  commentaireAutre?: InputMaybe<SortEnumType>;
  commentaireEnveloppe?: InputMaybe<SortEnumType>;
};

export type AdequationConfig = {
  __typename?: 'AdequationConfig';
  fieldConfigs: Array<FieldConfig>;
  lastChangeDate: Scalars['DateTime']['output'];
};

export type AdequationConfigFilterInput = {
  and?: InputMaybe<Array<AdequationConfigFilterInput>>;
  fieldConfigs?: InputMaybe<ListFilterInputTypeOfFieldConfigFilterInput>;
  lastChangeDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<AdequationConfigFilterInput>>;
};

export type AdequationConfigInput = {
  fieldConfigs: Array<FieldConfigInput>;
  lastChangeDate: Scalars['DateTime']['input'];
};

export type AdequationConfigSortInput = {
  lastChangeDate?: InputMaybe<SortEnumType>;
};

export type AdhesionConsultant = {
  __typename?: 'AdhesionConsultant';
  adhesionFin?: Maybe<Scalars['DateTime']['output']>;
  consultant: Consultant;
  consultantId: Scalars['Long']['output'];
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  exerciceCommercial: ExerciceCommercial;
  exerciceCommercialId: Scalars['Int']['output'];
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['Long']['output']>;
  modeReponse: Scalars['Byte']['output'];
  modeReponseNavigation: ModeReponseReadhesion;
  reponse: Scalars['Byte']['output'];
  reponseNavigation: ReponseReadhesion;
};

export type AdhesionConsultantFilterInput = {
  adhesionFin?: InputMaybe<DateTimeOperationFilterInput>;
  and?: InputMaybe<Array<AdhesionConsultantFilterInput>>;
  consultant?: InputMaybe<ConsultantFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  exerciceCommercial?: InputMaybe<ExerciceCommercialFilterInput>;
  exerciceCommercialId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<LongOperationFilterInput>;
  modeReponse?: InputMaybe<ByteOperationFilterInput>;
  modeReponseNavigation?: InputMaybe<ModeReponseReadhesionFilterInput>;
  or?: InputMaybe<Array<AdhesionConsultantFilterInput>>;
  reponse?: InputMaybe<ByteOperationFilterInput>;
  reponseNavigation?: InputMaybe<ReponseReadhesionFilterInput>;
};

export type Adresse = {
  __typename?: 'Adresse';
  adresse1?: Maybe<Scalars['String']['output']>;
  adresse2?: Maybe<Scalars['String']['output']>;
  adresse3?: Maybe<Scalars['String']['output']>;
  arianeId?: Maybe<Scalars['Long']['output']>;
  cedex?: Maybe<Scalars['String']['output']>;
  codePostalCode?: Maybe<Scalars['String']['output']>;
  complement?: Maybe<Scalars['String']['output']>;
  consultant: Array<Consultant>;
  consultantStatutJuridique: Array<ConsultantStatutJuridique>;
  contact: Array<Contact>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate: Scalars['DateTime']['output'];
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  modeLogement?: Maybe<Scalars['String']['output']>;
  modeLogementNavigation?: Maybe<ModeLogement>;
  note?: Maybe<Note>;
  noteId?: Maybe<Scalars['Long']['output']>;
  paysCode?: Maybe<Scalars['String']['output']>;
  paysCodeNavigation?: Maybe<Pays>;
  personneMoraleAdresse: Array<PersonneMoraleAdresse>;
  personnePhysique: Array<PersonnePhysique>;
  typeAdresseCode: Scalars['String']['output'];
  typeAdresseCodeNavigation: TypeAdresse;
  villeNom?: Maybe<Scalars['String']['output']>;
};


export type AdresseConsultantArgs = {
  where?: InputMaybe<ConsultantFilterInput>;
};


export type AdresseConsultantStatutJuridiqueArgs = {
  where?: InputMaybe<ConsultantStatutJuridiqueFilterInput>;
};


export type AdresseContactArgs = {
  where?: InputMaybe<ContactFilterInput>;
};


export type AdressePersonneMoraleAdresseArgs = {
  where?: InputMaybe<PersonneMoraleAdresseFilterInput>;
};


export type AdressePersonnePhysiqueArgs = {
  where?: InputMaybe<PersonnePhysiqueFilterInput>;
};

export type AdresseFilterInput = {
  adresse1?: InputMaybe<StringOperationFilterInput>;
  adresse2?: InputMaybe<StringOperationFilterInput>;
  adresse3?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<AdresseFilterInput>>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  cedex?: InputMaybe<StringOperationFilterInput>;
  codePostalCode?: InputMaybe<StringOperationFilterInput>;
  complement?: InputMaybe<StringOperationFilterInput>;
  consultant?: InputMaybe<ListFilterInputTypeOfConsultantFilterInput>;
  consultantStatutJuridique?: InputMaybe<ListFilterInputTypeOfConsultantStatutJuridiqueFilterInput>;
  contact?: InputMaybe<ListFilterInputTypeOfContactFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  modeLogement?: InputMaybe<StringOperationFilterInput>;
  modeLogementNavigation?: InputMaybe<ModeLogementFilterInput>;
  note?: InputMaybe<NoteFilterInput>;
  noteId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<AdresseFilterInput>>;
  paysCode?: InputMaybe<StringOperationFilterInput>;
  paysCodeNavigation?: InputMaybe<PaysFilterInput>;
  personneMoraleAdresse?: InputMaybe<ListFilterInputTypeOfPersonneMoraleAdresseFilterInput>;
  personnePhysique?: InputMaybe<ListFilterInputTypeOfPersonnePhysiqueFilterInput>;
  typeAdresseCode?: InputMaybe<StringOperationFilterInput>;
  typeAdresseCodeNavigation?: InputMaybe<TypeAdresseFilterInput>;
  villeNom?: InputMaybe<StringOperationFilterInput>;
};

export type AdresseInput = {
  codePays: Scalars['String']['input'];
  codePostal: Scalars['String']['input'];
  complement: Scalars['String']['input'];
  ville: Scalars['String']['input'];
  voie: Scalars['String']['input'];
};

export type AdressePersonneInput = {
  codePostal?: InputMaybe<Scalars['String']['input']>;
  complementAdresse?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  libelle?: InputMaybe<Scalars['String']['input']>;
  modeLogement?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  pays?: InputMaybe<Scalars['String']['input']>;
  typeAdresseCode: Scalars['String']['input'];
  ville?: InputMaybe<Scalars['String']['input']>;
};

export type Allocation = {
  __typename?: 'Allocation';
  dateModification?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  libelle: Scalars['String']['output'];
  modeDeGestionCode: Scalars['String']['output'];
  niveauDeRisque: NiveauDeRisque;
  produits: Array<Produit>;
  statut?: Maybe<AllocationPartenaireStatut>;
  storageFile?: Maybe<StorageFile>;
  storageFileId?: Maybe<Scalars['String']['output']>;
};

export type AllocationConseil = {
  __typename?: 'AllocationConseil';
  id: Scalars['String']['output'];
  libelle: Scalars['String']['output'];
  modeDeGestionCode: Scalars['String']['output'];
  niveauDeRisque: NiveauDeRisque;
};

export type AllocationConseilFilterInput = {
  and?: InputMaybe<Array<AllocationConseilFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  modeDeGestionCode?: InputMaybe<StringOperationFilterInput>;
  niveauDeRisque?: InputMaybe<NiveauDeRisqueOperationFilterInput>;
  or?: InputMaybe<Array<AllocationConseilFilterInput>>;
};

export type AllocationConseilInput = {
  id: Scalars['String']['input'];
  libelle: Scalars['String']['input'];
  modeDeGestionCode: Scalars['String']['input'];
  niveauDeRisque: NiveauDeRisque;
};

export type AllocationConseilSortInput = {
  id?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
  modeDeGestionCode?: InputMaybe<SortEnumType>;
  niveauDeRisque?: InputMaybe<SortEnumType>;
};

export type AllocationFilterInput = {
  and?: InputMaybe<Array<AllocationFilterInput>>;
  dateModification?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  modeDeGestionCode?: InputMaybe<StringOperationFilterInput>;
  niveauDeRisque?: InputMaybe<NiveauDeRisqueOperationFilterInput>;
  or?: InputMaybe<Array<AllocationFilterInput>>;
  produits?: InputMaybe<ListFilterInputTypeOfProduitFilterInput>;
  statut?: InputMaybe<NullableOfAllocationPartenaireStatutOperationFilterInput>;
  storageFileId?: InputMaybe<StringOperationFilterInput>;
};

export enum AllocationPartenaireStatut {
  Actif = 'ACTIF',
  Inactive = 'INACTIVE'
}

export type AllocationSortInput = {
  dateModification?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
  modeDeGestionCode?: InputMaybe<SortEnumType>;
  niveauDeRisque?: InputMaybe<SortEnumType>;
  statut?: InputMaybe<SortEnumType>;
  storageFileId?: InputMaybe<SortEnumType>;
};

export enum AllocationTransfertOption {
  Differente = 'DIFFERENTE',
  Identique = 'IDENTIQUE'
}

export enum AllocationVersementOption {
  Differente = 'DIFFERENTE',
  Identique = 'IDENTIQUE'
}

export enum AppReference {
  Ariane = 'ARIANE',
  Minotaure = 'MINOTAURE',
  MinotaureWithWarning = 'MINOTAURE_WITH_WARNING'
}

export type AppReferenceOperationFilterInput = {
  eq?: InputMaybe<AppReference>;
  in?: InputMaybe<Array<AppReference>>;
  neq?: InputMaybe<AppReference>;
  nin?: InputMaybe<Array<AppReference>>;
};

export type AppartenanceDocument = {
  __typename?: 'AppartenanceDocument';
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  gedTypeDocument: Array<GedTypeDocument>;
  libelle: Scalars['String']['output'];
};


export type AppartenanceDocumentGedTypeDocumentArgs = {
  where?: InputMaybe<GedTypeDocumentFilterInput>;
};

export type AppartenanceDocumentFilterInput = {
  and?: InputMaybe<Array<AppartenanceDocumentFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  gedTypeDocument?: InputMaybe<ListFilterInputTypeOfGedTypeDocumentFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AppartenanceDocumentFilterInput>>;
};

/** Defines when a policy shall be executed. */
export enum ApplyPolicy {
  /** After the resolver was executed. */
  AfterResolver = 'AFTER_RESOLVER',
  /** Before the resolver was executed. */
  BeforeResolver = 'BEFORE_RESOLVER',
  /** The policy is applied in the validation step before the execution. */
  Validation = 'VALIDATION'
}

export type ArbitrageDuplicationContext = {
  __typename?: 'ArbitrageDuplicationContext';
  objectifsIntersectionApplied?: Maybe<Scalars['Boolean']['output']>;
  sourceFicheId: Scalars['String']['output'];
  sourceObjectifs?: Maybe<Array<InvestisseurFicheObjectif>>;
};

export type ArbitrageDuplicationContextFilterInput = {
  and?: InputMaybe<Array<ArbitrageDuplicationContextFilterInput>>;
  objectifsIntersectionApplied?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<ArbitrageDuplicationContextFilterInput>>;
  sourceFicheId?: InputMaybe<StringOperationFilterInput>;
  sourceObjectifs?: InputMaybe<ListFilterInputTypeOfInvestisseurFicheObjectifFilterInput>;
};

export type ArbitrageDuplicationContextInput = {
  objectifsIntersectionApplied?: InputMaybe<Scalars['Boolean']['input']>;
  sourceFicheId: Scalars['String']['input'];
  sourceObjectifs?: InputMaybe<Array<InvestisseurFicheObjectifInput>>;
};

export type ArbitrageDuplicationContextSortInput = {
  objectifsIntersectionApplied?: InputMaybe<SortEnumType>;
  sourceFicheId?: InputMaybe<SortEnumType>;
};

export type AssujettiTva = {
  __typename?: 'AssujettiTVA';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  consultantStatutJuridique: Array<ConsultantStatutJuridique>;
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};


export type AssujettiTvaConsultantStatutJuridiqueArgs = {
  where?: InputMaybe<ConsultantStatutJuridiqueFilterInput>;
};

export type AssujettiTvaFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<AssujettiTvaFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  consultantStatutJuridique?: InputMaybe<ListFilterInputTypeOfConsultantStatutJuridiqueFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AssujettiTvaFilterInput>>;
};

export enum BackOfficeService {
  Psi = 'PSI',
  Svp = 'SVP'
}

export type BackOfficeServiceOperationFilterInput = {
  eq?: InputMaybe<BackOfficeService>;
  in?: InputMaybe<Array<BackOfficeService>>;
  neq?: InputMaybe<BackOfficeService>;
  nin?: InputMaybe<Array<BackOfficeService>>;
};

export enum BlobFilesPermissionDs {
  Read = 'READ',
  Write = 'WRITE'
}

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ByteOperationFilterInput = {
  eq?: InputMaybe<Scalars['Byte']['input']>;
  gt?: InputMaybe<Scalars['Byte']['input']>;
  gte?: InputMaybe<Scalars['Byte']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Byte']['input']>>>;
  lt?: InputMaybe<Scalars['Byte']['input']>;
  lte?: InputMaybe<Scalars['Byte']['input']>;
  neq?: InputMaybe<Scalars['Byte']['input']>;
  ngt?: InputMaybe<Scalars['Byte']['input']>;
  ngte?: InputMaybe<Scalars['Byte']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Byte']['input']>>>;
  nlt?: InputMaybe<Scalars['Byte']['input']>;
  nlte?: InputMaybe<Scalars['Byte']['input']>;
};

export type CarteDemarchageInput = {
  dateFinValidite?: InputMaybe<Scalars['DateTime']['input']>;
  documentId: Scalars['String']['input'];
};

export type CategorieSocioProfessionnelle = {
  __typename?: 'CategorieSocioProfessionnelle';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['Byte']['output'];
  correspondancePcs2003: Scalars['Byte']['output'];
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  inverseParentNavigation: Array<CategorieSocioProfessionnelle>;
  libelle: Scalars['String']['output'];
  parent?: Maybe<Scalars['Byte']['output']>;
  parentNavigation?: Maybe<CategorieSocioProfessionnelle>;
  situationProfessionnelles: Array<SituationProfessionnelle>;
};


export type CategorieSocioProfessionnelleInverseParentNavigationArgs = {
  where?: InputMaybe<CategorieSocioProfessionnelleFilterInput>;
};


export type CategorieSocioProfessionnelleSituationProfessionnellesArgs = {
  where?: InputMaybe<SituationProfessionnelleFilterInput>;
};

export type CategorieSocioProfessionnelleFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<CategorieSocioProfessionnelleFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  correspondancePcs2003?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  inverseParentNavigation?: InputMaybe<ListFilterInputTypeOfCategorieSocioProfessionnelleFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CategorieSocioProfessionnelleFilterInput>>;
  parent?: InputMaybe<ByteOperationFilterInput>;
  parentNavigation?: InputMaybe<CategorieSocioProfessionnelleFilterInput>;
  situationProfessionnelles?: InputMaybe<ListFilterInputTypeOfSituationProfessionnelleFilterInput>;
};

export type CategorieSocioProfessionnelleSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  correspondancePcs2003?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
  parent?: InputMaybe<SortEnumType>;
  parentNavigation?: InputMaybe<CategorieSocioProfessionnelleSortInput>;
};

export type CessionHistoCommande = {
  __typename?: 'CessionHistoCommande';
  cessionnaire: Consultant;
  cessionnaireId: Scalars['Long']['output'];
  commande: Commande;
  commandeId: Scalars['Long']['output'];
  consultant: Consultant;
  consultantId: Scalars['Long']['output'];
  creationDate: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['Long']['output']>;
  motifCession: MotifCession;
  motifCessionId: Scalars['Byte']['output'];
  statutJuridiqueConsultant?: Maybe<ConsultantStatutJuridique>;
  statutJuridiqueConsultantId?: Maybe<Scalars['Long']['output']>;
};

export type CessionHistoCommandeFilterInput = {
  and?: InputMaybe<Array<CessionHistoCommandeFilterInput>>;
  cessionnaire?: InputMaybe<ConsultantFilterInput>;
  cessionnaireId?: InputMaybe<LongOperationFilterInput>;
  commande?: InputMaybe<CommandeFilterInput>;
  commandeId?: InputMaybe<LongOperationFilterInput>;
  consultant?: InputMaybe<ConsultantFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  date?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<LongOperationFilterInput>;
  motifCession?: InputMaybe<MotifCessionFilterInput>;
  motifCessionId?: InputMaybe<ByteOperationFilterInput>;
  or?: InputMaybe<Array<CessionHistoCommandeFilterInput>>;
  statutJuridiqueConsultant?: InputMaybe<ConsultantStatutJuridiqueFilterInput>;
  statutJuridiqueConsultantId?: InputMaybe<LongOperationFilterInput>;
};

export type CessionHistoInvestisseur = {
  __typename?: 'CessionHistoInvestisseur';
  cessionnaire: Consultant;
  cessionnaireId: Scalars['Long']['output'];
  consultant: Consultant;
  consultantId: Scalars['Long']['output'];
  creationDate: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['Long']['output']>;
  investisseur: Investisseur;
  investisseurId: Scalars['Long']['output'];
  motifCession: MotifCession;
  motifCessionId: Scalars['Byte']['output'];
};

export type CessionHistoInvestisseurFilterInput = {
  and?: InputMaybe<Array<CessionHistoInvestisseurFilterInput>>;
  cessionnaire?: InputMaybe<ConsultantFilterInput>;
  cessionnaireId?: InputMaybe<LongOperationFilterInput>;
  consultant?: InputMaybe<ConsultantFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  date?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<LongOperationFilterInput>;
  investisseur?: InputMaybe<InvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  motifCession?: InputMaybe<MotifCessionFilterInput>;
  motifCessionId?: InputMaybe<ByteOperationFilterInput>;
  or?: InputMaybe<Array<CessionHistoInvestisseurFilterInput>>;
};

/** A segment of a collection. */
export type CessionHistoInvestisseurPaginatedCollectionSegment = {
  __typename?: 'CessionHistoInvestisseurPaginatedCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CessionHistoInvestisseur>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type CessionHistoInvestisseurSortInput = {
  cessionnaire?: InputMaybe<ConsultantSortInput>;
  cessionnaireId?: InputMaybe<SortEnumType>;
  consultant?: InputMaybe<ConsultantSortInput>;
  consultantId?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  date?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  idSource?: InputMaybe<SortEnumType>;
  investisseur?: InputMaybe<InvestisseurSortInput>;
  investisseurId?: InputMaybe<SortEnumType>;
  motifCession?: InputMaybe<MotifCessionSortInput>;
  motifCessionId?: InputMaybe<SortEnumType>;
};

export type Civilite = {
  __typename?: 'Civilite';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  creationDate: Scalars['DateTime']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  personnePhysique: Array<PersonnePhysique>;
};


export type CivilitePersonnePhysiqueArgs = {
  where?: InputMaybe<PersonnePhysiqueFilterInput>;
};

export type CiviliteFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<CiviliteFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CiviliteFilterInput>>;
  personnePhysique?: InputMaybe<ListFilterInputTypeOfPersonnePhysiqueFilterInput>;
};

export type CiviliteSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

/** Information about the offset pagination. */
export type CollectionSegmentInfo = {
  __typename?: 'CollectionSegmentInfo';
  /** Indicates whether more items exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more items exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean']['output'];
};

export type Commande = {
  __typename?: 'Commande';
  achatPersonnel: Scalars['Byte']['output'];
  baseCommissionnement?: Maybe<Scalars['Decimal']['output']>;
  cessionHistoCommande: Array<CessionHistoCommande>;
  conseillerCommande: Array<ConseillerCommande>;
  creationDate: Scalars['DateTime']['output'];
  dateActe?: Maybe<Scalars['DateTime']['output']>;
  dateAnnulation?: Maybe<Scalars['DateTime']['output']>;
  dateSortie?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  etatCommande: Scalars['Byte']['output'];
  etatCommandeNavigation: EtatCommande;
  etatPMR?: Maybe<Scalars['Byte']['output']>;
  etatPMRNavigation?: Maybe<EtatPmrCommande>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['Long']['output']>;
  investisseurCommande: Array<InvestisseurCommande>;
  modeSortie?: Maybe<ModeSortieCommande>;
  modeSortieId?: Maybe<Scalars['Byte']['output']>;
  motifAnnulation?: Maybe<MotifAnnulationCommande>;
  motifAnnulationId?: Maybe<Scalars['Byte']['output']>;
  mouvement: Array<Mouvement>;
  nom: Scalars['String']['output'];
  numCommande: Scalars['Long']['output'];
  numeroContrat?: Maybe<Scalars['String']['output']>;
  prixVenteTotalTTC?: Maybe<Scalars['Decimal']['output']>;
  produit: Produit;
  produitId: Scalars['Long']['output'];
  typeAnnulationId?: Maybe<Scalars['Byte']['output']>;
  typeCommande: Scalars['Byte']['output'];
  typeCommandeNavigation: TypeCommande;
};


export type CommandeCessionHistoCommandeArgs = {
  where?: InputMaybe<CessionHistoCommandeFilterInput>;
};


export type CommandeConseillerCommandeArgs = {
  where?: InputMaybe<ConseillerCommandeFilterInput>;
};


export type CommandeInvestisseurCommandeArgs = {
  where?: InputMaybe<InvestisseurCommandeFilterInput>;
};


export type CommandeMouvementArgs = {
  where?: InputMaybe<MouvementFilterInput>;
};

export type CommandeFilterInput = {
  achatPersonnel?: InputMaybe<ByteOperationFilterInput>;
  and?: InputMaybe<Array<CommandeFilterInput>>;
  baseCommissionnement?: InputMaybe<DecimalOperationFilterInput>;
  cessionHistoCommande?: InputMaybe<ListFilterInputTypeOfCessionHistoCommandeFilterInput>;
  conseillerCommande?: InputMaybe<ListFilterInputTypeOfConseillerCommandeFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateActe?: InputMaybe<DateTimeOperationFilterInput>;
  dateAnnulation?: InputMaybe<DateTimeOperationFilterInput>;
  dateSortie?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  etatCommande?: InputMaybe<ByteOperationFilterInput>;
  etatCommandeNavigation?: InputMaybe<EtatCommandeFilterInput>;
  etatPMR?: InputMaybe<ByteOperationFilterInput>;
  etatPMRNavigation?: InputMaybe<EtatPmrCommandeFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<LongOperationFilterInput>;
  investisseurCommande?: InputMaybe<ListFilterInputTypeOfInvestisseurCommandeFilterInput>;
  modeSortie?: InputMaybe<ModeSortieCommandeFilterInput>;
  modeSortieId?: InputMaybe<ByteOperationFilterInput>;
  motifAnnulation?: InputMaybe<MotifAnnulationCommandeFilterInput>;
  motifAnnulationId?: InputMaybe<ByteOperationFilterInput>;
  mouvement?: InputMaybe<ListFilterInputTypeOfMouvementFilterInput>;
  nom?: InputMaybe<StringOperationFilterInput>;
  numCommande?: InputMaybe<LongOperationFilterInput>;
  numeroContrat?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CommandeFilterInput>>;
  prixVenteTotalTTC?: InputMaybe<DecimalOperationFilterInput>;
  produit?: InputMaybe<ProduitFilterInput>;
  produitId?: InputMaybe<LongOperationFilterInput>;
  typeAnnulationId?: InputMaybe<ByteOperationFilterInput>;
  typeCommande?: InputMaybe<ByteOperationFilterInput>;
  typeCommandeNavigation?: InputMaybe<TypeCommandeFilterInput>;
};

export type CommandeSortInput = {
  achatPersonnel?: InputMaybe<SortEnumType>;
  baseCommissionnement?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  dateActe?: InputMaybe<SortEnumType>;
  dateAnnulation?: InputMaybe<SortEnumType>;
  dateSortie?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  etatCommande?: InputMaybe<SortEnumType>;
  etatCommandeNavigation?: InputMaybe<EtatCommandeSortInput>;
  etatPMR?: InputMaybe<SortEnumType>;
  etatPMRNavigation?: InputMaybe<EtatPmrCommandeSortInput>;
  id?: InputMaybe<SortEnumType>;
  idSource?: InputMaybe<SortEnumType>;
  modeSortie?: InputMaybe<ModeSortieCommandeSortInput>;
  modeSortieId?: InputMaybe<SortEnumType>;
  motifAnnulation?: InputMaybe<MotifAnnulationCommandeSortInput>;
  motifAnnulationId?: InputMaybe<SortEnumType>;
  nom?: InputMaybe<SortEnumType>;
  numCommande?: InputMaybe<SortEnumType>;
  numeroContrat?: InputMaybe<SortEnumType>;
  prixVenteTotalTTC?: InputMaybe<SortEnumType>;
  produit?: InputMaybe<ProduitSortInput>;
  produitId?: InputMaybe<SortEnumType>;
  typeAnnulationId?: InputMaybe<SortEnumType>;
  typeCommande?: InputMaybe<SortEnumType>;
  typeCommandeNavigation?: InputMaybe<TypeCommandeSortInput>;
};

/** A segment of a collection. */
export type CommandesFinancieresPaginatedCollectionSegment = {
  __typename?: 'CommandesFinancieresPaginatedCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Commande>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type CommandesPaginatedCollectionSegment = {
  __typename?: 'CommandesPaginatedCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Commande>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type CommissionAdiType = {
  __typename?: 'CommissionAdiType';
  code: Scalars['Int']['output'];
  consultantCommissionAdiActuelCommissionAdiTypeNavigation: Array<ConsultantCommissionAdi>;
  consultantCommissionAdiChoixCommissionAdiTypeNavigation: Array<ConsultantCommissionAdi>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  libelle: Scalars['String']['output'];
};


export type CommissionAdiTypeConsultantCommissionAdiActuelCommissionAdiTypeNavigationArgs = {
  where?: InputMaybe<ConsultantCommissionAdiFilterInput>;
};


export type CommissionAdiTypeConsultantCommissionAdiChoixCommissionAdiTypeNavigationArgs = {
  where?: InputMaybe<ConsultantCommissionAdiFilterInput>;
};

export type CommissionAdiTypeFilterInput = {
  and?: InputMaybe<Array<CommissionAdiTypeFilterInput>>;
  code?: InputMaybe<IntOperationFilterInput>;
  consultantCommissionAdiActuelCommissionAdiTypeNavigation?: InputMaybe<ListFilterInputTypeOfConsultantCommissionAdiFilterInput>;
  consultantCommissionAdiChoixCommissionAdiTypeNavigation?: InputMaybe<ListFilterInputTypeOfConsultantCommissionAdiFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CommissionAdiTypeFilterInput>>;
};

export type CommissionAdiTypeSortInput = {
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type ConditionVersementComplementaire = {
  __typename?: 'ConditionVersementComplementaire';
  montantMinAvecTransfert?: Maybe<Scalars['Int']['output']>;
  montantMinAvecVP?: Maybe<Scalars['Int']['output']>;
  montantMinVC?: Maybe<Scalars['Int']['output']>;
};

export type ConditionVersementComplementaireFilterInput = {
  and?: InputMaybe<Array<ConditionVersementComplementaireFilterInput>>;
  montantMinAvecTransfert?: InputMaybe<IntOperationFilterInput>;
  montantMinAvecVP?: InputMaybe<IntOperationFilterInput>;
  montantMinVC?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ConditionVersementComplementaireFilterInput>>;
};

export type ConditionVersementInitial = {
  __typename?: 'ConditionVersementInitial';
  montantMinAvecTransfert?: Maybe<Scalars['Int']['output']>;
  montantMinAvecVP?: Maybe<Scalars['Int']['output']>;
  montantMinSouscription?: Maybe<Scalars['Int']['output']>;
};

export type ConditionVersementInitialFilterInput = {
  and?: InputMaybe<Array<ConditionVersementInitialFilterInput>>;
  montantMinAvecTransfert?: InputMaybe<IntOperationFilterInput>;
  montantMinAvecVP?: InputMaybe<IntOperationFilterInput>;
  montantMinSouscription?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ConditionVersementInitialFilterInput>>;
};

export type ConditionVersementProgramme = {
  __typename?: 'ConditionVersementProgramme';
  montantMinAnnuel?: Maybe<Scalars['Int']['output']>;
  montantMinMensuel?: Maybe<Scalars['Int']['output']>;
  montantMinSemestriel?: Maybe<Scalars['Int']['output']>;
  montantMinTrimestriel?: Maybe<Scalars['Int']['output']>;
};

export type ConditionVersementProgrammeFilterInput = {
  and?: InputMaybe<Array<ConditionVersementProgrammeFilterInput>>;
  montantMinAnnuel?: InputMaybe<IntOperationFilterInput>;
  montantMinMensuel?: InputMaybe<IntOperationFilterInput>;
  montantMinSemestriel?: InputMaybe<IntOperationFilterInput>;
  montantMinTrimestriel?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ConditionVersementProgrammeFilterInput>>;
};

export type ConditionsOfApplicability = {
  __typename?: 'ConditionsOfApplicability';
  enveloppe?: Maybe<EnveloppeProduit>;
  habilitation?: Maybe<Habilitation>;
  id: Scalars['String']['output'];
  natureOperation?: Maybe<NatureOperation>;
  tags: Array<Scalars['String']['output']>;
  typeInvestisseur: InvestisseurType;
};

export type ConditionsOfApplicabilityFilterInput = {
  and?: InputMaybe<Array<ConditionsOfApplicabilityFilterInput>>;
  enveloppe?: InputMaybe<EnveloppeProduitFilterInput>;
  habilitation?: InputMaybe<HabilitationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  natureOperation?: InputMaybe<NatureOperationFilterInput>;
  or?: InputMaybe<Array<ConditionsOfApplicabilityFilterInput>>;
  tags?: InputMaybe<ListStringOperationFilterInput>;
  typeInvestisseur?: InputMaybe<InvestisseurTypeOperationFilterInput>;
};

export type ConditionsOfApplicabilitySortInput = {
  enveloppe?: InputMaybe<EnveloppeProduitSortInput>;
  habilitation?: InputMaybe<HabilitationSortInput>;
  id?: InputMaybe<SortEnumType>;
  natureOperation?: InputMaybe<NatureOperationSortInput>;
  typeInvestisseur?: InputMaybe<SortEnumType>;
};

export type ConfigFormulaire = {
  __typename?: 'ConfigFormulaire';
  enveloppeConfig: AdequationConfig;
  id: Scalars['String']['output'];
  lastUpdateDate: Scalars['DateTime']['output'];
  produitConfigs: Array<ProduitSpecificConfig>;
  version: Scalars['Int']['output'];
};

export type ConfigFormulaireFilterInput = {
  and?: InputMaybe<Array<ConfigFormulaireFilterInput>>;
  enveloppeConfig?: InputMaybe<AdequationConfigFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  lastUpdateDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ConfigFormulaireFilterInput>>;
  produitConfigs?: InputMaybe<ListFilterInputTypeOfProduitSpecificConfigFilterInput>;
  version?: InputMaybe<IntOperationFilterInput>;
};

export type ConfigFormulaireSortInput = {
  enveloppeConfig?: InputMaybe<AdequationConfigSortInput>;
  id?: InputMaybe<SortEnumType>;
  lastUpdateDate?: InputMaybe<SortEnumType>;
  version?: InputMaybe<SortEnumType>;
};

export enum ConfigStatut {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
  Draft = 'DRAFT',
  TemporaryValidButDeprecated = 'TEMPORARY_VALID_BUT_DEPRECATED',
  ValidButDeprecated = 'VALID_BUT_DEPRECATED'
}

export type ConfigStatutOperationFilterInput = {
  eq?: InputMaybe<ConfigStatut>;
  in?: InputMaybe<Array<ConfigStatut>>;
  neq?: InputMaybe<ConfigStatut>;
  nin?: InputMaybe<Array<ConfigStatut>>;
};

export type ConfigTemplate = {
  __typename?: 'ConfigTemplate';
  templateName: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type ConfigTemplateFilterInput = {
  and?: InputMaybe<Array<ConfigTemplateFilterInput>>;
  or?: InputMaybe<Array<ConfigTemplateFilterInput>>;
  templateName?: InputMaybe<StringOperationFilterInput>;
  version?: InputMaybe<IntOperationFilterInput>;
};

export type ConfigTemplateSortInput = {
  templateName?: InputMaybe<SortEnumType>;
  version?: InputMaybe<SortEnumType>;
};

export type ConnaissanceExperience = {
  __typename?: 'ConnaissanceExperience';
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Byte']['output'];
  libelle: Scalars['String']['output'];
  profilInvestisseur: Array<ProfilInvestisseur>;
};


export type ConnaissanceExperienceProfilInvestisseurArgs = {
  where?: InputMaybe<ProfilInvestisseurFilterInput>;
};

export type ConnaissanceExperienceFilterInput = {
  and?: InputMaybe<Array<ConnaissanceExperienceFilterInput>>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<ByteOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ConnaissanceExperienceFilterInput>>;
  profilInvestisseur?: InputMaybe<ListFilterInputTypeOfProfilInvestisseurFilterInput>;
};

export type ConseilConfig = {
  __typename?: 'ConseilConfig';
  commentaireDeVersion?: Maybe<Scalars['String']['output']>;
  conditionsOfApplicability: ConditionsOfApplicability;
  configFormulaire?: Maybe<ConfigFormulaire>;
  configTemplate?: Maybe<ConfigTemplate>;
  id: Scalars['String']['output'];
  isMajeurVersion?: Maybe<Scalars['Boolean']['output']>;
  lastChangeDate: Scalars['DateTime']['output'];
  legacyDocumentsDetails?: Maybe<Array<StorageFile>>;
  legacyDocumentsIds?: Maybe<Array<Scalars['String']['output']>>;
  libelle: Scalars['String']['output'];
  previousVersionDeprecationDate?: Maybe<Scalars['DateTime']['output']>;
  statut: ConfigStatut;
  validityLimitDate?: Maybe<Scalars['DateTime']['output']>;
  version: Scalars['Int']['output'];
};

export type ConseilConfigFilterInput = {
  and?: InputMaybe<Array<ConseilConfigFilterInput>>;
  commentaireDeVersion?: InputMaybe<StringOperationFilterInput>;
  conditionsOfApplicability?: InputMaybe<ConditionsOfApplicabilityFilterInput>;
  configFormulaire?: InputMaybe<ConfigFormulaireFilterInput>;
  configTemplate?: InputMaybe<ConfigTemplateFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isMajeurVersion?: InputMaybe<BooleanOperationFilterInput>;
  lastChangeDate?: InputMaybe<DateTimeOperationFilterInput>;
  legacyDocumentsIds?: InputMaybe<ListStringOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ConseilConfigFilterInput>>;
  previousVersionDeprecationDate?: InputMaybe<DateTimeOperationFilterInput>;
  statut?: InputMaybe<ConfigStatutOperationFilterInput>;
  validityLimitDate?: InputMaybe<DateTimeOperationFilterInput>;
  version?: InputMaybe<IntOperationFilterInput>;
};

/** A segment of a collection. */
export type ConseilConfigPaginatedCollectionSegment = {
  __typename?: 'ConseilConfigPaginatedCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ConseilConfig>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type ConseilConfigSortInput = {
  commentaireDeVersion?: InputMaybe<SortEnumType>;
  conditionsOfApplicability?: InputMaybe<ConditionsOfApplicabilitySortInput>;
  configFormulaire?: InputMaybe<ConfigFormulaireSortInput>;
  configTemplate?: InputMaybe<ConfigTemplateSortInput>;
  id?: InputMaybe<SortEnumType>;
  isMajeurVersion?: InputMaybe<SortEnumType>;
  lastChangeDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
  previousVersionDeprecationDate?: InputMaybe<SortEnumType>;
  statut?: InputMaybe<SortEnumType>;
  validityLimitDate?: InputMaybe<SortEnumType>;
  version?: InputMaybe<SortEnumType>;
};

export type ConseillerCommande = {
  __typename?: 'ConseillerCommande';
  commande: Commande;
  commandeId: Scalars['Long']['output'];
  conseiller: Consultant;
  conseillerId: Scalars['Long']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  typeConseillerCommande: Scalars['Byte']['output'];
  typeConseillerCommandeNavigation: TypeConseillerCommande;
};

export type ConseillerCommandeFilterInput = {
  and?: InputMaybe<Array<ConseillerCommandeFilterInput>>;
  commande?: InputMaybe<CommandeFilterInput>;
  commandeId?: InputMaybe<LongOperationFilterInput>;
  conseiller?: InputMaybe<ConsultantFilterInput>;
  conseillerId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<ConseillerCommandeFilterInput>>;
  typeConseillerCommande?: InputMaybe<ByteOperationFilterInput>;
  typeConseillerCommandeNavigation?: InputMaybe<TypeConseillerCommandeFilterInput>;
};

export type Consultant = {
  __typename?: 'Consultant';
  abonnementConsultant: Array<AbonnementConsultant>;
  adhesionConsultant: Array<AdhesionConsultant>;
  adresse: Array<Adresse>;
  affiliationDate?: Maybe<Scalars['DateTime']['output']>;
  arianeId?: Maybe<Scalars['Long']['output']>;
  cessionHistoCommandeCessionnaire: Array<CessionHistoCommande>;
  cessionHistoCommandeConsultant: Array<CessionHistoCommande>;
  cessionHistoInvestisseurCessionnaire: Array<CessionHistoInvestisseur>;
  cessionHistoInvestisseurConsultant: Array<CessionHistoInvestisseur>;
  civiliteCode: Scalars['String']['output'];
  code: Scalars['String']['output'];
  codeTier?: Maybe<Scalars['String']['output']>;
  commentairePeriodeJunior?: Maybe<Scalars['String']['output']>;
  conseillerCommande: Array<ConseillerCommande>;
  consultantCommissionAdi?: Maybe<ConsultantCommissionAdi>;
  consultantDistinction: Array<ConsultantDistinction>;
  consultantHabilitations: Array<ConsultantHabilitation>;
  consultantHabilitationsFictives: Array<ConsultantHabilitationsFictives>;
  consultantMouvement: Array<ConsultantMouvement>;
  consultantOrganisationConstellation: Array<ConsultantOrganisation>;
  consultantOrganisationConsultant?: Maybe<ConsultantOrganisation>;
  consultantOrganisationEtoile: Array<ConsultantOrganisation>;
  consultantOrganisationGalaxie: Array<ConsultantOrganisation>;
  consultantOrganisationManager: Array<ConsultantOrganisation>;
  consultantOrganisationPlanete: Array<ConsultantOrganisation>;
  consultantRcp: Array<ConsultantRcp>;
  consultantStatutCommercial: Array<ConsultantStatutCommercial>;
  consultantStatutJuridique: Array<ConsultantStatutJuridique>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate: Scalars['DateTime']['output'];
  date1AcquisitionDroit?: Maybe<Scalars['DateTime']['output']>;
  date1Manager?: Maybe<Scalars['DateTime']['output']>;
  date1VenteActee?: Maybe<Scalars['DateTime']['output']>;
  date1VenteFinancement?: Maybe<Scalars['DateTime']['output']>;
  date1VenteImmo?: Maybe<Scalars['DateTime']['output']>;
  date1VentePlacement?: Maybe<Scalars['DateTime']['output']>;
  dateAcquisitionDroit?: Maybe<Scalars['DateTime']['output']>;
  dateAffiliationProdemial?: Maybe<Scalars['DateTime']['output']>;
  dateContact?: Maybe<Scalars['DateTime']['output']>;
  dateDemission?: Maybe<Scalars['DateTime']['output']>;
  dateEntree?: Maybe<Scalars['DateTime']['output']>;
  dateFinPeriodeJunior?: Maybe<Scalars['DateTime']['output']>;
  dateFinValiditeAffiliation?: Maybe<Scalars['DateTime']['output']>;
  dateSeminairePro?: Maybe<Scalars['DateTime']['output']>;
  derniereDateExclusif?: Maybe<Scalars['DateTime']['output']>;
  derniereDateNonExclusif?: Maybe<Scalars['DateTime']['output']>;
  displayName: Scalars['String']['output'];
  editeurId?: Maybe<Scalars['Long']['output']>;
  edition: Array<Edition>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  eligilibleRenouvellement: Scalars['Boolean']['output'];
  email: Array<Email>;
  equivalenceDeFormationConsultant: Array<EquivalenceDeFormation>;
  equivalenceDeFormationConsultantFormateur: Array<EquivalenceDeFormation>;
  exclusif: Scalars['Boolean']['output'];
  facture: Array<Facture>;
  filesMetadata: Array<FileMetadata>;
  galaxy?: Maybe<Consultant>;
  galaxyId?: Maybe<Scalars['Long']['output']>;
  gerePar: AppReference;
  habilitationALPSI: Scalars['Boolean']['output'];
  habilitationAssurance: Scalars['Boolean']['output'];
  habilitationCIF: Scalars['Boolean']['output'];
  habilitationIOB: Scalars['Boolean']['output'];
  habilitationImmo: Scalars['Boolean']['output'];
  habilitationPMR: Scalars['Boolean']['output'];
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  inscriptionCycleCourt: Array<InscriptionCycleCourt>;
  inscriptionSession: Array<InscriptionSession>;
  inverseGalaxy: Array<Consultant>;
  inverseManager: Array<Consultant>;
  inverseParrain: Array<Consultant>;
  inverseTeteReseau: Array<Consultant>;
  investisseurConsultant: Array<InvestisseurConsultant>;
  manager?: Maybe<Consultant>;
  managerId?: Maybe<Scalars['Long']['output']>;
  mandatAutofacFinancement?: Maybe<Scalars['Byte']['output']>;
  mandatAutofacPlacement?: Maybe<Scalars['Byte']['output']>;
  mandatAutofacTotal?: Maybe<Scalars['Byte']['output']>;
  minotaureImportProgress?: Maybe<MinotaureImportProgress>;
  motifResiliationCode?: Maybe<Scalars['String']['output']>;
  motifResiliationCodeNavigation?: Maybe<MotifResiliationConsultant>;
  nbAmbassadeurs?: Maybe<Scalars['Byte']['output']>;
  nbRecommandations?: Maybe<Scalars['Byte']['output']>;
  nom: Scalars['String']['output'];
  origineSaisie: Scalars['Byte']['output'];
  origineSaisieNavigation: OrigineData;
  parrain?: Maybe<Consultant>;
  parrainId?: Maybe<Scalars['Long']['output']>;
  personnePhysique: Array<PersonnePhysique>;
  peutParainner?: Maybe<Scalars['Boolean']['output']>;
  prenom: Scalars['String']['output'];
  qualificationCode?: Maybe<Scalars['String']['output']>;
  qualificationCodeNavigation?: Maybe<QualificationConsultant>;
  raisonSociale?: Maybe<Scalars['String']['output']>;
  reponseRenouvellement?: Maybe<Scalars['Byte']['output']>;
  resiliationDate?: Maybe<Scalars['DateTime']['output']>;
  resiliationPaiementB2S: Array<ResiliationPaiementB2S>;
  souhaiteCollaborerAvecStelliumFi?: Maybe<Scalars['Boolean']['output']>;
  statutCode: Scalars['String']['output'];
  statutCodeNavigation: StatutConsultant;
  tauxRemuneration?: Maybe<Scalars['Decimal']['output']>;
  telephone: Array<Telephone>;
  teteReseau?: Maybe<Consultant>;
  teteReseauId?: Maybe<Scalars['Long']['output']>;
  titreCode?: Maybe<Scalars['String']['output']>;
  titreCodeNavigation?: Maybe<TitreConsultant>;
  totalDebours?: Maybe<Scalars['Decimal']['output']>;
};


export type ConsultantAbonnementConsultantArgs = {
  where?: InputMaybe<AbonnementConsultantFilterInput>;
};


export type ConsultantAdhesionConsultantArgs = {
  where?: InputMaybe<AdhesionConsultantFilterInput>;
};


export type ConsultantAdresseArgs = {
  where?: InputMaybe<AdresseFilterInput>;
};


export type ConsultantCessionHistoCommandeCessionnaireArgs = {
  where?: InputMaybe<CessionHistoCommandeFilterInput>;
};


export type ConsultantCessionHistoCommandeConsultantArgs = {
  where?: InputMaybe<CessionHistoCommandeFilterInput>;
};


export type ConsultantCessionHistoInvestisseurCessionnaireArgs = {
  where?: InputMaybe<CessionHistoInvestisseurFilterInput>;
};


export type ConsultantCessionHistoInvestisseurConsultantArgs = {
  where?: InputMaybe<CessionHistoInvestisseurFilterInput>;
};


export type ConsultantConseillerCommandeArgs = {
  where?: InputMaybe<ConseillerCommandeFilterInput>;
};


export type ConsultantConsultantDistinctionArgs = {
  where?: InputMaybe<ConsultantDistinctionFilterInput>;
};


export type ConsultantConsultantHabilitationsArgs = {
  where?: InputMaybe<ConsultantHabilitationFilterInput>;
};


export type ConsultantConsultantHabilitationsFictivesArgs = {
  where?: InputMaybe<ConsultantHabilitationsFictivesFilterInput>;
};


export type ConsultantConsultantMouvementArgs = {
  where?: InputMaybe<ConsultantMouvementFilterInput>;
};


export type ConsultantConsultantOrganisationConstellationArgs = {
  where?: InputMaybe<ConsultantOrganisationFilterInput>;
};


export type ConsultantConsultantOrganisationEtoileArgs = {
  where?: InputMaybe<ConsultantOrganisationFilterInput>;
};


export type ConsultantConsultantOrganisationGalaxieArgs = {
  where?: InputMaybe<ConsultantOrganisationFilterInput>;
};


export type ConsultantConsultantOrganisationManagerArgs = {
  where?: InputMaybe<ConsultantOrganisationFilterInput>;
};


export type ConsultantConsultantOrganisationPlaneteArgs = {
  where?: InputMaybe<ConsultantOrganisationFilterInput>;
};


export type ConsultantConsultantRcpArgs = {
  where?: InputMaybe<ConsultantRcpFilterInput>;
};


export type ConsultantConsultantStatutCommercialArgs = {
  where?: InputMaybe<ConsultantStatutCommercialFilterInput>;
};


export type ConsultantConsultantStatutJuridiqueArgs = {
  where?: InputMaybe<ConsultantStatutJuridiqueFilterInput>;
};


export type ConsultantEditionArgs = {
  where?: InputMaybe<EditionFilterInput>;
};


export type ConsultantEmailArgs = {
  where?: InputMaybe<EmailFilterInput>;
};


export type ConsultantEquivalenceDeFormationConsultantArgs = {
  where?: InputMaybe<EquivalenceDeFormationFilterInput>;
};


export type ConsultantEquivalenceDeFormationConsultantFormateurArgs = {
  where?: InputMaybe<EquivalenceDeFormationFilterInput>;
};


export type ConsultantFactureArgs = {
  where?: InputMaybe<FactureFilterInput>;
};


export type ConsultantInscriptionCycleCourtArgs = {
  where?: InputMaybe<InscriptionCycleCourtFilterInput>;
};


export type ConsultantInscriptionSessionArgs = {
  where?: InputMaybe<InscriptionSessionFilterInput>;
};


export type ConsultantInverseGalaxyArgs = {
  where?: InputMaybe<ConsultantFilterInput>;
};


export type ConsultantInverseManagerArgs = {
  where?: InputMaybe<ConsultantFilterInput>;
};


export type ConsultantInverseParrainArgs = {
  where?: InputMaybe<ConsultantFilterInput>;
};


export type ConsultantInverseTeteReseauArgs = {
  where?: InputMaybe<ConsultantFilterInput>;
};


export type ConsultantInvestisseurConsultantArgs = {
  where?: InputMaybe<InvestisseurConsultantFilterInput>;
};


export type ConsultantPersonnePhysiqueArgs = {
  where?: InputMaybe<PersonnePhysiqueFilterInput>;
};


export type ConsultantResiliationPaiementB2SArgs = {
  where?: InputMaybe<ResiliationPaiementB2SFilterInput>;
};


export type ConsultantTelephoneArgs = {
  where?: InputMaybe<TelephoneFilterInput>;
};

export type ConsultantCarteDemarchage = {
  __typename?: 'ConsultantCarteDemarchage';
  consultantHabilitation: ConsultantHabilitation;
  consultantHabilitationId: Scalars['Long']['output'];
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  dateDebut?: Maybe<Scalars['DateTime']['output']>;
  dateFin?: Maybe<Scalars['DateTime']['output']>;
  dateFinInitiale?: Maybe<Scalars['DateTime']['output']>;
  documentId?: Maybe<Scalars['UUID']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
};

export type ConsultantCarteDemarchageFilterInput = {
  and?: InputMaybe<Array<ConsultantCarteDemarchageFilterInput>>;
  consultantHabilitation?: InputMaybe<ConsultantHabilitationFilterInput>;
  consultantHabilitationId?: InputMaybe<LongOperationFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateDebut?: InputMaybe<DateTimeOperationFilterInput>;
  dateFin?: InputMaybe<DateTimeOperationFilterInput>;
  dateFinInitiale?: InputMaybe<DateTimeOperationFilterInput>;
  documentId?: InputMaybe<UuidOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantCarteDemarchageFilterInput>>;
};

export type ConsultantCommissionAdi = {
  __typename?: 'ConsultantCommissionAdi';
  actuelCommissionAdiType: Scalars['Int']['output'];
  actuelCommissionAdiTypeNavigation: CommissionAdiType;
  choixCommissionAdiType?: Maybe<Scalars['Int']['output']>;
  choixCommissionAdiTypeNavigation?: Maybe<CommissionAdiType>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  dateChoixCommissionAdiType?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idNavigation: Consultant;
};

export type ConsultantCommissionAdiFilterInput = {
  actuelCommissionAdiType?: InputMaybe<IntOperationFilterInput>;
  actuelCommissionAdiTypeNavigation?: InputMaybe<CommissionAdiTypeFilterInput>;
  and?: InputMaybe<Array<ConsultantCommissionAdiFilterInput>>;
  choixCommissionAdiType?: InputMaybe<IntOperationFilterInput>;
  choixCommissionAdiTypeNavigation?: InputMaybe<CommissionAdiTypeFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateChoixCommissionAdiType?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idNavigation?: InputMaybe<ConsultantFilterInput>;
  or?: InputMaybe<Array<ConsultantCommissionAdiFilterInput>>;
};

export type ConsultantCommissionAdiSortInput = {
  actuelCommissionAdiType?: InputMaybe<SortEnumType>;
  actuelCommissionAdiTypeNavigation?: InputMaybe<CommissionAdiTypeSortInput>;
  choixCommissionAdiType?: InputMaybe<SortEnumType>;
  choixCommissionAdiTypeNavigation?: InputMaybe<CommissionAdiTypeSortInput>;
  creationDate?: InputMaybe<SortEnumType>;
  dateChoixCommissionAdiType?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  idNavigation?: InputMaybe<ConsultantSortInput>;
};

export type ConsultantContrat = {
  __typename?: 'ConsultantContrat';
  consultantStatutJuridique: ConsultantStatutJuridique;
  consultantStatutJuridiqueId: Scalars['Long']['output'];
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  dateContrat?: Maybe<Scalars['DateTime']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  pieceJointe: Array<PieceJointeConsultant>;
  typeContratCode: Scalars['String']['output'];
  typeContratCodeNavigation: TypeContrat;
};


export type ConsultantContratPieceJointeArgs = {
  where?: InputMaybe<PieceJointeConsultantFilterInput>;
};

export type ConsultantContratFilterInput = {
  and?: InputMaybe<Array<ConsultantContratFilterInput>>;
  consultantStatutJuridique?: InputMaybe<ConsultantStatutJuridiqueFilterInput>;
  consultantStatutJuridiqueId?: InputMaybe<LongOperationFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateContrat?: InputMaybe<DateTimeOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantContratFilterInput>>;
  pieceJointe?: InputMaybe<ListFilterInputTypeOfPieceJointeConsultantFilterInput>;
  typeContratCode?: InputMaybe<StringOperationFilterInput>;
  typeContratCodeNavigation?: InputMaybe<TypeContratFilterInput>;
};

export type ConsultantDistinction = {
  __typename?: 'ConsultantDistinction';
  categorie: DistinctionCategorie;
  categorieId: Scalars['Byte']['output'];
  consultant: Consultant;
  consultantId: Scalars['Long']['output'];
  creationDate: Scalars['DateTime']['output'];
  dateApparitionDistinction: Scalars['DateTime']['output'];
  dateCalculDistinction: Scalars['DateTime']['output'];
  dateDistinction: Scalars['DateTime']['output'];
  distinction: Scalars['Byte']['output'];
  distinctionNavigation: Distinction;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  exercicePMR: Scalars['Int']['output'];
  exercicePMRNavigation: ExerciceCommercial;
  id: Scalars['Long']['output'];
  nombreEtoile: Scalars['Byte']['output'];
  statutDistinction: StatutDistinction;
  statutDistinctionId: Scalars['Byte']['output'];
};

export type ConsultantDistinctionFilterInput = {
  and?: InputMaybe<Array<ConsultantDistinctionFilterInput>>;
  categorie?: InputMaybe<DistinctionCategorieFilterInput>;
  categorieId?: InputMaybe<ByteOperationFilterInput>;
  consultant?: InputMaybe<ConsultantFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateApparitionDistinction?: InputMaybe<DateTimeOperationFilterInput>;
  dateCalculDistinction?: InputMaybe<DateTimeOperationFilterInput>;
  dateDistinction?: InputMaybe<DateTimeOperationFilterInput>;
  distinction?: InputMaybe<ByteOperationFilterInput>;
  distinctionNavigation?: InputMaybe<DistinctionFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  exercicePMR?: InputMaybe<IntOperationFilterInput>;
  exercicePMRNavigation?: InputMaybe<ExerciceCommercialFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  nombreEtoile?: InputMaybe<ByteOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantDistinctionFilterInput>>;
  statutDistinction?: InputMaybe<StatutDistinctionFilterInput>;
  statutDistinctionId?: InputMaybe<ByteOperationFilterInput>;
};

export type ConsultantFilterInput = {
  abonnementConsultant?: InputMaybe<ListFilterInputTypeOfAbonnementConsultantFilterInput>;
  adhesionConsultant?: InputMaybe<ListFilterInputTypeOfAdhesionConsultantFilterInput>;
  adresse?: InputMaybe<ListFilterInputTypeOfAdresseFilterInput>;
  affiliationDate?: InputMaybe<DateTimeOperationFilterInput>;
  and?: InputMaybe<Array<ConsultantFilterInput>>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  cessionHistoCommandeCessionnaire?: InputMaybe<ListFilterInputTypeOfCessionHistoCommandeFilterInput>;
  cessionHistoCommandeConsultant?: InputMaybe<ListFilterInputTypeOfCessionHistoCommandeFilterInput>;
  cessionHistoInvestisseurCessionnaire?: InputMaybe<ListFilterInputTypeOfCessionHistoInvestisseurFilterInput>;
  cessionHistoInvestisseurConsultant?: InputMaybe<ListFilterInputTypeOfCessionHistoInvestisseurFilterInput>;
  civiliteCode?: InputMaybe<StringOperationFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  codeTier?: InputMaybe<StringOperationFilterInput>;
  commentairePeriodeJunior?: InputMaybe<StringOperationFilterInput>;
  conseillerCommande?: InputMaybe<ListFilterInputTypeOfConseillerCommandeFilterInput>;
  consultantCommissionAdi?: InputMaybe<ConsultantCommissionAdiFilterInput>;
  consultantDistinction?: InputMaybe<ListFilterInputTypeOfConsultantDistinctionFilterInput>;
  consultantHabilitations?: InputMaybe<ListFilterInputTypeOfConsultantHabilitationFilterInput>;
  consultantHabilitationsFictives?: InputMaybe<ListFilterInputTypeOfConsultantHabilitationsFictivesFilterInput>;
  consultantMouvement?: InputMaybe<ListFilterInputTypeOfConsultantMouvementFilterInput>;
  consultantOrganisationConstellation?: InputMaybe<ListFilterInputTypeOfConsultantOrganisationFilterInput>;
  consultantOrganisationConsultant?: InputMaybe<ConsultantOrganisationFilterInput>;
  consultantOrganisationEtoile?: InputMaybe<ListFilterInputTypeOfConsultantOrganisationFilterInput>;
  consultantOrganisationGalaxie?: InputMaybe<ListFilterInputTypeOfConsultantOrganisationFilterInput>;
  consultantOrganisationManager?: InputMaybe<ListFilterInputTypeOfConsultantOrganisationFilterInput>;
  consultantOrganisationPlanete?: InputMaybe<ListFilterInputTypeOfConsultantOrganisationFilterInput>;
  consultantRcp?: InputMaybe<ListFilterInputTypeOfConsultantRcpFilterInput>;
  consultantStatutCommercial?: InputMaybe<ListFilterInputTypeOfConsultantStatutCommercialFilterInput>;
  consultantStatutJuridique?: InputMaybe<ListFilterInputTypeOfConsultantStatutJuridiqueFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  date1AcquisitionDroit?: InputMaybe<DateTimeOperationFilterInput>;
  date1Manager?: InputMaybe<DateTimeOperationFilterInput>;
  date1VenteActee?: InputMaybe<DateTimeOperationFilterInput>;
  date1VenteFinancement?: InputMaybe<DateTimeOperationFilterInput>;
  date1VenteImmo?: InputMaybe<DateTimeOperationFilterInput>;
  date1VentePlacement?: InputMaybe<DateTimeOperationFilterInput>;
  dateAcquisitionDroit?: InputMaybe<DateTimeOperationFilterInput>;
  dateAffiliationProdemial?: InputMaybe<DateTimeOperationFilterInput>;
  dateContact?: InputMaybe<DateTimeOperationFilterInput>;
  dateDemission?: InputMaybe<DateTimeOperationFilterInput>;
  dateEntree?: InputMaybe<DateTimeOperationFilterInput>;
  dateFinPeriodeJunior?: InputMaybe<DateTimeOperationFilterInput>;
  dateFinValiditeAffiliation?: InputMaybe<DateTimeOperationFilterInput>;
  dateSeminairePro?: InputMaybe<DateTimeOperationFilterInput>;
  derniereDateExclusif?: InputMaybe<DateTimeOperationFilterInput>;
  derniereDateNonExclusif?: InputMaybe<DateTimeOperationFilterInput>;
  displayName?: InputMaybe<StringOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  edition?: InputMaybe<ListFilterInputTypeOfEditionFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  eligilibleRenouvellement?: InputMaybe<BooleanOperationFilterInput>;
  email?: InputMaybe<ListFilterInputTypeOfEmailFilterInput>;
  equivalenceDeFormationConsultant?: InputMaybe<ListFilterInputTypeOfEquivalenceDeFormationFilterInput>;
  equivalenceDeFormationConsultantFormateur?: InputMaybe<ListFilterInputTypeOfEquivalenceDeFormationFilterInput>;
  exclusif?: InputMaybe<BooleanOperationFilterInput>;
  facture?: InputMaybe<ListFilterInputTypeOfFactureFilterInput>;
  galaxy?: InputMaybe<ConsultantFilterInput>;
  galaxyId?: InputMaybe<LongOperationFilterInput>;
  gerePar?: InputMaybe<AppReferenceOperationFilterInput>;
  habilitationALPSI?: InputMaybe<BooleanOperationFilterInput>;
  habilitationAssurance?: InputMaybe<BooleanOperationFilterInput>;
  habilitationCIF?: InputMaybe<BooleanOperationFilterInput>;
  habilitationIOB?: InputMaybe<BooleanOperationFilterInput>;
  habilitationImmo?: InputMaybe<BooleanOperationFilterInput>;
  habilitationPMR?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  inscriptionCycleCourt?: InputMaybe<ListFilterInputTypeOfInscriptionCycleCourtFilterInput>;
  inscriptionSession?: InputMaybe<ListFilterInputTypeOfInscriptionSessionFilterInput>;
  inverseGalaxy?: InputMaybe<ListFilterInputTypeOfConsultantFilterInput>;
  inverseManager?: InputMaybe<ListFilterInputTypeOfConsultantFilterInput>;
  inverseParrain?: InputMaybe<ListFilterInputTypeOfConsultantFilterInput>;
  inverseTeteReseau?: InputMaybe<ListFilterInputTypeOfConsultantFilterInput>;
  investisseurConsultant?: InputMaybe<ListFilterInputTypeOfInvestisseurConsultantFilterInput>;
  manager?: InputMaybe<ConsultantFilterInput>;
  managerId?: InputMaybe<LongOperationFilterInput>;
  mandatAutofacFinancement?: InputMaybe<ByteOperationFilterInput>;
  mandatAutofacPlacement?: InputMaybe<ByteOperationFilterInput>;
  mandatAutofacTotal?: InputMaybe<ByteOperationFilterInput>;
  motifResiliationCode?: InputMaybe<StringOperationFilterInput>;
  motifResiliationCodeNavigation?: InputMaybe<MotifResiliationConsultantFilterInput>;
  nbAmbassadeurs?: InputMaybe<ByteOperationFilterInput>;
  nbRecommandations?: InputMaybe<ByteOperationFilterInput>;
  nom?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantFilterInput>>;
  origineSaisie?: InputMaybe<ByteOperationFilterInput>;
  origineSaisieNavigation?: InputMaybe<OrigineDataFilterInput>;
  parrain?: InputMaybe<ConsultantFilterInput>;
  parrainId?: InputMaybe<LongOperationFilterInput>;
  personnePhysique?: InputMaybe<ListFilterInputTypeOfPersonnePhysiqueFilterInput>;
  peutParainner?: InputMaybe<BooleanOperationFilterInput>;
  prenom?: InputMaybe<StringOperationFilterInput>;
  qualificationCode?: InputMaybe<StringOperationFilterInput>;
  qualificationCodeNavigation?: InputMaybe<QualificationConsultantFilterInput>;
  raisonSociale?: InputMaybe<StringOperationFilterInput>;
  reponseRenouvellement?: InputMaybe<ByteOperationFilterInput>;
  resiliationDate?: InputMaybe<DateTimeOperationFilterInput>;
  resiliationPaiementB2S?: InputMaybe<ListFilterInputTypeOfResiliationPaiementB2SFilterInput>;
  souhaiteCollaborerAvecStelliumFi?: InputMaybe<BooleanOperationFilterInput>;
  statutCode?: InputMaybe<StringOperationFilterInput>;
  statutCodeNavigation?: InputMaybe<StatutConsultantFilterInput>;
  tauxRemuneration?: InputMaybe<DecimalOperationFilterInput>;
  telephone?: InputMaybe<ListFilterInputTypeOfTelephoneFilterInput>;
  teteReseau?: InputMaybe<ConsultantFilterInput>;
  teteReseauId?: InputMaybe<LongOperationFilterInput>;
  titreCode?: InputMaybe<StringOperationFilterInput>;
  titreCodeNavigation?: InputMaybe<TitreConsultantFilterInput>;
  totalDebours?: InputMaybe<DecimalOperationFilterInput>;
};

export type ConsultantHabilitation = {
  __typename?: 'ConsultantHabilitation';
  actionsBackOffice: Array<ConsultantHabilitationActionBackOffice>;
  associationProNom?: Maybe<Scalars['String']['output']>;
  cifPartenaireCode?: Maybe<Scalars['String']['output']>;
  codeHabilitation?: Maybe<Scalars['String']['output']>;
  consultant?: Maybe<Consultant>;
  consultantCartesDemarchage: Array<ConsultantCarteDemarchage>;
  consultantHabilitationInscription: Array<ConsultantHabilitationInscription>;
  consultantId?: Maybe<Scalars['Long']['output']>;
  consultantStatutJuridique?: Maybe<ConsultantStatutJuridique>;
  consultantStatutJuridiqueId?: Maybe<Scalars['Long']['output']>;
  creationDate: Scalars['DateTime']['output'];
  dateDebut?: Maybe<Scalars['DateTime']['output']>;
  dateFin?: Maybe<Scalars['DateTime']['output']>;
  datePremiereHabilitation?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  evaluationRequise?: Maybe<Scalars['Boolean']['output']>;
  expirations: Array<ConsultantHabilitationExpiration>;
  garantAdresse?: Maybe<Scalars['String']['output']>;
  garantNom?: Maybe<Scalars['String']['output']>;
  habilitation?: Maybe<Habilitation>;
  habilitationId?: Maybe<Scalars['Long']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  invalidityReasons: Array<ConsultantHabilitationInvalidityReason>;
  mediateur?: Maybe<Scalars['String']['output']>;
  mediateurAssu?: Maybe<Scalars['String']['output']>;
  mediateurCif?: Maybe<Scalars['String']['output']>;
  mediateurIOB?: Maybe<Scalars['String']['output']>;
  mediateurImmo?: Maybe<Scalars['String']['output']>;
  partenaireCourtierFinancement1?: Maybe<Scalars['String']['output']>;
  partenaireCourtierFinancement2?: Maybe<Scalars['String']['output']>;
  statut?: Maybe<Scalars['Int']['output']>;
  statutChanges: Array<ConsultantHabilitationStatutChange>;
};


export type ConsultantHabilitationActionsBackOfficeArgs = {
  where?: InputMaybe<ConsultantHabilitationActionBackOfficeFilterInput>;
};


export type ConsultantHabilitationConsultantCartesDemarchageArgs = {
  where?: InputMaybe<ConsultantCarteDemarchageFilterInput>;
};


export type ConsultantHabilitationConsultantHabilitationInscriptionArgs = {
  where?: InputMaybe<ConsultantHabilitationInscriptionFilterInput>;
};


export type ConsultantHabilitationExpirationsArgs = {
  where?: InputMaybe<ConsultantHabilitationExpirationFilterInput>;
};


export type ConsultantHabilitationInvalidityReasonsArgs = {
  where?: InputMaybe<ConsultantHabilitationInvalidityReasonFilterInput>;
};


export type ConsultantHabilitationStatutChangesArgs = {
  where?: InputMaybe<ConsultantHabilitationStatutChangeFilterInput>;
};

export type ConsultantHabilitationActionBackOffice = {
  __typename?: 'ConsultantHabilitationActionBackOffice';
  active: Scalars['Boolean']['output'];
  consultantHabilitation: ConsultantHabilitation;
  consultantHabilitationId: Scalars['Long']['output'];
  consultantHabilitationTempStatut: Scalars['Boolean']['output'];
  dateAction: Scalars['DateTime']['output'];
  dateEcheance?: Maybe<Scalars['DateTime']['output']>;
  echeance: ConsultantHabilitationActionBackOfficeEcheance;
  echeanceCode: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type ConsultantHabilitationActionBackOfficeEcheance = {
  __typename?: 'ConsultantHabilitationActionBackOfficeEcheance';
  actionsBackOffice: Array<ConsultantHabilitationActionBackOffice>;
  code: Scalars['String']['output'];
};


export type ConsultantHabilitationActionBackOfficeEcheanceActionsBackOfficeArgs = {
  where?: InputMaybe<ConsultantHabilitationActionBackOfficeFilterInput>;
};

export type ConsultantHabilitationActionBackOfficeEcheanceFilterInput = {
  actionsBackOffice?: InputMaybe<ListFilterInputTypeOfConsultantHabilitationActionBackOfficeFilterInput>;
  and?: InputMaybe<Array<ConsultantHabilitationActionBackOfficeEcheanceFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantHabilitationActionBackOfficeEcheanceFilterInput>>;
};

export type ConsultantHabilitationActionBackOfficeFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<ConsultantHabilitationActionBackOfficeFilterInput>>;
  consultantHabilitation?: InputMaybe<ConsultantHabilitationFilterInput>;
  consultantHabilitationId?: InputMaybe<LongOperationFilterInput>;
  consultantHabilitationTempStatut?: InputMaybe<BooleanOperationFilterInput>;
  dateAction?: InputMaybe<DateTimeOperationFilterInput>;
  dateEcheance?: InputMaybe<DateTimeOperationFilterInput>;
  echeance?: InputMaybe<ConsultantHabilitationActionBackOfficeEcheanceFilterInput>;
  echeanceCode?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantHabilitationActionBackOfficeFilterInput>>;
};

export type ConsultantHabilitationExpiration = {
  __typename?: 'ConsultantHabilitationExpiration';
  dateExpiration: Scalars['DateTime']['output'];
  expirationReason: Scalars['String']['output'];
  habilitation: ConsultantHabilitation;
  habilitationId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
  reason: ConsultantHabilitationExpirationReason;
};

export type ConsultantHabilitationExpirationFilterInput = {
  and?: InputMaybe<Array<ConsultantHabilitationExpirationFilterInput>>;
  dateExpiration?: InputMaybe<DateTimeOperationFilterInput>;
  expirationReason?: InputMaybe<StringOperationFilterInput>;
  habilitation?: InputMaybe<ConsultantHabilitationFilterInput>;
  habilitationId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantHabilitationExpirationFilterInput>>;
  reason?: InputMaybe<ConsultantHabilitationExpirationReasonFilterInput>;
};

export type ConsultantHabilitationExpirationReason = {
  __typename?: 'ConsultantHabilitationExpirationReason';
  code: Scalars['String']['output'];
  expirations: Array<ConsultantHabilitationExpiration>;
};


export type ConsultantHabilitationExpirationReasonExpirationsArgs = {
  where?: InputMaybe<ConsultantHabilitationExpirationFilterInput>;
};

export type ConsultantHabilitationExpirationReasonFilterInput = {
  and?: InputMaybe<Array<ConsultantHabilitationExpirationReasonFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  expirations?: InputMaybe<ListFilterInputTypeOfConsultantHabilitationExpirationFilterInput>;
  or?: InputMaybe<Array<ConsultantHabilitationExpirationReasonFilterInput>>;
};

export type ConsultantHabilitationFilterInput = {
  actionsBackOffice?: InputMaybe<ListFilterInputTypeOfConsultantHabilitationActionBackOfficeFilterInput>;
  and?: InputMaybe<Array<ConsultantHabilitationFilterInput>>;
  associationProNom?: InputMaybe<StringOperationFilterInput>;
  cifPartenaireCode?: InputMaybe<StringOperationFilterInput>;
  codeHabilitation?: InputMaybe<StringOperationFilterInput>;
  consultant?: InputMaybe<ConsultantFilterInput>;
  consultantCartesDemarchage?: InputMaybe<ListFilterInputTypeOfConsultantCarteDemarchageFilterInput>;
  consultantHabilitationInscription?: InputMaybe<ListFilterInputTypeOfConsultantHabilitationInscriptionFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  consultantStatutJuridique?: InputMaybe<ConsultantStatutJuridiqueFilterInput>;
  consultantStatutJuridiqueId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateDebut?: InputMaybe<DateTimeOperationFilterInput>;
  dateFin?: InputMaybe<DateTimeOperationFilterInput>;
  datePremiereHabilitation?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  evaluationRequise?: InputMaybe<BooleanOperationFilterInput>;
  expirations?: InputMaybe<ListFilterInputTypeOfConsultantHabilitationExpirationFilterInput>;
  garantAdresse?: InputMaybe<StringOperationFilterInput>;
  garantNom?: InputMaybe<StringOperationFilterInput>;
  habilitation?: InputMaybe<HabilitationFilterInput>;
  habilitationId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  invalidityReasons?: InputMaybe<ListFilterInputTypeOfConsultantHabilitationInvalidityReasonFilterInput>;
  mediateur?: InputMaybe<StringOperationFilterInput>;
  mediateurAssu?: InputMaybe<StringOperationFilterInput>;
  mediateurCif?: InputMaybe<StringOperationFilterInput>;
  mediateurIOB?: InputMaybe<StringOperationFilterInput>;
  mediateurImmo?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantHabilitationFilterInput>>;
  partenaireCourtierFinancement1?: InputMaybe<StringOperationFilterInput>;
  partenaireCourtierFinancement2?: InputMaybe<StringOperationFilterInput>;
  statut?: InputMaybe<IntOperationFilterInput>;
  statutChanges?: InputMaybe<ListFilterInputTypeOfConsultantHabilitationStatutChangeFilterInput>;
};

export type ConsultantHabilitationInscription = {
  __typename?: 'ConsultantHabilitationInscription';
  carteTStellium?: Maybe<Scalars['Boolean']['output']>;
  consultantHabilitation?: Maybe<ConsultantHabilitation>;
  consultantHabilitationId?: Maybe<Scalars['Long']['output']>;
  consultantHabilitationInscriptionCategorie: Array<ConsultantHabilitationInscriptionCategorie>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  dateDebut?: Maybe<Scalars['DateTime']['output']>;
  dateDepot?: Maybe<Scalars['DateTime']['output']>;
  dateFin?: Maybe<Scalars['DateTime']['output']>;
  descriptionInscription?: Maybe<Scalars['String']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idHabConsInsc?: Maybe<Scalars['Long']['output']>;
  idSource?: Maybe<Scalars['String']['output']>;
  libelleInscription?: Maybe<Scalars['String']['output']>;
  numeroCarteTConsultant?: Maybe<Scalars['String']['output']>;
  numeroInscription?: Maybe<Scalars['String']['output']>;
  orgCIF?: Maybe<Scalars['String']['output']>;
  organismeCode?: Maybe<Scalars['String']['output']>;
  organismeCodeNavigation?: Maybe<Organisme>;
  pieceJointeConsultant: Array<PieceJointeConsultant>;
};


export type ConsultantHabilitationInscriptionConsultantHabilitationInscriptionCategorieArgs = {
  where?: InputMaybe<ConsultantHabilitationInscriptionCategorieFilterInput>;
};


export type ConsultantHabilitationInscriptionPieceJointeConsultantArgs = {
  where?: InputMaybe<PieceJointeConsultantFilterInput>;
};

export type ConsultantHabilitationInscriptionCategorie = {
  __typename?: 'ConsultantHabilitationInscriptionCategorie';
  consultantHabilitationInscription: ConsultantHabilitationInscription;
  consultantHabilitationInscriptionCategorieMandant: Array<ConsultantHabilitationInscriptionCategorieMandant>;
  consultantHabilitationInscriptionId: Scalars['Long']['output'];
  creationDate: Scalars['DateTime']['output'];
  dateDebut?: Maybe<Scalars['DateTime']['output']>;
  dateFin?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  habilitationInscriptionCategorie: HabilitationInscriptionCategorie;
  habilitationInscriptionCategorieId: Scalars['Int']['output'];
  id: Scalars['Long']['output'];
  rn_Create_User?: Maybe<Scalars['Long']['output']>;
  rn_Edit_User?: Maybe<Scalars['Long']['output']>;
};


export type ConsultantHabilitationInscriptionCategorieConsultantHabilitationInscriptionCategorieMandantArgs = {
  where?: InputMaybe<ConsultantHabilitationInscriptionCategorieMandantFilterInput>;
};

export type ConsultantHabilitationInscriptionCategorieFilterInput = {
  and?: InputMaybe<Array<ConsultantHabilitationInscriptionCategorieFilterInput>>;
  consultantHabilitationInscription?: InputMaybe<ConsultantHabilitationInscriptionFilterInput>;
  consultantHabilitationInscriptionCategorieMandant?: InputMaybe<ListFilterInputTypeOfConsultantHabilitationInscriptionCategorieMandantFilterInput>;
  consultantHabilitationInscriptionId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateDebut?: InputMaybe<DateTimeOperationFilterInput>;
  dateFin?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  habilitationInscriptionCategorie?: InputMaybe<HabilitationInscriptionCategorieFilterInput>;
  habilitationInscriptionCategorieId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantHabilitationInscriptionCategorieFilterInput>>;
  rn_Create_User?: InputMaybe<LongOperationFilterInput>;
  rn_Edit_User?: InputMaybe<LongOperationFilterInput>;
};

export type ConsultantHabilitationInscriptionCategorieMandant = {
  __typename?: 'ConsultantHabilitationInscriptionCategorieMandant';
  consultantHabilitationInscriptionCategorie?: Maybe<ConsultantHabilitationInscriptionCategorie>;
  consultantHabilitationInscriptionCategorieId?: Maybe<Scalars['Long']['output']>;
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  mandant?: Maybe<Scalars['String']['output']>;
};

export type ConsultantHabilitationInscriptionCategorieMandantFilterInput = {
  and?: InputMaybe<Array<ConsultantHabilitationInscriptionCategorieMandantFilterInput>>;
  consultantHabilitationInscriptionCategorie?: InputMaybe<ConsultantHabilitationInscriptionCategorieFilterInput>;
  consultantHabilitationInscriptionCategorieId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  mandant?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantHabilitationInscriptionCategorieMandantFilterInput>>;
};

export type ConsultantHabilitationInscriptionFilterInput = {
  and?: InputMaybe<Array<ConsultantHabilitationInscriptionFilterInput>>;
  carteTStellium?: InputMaybe<BooleanOperationFilterInput>;
  consultantHabilitation?: InputMaybe<ConsultantHabilitationFilterInput>;
  consultantHabilitationId?: InputMaybe<LongOperationFilterInput>;
  consultantHabilitationInscriptionCategorie?: InputMaybe<ListFilterInputTypeOfConsultantHabilitationInscriptionCategorieFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateDebut?: InputMaybe<DateTimeOperationFilterInput>;
  dateDepot?: InputMaybe<DateTimeOperationFilterInput>;
  dateFin?: InputMaybe<DateTimeOperationFilterInput>;
  descriptionInscription?: InputMaybe<StringOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idHabConsInsc?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  libelleInscription?: InputMaybe<StringOperationFilterInput>;
  numeroCarteTConsultant?: InputMaybe<StringOperationFilterInput>;
  numeroInscription?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantHabilitationInscriptionFilterInput>>;
  orgCIF?: InputMaybe<StringOperationFilterInput>;
  organismeCode?: InputMaybe<StringOperationFilterInput>;
  organismeCodeNavigation?: InputMaybe<OrganismeFilterInput>;
  pieceJointeConsultant?: InputMaybe<ListFilterInputTypeOfPieceJointeConsultantFilterInput>;
};

export type ConsultantHabilitationInvalidityReason = {
  __typename?: 'ConsultantHabilitationInvalidityReason';
  consultantHabilitation: ConsultantHabilitation;
  consultantHabilitationId: Scalars['Long']['output'];
  evaluationDate: Scalars['DateTime']['output'];
  id: Scalars['Long']['output'];
  reason: ConsultantHabilitationStatutChangeReason;
  reasonCode?: Maybe<Scalars['String']['output']>;
};

export type ConsultantHabilitationInvalidityReasonFilterInput = {
  and?: InputMaybe<Array<ConsultantHabilitationInvalidityReasonFilterInput>>;
  consultantHabilitation?: InputMaybe<ConsultantHabilitationFilterInput>;
  consultantHabilitationId?: InputMaybe<LongOperationFilterInput>;
  evaluationDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantHabilitationInvalidityReasonFilterInput>>;
  reason?: InputMaybe<ConsultantHabilitationStatutChangeReasonFilterInput>;
  reasonCode?: InputMaybe<StringOperationFilterInput>;
};

export type ConsultantHabilitationStatutChange = {
  __typename?: 'ConsultantHabilitationStatutChange';
  changeDate: Scalars['DateTime']['output'];
  changeReason: ConsultantHabilitationStatutChangeReason;
  changeReasonCode?: Maybe<Scalars['String']['output']>;
  changeType: ConsultantHabilitationStatutChangeType;
  changeTypeCode: Scalars['String']['output'];
  consultantHabilitation: ConsultantHabilitation;
  consultantHabilitationId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
};

export type ConsultantHabilitationStatutChangeFilterInput = {
  and?: InputMaybe<Array<ConsultantHabilitationStatutChangeFilterInput>>;
  changeDate?: InputMaybe<DateTimeOperationFilterInput>;
  changeReason?: InputMaybe<ConsultantHabilitationStatutChangeReasonFilterInput>;
  changeReasonCode?: InputMaybe<StringOperationFilterInput>;
  changeType?: InputMaybe<ConsultantHabilitationStatutChangeTypeFilterInput>;
  changeTypeCode?: InputMaybe<StringOperationFilterInput>;
  consultantHabilitation?: InputMaybe<ConsultantHabilitationFilterInput>;
  consultantHabilitationId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantHabilitationStatutChangeFilterInput>>;
};

export type ConsultantHabilitationStatutChangeReason = {
  __typename?: 'ConsultantHabilitationStatutChangeReason';
  code: Scalars['String']['output'];
  invalidityReasons: Array<ConsultantHabilitationInvalidityReason>;
  statutChanges: Array<ConsultantHabilitationStatutChange>;
};


export type ConsultantHabilitationStatutChangeReasonInvalidityReasonsArgs = {
  where?: InputMaybe<ConsultantHabilitationInvalidityReasonFilterInput>;
};


export type ConsultantHabilitationStatutChangeReasonStatutChangesArgs = {
  where?: InputMaybe<ConsultantHabilitationStatutChangeFilterInput>;
};

export enum ConsultantHabilitationStatutChangeReasonEnum {
  CarteDeDemarchage = 'CARTE_DE_DEMARCHAGE',
  CollabStefi = 'COLLAB_STEFI',
  FormationContinue = 'FORMATION_CONTINUE',
  FormationInitiale = 'FORMATION_INITIALE',
  HabilitationIob = 'HABILITATION_IOB',
  InitiativeBackOffice = 'INITIATIVE_BACK_OFFICE',
  Inscription = 'INSCRIPTION',
  Rcp = 'RCP',
  Resiliation = 'RESILIATION',
  StatutJuridique = 'STATUT_JURIDIQUE'
}

export type ConsultantHabilitationStatutChangeReasonEnumOperationFilterInput = {
  eq?: InputMaybe<ConsultantHabilitationStatutChangeReasonEnum>;
  in?: InputMaybe<Array<ConsultantHabilitationStatutChangeReasonEnum>>;
  neq?: InputMaybe<ConsultantHabilitationStatutChangeReasonEnum>;
  nin?: InputMaybe<Array<ConsultantHabilitationStatutChangeReasonEnum>>;
};

export type ConsultantHabilitationStatutChangeReasonFilterInput = {
  and?: InputMaybe<Array<ConsultantHabilitationStatutChangeReasonFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  invalidityReasons?: InputMaybe<ListFilterInputTypeOfConsultantHabilitationInvalidityReasonFilterInput>;
  or?: InputMaybe<Array<ConsultantHabilitationStatutChangeReasonFilterInput>>;
  statutChanges?: InputMaybe<ListFilterInputTypeOfConsultantHabilitationStatutChangeFilterInput>;
};

export type ConsultantHabilitationStatutChangeType = {
  __typename?: 'ConsultantHabilitationStatutChangeType';
  code: Scalars['String']['output'];
  statutChanges: Array<ConsultantHabilitationStatutChange>;
};


export type ConsultantHabilitationStatutChangeTypeStatutChangesArgs = {
  where?: InputMaybe<ConsultantHabilitationStatutChangeFilterInput>;
};

export type ConsultantHabilitationStatutChangeTypeFilterInput = {
  and?: InputMaybe<Array<ConsultantHabilitationStatutChangeTypeFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantHabilitationStatutChangeTypeFilterInput>>;
  statutChanges?: InputMaybe<ListFilterInputTypeOfConsultantHabilitationStatutChangeFilterInput>;
};

export type ConsultantHabilitationsFictives = {
  __typename?: 'ConsultantHabilitationsFictives';
  consultant: Consultant;
  consultantId: Scalars['Long']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  habilitation: Scalars['String']['output'];
  id: Scalars['Long']['output'];
};

export type ConsultantHabilitationsFictivesFilterInput = {
  and?: InputMaybe<Array<ConsultantHabilitationsFictivesFilterInput>>;
  consultant?: InputMaybe<ConsultantFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  habilitation?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantHabilitationsFictivesFilterInput>>;
};

export type ConsultantId = {
  __typename?: 'ConsultantId';
  code: Scalars['String']['output'];
  id: Scalars['Long']['output'];
};

export type ConsultantInput = {
  civiliteCode: Scalars['String']['input'];
  code: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  nom: Scalars['String']['input'];
  prenom: Scalars['String']['input'];
};

export type ConsultantMouvement = {
  __typename?: 'ConsultantMouvement';
  consultant: Consultant;
  consultantId: Scalars['Long']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  mouvement: Mouvement;
  mouvementId: Scalars['Long']['output'];
  roleConsultantMouvement: Scalars['Byte']['output'];
  roleConsultantMouvementNavigation: TypeConseillerCommande;
};

export type ConsultantMouvementFilterInput = {
  and?: InputMaybe<Array<ConsultantMouvementFilterInput>>;
  consultant?: InputMaybe<ConsultantFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  mouvement?: InputMaybe<MouvementFilterInput>;
  mouvementId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantMouvementFilterInput>>;
  roleConsultantMouvement?: InputMaybe<ByteOperationFilterInput>;
  roleConsultantMouvementNavigation?: InputMaybe<TypeConseillerCommandeFilterInput>;
};

export type ConsultantOrganisation = {
  __typename?: 'ConsultantOrganisation';
  constellation?: Maybe<Consultant>;
  constellationId?: Maybe<Scalars['Long']['output']>;
  consultant: Consultant;
  consultantId: Scalars['Long']['output'];
  etoile?: Maybe<Consultant>;
  etoileId?: Maybe<Scalars['Long']['output']>;
  galaxie?: Maybe<Consultant>;
  galaxieId?: Maybe<Scalars['Long']['output']>;
  manager?: Maybe<Consultant>;
  managerId?: Maybe<Scalars['Long']['output']>;
  nbMembresOrgan4Nvx?: Maybe<Scalars['Int']['output']>;
  nbMembresOrgan8Nvx?: Maybe<Scalars['Int']['output']>;
  planete?: Maybe<Consultant>;
  planeteId?: Maybe<Scalars['Long']['output']>;
  qualification?: Maybe<QualificationConsultant>;
  qualificationId?: Maybe<Scalars['String']['output']>;
  tauxRemuneration?: Maybe<TauxRemunerationConsultant>;
  tauxRemunerationId?: Maybe<Scalars['Int']['output']>;
  titre?: Maybe<TitreConsultant>;
  titreId?: Maybe<Scalars['String']['output']>;
};

export type ConsultantOrganisationFilterInput = {
  and?: InputMaybe<Array<ConsultantOrganisationFilterInput>>;
  constellation?: InputMaybe<ConsultantFilterInput>;
  constellationId?: InputMaybe<LongOperationFilterInput>;
  consultant?: InputMaybe<ConsultantFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  etoile?: InputMaybe<ConsultantFilterInput>;
  etoileId?: InputMaybe<LongOperationFilterInput>;
  galaxie?: InputMaybe<ConsultantFilterInput>;
  galaxieId?: InputMaybe<LongOperationFilterInput>;
  manager?: InputMaybe<ConsultantFilterInput>;
  managerId?: InputMaybe<LongOperationFilterInput>;
  nbMembresOrgan4Nvx?: InputMaybe<IntOperationFilterInput>;
  nbMembresOrgan8Nvx?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantOrganisationFilterInput>>;
  planete?: InputMaybe<ConsultantFilterInput>;
  planeteId?: InputMaybe<LongOperationFilterInput>;
  qualification?: InputMaybe<QualificationConsultantFilterInput>;
  qualificationId?: InputMaybe<StringOperationFilterInput>;
  tauxRemuneration?: InputMaybe<TauxRemunerationConsultantFilterInput>;
  tauxRemunerationId?: InputMaybe<IntOperationFilterInput>;
  titre?: InputMaybe<TitreConsultantFilterInput>;
  titreId?: InputMaybe<StringOperationFilterInput>;
};

export type ConsultantOrganisationSortInput = {
  constellation?: InputMaybe<ConsultantSortInput>;
  constellationId?: InputMaybe<SortEnumType>;
  consultant?: InputMaybe<ConsultantSortInput>;
  consultantId?: InputMaybe<SortEnumType>;
  etoile?: InputMaybe<ConsultantSortInput>;
  etoileId?: InputMaybe<SortEnumType>;
  galaxie?: InputMaybe<ConsultantSortInput>;
  galaxieId?: InputMaybe<SortEnumType>;
  manager?: InputMaybe<ConsultantSortInput>;
  managerId?: InputMaybe<SortEnumType>;
  nbMembresOrgan4Nvx?: InputMaybe<SortEnumType>;
  nbMembresOrgan8Nvx?: InputMaybe<SortEnumType>;
  planete?: InputMaybe<ConsultantSortInput>;
  planeteId?: InputMaybe<SortEnumType>;
  qualification?: InputMaybe<QualificationConsultantSortInput>;
  qualificationId?: InputMaybe<SortEnumType>;
  tauxRemuneration?: InputMaybe<TauxRemunerationConsultantSortInput>;
  tauxRemunerationId?: InputMaybe<SortEnumType>;
  titre?: InputMaybe<TitreConsultantSortInput>;
  titreId?: InputMaybe<SortEnumType>;
};

export type ConsultantRcp = {
  __typename?: 'ConsultantRcp';
  assureurRcpAdresse?: Maybe<Scalars['String']['output']>;
  assureurRcpNom?: Maybe<Scalars['String']['output']>;
  consultant: Consultant;
  consultantId: Scalars['Long']['output'];
  consultantStatutJuridique?: Maybe<ConsultantStatutJuridique>;
  consultantStatutJuridiqueId?: Maybe<Scalars['Long']['output']>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  dateAnnulation?: Maybe<Scalars['DateTime']['output']>;
  dateDebut?: Maybe<Scalars['DateTime']['output']>;
  dateFin?: Maybe<Scalars['DateTime']['output']>;
  documentId?: Maybe<Scalars['UUID']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  garantieRcpMontantParSinistre: Scalars['Decimal']['output'];
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  motifAnnulationId?: Maybe<Scalars['String']['output']>;
  organismeAssureur?: Maybe<OrganismeAssureurRcp>;
  organismeAssureurId?: Maybe<Scalars['Long']['output']>;
  typeRcpCode?: Maybe<Scalars['String']['output']>;
  typeRcpCodeNavigation?: Maybe<TypeRcp>;
};

export type ConsultantRcpFilterInput = {
  and?: InputMaybe<Array<ConsultantRcpFilterInput>>;
  assureurRcpAdresse?: InputMaybe<StringOperationFilterInput>;
  assureurRcpNom?: InputMaybe<StringOperationFilterInput>;
  consultant?: InputMaybe<ConsultantFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  consultantStatutJuridique?: InputMaybe<ConsultantStatutJuridiqueFilterInput>;
  consultantStatutJuridiqueId?: InputMaybe<LongOperationFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateAnnulation?: InputMaybe<DateTimeOperationFilterInput>;
  dateDebut?: InputMaybe<DateTimeOperationFilterInput>;
  dateFin?: InputMaybe<DateTimeOperationFilterInput>;
  documentId?: InputMaybe<UuidOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  garantieRcpMontantParSinistre?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  motifAnnulationId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantRcpFilterInput>>;
  organismeAssureur?: InputMaybe<OrganismeAssureurRcpFilterInput>;
  organismeAssureurId?: InputMaybe<LongOperationFilterInput>;
  typeRcpCode?: InputMaybe<StringOperationFilterInput>;
  typeRcpCodeNavigation?: InputMaybe<TypeRcpFilterInput>;
};

export type ConsultantSortInput = {
  affiliationDate?: InputMaybe<SortEnumType>;
  arianeId?: InputMaybe<SortEnumType>;
  civiliteCode?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  codeTier?: InputMaybe<SortEnumType>;
  commentairePeriodeJunior?: InputMaybe<SortEnumType>;
  consultantCommissionAdi?: InputMaybe<ConsultantCommissionAdiSortInput>;
  consultantOrganisationConsultant?: InputMaybe<ConsultantOrganisationSortInput>;
  createurId?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  date1AcquisitionDroit?: InputMaybe<SortEnumType>;
  date1Manager?: InputMaybe<SortEnumType>;
  date1VenteActee?: InputMaybe<SortEnumType>;
  date1VenteFinancement?: InputMaybe<SortEnumType>;
  date1VenteImmo?: InputMaybe<SortEnumType>;
  date1VentePlacement?: InputMaybe<SortEnumType>;
  dateAcquisitionDroit?: InputMaybe<SortEnumType>;
  dateAffiliationProdemial?: InputMaybe<SortEnumType>;
  dateContact?: InputMaybe<SortEnumType>;
  dateDemission?: InputMaybe<SortEnumType>;
  dateEntree?: InputMaybe<SortEnumType>;
  dateFinPeriodeJunior?: InputMaybe<SortEnumType>;
  dateFinValiditeAffiliation?: InputMaybe<SortEnumType>;
  dateSeminairePro?: InputMaybe<SortEnumType>;
  derniereDateExclusif?: InputMaybe<SortEnumType>;
  derniereDateNonExclusif?: InputMaybe<SortEnumType>;
  displayName?: InputMaybe<SortEnumType>;
  editeurId?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  eligilibleRenouvellement?: InputMaybe<SortEnumType>;
  exclusif?: InputMaybe<SortEnumType>;
  galaxy?: InputMaybe<ConsultantSortInput>;
  galaxyId?: InputMaybe<SortEnumType>;
  gerePar?: InputMaybe<SortEnumType>;
  habilitationALPSI?: InputMaybe<SortEnumType>;
  habilitationAssurance?: InputMaybe<SortEnumType>;
  habilitationCIF?: InputMaybe<SortEnumType>;
  habilitationIOB?: InputMaybe<SortEnumType>;
  habilitationImmo?: InputMaybe<SortEnumType>;
  habilitationPMR?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  idSource?: InputMaybe<SortEnumType>;
  manager?: InputMaybe<ConsultantSortInput>;
  managerId?: InputMaybe<SortEnumType>;
  mandatAutofacFinancement?: InputMaybe<SortEnumType>;
  mandatAutofacPlacement?: InputMaybe<SortEnumType>;
  mandatAutofacTotal?: InputMaybe<SortEnumType>;
  motifResiliationCode?: InputMaybe<SortEnumType>;
  motifResiliationCodeNavigation?: InputMaybe<MotifResiliationConsultantSortInput>;
  nbAmbassadeurs?: InputMaybe<SortEnumType>;
  nbRecommandations?: InputMaybe<SortEnumType>;
  nom?: InputMaybe<SortEnumType>;
  origineSaisie?: InputMaybe<SortEnumType>;
  origineSaisieNavigation?: InputMaybe<OrigineDataSortInput>;
  parrain?: InputMaybe<ConsultantSortInput>;
  parrainId?: InputMaybe<SortEnumType>;
  peutParainner?: InputMaybe<SortEnumType>;
  prenom?: InputMaybe<SortEnumType>;
  qualificationCode?: InputMaybe<SortEnumType>;
  qualificationCodeNavigation?: InputMaybe<QualificationConsultantSortInput>;
  raisonSociale?: InputMaybe<SortEnumType>;
  reponseRenouvellement?: InputMaybe<SortEnumType>;
  resiliationDate?: InputMaybe<SortEnumType>;
  souhaiteCollaborerAvecStelliumFi?: InputMaybe<SortEnumType>;
  statutCode?: InputMaybe<SortEnumType>;
  statutCodeNavigation?: InputMaybe<StatutConsultantSortInput>;
  tauxRemuneration?: InputMaybe<SortEnumType>;
  teteReseau?: InputMaybe<ConsultantSortInput>;
  teteReseauId?: InputMaybe<SortEnumType>;
  titreCode?: InputMaybe<SortEnumType>;
  titreCodeNavigation?: InputMaybe<TitreConsultantSortInput>;
  totalDebours?: InputMaybe<SortEnumType>;
};

export type ConsultantStatutCommercial = {
  __typename?: 'ConsultantStatutCommercial';
  consultant: Consultant;
  consultantId: Scalars['Long']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  stacActif: Scalars['Int']['output'];
  stacDateDebut: Scalars['DateTime']['output'];
  stacDateFin?: Maybe<Scalars['DateTime']['output']>;
  stacMotifAcquisitionStatut: Scalars['String']['output'];
  statutCommercialCode: Scalars['String']['output'];
  statutCommercialCodeNavigation: StatutCommercial;
};

export type ConsultantStatutCommercialFilterInput = {
  and?: InputMaybe<Array<ConsultantStatutCommercialFilterInput>>;
  consultant?: InputMaybe<ConsultantFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantStatutCommercialFilterInput>>;
  stacActif?: InputMaybe<IntOperationFilterInput>;
  stacDateDebut?: InputMaybe<DateTimeOperationFilterInput>;
  stacDateFin?: InputMaybe<DateTimeOperationFilterInput>;
  stacMotifAcquisitionStatut?: InputMaybe<StringOperationFilterInput>;
  statutCommercialCode?: InputMaybe<StringOperationFilterInput>;
  statutCommercialCodeNavigation?: InputMaybe<StatutCommercialFilterInput>;
};

export type ConsultantStatutJuridique = {
  __typename?: 'ConsultantStatutJuridique';
  actif: Scalars['Boolean']['output'];
  adressePro: Adresse;
  adresseProId: Scalars['Long']['output'];
  assujettiTVACode?: Maybe<Scalars['String']['output']>;
  assujettiTVACodeNavigation?: Maybe<AssujettiTva>;
  cessionHistoCommande: Array<CessionHistoCommande>;
  changes: Array<ConsultantStatutJuridiqueChange>;
  codeTier?: Maybe<Scalars['String']['output']>;
  commissionDifferenceImmo: Scalars['Boolean']['output'];
  commissionDifferencePlacement: Scalars['Boolean']['output'];
  consultant: Consultant;
  consultantContrat: Array<ConsultantContrat>;
  consultantHabilitation: Array<ConsultantHabilitation>;
  consultantId: Scalars['Long']['output'];
  consultantRcp: Array<ConsultantRcp>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  dateAttest3558?: Maybe<Scalars['DateTime']['output']>;
  dateAttestHonneur?: Maybe<Scalars['DateTime']['output']>;
  dateAttestKbisPerso?: Maybe<Scalars['DateTime']['output']>;
  dateAttestUrssafSociete?: Maybe<Scalars['DateTime']['output']>;
  dateKBISOriginal?: Maybe<Scalars['DateTime']['output']>;
  dateUrssafPer?: Maybe<Scalars['DateTime']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  etatStatutCode: Scalars['String']['output'];
  etatStatutCodeNavigation: EtatStatut;
  facture: Array<Facture>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  lienConsultantStatutJuridiqueTypeHabilitation: Array<LienConsultantStatutJuridiqueTypeHabilitation>;
  nomCommercial?: Maybe<Scalars['String']['output']>;
  numeroTva?: Maybe<Scalars['String']['output']>;
  raisonSociale?: Maybe<Scalars['String']['output']>;
  siret?: Maybe<Scalars['String']['output']>;
  statutJuridiqueCode: Scalars['String']['output'];
  statutJuridiqueCodeNavigation: StatutJuridique;
  typeSocieteCode?: Maybe<Scalars['String']['output']>;
  typeSocieteCodeNavigation?: Maybe<TypeSociete>;
  villeSiret?: Maybe<Scalars['String']['output']>;
};


export type ConsultantStatutJuridiqueCessionHistoCommandeArgs = {
  where?: InputMaybe<CessionHistoCommandeFilterInput>;
};


export type ConsultantStatutJuridiqueChangesArgs = {
  where?: InputMaybe<ConsultantStatutJuridiqueChangeFilterInput>;
};


export type ConsultantStatutJuridiqueConsultantContratArgs = {
  where?: InputMaybe<ConsultantContratFilterInput>;
};


export type ConsultantStatutJuridiqueConsultantHabilitationArgs = {
  where?: InputMaybe<ConsultantHabilitationFilterInput>;
};


export type ConsultantStatutJuridiqueConsultantRcpArgs = {
  where?: InputMaybe<ConsultantRcpFilterInput>;
};


export type ConsultantStatutJuridiqueFactureArgs = {
  where?: InputMaybe<FactureFilterInput>;
};


export type ConsultantStatutJuridiqueLienConsultantStatutJuridiqueTypeHabilitationArgs = {
  where?: InputMaybe<LienConsultantStatutJuridiqueTypeHabilitationFilterInput>;
};

export type ConsultantStatutJuridiqueChange = {
  __typename?: 'ConsultantStatutJuridiqueChange';
  changeDate: Scalars['DateTime']['output'];
  changeReason: ConsultantStatutJuridiqueChangeReason;
  changeReasonCode: Scalars['String']['output'];
  consultantStatutJuridique: ConsultantStatutJuridique;
  consultantStatutJuridiqueId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
};

export type ConsultantStatutJuridiqueChangeFilterInput = {
  and?: InputMaybe<Array<ConsultantStatutJuridiqueChangeFilterInput>>;
  changeDate?: InputMaybe<DateTimeOperationFilterInput>;
  changeReason?: InputMaybe<ConsultantStatutJuridiqueChangeReasonFilterInput>;
  changeReasonCode?: InputMaybe<StringOperationFilterInput>;
  consultantStatutJuridique?: InputMaybe<ConsultantStatutJuridiqueFilterInput>;
  consultantStatutJuridiqueId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantStatutJuridiqueChangeFilterInput>>;
};

export type ConsultantStatutJuridiqueChangeReason = {
  __typename?: 'ConsultantStatutJuridiqueChangeReason';
  code: Scalars['String']['output'];
  statutJuridiqueChanges: Array<ConsultantStatutJuridiqueChange>;
};


export type ConsultantStatutJuridiqueChangeReasonStatutJuridiqueChangesArgs = {
  where?: InputMaybe<ConsultantStatutJuridiqueChangeFilterInput>;
};

export type ConsultantStatutJuridiqueChangeReasonFilterInput = {
  and?: InputMaybe<Array<ConsultantStatutJuridiqueChangeReasonFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantStatutJuridiqueChangeReasonFilterInput>>;
  statutJuridiqueChanges?: InputMaybe<ListFilterInputTypeOfConsultantStatutJuridiqueChangeFilterInput>;
};

export type ConsultantStatutJuridiqueFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  adressePro?: InputMaybe<AdresseFilterInput>;
  adresseProId?: InputMaybe<LongOperationFilterInput>;
  and?: InputMaybe<Array<ConsultantStatutJuridiqueFilterInput>>;
  assujettiTVACode?: InputMaybe<StringOperationFilterInput>;
  assujettiTVACodeNavigation?: InputMaybe<AssujettiTvaFilterInput>;
  cessionHistoCommande?: InputMaybe<ListFilterInputTypeOfCessionHistoCommandeFilterInput>;
  changes?: InputMaybe<ListFilterInputTypeOfConsultantStatutJuridiqueChangeFilterInput>;
  codeTier?: InputMaybe<StringOperationFilterInput>;
  commissionDifferenceImmo?: InputMaybe<BooleanOperationFilterInput>;
  commissionDifferencePlacement?: InputMaybe<BooleanOperationFilterInput>;
  consultant?: InputMaybe<ConsultantFilterInput>;
  consultantContrat?: InputMaybe<ListFilterInputTypeOfConsultantContratFilterInput>;
  consultantHabilitation?: InputMaybe<ListFilterInputTypeOfConsultantHabilitationFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  consultantRcp?: InputMaybe<ListFilterInputTypeOfConsultantRcpFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateAttest3558?: InputMaybe<DateTimeOperationFilterInput>;
  dateAttestHonneur?: InputMaybe<DateTimeOperationFilterInput>;
  dateAttestKbisPerso?: InputMaybe<DateTimeOperationFilterInput>;
  dateAttestUrssafSociete?: InputMaybe<DateTimeOperationFilterInput>;
  dateKBISOriginal?: InputMaybe<DateTimeOperationFilterInput>;
  dateUrssafPer?: InputMaybe<DateTimeOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  etatStatutCode?: InputMaybe<StringOperationFilterInput>;
  etatStatutCodeNavigation?: InputMaybe<EtatStatutFilterInput>;
  facture?: InputMaybe<ListFilterInputTypeOfFactureFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  lienConsultantStatutJuridiqueTypeHabilitation?: InputMaybe<ListFilterInputTypeOfLienConsultantStatutJuridiqueTypeHabilitationFilterInput>;
  nomCommercial?: InputMaybe<StringOperationFilterInput>;
  numeroTva?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ConsultantStatutJuridiqueFilterInput>>;
  raisonSociale?: InputMaybe<StringOperationFilterInput>;
  siret?: InputMaybe<StringOperationFilterInput>;
  statutJuridiqueCode?: InputMaybe<StringOperationFilterInput>;
  statutJuridiqueCodeNavigation?: InputMaybe<StatutJuridiqueFilterInput>;
  typeSocieteCode?: InputMaybe<StringOperationFilterInput>;
  typeSocieteCodeNavigation?: InputMaybe<TypeSocieteFilterInput>;
  villeSiret?: InputMaybe<StringOperationFilterInput>;
};

/** A segment of a collection. */
export type ConsultantsByNamePaginatedCollectionSegment = {
  __typename?: 'ConsultantsByNamePaginatedCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Consultant>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type ConsultantsPaginatedCollectionSegment = {
  __typename?: 'ConsultantsPaginatedCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Consultant>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type Contact = {
  __typename?: 'Contact';
  adresse: Array<Adresse>;
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  email: Array<Email>;
  estBenefEffectif: Scalars['Boolean']['output'];
  estInterlocuteurPrincipal: Scalars['Boolean']['output'];
  fonction?: Maybe<FonctionContact>;
  fonctionId?: Maybe<Scalars['Byte']['output']>;
  id: Scalars['Long']['output'];
  idSourceARInvestisseurEntreprise?: Maybe<Scalars['Long']['output']>;
  idSourceContact?: Maybe<Scalars['Long']['output']>;
  idSourceOfInvPP?: Maybe<Scalars['Long']['output']>;
  partenaire?: Maybe<Partenaire>;
  partenaireId?: Maybe<Scalars['Long']['output']>;
  personneMorale?: Maybe<PersonneMorale>;
  personneMoraleId?: Maybe<Scalars['Long']['output']>;
  personnePhysique?: Maybe<PersonnePhysique>;
  personnePhysiqueId?: Maybe<Scalars['Long']['output']>;
  telephone: Array<Telephone>;
};


export type ContactAdresseArgs = {
  where?: InputMaybe<AdresseFilterInput>;
};


export type ContactEmailArgs = {
  where?: InputMaybe<EmailFilterInput>;
};


export type ContactTelephoneArgs = {
  where?: InputMaybe<TelephoneFilterInput>;
};

export type ContactFilterInput = {
  adresse?: InputMaybe<ListFilterInputTypeOfAdresseFilterInput>;
  and?: InputMaybe<Array<ContactFilterInput>>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  email?: InputMaybe<ListFilterInputTypeOfEmailFilterInput>;
  estBenefEffectif?: InputMaybe<BooleanOperationFilterInput>;
  estInterlocuteurPrincipal?: InputMaybe<BooleanOperationFilterInput>;
  fonction?: InputMaybe<FonctionContactFilterInput>;
  fonctionId?: InputMaybe<ByteOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSourceARInvestisseurEntreprise?: InputMaybe<LongOperationFilterInput>;
  idSourceContact?: InputMaybe<LongOperationFilterInput>;
  idSourceOfInvPP?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<ContactFilterInput>>;
  partenaire?: InputMaybe<PartenaireFilterInput>;
  partenaireId?: InputMaybe<LongOperationFilterInput>;
  personneMorale?: InputMaybe<PersonneMoraleFilterInput>;
  personneMoraleId?: InputMaybe<LongOperationFilterInput>;
  personnePhysique?: InputMaybe<PersonnePhysiqueFilterInput>;
  personnePhysiqueId?: InputMaybe<LongOperationFilterInput>;
  telephone?: InputMaybe<ListFilterInputTypeOfTelephoneFilterInput>;
};

export type CreateDraftConseilConfigInput = {
  coAId: Scalars['String']['input'];
  commentaireDeVersion?: InputMaybe<Scalars['String']['input']>;
  dateObsolescenceVersionPrecedente?: InputMaybe<Scalars['DateTime']['input']>;
  isMajeurVersion: Scalars['Boolean']['input'];
  templateName?: InputMaybe<Scalars['String']['input']>;
  templateUrl?: InputMaybe<Scalars['String']['input']>;
  useLatestReferenceConfig?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateFicheConseilInput = {
  conseilConfigId: Scalars['String']['input'];
  enveloppe: EnveloppeProduitWithLibelleInput;
  investisseurType: InvestisseurType;
  natureOperation: NatureOperationWithLibelleInput;
};

export type CreateStorageFileInput = {
  denomination?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
};

export type Cursus = {
  __typename?: 'Cursus';
  codeFamille?: Maybe<Scalars['Byte']['output']>;
  codeFamilleNavigation?: Maybe<FormationType>;
  codeSaison?: Maybe<Scalars['Byte']['output']>;
  codeSaisonNavigation?: Maybe<FormationSaison>;
  creationDate: Scalars['DateTime']['output'];
  cursusCycleCourt: Array<CursusCycleCourt>;
  cursusFormation: Array<CursusFormation>;
  dateDebutValidite?: Maybe<Scalars['DateTime']['output']>;
  dateFinValidite?: Maybe<Scalars['DateTime']['output']>;
  dureeHeure?: Maybe<Scalars['Decimal']['output']>;
  dureeJour?: Maybe<Scalars['Decimal']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['Long']['output']>;
  nom: Scalars['String']['output'];
  obligatoire?: Maybe<Scalars['Byte']['output']>;
  reference: Scalars['String']['output'];
};


export type CursusCursusCycleCourtArgs = {
  where?: InputMaybe<CursusCycleCourtFilterInput>;
};


export type CursusCursusFormationArgs = {
  where?: InputMaybe<CursusFormationFilterInput>;
};

export type CursusCycleCourt = {
  __typename?: 'CursusCycleCourt';
  creationDate: Scalars['DateTime']['output'];
  cursus: Cursus;
  cursusId: Scalars['Long']['output'];
  cycleCourt: CycleCourt;
  cycleCourtId: Scalars['Long']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
};

export type CursusCycleCourtFilterInput = {
  and?: InputMaybe<Array<CursusCycleCourtFilterInput>>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  cursus?: InputMaybe<CursusFilterInput>;
  cursusId?: InputMaybe<LongOperationFilterInput>;
  cycleCourt?: InputMaybe<CycleCourtFilterInput>;
  cycleCourtId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<CursusCycleCourtFilterInput>>;
};

export type CursusFilterInput = {
  and?: InputMaybe<Array<CursusFilterInput>>;
  codeFamille?: InputMaybe<ByteOperationFilterInput>;
  codeFamilleNavigation?: InputMaybe<FormationTypeFilterInput>;
  codeSaison?: InputMaybe<ByteOperationFilterInput>;
  codeSaisonNavigation?: InputMaybe<FormationSaisonFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  cursusCycleCourt?: InputMaybe<ListFilterInputTypeOfCursusCycleCourtFilterInput>;
  cursusFormation?: InputMaybe<ListFilterInputTypeOfCursusFormationFilterInput>;
  dateDebutValidite?: InputMaybe<DateTimeOperationFilterInput>;
  dateFinValidite?: InputMaybe<DateTimeOperationFilterInput>;
  dureeHeure?: InputMaybe<DecimalOperationFilterInput>;
  dureeJour?: InputMaybe<DecimalOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<LongOperationFilterInput>;
  nom?: InputMaybe<StringOperationFilterInput>;
  obligatoire?: InputMaybe<ByteOperationFilterInput>;
  or?: InputMaybe<Array<CursusFilterInput>>;
  reference?: InputMaybe<StringOperationFilterInput>;
};

export type CursusFormation = {
  __typename?: 'CursusFormation';
  creationDate: Scalars['DateTime']['output'];
  cursus: Cursus;
  cursusId: Scalars['Long']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  formation: ActionDeFormation;
  formationId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
};

export type CursusFormationFilterInput = {
  and?: InputMaybe<Array<CursusFormationFilterInput>>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  cursus?: InputMaybe<CursusFilterInput>;
  cursusId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  formation?: InputMaybe<ActionDeFormationFilterInput>;
  formationId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<CursusFormationFilterInput>>;
};

export type CycleCourt = {
  __typename?: 'CycleCourt';
  codeEtat?: Maybe<Scalars['Byte']['output']>;
  codeEtatNavigation?: Maybe<SessionEtat>;
  codeGenre?: Maybe<Scalars['Byte']['output']>;
  codeGenreNavigation?: Maybe<SessionGenre>;
  creationDate: Scalars['DateTime']['output'];
  cursusCycleCourt: Array<CursusCycleCourt>;
  dateDebut?: Maybe<Scalars['DateTime']['output']>;
  dateFin?: Maybe<Scalars['DateTime']['output']>;
  dureeHeure?: Maybe<Scalars['Decimal']['output']>;
  dureeJour?: Maybe<Scalars['Decimal']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['Long']['output']>;
  inscriptionCycleCourt: Array<InscriptionCycleCourt>;
  nom: Scalars['String']['output'];
};


export type CycleCourtCursusCycleCourtArgs = {
  where?: InputMaybe<CursusCycleCourtFilterInput>;
};


export type CycleCourtInscriptionCycleCourtArgs = {
  where?: InputMaybe<InscriptionCycleCourtFilterInput>;
};

export type CycleCourtFilterInput = {
  and?: InputMaybe<Array<CycleCourtFilterInput>>;
  codeEtat?: InputMaybe<ByteOperationFilterInput>;
  codeEtatNavigation?: InputMaybe<SessionEtatFilterInput>;
  codeGenre?: InputMaybe<ByteOperationFilterInput>;
  codeGenreNavigation?: InputMaybe<SessionGenreFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  cursusCycleCourt?: InputMaybe<ListFilterInputTypeOfCursusCycleCourtFilterInput>;
  dateDebut?: InputMaybe<DateTimeOperationFilterInput>;
  dateFin?: InputMaybe<DateTimeOperationFilterInput>;
  dureeHeure?: InputMaybe<DecimalOperationFilterInput>;
  dureeJour?: InputMaybe<DecimalOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<LongOperationFilterInput>;
  inscriptionCycleCourt?: InputMaybe<ListFilterInputTypeOfInscriptionCycleCourtFilterInput>;
  nom?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CycleCourtFilterInput>>;
};

export type DateOperationFilterInput = {
  eq?: InputMaybe<Scalars['Date']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  neq?: InputMaybe<Scalars['Date']['input']>;
  ngt?: InputMaybe<Scalars['Date']['input']>;
  ngte?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  nlt?: InputMaybe<Scalars['Date']['input']>;
  nlte?: InputMaybe<Scalars['Date']['input']>;
};

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  ngt?: InputMaybe<Scalars['DateTime']['input']>;
  ngte?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nlt?: InputMaybe<Scalars['DateTime']['input']>;
  nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DecimalOperationFilterInput = {
  eq?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  neq?: InputMaybe<Scalars['Decimal']['input']>;
  ngt?: InputMaybe<Scalars['Decimal']['input']>;
  ngte?: InputMaybe<Scalars['Decimal']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  nlt?: InputMaybe<Scalars['Decimal']['input']>;
  nlte?: InputMaybe<Scalars['Decimal']['input']>;
};

export type DeleteRelationInput = {
  personnePhysiqueId: Scalars['Long']['input'];
  relationPersonnePhysiqueIds: Array<Scalars['Long']['input']>;
  typeRelation?: InputMaybe<Scalars['String']['input']>;
};

export type Departement = {
  __typename?: 'Departement';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  nom?: Maybe<Scalars['String']['output']>;
  organisme: Array<Organisme>;
  personnePhysique: Array<PersonnePhysique>;
};


export type DepartementOrganismeArgs = {
  where?: InputMaybe<OrganismeFilterInput>;
};


export type DepartementPersonnePhysiqueArgs = {
  where?: InputMaybe<PersonnePhysiqueFilterInput>;
};

export type DepartementFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<DepartementFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  nom?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DepartementFilterInput>>;
  organisme?: InputMaybe<ListFilterInputTypeOfOrganismeFilterInput>;
  personnePhysique?: InputMaybe<ListFilterInputTypeOfPersonnePhysiqueFilterInput>;
};

export type DepartementSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  nom?: InputMaybe<SortEnumType>;
};

export type DetenteurPatrimoineActif = {
  __typename?: 'DetenteurPatrimoineActif';
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  detentionNuPropriete?: Maybe<Scalars['Decimal']['output']>;
  detentionPleinePropriete?: Maybe<Scalars['Decimal']['output']>;
  detentionUsufruit?: Maybe<Scalars['Decimal']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  investisseur?: Maybe<Investisseur>;
  investisseurId?: Maybe<Scalars['Long']['output']>;
  patrimoineActif?: Maybe<PatrimoineActif>;
  patrimoineActifId?: Maybe<Scalars['Long']['output']>;
  personnePhysique?: Maybe<PersonnePhysique>;
  personnePhysiqueId?: Maybe<Scalars['Long']['output']>;
};

export type DetenteurPatrimoineActifFilterInput = {
  and?: InputMaybe<Array<DetenteurPatrimoineActifFilterInput>>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  detentionNuPropriete?: InputMaybe<DecimalOperationFilterInput>;
  detentionPleinePropriete?: InputMaybe<DecimalOperationFilterInput>;
  detentionUsufruit?: InputMaybe<DecimalOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  investisseur?: InputMaybe<InvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<DetenteurPatrimoineActifFilterInput>>;
  patrimoineActif?: InputMaybe<PatrimoineActifFilterInput>;
  patrimoineActifId?: InputMaybe<LongOperationFilterInput>;
  personnePhysique?: InputMaybe<PersonnePhysiqueFilterInput>;
  personnePhysiqueId?: InputMaybe<LongOperationFilterInput>;
};

export type DetenteurPatrimoineChargeRevenu = {
  __typename?: 'DetenteurPatrimoineChargeRevenu';
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  investisseur: Investisseur;
  investisseurId: Scalars['Long']['output'];
  patrimoineChargeRevenu: PatrimoineChargeRevenu;
  patrimoineChargeRevenuId: Scalars['Long']['output'];
  tauxDetention?: Maybe<Scalars['Decimal']['output']>;
};

export type DetenteurPatrimoineChargeRevenuFilterInput = {
  and?: InputMaybe<Array<DetenteurPatrimoineChargeRevenuFilterInput>>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  investisseur?: InputMaybe<InvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<DetenteurPatrimoineChargeRevenuFilterInput>>;
  patrimoineChargeRevenu?: InputMaybe<PatrimoineChargeRevenuFilterInput>;
  patrimoineChargeRevenuId?: InputMaybe<LongOperationFilterInput>;
  tauxDetention?: InputMaybe<DecimalOperationFilterInput>;
};

export type DetenteurPatrimoinePassif = {
  __typename?: 'DetenteurPatrimoinePassif';
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  investisseur: Investisseur;
  investisseurId: Scalars['Long']['output'];
  patrimoinePassif: PatrimoinePassif;
  patrimoinePassifId: Scalars['Long']['output'];
  quotePartAdi?: Maybe<Scalars['Decimal']['output']>;
  tauxDetention: Scalars['Decimal']['output'];
};

export type DetenteurPatrimoinePassifFilterInput = {
  and?: InputMaybe<Array<DetenteurPatrimoinePassifFilterInput>>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  investisseur?: InputMaybe<InvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<DetenteurPatrimoinePassifFilterInput>>;
  patrimoinePassif?: InputMaybe<PatrimoinePassifFilterInput>;
  patrimoinePassifId?: InputMaybe<LongOperationFilterInput>;
  quotePartAdi?: InputMaybe<DecimalOperationFilterInput>;
  tauxDetention?: InputMaybe<DecimalOperationFilterInput>;
};

export type Detention = {
  __typename?: 'Detention';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  patrimoineActif: Array<PatrimoineActif>;
  patrimoineChargeRevenu: Array<PatrimoineChargeRevenu>;
  patrimoinePassif: Array<PatrimoinePassif>;
};


export type DetentionPatrimoineActifArgs = {
  where?: InputMaybe<PatrimoineActifFilterInput>;
};


export type DetentionPatrimoineChargeRevenuArgs = {
  where?: InputMaybe<PatrimoineChargeRevenuFilterInput>;
};


export type DetentionPatrimoinePassifArgs = {
  where?: InputMaybe<PatrimoinePassifFilterInput>;
};

export type DetentionFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<DetentionFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DetentionFilterInput>>;
  patrimoineActif?: InputMaybe<ListFilterInputTypeOfPatrimoineActifFilterInput>;
  patrimoineChargeRevenu?: InputMaybe<ListFilterInputTypeOfPatrimoineChargeRevenuFilterInput>;
  patrimoinePassif?: InputMaybe<ListFilterInputTypeOfPatrimoinePassifFilterInput>;
};

export enum DisponibiliteEpargne {
  ConserverAvecRetraits = 'CONSERVER_AVEC_RETRAITS',
  ConserverSansRetrait = 'CONSERVER_SANS_RETRAIT',
  DedieRetraite = 'DEDIE_RETRAITE',
  ToujoursDispo = 'TOUJOURS_DISPO',
  Transmission = 'TRANSMISSION'
}

export type DisponibiliteEpargneOperationFilterInput = {
  eq?: InputMaybe<DisponibiliteEpargne>;
  in?: InputMaybe<Array<DisponibiliteEpargne>>;
  neq?: InputMaybe<DisponibiliteEpargne>;
  nin?: InputMaybe<Array<DisponibiliteEpargne>>;
};

export type DisponibiliteEpargneOption = {
  __typename?: 'DisponibiliteEpargneOption';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  value: DisponibiliteEpargne;
};

export type DisponibiliteEpargneOptionFilterInput = {
  and?: InputMaybe<Array<DisponibiliteEpargneOptionFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  label?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DisponibiliteEpargneOptionFilterInput>>;
  value?: InputMaybe<DisponibiliteEpargneOperationFilterInput>;
};

export type DisponibiliteEpargneOptionInput = {
  id: Scalars['String']['input'];
  label: Scalars['String']['input'];
  value: DisponibiliteEpargne;
};

export type Disposition = {
  __typename?: 'Disposition';
  autresDispositions?: Maybe<Scalars['Boolean']['output']>;
  autresDonation?: Maybe<Scalars['Boolean']['output']>;
  beneficiaire?: Maybe<Scalars['String']['output']>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  dateDonation?: Maybe<Scalars['LocalDate']['output']>;
  demembrement?: Maybe<Scalars['String']['output']>;
  donationConjoint?: Maybe<Scalars['Boolean']['output']>;
  donationDernierVivant?: Maybe<Scalars['Boolean']['output']>;
  donationPartage?: Maybe<Scalars['Boolean']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  forme?: Maybe<Scalars['String']['output']>;
  idSource?: Maybe<Scalars['String']['output']>;
  legsParticuliers?: Maybe<Scalars['Boolean']['output']>;
  legsUniversels?: Maybe<Scalars['Boolean']['output']>;
  montant?: Maybe<Scalars['Int']['output']>;
  note: Array<Note>;
  objet?: Maybe<Scalars['String']['output']>;
  personnePhysique: PersonnePhysique;
  personnePhysiqueId: Scalars['Long']['output'];
};


export type DispositionNoteArgs = {
  where?: InputMaybe<NoteFilterInput>;
};

export type DispositionFilterInput = {
  and?: InputMaybe<Array<DispositionFilterInput>>;
  autresDispositions?: InputMaybe<BooleanOperationFilterInput>;
  autresDonation?: InputMaybe<BooleanOperationFilterInput>;
  beneficiaire?: InputMaybe<StringOperationFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateDonation?: InputMaybe<LocalDateOperationFilterInput>;
  demembrement?: InputMaybe<StringOperationFilterInput>;
  donationConjoint?: InputMaybe<BooleanOperationFilterInput>;
  donationDernierVivant?: InputMaybe<BooleanOperationFilterInput>;
  donationPartage?: InputMaybe<BooleanOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  forme?: InputMaybe<StringOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  legsParticuliers?: InputMaybe<BooleanOperationFilterInput>;
  legsUniversels?: InputMaybe<BooleanOperationFilterInput>;
  montant?: InputMaybe<IntOperationFilterInput>;
  note?: InputMaybe<ListFilterInputTypeOfNoteFilterInput>;
  objet?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DispositionFilterInput>>;
  personnePhysique?: InputMaybe<PersonnePhysiqueFilterInput>;
  personnePhysiqueId?: InputMaybe<LongOperationFilterInput>;
};

export type DispositionSortInput = {
  autresDispositions?: InputMaybe<SortEnumType>;
  autresDonation?: InputMaybe<SortEnumType>;
  beneficiaire?: InputMaybe<SortEnumType>;
  createurId?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  dateDonation?: InputMaybe<SortEnumType>;
  demembrement?: InputMaybe<SortEnumType>;
  donationConjoint?: InputMaybe<SortEnumType>;
  donationDernierVivant?: InputMaybe<SortEnumType>;
  donationPartage?: InputMaybe<SortEnumType>;
  editeurId?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  forme?: InputMaybe<SortEnumType>;
  idSource?: InputMaybe<SortEnumType>;
  legsParticuliers?: InputMaybe<SortEnumType>;
  legsUniversels?: InputMaybe<SortEnumType>;
  montant?: InputMaybe<SortEnumType>;
  objet?: InputMaybe<SortEnumType>;
  personnePhysique?: InputMaybe<PersonnePhysiqueSortInput>;
  personnePhysiqueId?: InputMaybe<SortEnumType>;
};

export type Distinction = {
  __typename?: 'Distinction';
  code: Scalars['Byte']['output'];
  consultantDistinction: Array<ConsultantDistinction>;
  creationDate: Scalars['DateTime']['output'];
  distinctionCategorie: Scalars['Byte']['output'];
  distinctionCategorieNavigation: DistinctionCategorie;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};


export type DistinctionConsultantDistinctionArgs = {
  where?: InputMaybe<ConsultantDistinctionFilterInput>;
};

export type DistinctionCategorie = {
  __typename?: 'DistinctionCategorie';
  code: Scalars['Byte']['output'];
  consultantDistinction: Array<ConsultantDistinction>;
  creationDate: Scalars['DateTime']['output'];
  distinction: Array<Distinction>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};


export type DistinctionCategorieConsultantDistinctionArgs = {
  where?: InputMaybe<ConsultantDistinctionFilterInput>;
};


export type DistinctionCategorieDistinctionArgs = {
  where?: InputMaybe<DistinctionFilterInput>;
};

export type DistinctionCategorieFilterInput = {
  and?: InputMaybe<Array<DistinctionCategorieFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  consultantDistinction?: InputMaybe<ListFilterInputTypeOfConsultantDistinctionFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  distinction?: InputMaybe<ListFilterInputTypeOfDistinctionFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DistinctionCategorieFilterInput>>;
};

export type DistinctionFilterInput = {
  and?: InputMaybe<Array<DistinctionFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  consultantDistinction?: InputMaybe<ListFilterInputTypeOfConsultantDistinctionFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  distinctionCategorie?: InputMaybe<ByteOperationFilterInput>;
  distinctionCategorieNavigation?: InputMaybe<DistinctionCategorieFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DistinctionFilterInput>>;
};

export type DocumentFilterConfigurationInput = {
  activeFilter?: InputMaybe<Scalars['Boolean']['input']>;
  consultantCodesFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  consultantFilesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  consultantIdsFilter?: InputMaybe<Array<Scalars['Int']['input']>>;
  continuationToken?: InputMaybe<Scalars['String']['input']>;
  creeParFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  documentIdsFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  documentTypesFilter?: InputMaybe<Array<GedDocumentType>>;
  documentTypesStringFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  etatSignatureFilter?: InputMaybe<Array<SignatureState>>;
  handwrittenSignatureFilter?: InputMaybe<Scalars['Boolean']['input']>;
  includeSignatairesToIdsFilter?: InputMaybe<Scalars['Boolean']['input']>;
  investisseurFilesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  investisseurIdsFilter?: InputMaybe<Array<Scalars['Long']['input']>>;
  maxDocumentsPerRequest?: InputMaybe<Scalars['Int']['input']>;
  nomDeFichierFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  tagsFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  timeStampFilter?: InputMaybe<FilterDateTimeInput>;
};

export type DocumentSignatureInput = {
  documentIds: Array<Scalars['String']['input']>;
  providerSettings: ProviderSettingsInput;
  signataire: Array<SignataireInput>;
};

export type DonationInput = {
  beneficiaire?: InputMaybe<Scalars['String']['input']>;
  commentaire?: InputMaybe<Scalars['String']['input']>;
  dateDonation?: InputMaybe<Scalars['DateTime']['input']>;
  demembrement?: InputMaybe<Scalars['String']['input']>;
  donation?: InputMaybe<Scalars['Boolean']['input']>;
  donationDernierVivant?: InputMaybe<Scalars['Boolean']['input']>;
  forme?: InputMaybe<Scalars['String']['input']>;
  montant?: InputMaybe<Scalars['Int']['input']>;
  objet?: InputMaybe<Scalars['String']['input']>;
};

export type DoublonInvestisseurCheckResult = {
  __typename?: 'DoublonInvestisseurCheckResult';
  canBeCreated: Scalars['Boolean']['output'];
  existingRelationInvestisseurId?: Maybe<Scalars['Long']['output']>;
  isDoublon: Scalars['Boolean']['output'];
  isInOwnPortefeuille: Scalars['Boolean']['output'];
  isOtherConsultantContact: Scalars['Boolean']['output'];
  isOtherConsultantSigned: Scalars['Boolean']['output'];
};

export type Edition = {
  __typename?: 'Edition';
  consultant?: Maybe<Consultant>;
  consultantId?: Maybe<Scalars['Long']['output']>;
  dateCreation: Scalars['DateTime']['output'];
  dateEdition: Scalars['DateTime']['output'];
  dateProchaineEdition?: Maybe<Scalars['DateTime']['output']>;
  documentId?: Maybe<Scalars['UUID']['output']>;
  estSupprime: Scalars['Boolean']['output'];
  extension: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  nombreTelechargement: Scalars['Int']['output'];
  typeEditionCode: Scalars['String']['output'];
  typeEditionCodeNavigation: TypeEdition;
};

export type EditionFilterInput = {
  and?: InputMaybe<Array<EditionFilterInput>>;
  consultant?: InputMaybe<ConsultantFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  dateCreation?: InputMaybe<DateTimeOperationFilterInput>;
  dateEdition?: InputMaybe<DateTimeOperationFilterInput>;
  dateProchaineEdition?: InputMaybe<DateTimeOperationFilterInput>;
  documentId?: InputMaybe<UuidOperationFilterInput>;
  estSupprime?: InputMaybe<BooleanOperationFilterInput>;
  extension?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  nombreTelechargement?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<EditionFilterInput>>;
  typeEditionCode?: InputMaybe<StringOperationFilterInput>;
  typeEditionCodeNavigation?: InputMaybe<TypeEditionFilterInput>;
};

export type Email = {
  __typename?: 'Email';
  adresse: Scalars['String']['output'];
  arianeId?: Maybe<Scalars['Long']['output']>;
  consultant: Array<Consultant>;
  contact: Array<Contact>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate: Scalars['DateTime']['output'];
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  estAdresseCorrespondance?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Note>;
  noteId?: Maybe<Scalars['Long']['output']>;
  personnePhysique: Array<PersonnePhysique>;
  typeEmailCode: Scalars['String']['output'];
  typeEmailCodeNavigation: TypeEmail;
};


export type EmailConsultantArgs = {
  where?: InputMaybe<ConsultantFilterInput>;
};


export type EmailContactArgs = {
  where?: InputMaybe<ContactFilterInput>;
};


export type EmailPersonnePhysiqueArgs = {
  where?: InputMaybe<PersonnePhysiqueFilterInput>;
};

export type EmailFilterInput = {
  adresse?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<EmailFilterInput>>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  consultant?: InputMaybe<ListFilterInputTypeOfConsultantFilterInput>;
  contact?: InputMaybe<ListFilterInputTypeOfContactFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  estAdresseCorrespondance?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  note?: InputMaybe<NoteFilterInput>;
  noteId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<EmailFilterInput>>;
  personnePhysique?: InputMaybe<ListFilterInputTypeOfPersonnePhysiqueFilterInput>;
  typeEmailCode?: InputMaybe<StringOperationFilterInput>;
  typeEmailCodeNavigation?: InputMaybe<TypeEmailFilterInput>;
};

export type EmailInput = {
  adresse: Scalars['String']['input'];
  estAdresseCorrespondance?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  typeEmailCode?: InputMaybe<Scalars['String']['input']>;
};

export type EnveloppeProduit = {
  __typename?: 'EnveloppeProduit';
  backOfficeService: BackOfficeService;
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  enveloppeProduitExtension: EnveloppeProduitExtension;
  libelle: Scalars['String']['output'];
  produit: Array<Produit>;
  type2: Scalars['Byte']['output'];
  type2Navigation: Type2Produit;
};


export type EnveloppeProduitProduitArgs = {
  where?: InputMaybe<ProduitFilterInput>;
};

export type EnveloppeProduitExtension = {
  __typename?: 'EnveloppeProduitExtension';
  code: Scalars['Byte']['output'];
};

export type EnveloppeProduitFilterInput = {
  and?: InputMaybe<Array<EnveloppeProduitFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EnveloppeProduitFilterInput>>;
  produit?: InputMaybe<ListFilterInputTypeOfProduitFilterInput>;
  type2?: InputMaybe<ByteOperationFilterInput>;
  type2Navigation?: InputMaybe<Type2ProduitFilterInput>;
};

export type EnveloppeProduitSortInput = {
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
  type2?: InputMaybe<SortEnumType>;
  type2Navigation?: InputMaybe<Type2ProduitSortInput>;
};

export type EnveloppeProduitWithLibelle = {
  __typename?: 'EnveloppeProduitWithLibelle';
  code: Scalars['Byte']['output'];
  libelle: Scalars['String']['output'];
};

export type EnveloppeProduitWithLibelleFilterInput = {
  and?: InputMaybe<Array<EnveloppeProduitWithLibelleFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EnveloppeProduitWithLibelleFilterInput>>;
};

export type EnveloppeProduitWithLibelleInput = {
  code: Scalars['Byte']['input'];
  libelle: Scalars['String']['input'];
};

export type EnveloppeProduitWithLibelleSortInput = {
  code?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type EquivalenceDeFormation = {
  __typename?: 'EquivalenceDeFormation';
  codeFormation: Scalars['Byte']['output'];
  codeFormationNavigation: Formation;
  commentaire?: Maybe<Scalars['String']['output']>;
  consultant: Consultant;
  consultantFormateur?: Maybe<Consultant>;
  consultantFormateurId?: Maybe<Scalars['Long']['output']>;
  consultantId: Scalars['Long']['output'];
  creationDate: Scalars['DateTime']['output'];
  dateFinValidite?: Maybe<Scalars['DateTime']['output']>;
  dateFormation?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['Long']['output']>;
  nom?: Maybe<Scalars['String']['output']>;
  organisme?: Maybe<Scalars['String']['output']>;
  typeJustification?: Maybe<Scalars['Byte']['output']>;
  typeJustificationNavigation?: Maybe<TypeJustificationFormation>;
};

export type EquivalenceDeFormationFilterInput = {
  and?: InputMaybe<Array<EquivalenceDeFormationFilterInput>>;
  codeFormation?: InputMaybe<ByteOperationFilterInput>;
  codeFormationNavigation?: InputMaybe<FormationFilterInput>;
  commentaire?: InputMaybe<StringOperationFilterInput>;
  consultant?: InputMaybe<ConsultantFilterInput>;
  consultantFormateur?: InputMaybe<ConsultantFilterInput>;
  consultantFormateurId?: InputMaybe<LongOperationFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateFinValidite?: InputMaybe<DateTimeOperationFilterInput>;
  dateFormation?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<LongOperationFilterInput>;
  nom?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EquivalenceDeFormationFilterInput>>;
  organisme?: InputMaybe<StringOperationFilterInput>;
  typeJustification?: InputMaybe<ByteOperationFilterInput>;
  typeJustificationNavigation?: InputMaybe<TypeJustificationFormationFilterInput>;
};

export type EquivalenceFormationContinue = {
  __typename?: 'EquivalenceFormationContinue';
  consultantId: Scalars['Long']['output'];
  dateFormation: Scalars['DateTime']['output'];
  millesime: Scalars['Int']['output'];
  nom: Scalars['String']['output'];
};

export type EquivalenceFormationContinueFilterInput = {
  and?: InputMaybe<Array<EquivalenceFormationContinueFilterInput>>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  dateFormation?: InputMaybe<DateTimeOperationFilterInput>;
  millesime?: InputMaybe<IntOperationFilterInput>;
  nom?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EquivalenceFormationContinueFilterInput>>;
};

export type EquivalenceFormationContinueSortInput = {
  consultantId?: InputMaybe<SortEnumType>;
  dateFormation?: InputMaybe<SortEnumType>;
  millesime?: InputMaybe<SortEnumType>;
  nom?: InputMaybe<SortEnumType>;
};

export type EtatCivil = {
  __typename?: 'EtatCivil';
  codePaysResidenceStableCouple?: Maybe<Scalars['String']['output']>;
  codePaysResidenceStableCoupleNavigation?: Maybe<Pays>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  dateChangementSituation?: Maybe<Scalars['LocalDate']['output']>;
  dateContratUnion?: Maybe<Scalars['LocalDate']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  foyerFiscalIdentique: Scalars['Boolean']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  lieuContratUnion?: Maybe<Scalars['String']['output']>;
  nombreEnfantACharge?: Maybe<Scalars['Byte']['output']>;
  note?: Maybe<Note>;
  noteId?: Maybe<Scalars['Long']['output']>;
  personnePhysique: PersonnePhysique;
  personnePhysiqueId: Scalars['Long']['output'];
  regimePacsIndivision?: Maybe<Scalars['Boolean']['output']>;
  typeAvantageMatrimonialCode?: Maybe<Scalars['String']['output']>;
  typeAvantageMatrimonialCodeNavigation?: Maybe<TypeAvantageMatrimonial>;
  typeRegimeSituationEtatCivilCode?: Maybe<Scalars['String']['output']>;
  typeRegimeSituationEtatCivilCodeNavigation?: Maybe<TypeRegimeSituationEtatCivil>;
  typeSituationEtatCivilCode?: Maybe<Scalars['String']['output']>;
  typeSituationEtatCivilCodeNavigation?: Maybe<TypeSituationEtatCivil>;
};

export type EtatCivilFilterInput = {
  and?: InputMaybe<Array<EtatCivilFilterInput>>;
  codePaysResidenceStableCouple?: InputMaybe<StringOperationFilterInput>;
  codePaysResidenceStableCoupleNavigation?: InputMaybe<PaysFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateChangementSituation?: InputMaybe<LocalDateOperationFilterInput>;
  dateContratUnion?: InputMaybe<LocalDateOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  foyerFiscalIdentique?: InputMaybe<BooleanOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  lieuContratUnion?: InputMaybe<StringOperationFilterInput>;
  nombreEnfantACharge?: InputMaybe<ByteOperationFilterInput>;
  note?: InputMaybe<NoteFilterInput>;
  noteId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<EtatCivilFilterInput>>;
  personnePhysique?: InputMaybe<PersonnePhysiqueFilterInput>;
  personnePhysiqueId?: InputMaybe<LongOperationFilterInput>;
  regimePacsIndivision?: InputMaybe<BooleanOperationFilterInput>;
  typeAvantageMatrimonialCode?: InputMaybe<StringOperationFilterInput>;
  typeAvantageMatrimonialCodeNavigation?: InputMaybe<TypeAvantageMatrimonialFilterInput>;
  typeRegimeSituationEtatCivilCode?: InputMaybe<StringOperationFilterInput>;
  typeRegimeSituationEtatCivilCodeNavigation?: InputMaybe<TypeRegimeSituationEtatCivilFilterInput>;
  typeSituationEtatCivilCode?: InputMaybe<StringOperationFilterInput>;
  typeSituationEtatCivilCodeNavigation?: InputMaybe<TypeSituationEtatCivilFilterInput>;
};

export type EtatCivilInput = {
  avantageMatrimonial?: InputMaybe<Scalars['String']['input']>;
  commentaire?: InputMaybe<Scalars['String']['input']>;
  dateChangementSituation?: InputMaybe<Scalars['DateTime']['input']>;
  dateContratUnion?: InputMaybe<Scalars['DateTime']['input']>;
  foyerFiscalIdentique: Scalars['Boolean']['input'];
  lieuContratUnion?: InputMaybe<Scalars['String']['input']>;
  nombreEnfantACharge?: InputMaybe<Scalars['Byte']['input']>;
  regimeMatrimoniale?: InputMaybe<Scalars['String']['input']>;
  regimePacsIndivision: Scalars['Boolean']['input'];
  situationMatrimoniale?: InputMaybe<Scalars['String']['input']>;
};

export type EtatCivilSortInput = {
  codePaysResidenceStableCouple?: InputMaybe<SortEnumType>;
  codePaysResidenceStableCoupleNavigation?: InputMaybe<PaysSortInput>;
  createurId?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  dateChangementSituation?: InputMaybe<SortEnumType>;
  dateContratUnion?: InputMaybe<SortEnumType>;
  editeurId?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  foyerFiscalIdentique?: InputMaybe<SortEnumType>;
  idSource?: InputMaybe<SortEnumType>;
  lieuContratUnion?: InputMaybe<SortEnumType>;
  nombreEnfantACharge?: InputMaybe<SortEnumType>;
  note?: InputMaybe<NoteSortInput>;
  noteId?: InputMaybe<SortEnumType>;
  personnePhysique?: InputMaybe<PersonnePhysiqueSortInput>;
  personnePhysiqueId?: InputMaybe<SortEnumType>;
  regimePacsIndivision?: InputMaybe<SortEnumType>;
  typeAvantageMatrimonialCode?: InputMaybe<SortEnumType>;
  typeAvantageMatrimonialCodeNavigation?: InputMaybe<TypeAvantageMatrimonialSortInput>;
  typeRegimeSituationEtatCivilCode?: InputMaybe<SortEnumType>;
  typeRegimeSituationEtatCivilCodeNavigation?: InputMaybe<TypeRegimeSituationEtatCivilSortInput>;
  typeSituationEtatCivilCode?: InputMaybe<SortEnumType>;
  typeSituationEtatCivilCodeNavigation?: InputMaybe<TypeSituationEtatCivilSortInput>;
};

export type EtatCommande = {
  __typename?: 'EtatCommande';
  code: Scalars['Byte']['output'];
  commande: Array<Commande>;
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};

export type EtatCommandeFilterInput = {
  and?: InputMaybe<Array<EtatCommandeFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  commande?: InputMaybe<ListFilterInputTypeOfCommandeFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EtatCommandeFilterInput>>;
};

export type EtatCommandeSortInput = {
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type EtatMouvement = {
  __typename?: 'EtatMouvement';
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  mouvement: Array<Mouvement>;
};


export type EtatMouvementMouvementArgs = {
  where?: InputMaybe<MouvementFilterInput>;
};

export type EtatMouvementFilterInput = {
  and?: InputMaybe<Array<EtatMouvementFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  mouvement?: InputMaybe<ListFilterInputTypeOfMouvementFilterInput>;
  or?: InputMaybe<Array<EtatMouvementFilterInput>>;
};

export type EtatMouvementSortInput = {
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type EtatPmrCommande = {
  __typename?: 'EtatPmrCommande';
  code: Scalars['Byte']['output'];
  commande: Array<Commande>;
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};

export type EtatPmrCommandeFilterInput = {
  and?: InputMaybe<Array<EtatPmrCommandeFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  commande?: InputMaybe<ListFilterInputTypeOfCommandeFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EtatPmrCommandeFilterInput>>;
};

export type EtatPmrCommandeSortInput = {
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type EtatProduit = {
  __typename?: 'EtatProduit';
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  produit: Array<Produit>;
};


export type EtatProduitProduitArgs = {
  where?: InputMaybe<ProduitFilterInput>;
};

export type EtatProduitFilterInput = {
  and?: InputMaybe<Array<EtatProduitFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EtatProduitFilterInput>>;
  produit?: InputMaybe<ListFilterInputTypeOfProduitFilterInput>;
};

export type EtatProduitSortInput = {
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type EtatResiliationB2S = {
  __typename?: 'EtatResiliationB2S';
  code: Scalars['String']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate: Scalars['DateTime']['output'];
  libelle: Scalars['String']['output'];
  resiliationPaiementB2S: Array<ResiliationPaiementB2S>;
};


export type EtatResiliationB2SResiliationPaiementB2SArgs = {
  where?: InputMaybe<ResiliationPaiementB2SFilterInput>;
};

export type EtatResiliationB2SFilterInput = {
  and?: InputMaybe<Array<EtatResiliationB2SFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EtatResiliationB2SFilterInput>>;
  resiliationPaiementB2S?: InputMaybe<ListFilterInputTypeOfResiliationPaiementB2SFilterInput>;
};

export type EtatStatut = {
  __typename?: 'EtatStatut';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  consultantStatutJuridique: Array<ConsultantStatutJuridique>;
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};


export type EtatStatutConsultantStatutJuridiqueArgs = {
  where?: InputMaybe<ConsultantStatutJuridiqueFilterInput>;
};

export type EtatStatutFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<EtatStatutFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  consultantStatutJuridique?: InputMaybe<ListFilterInputTypeOfConsultantStatutJuridiqueFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EtatStatutFilterInput>>;
};

export type EtatTransfertClient = {
  __typename?: 'EtatTransfertClient';
  code: Scalars['String']['output'];
  transfertClient: Array<TransfertClient>;
};


export type EtatTransfertClientTransfertClientArgs = {
  where?: InputMaybe<TransfertClientFilterInput>;
};

export type EtatTransfertClientFilterInput = {
  and?: InputMaybe<Array<EtatTransfertClientFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EtatTransfertClientFilterInput>>;
  transfertClient?: InputMaybe<ListFilterInputTypeOfTransfertClientFilterInput>;
};

export type EtatTransfertClientSortInput = {
  code?: InputMaybe<SortEnumType>;
};

export type ExerciceCommercial = {
  __typename?: 'ExerciceCommercial';
  actif: Scalars['Boolean']['output'];
  adhesionConsultant: Array<AdhesionConsultant>;
  codeExercice: Scalars['Long']['output'];
  consultantDistinction: Array<ConsultantDistinction>;
  creationDate: Scalars['DateTime']['output'];
  dateAdhesionReport?: Maybe<Scalars['DateTime']['output']>;
  dateDebut?: Maybe<Scalars['DateTime']['output']>;
  dateFin?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  libelleExercice: Scalars['String']['output'];
};


export type ExerciceCommercialAdhesionConsultantArgs = {
  where?: InputMaybe<AdhesionConsultantFilterInput>;
};


export type ExerciceCommercialConsultantDistinctionArgs = {
  where?: InputMaybe<ConsultantDistinctionFilterInput>;
};

export type ExerciceCommercialFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  adhesionConsultant?: InputMaybe<ListFilterInputTypeOfAdhesionConsultantFilterInput>;
  and?: InputMaybe<Array<ExerciceCommercialFilterInput>>;
  codeExercice?: InputMaybe<LongOperationFilterInput>;
  consultantDistinction?: InputMaybe<ListFilterInputTypeOfConsultantDistinctionFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateAdhesionReport?: InputMaybe<DateTimeOperationFilterInput>;
  dateDebut?: InputMaybe<DateTimeOperationFilterInput>;
  dateFin?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  libelleExercice?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ExerciceCommercialFilterInput>>;
};

export type Expiration = {
  __typename?: 'Expiration';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateAnniversaire: Scalars['DateTime']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  periode: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  typePieceJointe: Array<TypePieceJointe>;
};


export type ExpirationTypePieceJointeArgs = {
  where?: InputMaybe<TypePieceJointeFilterInput>;
};

export type ExpirationFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<ExpirationFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateAnniversaire?: InputMaybe<DateTimeOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ExpirationFilterInput>>;
  periode?: InputMaybe<IntOperationFilterInput>;
  type?: InputMaybe<IntOperationFilterInput>;
  typePieceJointe?: InputMaybe<ListFilterInputTypeOfTypePieceJointeFilterInput>;
};

export type Facture = {
  __typename?: 'Facture';
  besoinApprobation: Scalars['Boolean']['output'];
  codeEtablissement: Scalars['String']['output'];
  consultant: Consultant;
  consultantId: Scalars['Long']['output'];
  creationDate: Scalars['DateTime']['output'];
  dateApprobation?: Maybe<Scalars['DateTime']['output']>;
  dateCreation: Scalars['DateTime']['output'];
  dateFacture: Scalars['DateTime']['output'];
  dateLimiteValidite: Scalars['DateTime']['output'];
  dateModification?: Maybe<Scalars['DateTime']['output']>;
  datePaiement?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['UUID']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  montant: Scalars['Decimal']['output'];
  nomFichier?: Maybe<Scalars['String']['output']>;
  nomFiliale: Scalars['String']['output'];
  nombreTelechargement: Scalars['Int']['output'];
  noteApprobation?: Maybe<Note>;
  noteApprobationId?: Maybe<Scalars['Long']['output']>;
  numeroEcritureComptable: Scalars['String']['output'];
  numeroFacture: Scalars['String']['output'];
  numeroPieceComptable: Scalars['String']['output'];
  statutApprobation?: Maybe<Scalars['Boolean']['output']>;
  statutJuridique: ConsultantStatutJuridique;
  statutJuridiqueId: Scalars['Long']['output'];
  yearFacture?: Maybe<Scalars['Int']['output']>;
};

export type FactureFilterInput = {
  and?: InputMaybe<Array<FactureFilterInput>>;
  besoinApprobation?: InputMaybe<BooleanOperationFilterInput>;
  codeEtablissement?: InputMaybe<StringOperationFilterInput>;
  consultant?: InputMaybe<ConsultantFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateApprobation?: InputMaybe<DateTimeOperationFilterInput>;
  dateCreation?: InputMaybe<DateTimeOperationFilterInput>;
  dateFacture?: InputMaybe<DateTimeOperationFilterInput>;
  dateLimiteValidite?: InputMaybe<DateTimeOperationFilterInput>;
  dateModification?: InputMaybe<DateTimeOperationFilterInput>;
  datePaiement?: InputMaybe<DateTimeOperationFilterInput>;
  documentId?: InputMaybe<UuidOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  montant?: InputMaybe<DecimalOperationFilterInput>;
  nomFichier?: InputMaybe<StringOperationFilterInput>;
  nomFiliale?: InputMaybe<StringOperationFilterInput>;
  nombreTelechargement?: InputMaybe<IntOperationFilterInput>;
  noteApprobation?: InputMaybe<NoteFilterInput>;
  noteApprobationId?: InputMaybe<LongOperationFilterInput>;
  numeroEcritureComptable?: InputMaybe<StringOperationFilterInput>;
  numeroFacture?: InputMaybe<StringOperationFilterInput>;
  numeroPieceComptable?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FactureFilterInput>>;
  statutApprobation?: InputMaybe<BooleanOperationFilterInput>;
  statutJuridique?: InputMaybe<ConsultantStatutJuridiqueFilterInput>;
  statutJuridiqueId?: InputMaybe<LongOperationFilterInput>;
  yearFacture?: InputMaybe<IntOperationFilterInput>;
};

export type FicheConseil = {
  __typename?: 'FicheConseil';
  allocation?: Maybe<AllocationConseil>;
  allocationConsultantFile?: Maybe<StorageFile>;
  allocationConsultantFileId?: Maybe<Scalars['String']['output']>;
  allocationPrecision?: Maybe<Scalars['String']['output']>;
  allocationTransfertOption?: Maybe<AllocationTransfertOption>;
  allocationVersementOption?: Maybe<AllocationVersementOption>;
  arbitrageDuplicationContext?: Maybe<ArbitrageDuplicationContext>;
  arbitrageLibreSupportsEntrants?: Maybe<Scalars['String']['output']>;
  arbitrageLibreSupportsSortants?: Maybe<Scalars['String']['output']>;
  avecArbitragesProgrammes?: Maybe<Scalars['Boolean']['output']>;
  avecMiseEnPlaceOuModificationVP?: Maybe<Scalars['Boolean']['output']>;
  coInvestisseur?: Maybe<Investisseur>;
  conseilConfigId: Scalars['String']['output'];
  conseilConfigLibelle: Scalars['String']['output'];
  consultant: Consultant;
  contratId?: Maybe<Scalars['Long']['output']>;
  dateCreation: Scalars['DateTime']['output'];
  dateGenerationPdf?: Maybe<Scalars['DateTime']['output']>;
  dateModification: Scalars['DateTime']['output'];
  defaultLibelle: Scalars['String']['output'];
  disponibiliteEpargne?: Maybe<DisponibiliteEpargne>;
  disponibiliteEpargneOptions?: Maybe<Array<DisponibiliteEpargneOption>>;
  enveloppe?: Maybe<EnveloppeProduitWithLibelle>;
  fondsEvenementiels?: Maybe<Array<FondsEvenementielConseil>>;
  formConfig: AdequationConfig;
  horizonPlacement?: Maybe<HorizonPlacement>;
  id: Scalars['String']['output'];
  investisseur?: Maybe<Investisseur>;
  investisseurType: InvestisseurType;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  libelle?: Maybe<Scalars['String']['output']>;
  modeDeGestion?: Maybe<ModeDeGestion>;
  motivationOperation?: Maybe<Scalars['String']['output']>;
  natureOperation?: Maybe<NatureOperationWithLibelle>;
  numeroContrat?: Maybe<Scalars['String']['output']>;
  objectifs: Array<InvestisseurFicheObjectif>;
  optionsAutomatiques?: Maybe<Array<OptionAutomatiqueConseil>>;
  portefeuilleOption?: Maybe<PortefeuilleOption>;
  precisionComplementaire?: Maybe<AdditionalDetails>;
  produit?: Maybe<ProduitConseil>;
  statut: FicheConseilState;
  storageFileId?: Maybe<Scalars['String']['output']>;
  toDictionary: Array<KeyValuePairOfStringAndObject>;
  toJsonString: Scalars['String']['output'];
  toleranceRisque?: Maybe<ToleranceRisque>;
  toleranceRisqueOptions?: Maybe<Array<ToleranceRisqueOption>>;
  transactionPersonnelle: TransactionPersonnelleEnum;
  versements: Versements;
  vpModeOptions?: Maybe<VpModeOptions>;
};

export type FicheConseilFilterInput = {
  allocation?: InputMaybe<AllocationConseilFilterInput>;
  allocationConsultantFile?: InputMaybe<StorageFileFilterInput>;
  allocationConsultantFileId?: InputMaybe<StringOperationFilterInput>;
  allocationPrecision?: InputMaybe<StringOperationFilterInput>;
  allocationTransfertOption?: InputMaybe<NullableOfAllocationTransfertOptionOperationFilterInput>;
  allocationVersementOption?: InputMaybe<NullableOfAllocationVersementOptionOperationFilterInput>;
  and?: InputMaybe<Array<FicheConseilFilterInput>>;
  arbitrageDuplicationContext?: InputMaybe<ArbitrageDuplicationContextFilterInput>;
  arbitrageLibreSupportsEntrants?: InputMaybe<StringOperationFilterInput>;
  arbitrageLibreSupportsSortants?: InputMaybe<StringOperationFilterInput>;
  avecArbitragesProgrammes?: InputMaybe<BooleanOperationFilterInput>;
  avecMiseEnPlaceOuModificationVP?: InputMaybe<BooleanOperationFilterInput>;
  coInvestisseur?: InputMaybe<InvestisseurFilterInput>;
  conseilConfigId?: InputMaybe<StringOperationFilterInput>;
  conseilConfigLibelle?: InputMaybe<StringOperationFilterInput>;
  consultant?: InputMaybe<ConsultantFilterInput>;
  contratId?: InputMaybe<LongOperationFilterInput>;
  dateCreation?: InputMaybe<DateTimeOperationFilterInput>;
  dateGenerationPdf?: InputMaybe<DateTimeOperationFilterInput>;
  dateModification?: InputMaybe<DateTimeOperationFilterInput>;
  disponibiliteEpargne?: InputMaybe<NullableOfDisponibiliteEpargneOperationFilterInput>;
  disponibiliteEpargneOptions?: InputMaybe<ListFilterInputTypeOfDisponibiliteEpargneOptionFilterInput>;
  enveloppe?: InputMaybe<EnveloppeProduitWithLibelleFilterInput>;
  fondsEvenementiels?: InputMaybe<ListFilterInputTypeOfFondsEvenementielConseilFilterInput>;
  formConfig?: InputMaybe<AdequationConfigFilterInput>;
  horizonPlacement?: InputMaybe<HorizonPlacementFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  investisseur?: InputMaybe<InvestisseurFilterInput>;
  investisseurType?: InputMaybe<InvestisseurTypeOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  modeDeGestion?: InputMaybe<ModeDeGestionFilterInput>;
  motivationOperation?: InputMaybe<StringOperationFilterInput>;
  natureOperation?: InputMaybe<NatureOperationWithLibelleFilterInput>;
  numeroContrat?: InputMaybe<StringOperationFilterInput>;
  objectifs?: InputMaybe<ListFilterInputTypeOfInvestisseurFicheObjectifFilterInput>;
  optionsAutomatiques?: InputMaybe<ListFilterInputTypeOfOptionAutomatiqueConseilFilterInput>;
  or?: InputMaybe<Array<FicheConseilFilterInput>>;
  portefeuilleOption?: InputMaybe<NullableOfPortefeuilleOptionOperationFilterInput>;
  precisionComplementaire?: InputMaybe<AdditionalDetailsFilterInput>;
  produit?: InputMaybe<ProduitConseilFilterInput>;
  statut?: InputMaybe<FicheConseilStateOperationFilterInput>;
  storageFileId?: InputMaybe<StringOperationFilterInput>;
  toleranceRisque?: InputMaybe<NullableOfToleranceRisqueOperationFilterInput>;
  toleranceRisqueOptions?: InputMaybe<ListFilterInputTypeOfToleranceRisqueOptionFilterInput>;
  transactionPersonnelle?: InputMaybe<TransactionPersonnelleEnumOperationFilterInput>;
  versements?: InputMaybe<VersementsFilterInput>;
  vpModeOptions?: InputMaybe<NullableOfVpModeOptionsOperationFilterInput>;
};

export type FicheConseilInput = {
  allocation?: InputMaybe<AllocationConseilInput>;
  allocationConsultantFile?: InputMaybe<StorageFileInput>;
  allocationConsultantFileId?: InputMaybe<Scalars['String']['input']>;
  allocationPrecision?: InputMaybe<Scalars['String']['input']>;
  allocationTransfertOption?: InputMaybe<AllocationTransfertOption>;
  allocationVersementOption?: InputMaybe<AllocationVersementOption>;
  arbitrageDuplicationContext?: InputMaybe<ArbitrageDuplicationContextInput>;
  arbitrageLibreSupportsEntrants?: InputMaybe<Scalars['String']['input']>;
  arbitrageLibreSupportsSortants?: InputMaybe<Scalars['String']['input']>;
  avecArbitragesProgrammes?: InputMaybe<Scalars['Boolean']['input']>;
  avecMiseEnPlaceOuModificationVP?: InputMaybe<Scalars['Boolean']['input']>;
  coInvestisseur?: InputMaybe<InvestisseurInput>;
  conseilConfigId: Scalars['String']['input'];
  conseilConfigLibelle: Scalars['String']['input'];
  consultant: ConsultantInput;
  contratId?: InputMaybe<Scalars['Long']['input']>;
  dateCreation: Scalars['DateTime']['input'];
  dateGenerationPdf?: InputMaybe<Scalars['DateTime']['input']>;
  dateModification: Scalars['DateTime']['input'];
  disponibiliteEpargne?: InputMaybe<DisponibiliteEpargne>;
  disponibiliteEpargneOptions?: InputMaybe<Array<DisponibiliteEpargneOptionInput>>;
  enveloppe: EnveloppeProduitWithLibelleInput;
  fondsEvenementiels?: InputMaybe<Array<FondsEvenementielConseilInput>>;
  formConfig: AdequationConfigInput;
  horizonPlacement?: InputMaybe<HorizonPlacementInput>;
  id: Scalars['String']['input'];
  investisseur?: InputMaybe<InvestisseurInput>;
  investisseurType: InvestisseurType;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  libelle?: InputMaybe<Scalars['String']['input']>;
  modeDeGestion?: InputMaybe<ModeDeGestionInput>;
  motivationOperation?: InputMaybe<Scalars['String']['input']>;
  natureOperation: NatureOperationWithLibelleInput;
  numeroContrat?: InputMaybe<Scalars['String']['input']>;
  objectifs: Array<InvestisseurFicheObjectifInput>;
  optionsAutomatiques?: InputMaybe<Array<OptionAutomatiqueConseilInput>>;
  portefeuilleOption?: InputMaybe<PortefeuilleOption>;
  precisionComplementaire?: InputMaybe<AdditionalDetailsInput>;
  produit?: InputMaybe<ProduitConseilInput>;
  statut: FicheConseilState;
  storageFileId?: InputMaybe<Scalars['String']['input']>;
  toleranceRisque?: InputMaybe<ToleranceRisque>;
  toleranceRisqueOptions?: InputMaybe<Array<ToleranceRisqueOptionInput>>;
  transactionPersonnelle: TransactionPersonnelleEnum;
  versements: VersementsInput;
  vpModeOptions?: InputMaybe<VpModeOptions>;
};

export type FicheConseilSortInput = {
  allocation?: InputMaybe<AllocationConseilSortInput>;
  allocationConsultantFile?: InputMaybe<StorageFileSortInput>;
  allocationConsultantFileId?: InputMaybe<SortEnumType>;
  allocationPrecision?: InputMaybe<SortEnumType>;
  allocationTransfertOption?: InputMaybe<SortEnumType>;
  allocationVersementOption?: InputMaybe<SortEnumType>;
  arbitrageDuplicationContext?: InputMaybe<ArbitrageDuplicationContextSortInput>;
  arbitrageLibreSupportsEntrants?: InputMaybe<SortEnumType>;
  arbitrageLibreSupportsSortants?: InputMaybe<SortEnumType>;
  avecArbitragesProgrammes?: InputMaybe<SortEnumType>;
  avecMiseEnPlaceOuModificationVP?: InputMaybe<SortEnumType>;
  coInvestisseur?: InputMaybe<InvestisseurSortInput>;
  conseilConfigId?: InputMaybe<SortEnumType>;
  conseilConfigLibelle?: InputMaybe<SortEnumType>;
  consultant?: InputMaybe<ConsultantSortInput>;
  contratId?: InputMaybe<SortEnumType>;
  dateCreation?: InputMaybe<SortEnumType>;
  dateGenerationPdf?: InputMaybe<SortEnumType>;
  dateModification?: InputMaybe<SortEnumType>;
  disponibiliteEpargne?: InputMaybe<SortEnumType>;
  enveloppe?: InputMaybe<EnveloppeProduitWithLibelleSortInput>;
  formConfig?: InputMaybe<AdequationConfigSortInput>;
  horizonPlacement?: InputMaybe<HorizonPlacementSortInput>;
  id?: InputMaybe<SortEnumType>;
  investisseur?: InputMaybe<InvestisseurSortInput>;
  investisseurType?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
  modeDeGestion?: InputMaybe<ModeDeGestionSortInput>;
  motivationOperation?: InputMaybe<SortEnumType>;
  natureOperation?: InputMaybe<NatureOperationWithLibelleSortInput>;
  numeroContrat?: InputMaybe<SortEnumType>;
  portefeuilleOption?: InputMaybe<SortEnumType>;
  precisionComplementaire?: InputMaybe<AdditionalDetailsSortInput>;
  produit?: InputMaybe<ProduitConseilSortInput>;
  statut?: InputMaybe<SortEnumType>;
  storageFileId?: InputMaybe<SortEnumType>;
  toleranceRisque?: InputMaybe<SortEnumType>;
  transactionPersonnelle?: InputMaybe<SortEnumType>;
  versements?: InputMaybe<VersementsSortInput>;
  vpModeOptions?: InputMaybe<SortEnumType>;
};

export enum FicheConseilState {
  ConseilDone = 'CONSEIL_DONE',
  DraftCreated = 'DRAFT_CREATED',
  DraftInvestisseurSelected = 'DRAFT_INVESTISSEUR_SELECTED',
  DraftInvestisseurValidated = 'DRAFT_INVESTISSEUR_VALIDATED',
  DraftInvestmentProjectValidated = 'DRAFT_INVESTMENT_PROJECT_VALIDATED',
  DraftKycValidated = 'DRAFT_KYC_VALIDATED',
  DraftRequirementsAndNeedsValidated = 'DRAFT_REQUIREMENTS_AND_NEEDS_VALIDATED'
}

export type FicheConseilStateOperationFilterInput = {
  eq?: InputMaybe<FicheConseilState>;
  in?: InputMaybe<Array<FicheConseilState>>;
  neq?: InputMaybe<FicheConseilState>;
  nin?: InputMaybe<Array<FicheConseilState>>;
};

/** A segment of a collection. */
export type FichesPaginatedCollectionSegment = {
  __typename?: 'FichesPaginatedCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FicheConseil>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type FieldConfig = {
  __typename?: 'FieldConfig';
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isVisible: Scalars['Boolean']['output'];
  validators: Array<FieldValidatorConfig>;
};

export type FieldConfigFilterInput = {
  and?: InputMaybe<Array<FieldConfigFilterInput>>;
  fieldKey?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isVisible?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<FieldConfigFilterInput>>;
  validators?: InputMaybe<ListFilterInputTypeOfFieldValidatorConfigFilterInput>;
};

export type FieldConfigInput = {
  fieldKey: Scalars['String']['input'];
  id: Scalars['String']['input'];
  isVisible: Scalars['Boolean']['input'];
  validators: Array<FieldValidatorConfigInput>;
};

export type FieldValidatorConfig = {
  __typename?: 'FieldValidatorConfig';
  errorMessage: Scalars['String']['output'];
  id: Scalars['String']['output'];
  parameters: Array<FieldValidatorConfigParameter>;
  validatorKey: Scalars['String']['output'];
};

export type FieldValidatorConfigFilterInput = {
  and?: InputMaybe<Array<FieldValidatorConfigFilterInput>>;
  errorMessage?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FieldValidatorConfigFilterInput>>;
  parameters?: InputMaybe<ListFilterInputTypeOfFieldValidatorConfigParameterFilterInput>;
  validatorKey?: InputMaybe<StringOperationFilterInput>;
};

export type FieldValidatorConfigInput = {
  errorMessage: Scalars['String']['input'];
  id: Scalars['String']['input'];
  parameters: Array<FieldValidatorConfigParameterInput>;
  validatorKey: Scalars['String']['input'];
};

export type FieldValidatorConfigParameter = {
  __typename?: 'FieldValidatorConfigParameter';
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type FieldValidatorConfigParameterFilterInput = {
  and?: InputMaybe<Array<FieldValidatorConfigParameterFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  key?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FieldValidatorConfigParameterFilterInput>>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type FieldValidatorConfigParameterInput = {
  id: Scalars['String']['input'];
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type FileInvestisseur = {
  __typename?: 'FileInvestisseur';
  code?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  nom?: Maybe<Scalars['String']['output']>;
  prenom?: Maybe<Scalars['String']['output']>;
};

export type FileMetadata = {
  __typename?: 'FileMetadata';
  actif?: Maybe<Scalars['Boolean']['output']>;
  categorieCode?: Maybe<GedCategory>;
  consultantId?: Maybe<Scalars['Long']['output']>;
  contratId?: Maybe<Scalars['String']['output']>;
  creePar?: Maybe<Scalars['String']['output']>;
  dateDeCreation: Scalars['DateTime']['output'];
  dateDeDebutValidite?: Maybe<Scalars['DateTime']['output']>;
  dateDeDerniereModification: Scalars['DateTime']['output'];
  dateDeFinValidite?: Maybe<Scalars['DateTime']['output']>;
  dateDeReference?: Maybe<Scalars['LocalDate']['output']>;
  dateSignature?: Maybe<Scalars['DateTime']['output']>;
  denomination?: Maybe<Scalars['String']['output']>;
  derniereModificationPar?: Maybe<Scalars['String']['output']>;
  documentIdentifier?: Maybe<Scalars['String']['output']>;
  etatSignature?: Maybe<SignatureState>;
  extension?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  investisseurId?: Maybe<Scalars['Long']['output']>;
  investisseurIds?: Maybe<Array<Scalars['Long']['output']>>;
  investisseurs: Array<Maybe<FileInvestisseur>>;
  isHandwrittenSignature: Scalars['Boolean']['output'];
  patrimoineId?: Maybe<Scalars['String']['output']>;
  permission?: Maybe<Permission>;
  signatureId?: Maybe<Scalars['String']['output']>;
  signatureOrder?: Maybe<Scalars['Int']['output']>;
  signatureStates?: Maybe<SignerStatesResponse>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  typeDocument?: Maybe<GedDocumentType>;
  typeDocumentCode?: Maybe<Scalars['String']['output']>;
  typeLibelle?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  urlExpireDate?: Maybe<Scalars['DateTime']['output']>;
  versionNumber?: Maybe<Scalars['Int']['output']>;
};


export type FileMetadataInvestisseurIdsArgs = {
  where?: InputMaybe<LongOperationFilterInput>;
};


export type FileMetadataTagsArgs = {
  where?: InputMaybe<StringOperationFilterInput>;
};

export type FileMetadataFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<FileMetadataFilterInput>>;
  categorieCode?: InputMaybe<NullableOfGedCategoryOperationFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  contratId?: InputMaybe<StringOperationFilterInput>;
  creePar?: InputMaybe<StringOperationFilterInput>;
  dateDeCreation?: InputMaybe<DateTimeOperationFilterInput>;
  dateDeDebutValidite?: InputMaybe<DateTimeOperationFilterInput>;
  dateDeDerniereModification?: InputMaybe<DateTimeOperationFilterInput>;
  dateDeFinValidite?: InputMaybe<DateTimeOperationFilterInput>;
  dateDeReference?: InputMaybe<LocalDateOperationFilterInput>;
  dateSignature?: InputMaybe<DateTimeOperationFilterInput>;
  denomination?: InputMaybe<StringOperationFilterInput>;
  derniereModificationPar?: InputMaybe<StringOperationFilterInput>;
  etatSignature?: InputMaybe<NullableOfSignatureStateOperationFilterInput>;
  extension?: InputMaybe<StringOperationFilterInput>;
  fileId?: InputMaybe<StringOperationFilterInput>;
  fileName?: InputMaybe<StringOperationFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  investisseurIds?: InputMaybe<ListLongOperationFilterInput>;
  isHandwrittenSignature?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<FileMetadataFilterInput>>;
  patrimoineId?: InputMaybe<StringOperationFilterInput>;
  permission?: InputMaybe<NullableOfPermissionOperationFilterInput>;
  signatureId?: InputMaybe<StringOperationFilterInput>;
  signatureOrder?: InputMaybe<IntOperationFilterInput>;
  tags?: InputMaybe<ListStringOperationFilterInput>;
  typeDocument?: InputMaybe<NullableOfGedDocumentTypeOperationFilterInput>;
  typeDocumentCode?: InputMaybe<StringOperationFilterInput>;
  url?: InputMaybe<StringOperationFilterInput>;
  urlExpireDate?: InputMaybe<DateTimeOperationFilterInput>;
  versionNumber?: InputMaybe<IntOperationFilterInput>;
};

export type FileMetadataSortInput = {
  actif?: InputMaybe<SortEnumType>;
  categorieCode?: InputMaybe<SortEnumType>;
  consultantId?: InputMaybe<SortEnumType>;
  contratId?: InputMaybe<SortEnumType>;
  creePar?: InputMaybe<SortEnumType>;
  dateDeCreation?: InputMaybe<SortEnumType>;
  dateDeDebutValidite?: InputMaybe<SortEnumType>;
  dateDeDerniereModification?: InputMaybe<SortEnumType>;
  dateDeFinValidite?: InputMaybe<SortEnumType>;
  dateDeReference?: InputMaybe<SortEnumType>;
  dateSignature?: InputMaybe<SortEnumType>;
  denomination?: InputMaybe<SortEnumType>;
  derniereModificationPar?: InputMaybe<SortEnumType>;
  etatSignature?: InputMaybe<SortEnumType>;
  extension?: InputMaybe<SortEnumType>;
  fileId?: InputMaybe<SortEnumType>;
  fileName?: InputMaybe<SortEnumType>;
  investisseurId?: InputMaybe<SortEnumType>;
  isHandwrittenSignature?: InputMaybe<SortEnumType>;
  patrimoineId?: InputMaybe<SortEnumType>;
  permission?: InputMaybe<SortEnumType>;
  signatureId?: InputMaybe<SortEnumType>;
  signatureOrder?: InputMaybe<SortEnumType>;
  typeDocument?: InputMaybe<SortEnumType>;
  typeDocumentCode?: InputMaybe<SortEnumType>;
  url?: InputMaybe<SortEnumType>;
  urlExpireDate?: InputMaybe<SortEnumType>;
  versionNumber?: InputMaybe<SortEnumType>;
};

export type FileMetadataUpdateInput = {
  actif?: InputMaybe<Scalars['Boolean']['input']>;
  denomination?: InputMaybe<Scalars['String']['input']>;
  extension?: InputMaybe<Scalars['String']['input']>;
  typeDocumentCode?: InputMaybe<Scalars['String']['input']>;
};

export enum FileStorageStatus {
  Active = 'ACTIVE',
  Deprecated = 'DEPRECATED'
}

export type FilialeFacturation = {
  __typename?: 'FilialeFacturation';
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate: Scalars['DateTime']['output'];
  gammeProduit: Array<GammeProduit>;
  libelle: Scalars['String']['output'];
  produit: Array<Produit>;
};


export type FilialeFacturationGammeProduitArgs = {
  where?: InputMaybe<GammeProduitFilterInput>;
};


export type FilialeFacturationProduitArgs = {
  where?: InputMaybe<ProduitFilterInput>;
};

export type FilialeFacturationFilterInput = {
  and?: InputMaybe<Array<FilialeFacturationFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  gammeProduit?: InputMaybe<ListFilterInputTypeOfGammeProduitFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FilialeFacturationFilterInput>>;
  produit?: InputMaybe<ListFilterInputTypeOfProduitFilterInput>;
};

export type FilialeFacturationSortInput = {
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type FilleulDataInput = {
  adresse: AdresseInput;
  civilite: Scalars['String']['input'];
  codeComFilleulProspect: Scalars['String']['input'];
  codeParrain: Scalars['String']['input'];
  codePaysNaissance: Scalars['String']['input'];
  codePaysNationalite: Scalars['String']['input'];
  dateNaissance: Scalars['String']['input'];
  departementNaissance: Scalars['String']['input'];
  email: Scalars['String']['input'];
  emailFacturation: Scalars['String']['input'];
  genre?: InputMaybe<Scalars['String']['input']>;
  isExclusif: Scalars['Boolean']['input'];
  nom: Scalars['String']['input'];
  nomNaissance: Scalars['String']['input'];
  prenom: Scalars['String']['input'];
  prenoms: Scalars['String']['input'];
  professionLiberale?: InputMaybe<ProfessionLiberaleInput>;
  societe?: InputMaybe<SocieteInput>;
  souhaitCollabStelliumFi: Scalars['Boolean']['input'];
  statutJuridiqueAssurance: TypeStatutJuridique;
  statutJuridiqueImmobilier: TypeStatutJuridique;
  telephone: TelephoneInput;
  villeNaissance: Scalars['String']['input'];
};

export type FilterDateTimeInput = {
  mode: FilterMode;
  toCompare?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum FilterMode {
  Contains = 'CONTAINS',
  Equal = 'EQUAL',
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  LessThanOrEqual = 'LESS_THAN_OR_EQUAL',
  NoneOf = 'NONE_OF',
  OneOf = 'ONE_OF',
  Unequal = 'UNEQUAL'
}

export type FonctionContact = {
  __typename?: 'FonctionContact';
  code: Scalars['Byte']['output'];
  contact: Array<Contact>;
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};


export type FonctionContactContactArgs = {
  where?: InputMaybe<ContactFilterInput>;
};

export type FonctionContactFilterInput = {
  and?: InputMaybe<Array<FonctionContactFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  contact?: InputMaybe<ListFilterInputTypeOfContactFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FonctionContactFilterInput>>;
};

export type FondsEvenementiel = {
  __typename?: 'FondsEvenementiel';
  code: Scalars['String']['output'];
  id: Scalars['String']['output'];
  libelle: Scalars['String']['output'];
  modeDeGestionCode: Scalars['String']['output'];
  ordre: Scalars['Int']['output'];
  produits: Array<Produit>;
};

export type FondsEvenementielConseil = {
  __typename?: 'FondsEvenementielConseil';
  code: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  libelle: Scalars['String']['output'];
};

export type FondsEvenementielConseilFilterInput = {
  and?: InputMaybe<Array<FondsEvenementielConseilFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isSelected?: InputMaybe<BooleanOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FondsEvenementielConseilFilterInput>>;
};

export type FondsEvenementielConseilInput = {
  code: Scalars['String']['input'];
  id: Scalars['String']['input'];
  isSelected?: InputMaybe<Scalars['Boolean']['input']>;
  libelle: Scalars['String']['input'];
};

export type FondsEvenementielExtension = {
  __typename?: 'FondsEvenementielExtension';
  id: Scalars['Long']['output'];
};

export type FondsEvenementielFilterInput = {
  and?: InputMaybe<Array<FondsEvenementielFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  modeDeGestionCode?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FondsEvenementielFilterInput>>;
  ordre?: InputMaybe<IntOperationFilterInput>;
  produits?: InputMaybe<ListFilterInputTypeOfProduitFilterInput>;
};

export type FondsEvenementielSortInput = {
  code?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
  modeDeGestionCode?: InputMaybe<SortEnumType>;
  ordre?: InputMaybe<SortEnumType>;
};

export type Formation = {
  __typename?: 'Formation';
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  equivalenceDeFormation: Array<EquivalenceDeFormation>;
  libelle: Scalars['String']['output'];
  type: Scalars['Byte']['output'];
  typeNavigation: FormationType;
};


export type FormationEquivalenceDeFormationArgs = {
  where?: InputMaybe<EquivalenceDeFormationFilterInput>;
};

export type FormationContinue = {
  __typename?: 'FormationContinue';
  codeFamille?: Maybe<Scalars['Byte']['output']>;
  consultantId: Scalars['Long']['output'];
  cursus: Scalars['String']['output'];
  dateValidationFormation?: Maybe<Scalars['DateTime']['output']>;
  formationValide?: Maybe<Scalars['Byte']['output']>;
  millesime: Scalars['Int']['output'];
  nbHeures?: Maybe<Scalars['Decimal']['output']>;
  nomADF: Scalars['String']['output'];
  nomSession: Scalars['String']['output'];
  referenceActionDeFormation: Scalars['String']['output'];
};

export type FormationContinueFilterInput = {
  and?: InputMaybe<Array<FormationContinueFilterInput>>;
  codeFamille?: InputMaybe<ByteOperationFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  cursus?: InputMaybe<StringOperationFilterInput>;
  dateValidationFormation?: InputMaybe<DateTimeOperationFilterInput>;
  formationValide?: InputMaybe<ByteOperationFilterInput>;
  millesime?: InputMaybe<IntOperationFilterInput>;
  nbHeures?: InputMaybe<DecimalOperationFilterInput>;
  nomADF?: InputMaybe<StringOperationFilterInput>;
  nomSession?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FormationContinueFilterInput>>;
  referenceActionDeFormation?: InputMaybe<StringOperationFilterInput>;
};

export type FormationContinueSortInput = {
  codeFamille?: InputMaybe<SortEnumType>;
  consultantId?: InputMaybe<SortEnumType>;
  cursus?: InputMaybe<SortEnumType>;
  dateValidationFormation?: InputMaybe<SortEnumType>;
  formationValide?: InputMaybe<SortEnumType>;
  millesime?: InputMaybe<SortEnumType>;
  nbHeures?: InputMaybe<SortEnumType>;
  nomADF?: InputMaybe<SortEnumType>;
  nomSession?: InputMaybe<SortEnumType>;
  referenceActionDeFormation?: InputMaybe<SortEnumType>;
};

export type FormationEtat = {
  __typename?: 'FormationEtat';
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  inscriptionCycleCourt: Array<InscriptionCycleCourt>;
  inscriptionSession: Array<InscriptionSession>;
  libelle: Scalars['String']['output'];
};


export type FormationEtatInscriptionCycleCourtArgs = {
  where?: InputMaybe<InscriptionCycleCourtFilterInput>;
};


export type FormationEtatInscriptionSessionArgs = {
  where?: InputMaybe<InscriptionSessionFilterInput>;
};

export type FormationEtatFilterInput = {
  and?: InputMaybe<Array<FormationEtatFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  inscriptionCycleCourt?: InputMaybe<ListFilterInputTypeOfInscriptionCycleCourtFilterInput>;
  inscriptionSession?: InputMaybe<ListFilterInputTypeOfInscriptionSessionFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FormationEtatFilterInput>>;
};

export type FormationFilterInput = {
  and?: InputMaybe<Array<FormationFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  equivalenceDeFormation?: InputMaybe<ListFilterInputTypeOfEquivalenceDeFormationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FormationFilterInput>>;
  type?: InputMaybe<ByteOperationFilterInput>;
  typeNavigation?: InputMaybe<FormationTypeFilterInput>;
};

export type FormationHabilitante = {
  __typename?: 'FormationHabilitante';
  codeEtat?: Maybe<Scalars['Byte']['output']>;
  codeNature?: Maybe<Scalars['Byte']['output']>;
  consultantId: Scalars['Long']['output'];
  creationDate: Scalars['DateTime']['output'];
  cursus: Scalars['String']['output'];
  dateInscription?: Maybe<Scalars['DateTime']['output']>;
  dateValidationFormation?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  formationValide?: Maybe<Scalars['Byte']['output']>;
  nomADF: Scalars['String']['output'];
  nomSession: Scalars['String']['output'];
  referenceActionDeFormation: Scalars['String']['output'];
  sessionId?: Maybe<Scalars['Long']['output']>;
  typesHabilitations?: Maybe<Array<TypeHabilitation>>;
};


export type FormationHabilitanteTypesHabilitationsArgs = {
  where?: InputMaybe<TypeHabilitationOperationFilterInput>;
};

export type FormationHabilitanteFilterInput = {
  and?: InputMaybe<Array<FormationHabilitanteFilterInput>>;
  codeEtat?: InputMaybe<ByteOperationFilterInput>;
  codeNature?: InputMaybe<ByteOperationFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  cursus?: InputMaybe<StringOperationFilterInput>;
  dateInscription?: InputMaybe<DateTimeOperationFilterInput>;
  dateValidationFormation?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  formationValide?: InputMaybe<ByteOperationFilterInput>;
  nomADF?: InputMaybe<StringOperationFilterInput>;
  nomSession?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FormationHabilitanteFilterInput>>;
  referenceActionDeFormation?: InputMaybe<StringOperationFilterInput>;
  sessionId?: InputMaybe<LongOperationFilterInput>;
  typesHabilitations?: InputMaybe<ListTypeHabilitationOperationFilterInput>;
};

export type FormationHabilitanteSortInput = {
  codeEtat?: InputMaybe<SortEnumType>;
  codeNature?: InputMaybe<SortEnumType>;
  consultantId?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  cursus?: InputMaybe<SortEnumType>;
  dateInscription?: InputMaybe<SortEnumType>;
  dateValidationFormation?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  formationValide?: InputMaybe<SortEnumType>;
  nomADF?: InputMaybe<SortEnumType>;
  nomSession?: InputMaybe<SortEnumType>;
  referenceActionDeFormation?: InputMaybe<SortEnumType>;
  sessionId?: InputMaybe<SortEnumType>;
};

export type FormationMotifAbandon = {
  __typename?: 'FormationMotifAbandon';
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  inscriptionCycleCourt: Array<InscriptionCycleCourt>;
  libelle: Scalars['String']['output'];
};


export type FormationMotifAbandonInscriptionCycleCourtArgs = {
  where?: InputMaybe<InscriptionCycleCourtFilterInput>;
};

export type FormationMotifAbandonFilterInput = {
  and?: InputMaybe<Array<FormationMotifAbandonFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  inscriptionCycleCourt?: InputMaybe<ListFilterInputTypeOfInscriptionCycleCourtFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FormationMotifAbandonFilterInput>>;
};

export type FormationNature = {
  __typename?: 'FormationNature';
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  inscriptionCycleCourt: Array<InscriptionCycleCourt>;
  inscriptionSession: Array<InscriptionSession>;
  libelle: Scalars['String']['output'];
};


export type FormationNatureInscriptionCycleCourtArgs = {
  where?: InputMaybe<InscriptionCycleCourtFilterInput>;
};


export type FormationNatureInscriptionSessionArgs = {
  where?: InputMaybe<InscriptionSessionFilterInput>;
};

export type FormationNatureFilterInput = {
  and?: InputMaybe<Array<FormationNatureFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  inscriptionCycleCourt?: InputMaybe<ListFilterInputTypeOfInscriptionCycleCourtFilterInput>;
  inscriptionSession?: InputMaybe<ListFilterInputTypeOfInscriptionSessionFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FormationNatureFilterInput>>;
};

export type FormationOrigine = {
  __typename?: 'FormationOrigine';
  code: Scalars['String']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  inscriptionCycleCourt: Array<InscriptionCycleCourt>;
  libelle: Scalars['String']['output'];
};


export type FormationOrigineInscriptionCycleCourtArgs = {
  where?: InputMaybe<InscriptionCycleCourtFilterInput>;
};

export type FormationOrigineFilterInput = {
  and?: InputMaybe<Array<FormationOrigineFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  inscriptionCycleCourt?: InputMaybe<ListFilterInputTypeOfInscriptionCycleCourtFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FormationOrigineFilterInput>>;
};

export type FormationSaison = {
  __typename?: 'FormationSaison';
  actionDeFormation: Array<ActionDeFormation>;
  code: Scalars['Byte']['output'];
  codeSource: Scalars['String']['output'];
  creationDate: Scalars['DateTime']['output'];
  cursus: Array<Cursus>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};


export type FormationSaisonActionDeFormationArgs = {
  where?: InputMaybe<ActionDeFormationFilterInput>;
};


export type FormationSaisonCursusArgs = {
  where?: InputMaybe<CursusFilterInput>;
};

export type FormationSaisonFilterInput = {
  actionDeFormation?: InputMaybe<ListFilterInputTypeOfActionDeFormationFilterInput>;
  and?: InputMaybe<Array<FormationSaisonFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  codeSource?: InputMaybe<StringOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  cursus?: InputMaybe<ListFilterInputTypeOfCursusFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FormationSaisonFilterInput>>;
};

export type FormationType = {
  __typename?: 'FormationType';
  actionDeFormation: Array<ActionDeFormation>;
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  cursus: Array<Cursus>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  formation: Array<Formation>;
  libelle: Scalars['String']['output'];
};


export type FormationTypeActionDeFormationArgs = {
  where?: InputMaybe<ActionDeFormationFilterInput>;
};


export type FormationTypeCursusArgs = {
  where?: InputMaybe<CursusFilterInput>;
};


export type FormationTypeFormationArgs = {
  where?: InputMaybe<FormationFilterInput>;
};

export type FormationTypeFilterInput = {
  actionDeFormation?: InputMaybe<ListFilterInputTypeOfActionDeFormationFilterInput>;
  and?: InputMaybe<Array<FormationTypeFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  cursus?: InputMaybe<ListFilterInputTypeOfCursusFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  formation?: InputMaybe<ListFilterInputTypeOfFormationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FormationTypeFilterInput>>;
};

export type FormeJuridique = {
  __typename?: 'FormeJuridique';
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  personneMorale: Array<PersonneMorale>;
  type: Scalars['Byte']['output'];
  typeNavigation: TypeFormeJuridique;
};


export type FormeJuridiquePersonneMoraleArgs = {
  where?: InputMaybe<PersonneMoraleFilterInput>;
};

export type FormeJuridiqueFilterInput = {
  and?: InputMaybe<Array<FormeJuridiqueFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FormeJuridiqueFilterInput>>;
  personneMorale?: InputMaybe<ListFilterInputTypeOfPersonneMoraleFilterInput>;
  type?: InputMaybe<ByteOperationFilterInput>;
  typeNavigation?: InputMaybe<TypeFormeJuridiqueFilterInput>;
};

export enum FrequenceVersement {
  Annuel = 'ANNUEL',
  Mensuel = 'MENSUEL',
  Semestriel = 'SEMESTRIEL',
  Trimestriel = 'TRIMESTRIEL'
}

export type GammeProduit = {
  __typename?: 'GammeProduit';
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  filialeFacturation: Scalars['Byte']['output'];
  filialeFacturationNavigation: FilialeFacturation;
  libelle: Scalars['String']['output'];
  type2Produit: Array<Type2Produit>;
};


export type GammeProduitType2ProduitArgs = {
  where?: InputMaybe<Type2ProduitFilterInput>;
};

export type GammeProduitFilterInput = {
  and?: InputMaybe<Array<GammeProduitFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  filialeFacturation?: InputMaybe<ByteOperationFilterInput>;
  filialeFacturationNavigation?: InputMaybe<FilialeFacturationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<GammeProduitFilterInput>>;
  type2Produit?: InputMaybe<ListFilterInputTypeOfType2ProduitFilterInput>;
};

export type GammeProduitSortInput = {
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  filialeFacturation?: InputMaybe<SortEnumType>;
  filialeFacturationNavigation?: InputMaybe<FilialeFacturationSortInput>;
  libelle?: InputMaybe<SortEnumType>;
};

export type GedCategorie = {
  __typename?: 'GedCategorie';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  creationDate: Scalars['DateTime']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  gedTypeDocument: Array<GedTypeDocument>;
  libelle: Scalars['String']['output'];
};


export type GedCategorieGedTypeDocumentArgs = {
  where?: InputMaybe<GedTypeDocumentFilterInput>;
};

export type GedCategorieFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<GedCategorieFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  gedTypeDocument?: InputMaybe<ListFilterInputTypeOfGedTypeDocumentFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<GedCategorieFilterInput>>;
};

export enum GedCategory {
  Affi = 'AFFI',
  Apprenti = 'APPRENTI',
  Autre = 'AUTRE',
  Contrat = 'CONTRAT',
  ContratFinancement = 'CONTRAT_FINANCEMENT',
  Corres = 'CORRES',
  Credits = 'CREDITS',
  Documentpersonnel = 'DOCUMENTPERSONNEL',
  Epargne = 'EPARGNE',
  Groupe = 'GROUPE',
  Hab = 'HAB',
  Icont = 'ICONT',
  IdentiteCoordonnees = 'IDENTITE_COORDONNEES',
  Idt = 'IDT',
  Immo = 'IMMO',
  Impots = 'IMPOTS',
  Label = 'LABEL',
  Nr = 'NR',
  Portrait = 'PORTRAIT',
  Reglementaire = 'REGLEMENTAIRE',
  Revenus = 'REVENUS',
  Service = 'SERVICE',
  SimulationFinancement = 'SIMULATION_FINANCEMENT',
  Staj = 'STAJ',
  ValeurNonSupportee = 'VALEUR_NON_SUPPORTEE'
}

export enum GedDocumentType {
  ActDeces = 'ACT_DECES',
  ActNaissance = 'ACT_NAISSANCE',
  ActProp = 'ACT_PROP',
  AraConsPj1 = 'ARA_CONS_PJ1',
  AraConsPj2 = 'ARA_CONS_PJ2',
  AraConsPj3 = 'ARA_CONS_PJ3',
  AraConsPj17 = 'ARA_CONS_PJ17',
  AraConsPj18 = 'ARA_CONS_PJ18',
  AraConsPj19 = 'ARA_CONS_PJ19',
  AraConsPj20 = 'ARA_CONS_PJ20',
  AraConsPj21 = 'ARA_CONS_PJ21',
  AraConsPj22 = 'ARA_CONS_PJ22',
  AraConsPj65 = 'ARA_CONS_PJ65',
  AraConsPj66 = 'ARA_CONS_PJ66',
  AraConsPj67 = 'ARA_CONS_PJ67',
  AraConsPj68 = 'ARA_CONS_PJ68',
  AraConsPj69 = 'ARA_CONS_PJ69',
  AraConsPj70 = 'ARA_CONS_PJ70',
  AraConsPj71 = 'ARA_CONS_PJ71',
  AraConsPj81 = 'ARA_CONS_PJ81',
  AraConsPj82 = 'ARA_CONS_PJ82',
  AraConsPj83 = 'ARA_CONS_PJ83',
  AraConsPj84 = 'ARA_CONS_PJ84',
  AraConsPj85 = 'ARA_CONS_PJ85',
  AraConsPj86 = 'ARA_CONS_PJ86',
  AraConsPj87 = 'ARA_CONS_PJ87',
  AraConsPj88 = 'ARA_CONS_PJ88',
  AraConsPj89 = 'ARA_CONS_PJ89',
  AraConsPj90 = 'ARA_CONS_PJ90',
  AraConsPj91 = 'ARA_CONS_PJ91',
  AraConsPj92 = 'ARA_CONS_PJ92',
  AraConsPj94 = 'ARA_CONS_PJ94',
  AraConsPj95 = 'ARA_CONS_PJ95',
  AraConsPj96 = 'ARA_CONS_PJ96',
  AraConsPj97 = 'ARA_CONS_PJ97',
  AraConsPj132 = 'ARA_CONS_PJ132',
  AraConsPj164 = 'ARA_CONS_PJ164',
  AraConsPj165 = 'ARA_CONS_PJ165',
  AraConsPj166 = 'ARA_CONS_PJ166',
  AraConsPj167 = 'ARA_CONS_PJ167',
  AraConsPj168 = 'ARA_CONS_PJ168',
  AraConsPj169 = 'ARA_CONS_PJ169',
  AraConsPj170 = 'ARA_CONS_PJ170',
  AraConsPj171 = 'ARA_CONS_PJ171',
  AraConsPj172 = 'ARA_CONS_PJ172',
  AraConsPj173 = 'ARA_CONS_PJ173',
  AraConsPj174 = 'ARA_CONS_PJ174',
  AraConsPj175 = 'ARA_CONS_PJ175',
  AraConsPj177 = 'ARA_CONS_PJ177',
  AraConsPj178 = 'ARA_CONS_PJ178',
  AraConsPj179 = 'ARA_CONS_PJ179',
  AraConsPj180 = 'ARA_CONS_PJ180',
  AraConsPj196 = 'ARA_CONS_PJ196',
  AraConsPj212 = 'ARA_CONS_PJ212',
  AraConsPj228 = 'ARA_CONS_PJ228',
  AraConsPj244 = 'ARA_CONS_PJ244',
  AraConsPj261 = 'ARA_CONS_PJ261',
  AraConsPj262 = 'ARA_CONS_PJ262',
  AraConsPj263 = 'ARA_CONS_PJ263',
  AraConsPj278 = 'ARA_CONS_PJ278',
  AraConsPj294 = 'ARA_CONS_PJ294',
  AraConsPj313 = 'ARA_CONS_PJ313',
  AraConsPj314 = 'ARA_CONS_PJ314',
  AraConsPj329 = 'ARA_CONS_PJ329',
  AraConsPj330 = 'ARA_CONS_PJ330',
  AraConsPj331 = 'ARA_CONS_PJ331',
  AraConsPj332 = 'ARA_CONS_PJ332',
  AraConsPj333 = 'ARA_CONS_PJ333',
  AraConsPj334 = 'ARA_CONS_PJ334',
  AraConsPj361 = 'ARA_CONS_PJ361',
  AraConsPj377 = 'ARA_CONS_PJ377',
  AraConsPj378 = 'ARA_CONS_PJ378',
  AraConsPj489 = 'ARA_CONS_PJ489',
  Att85A = 'ATT85A',
  AttestCollabCci = 'ATTEST_COLLAB_CCI',
  AttFi = 'ATT_FI',
  AttFiad = 'ATT_FIAD',
  AttFormation = 'ATT_FORMATION',
  AttHabImmo = 'ATT_HAB_IMMO',
  AttHeberg = 'ATT_HEBERG',
  AttInv = 'ATT_INV',
  AttResTmp = 'ATT_RES_TMP',
  AttSign = 'ATT_SIGN',
  AttStellium = 'ATT_STELLIUM',
  AttStNoFr = 'ATT_ST_NO_FR',
  AttUsg = 'ATT_USG',
  AttVigilanceAgc = 'ATT_VIGILANCE_AGC',
  AttVigilancePl = 'ATT_VIGILANCE_PL',
  AttVigilanceSoc = 'ATT_VIGILANCE_SOC',
  Autre = 'AUTRE',
  AvenantActivConcur = 'AVENANT_ACTIV_CONCUR',
  AvenantFinActivConcur = 'AVENANT_FIN_ACTIV_CONCUR',
  AvenantMif2Alpsi = 'AVENANT_MIF2_ALPSI',
  AvenantMif2Cif = 'AVENANT_MIF2_CIF',
  BancReleve = 'BANC_RELEVE',
  BilanCompt = 'BILAN_COMPT',
  BilanExploit = 'BILAN_EXPLOIT',
  BullPaye = 'BULL_PAYE',
  BullPayeDernierDecembre = 'BULL_PAYE_DERNIER_DECEMBRE',
  CaptureSyntheseCompteUrssaf = 'CAPTURE_SYNTHESE_COMPTE_URSSAF',
  CarteDemarchageAlpsi = 'CARTE_DEMARCHAGE_ALPSI',
  CarteDemarchageStefi = 'CARTE_DEMARCHAGE_STEFI',
  CarteT = 'CARTE_T',
  CarteVitale = 'CARTE_VITALE',
  Carto = 'CARTO',
  Cerfa3558Agc = 'CERFA3558_AGC',
  Cerfa3558Pl = 'CERFA3558_PL',
  Cerfa3558Soc = 'CERFA3558_SOC',
  Cerfa3666Agc = 'CERFA3666_AGC',
  Cerfa3666Pl = 'CERFA3666_PL',
  Cerfa3666Soc = 'CERFA3666_SOC',
  CertifTravail = 'CERTIF_TRAVAIL',
  Cni = 'CNI',
  CniHeberg = 'CNI_HEBERG',
  CniMere = 'CNI_MERE',
  CniPere = 'CNI_PERE',
  ContAgentCo = 'CONT_AGENT_CO',
  ContApprentissage = 'CONT_APPRENTISSAGE',
  ContAutre = 'CONT_AUTRE',
  ContCollabFinancement = 'CONT_COLLAB_FINANCEMENT',
  ContIntermAssuCourtage = 'CONT_INTERM_ASSU_COURTAGE',
  ContTrav = 'CONT_TRAV',
  ConventionCadre = 'CONVENTION_CADRE',
  ConvDistribInvest = 'CONV_DISTRIB_INVEST',
  Dci = 'DCI',
  DclAdeq = 'DCL_ADEQ',
  DeclFond = 'DECL_FOND',
  Der = 'DER',
  Diplome = 'DIPLOME',
  EditionConsultant = 'EDITION_CONSULTANT',
  EpargnReleve = 'EPARGN_RELEVE',
  Esp = 'ESP',
  Esp1Er = 'ESP1ER',
  ExtrCasierJudi = 'EXTR_CASIER_JUDI',
  ExtrKbis = 'EXTR_KBIS',
  ExtMarg = 'EXT_MARG',
  FicheConseil = 'FICHE_CONSEIL',
  FinBancReleve = 'FIN_BANC_RELEVE',
  FinBilan = 'FIN_BILAN',
  FinImpotsMultiple = 'FIN_IMPOTS_MULTIPLE',
  FinRevPlus55 = 'FIN_REV_PLUS55',
  FormationContinueAlpsi = 'FORMATION_CONTINUE_ALPSI',
  FormationContinueAssu = 'FORMATION_CONTINUE_ASSU',
  FormationContinueFinancement = 'FORMATION_CONTINUE_FINANCEMENT',
  FormationContinueImmo = 'FORMATION_CONTINUE_IMMO',
  FormulaireRelationSecondaire = 'FORMULAIRE_RELATION_SECONDAIRE',
  FormulaireTransfertClient = 'FORMULAIRE_TRANSFERT_CLIENT',
  Fpat = 'FPAT',
  Fpres = 'FPRES',
  ImmatOriasAlpsi = 'IMMAT_ORIAS_ALPSI',
  ImmatOriasCif = 'IMMAT_ORIAS_CIF',
  ImmatOriasIob = 'IMMAT_ORIAS_IOB',
  ImmatOriasMia = 'IMMAT_ORIAS_MIA',
  ImmoCompromis = 'IMMO_COMPROMIS',
  ImmoResa = 'IMMO_RESA',
  Impot2031 = 'IMPOT2031',
  Impot2035 = 'IMPOT2035',
  Impot2042 = 'IMPOT2042',
  Impot2044 = 'IMPOT2044',
  Impot2139 = 'IMPOT2139',
  ImpotAvis = 'IMPOT_AVIS',
  ImpotAvisN = 'IMPOT_AVIS_N',
  ImpotAvisN1 = 'IMPOT_AVIS_N1',
  ImpotFonc = 'IMPOT_FONC',
  ImpotHab = 'IMPOT_HAB',
  ImpotIfi = 'IMPOT_IFI',
  Jd = 'JD',
  JugCurat = 'JUG_CURAT',
  JugDiv = 'JUG_DIV',
  JugOrd = 'JUG_ORD',
  JugTut = 'JUG_TUT',
  JustifApport = 'JUSTIF_APPORT',
  JustifDomicile = 'JUSTIF_DOMICILE',
  JustifPrim = 'JUSTIF_PRIM',
  JustDom = 'JUST_DOM',
  JustFiscEtr = 'JUST_FISC_ETR',
  JustFond = 'JUST_FOND',
  Kbis = 'KBIS',
  KbisPl = 'KBIS_PL',
  KbisSoc = 'KBIS_SOC',
  Lettre = 'LETTRE',
  LivretFam = 'LIVRET_FAM',
  LMission = 'L_MISSION',
  MandatAlpsi = 'MANDAT_ALPSI',
  MandatAutofac = 'MANDAT_AUTOFAC',
  MandatAutofacPar = 'MANDAT_AUTOFAC_PAR',
  MandatCif = 'MANDAT_CIF',
  MandatEntremisePl = 'MANDAT_ENTREMISE_PL',
  MandatEntremiseSoc = 'MANDAT_ENTREMISE_SOC',
  MandatFinanc = 'MANDAT_FINANC',
  MandatStefi = 'MANDAT_STEFI',
  MandatStelliumImmo = 'MANDAT_STELLIUM_IMMO',
  MariageContrat = 'MARIAGE_CONTRAT',
  MdtSepa = 'MDT_SEPA',
  Message = 'MESSAGE',
  NotifAffiliationAgc = 'NOTIF_AFFILIATION_AGC',
  NotifAffiliationPl = 'NOTIF_AFFILIATION_PL',
  NotifAffiliationSoc = 'NOTIF_AFFILIATION_SOC',
  NotifDemandeDelaiUrssaf = 'NOTIF_DEMANDE_DELAI_URSSAF',
  Nr = 'NR',
  OffrePret = 'OFFRE_PRET',
  PacsDiss = 'PACS_DISS',
  Passeport = 'PASSEPORT',
  PhotoIdentite = 'PHOTO_IDENTITE',
  PhotoPortrait = 'PHOTO_PORTRAIT',
  ProfInvest = 'PROF_INVEST',
  Rbe = 'RBE',
  Rcp = 'RCP',
  RecInfo = 'REC_INFO',
  Reglimpactplus = 'REGLIMPACTPLUS',
  RembAnticp = 'REMB_ANTICP',
  RevCptEpargne = 'REV_CPT_EPARGNE',
  RevFonc = 'REV_FONC',
  RevFoncBail = 'REV_FONC_BAIL',
  RevFoncEstim = 'REV_FONC_ESTIM',
  RevFoncQuit = 'REV_FONC_QUIT',
  RevPensions = 'REV_PENSIONS',
  Rib = 'RIB',
  RibAgc = 'RIB_AGC',
  RibPl = 'RIB_PL',
  RibSoc = 'RIB_SOC',
  Rsac = 'RSAC',
  Rto = 'RTO',
  SciStatuts = 'SCI_STATUTS',
  SimulFinanc = 'SIMUL_FINANC',
  Souscript = 'SOUSCRIPT',
  SouscriptComp = 'SOUSCRIPT_COMP',
  StatutSociete = 'STATUT_SOCIETE',
  TabAmort = 'TAB_AMORT',
  TitreSejour = 'TITRE_SEJOUR',
  TtireDansRachat = 'TTIRE_DANS_RACHAT',
  ValeurNonSupportee = 'VALEUR_NON_SUPPORTEE'
}

export type GedTypeDocument = {
  __typename?: 'GedTypeDocument';
  actif?: Maybe<Scalars['Boolean']['output']>;
  appartenanceDocument: AppartenanceDocument;
  appartenanceDocumentId: Scalars['Byte']['output'];
  code: Scalars['String']['output'];
  codeCategorie: Scalars['String']['output'];
  codeCategorieNavigation: GedCategorie;
  creationDate: Scalars['DateTime']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  dernierDocumentVisible: Scalars['Boolean']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  suppressionNonDefinitive: Scalars['Boolean']['output'];
};

export type GedTypeDocumentFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<GedTypeDocumentFilterInput>>;
  appartenanceDocument?: InputMaybe<AppartenanceDocumentFilterInput>;
  appartenanceDocumentId?: InputMaybe<ByteOperationFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  codeCategorie?: InputMaybe<StringOperationFilterInput>;
  codeCategorieNavigation?: InputMaybe<GedCategorieFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  dernierDocumentVisible?: InputMaybe<BooleanOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<GedTypeDocumentFilterInput>>;
  personnePhysiqueDocument?: InputMaybe<ListFilterInputTypeOfPersonnePhysiqueDocumentFilterInput>;
  suppressionNonDefinitive?: InputMaybe<BooleanOperationFilterInput>;
};

export type Habilitation = {
  __typename?: 'Habilitation';
  actif: Scalars['Boolean']['output'];
  associationProNom: Scalars['Boolean']['output'];
  cifPartenaireCode: Scalars['Boolean']['output'];
  code?: Maybe<Scalars['String']['output']>;
  consultantHabilitation: Array<ConsultantHabilitation>;
  creationDate: Scalars['DateTime']['output'];
  dateDebut?: Maybe<Scalars['LocalDate']['output']>;
  dateFin?: Maybe<Scalars['LocalDate']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  garantAdresse: Scalars['Boolean']['output'];
  garantNom: Scalars['Boolean']['output'];
  habilitationInscription: Array<HabilitationInscription>;
  habilitationRcp: Array<HabilitationRcp>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  libelle?: Maybe<Scalars['String']['output']>;
  lienConsultantStatutJuridiqueTypeHabilitation: Array<LienConsultantStatutJuridiqueTypeHabilitation>;
  mediateur: Scalars['Boolean']['output'];
  origineHabilitation?: Maybe<Scalars['String']['output']>;
  partenaireCourtierFinancement1: Scalars['Boolean']['output'];
  partenaireCourtierFinancement2: Scalars['Boolean']['output'];
  produit: Array<Produit>;
};


export type HabilitationConsultantHabilitationArgs = {
  where?: InputMaybe<ConsultantHabilitationFilterInput>;
};


export type HabilitationHabilitationInscriptionArgs = {
  where?: InputMaybe<HabilitationInscriptionFilterInput>;
};


export type HabilitationHabilitationRcpArgs = {
  where?: InputMaybe<HabilitationRcpFilterInput>;
};


export type HabilitationLienConsultantStatutJuridiqueTypeHabilitationArgs = {
  where?: InputMaybe<LienConsultantStatutJuridiqueTypeHabilitationFilterInput>;
};


export type HabilitationProduitArgs = {
  where?: InputMaybe<ProduitFilterInput>;
};

export type HabilitationFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<HabilitationFilterInput>>;
  associationProNom?: InputMaybe<BooleanOperationFilterInput>;
  cifPartenaireCode?: InputMaybe<BooleanOperationFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  consultantHabilitation?: InputMaybe<ListFilterInputTypeOfConsultantHabilitationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateDebut?: InputMaybe<LocalDateOperationFilterInput>;
  dateFin?: InputMaybe<LocalDateOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  garantAdresse?: InputMaybe<BooleanOperationFilterInput>;
  garantNom?: InputMaybe<BooleanOperationFilterInput>;
  habilitationInscription?: InputMaybe<ListFilterInputTypeOfHabilitationInscriptionFilterInput>;
  habilitationRcp?: InputMaybe<ListFilterInputTypeOfHabilitationRcpFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  lienConsultantStatutJuridiqueTypeHabilitation?: InputMaybe<ListFilterInputTypeOfLienConsultantStatutJuridiqueTypeHabilitationFilterInput>;
  mediateur?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<HabilitationFilterInput>>;
  origineHabilitation?: InputMaybe<StringOperationFilterInput>;
  partenaireCourtierFinancement1?: InputMaybe<BooleanOperationFilterInput>;
  partenaireCourtierFinancement2?: InputMaybe<BooleanOperationFilterInput>;
  produit?: InputMaybe<ListFilterInputTypeOfProduitFilterInput>;
};

export type HabilitationInfo = {
  __typename?: 'HabilitationInfo';
  habilitationId: Scalars['Long']['output'];
  statutChangeReasons: Array<ConsultantHabilitationStatutChangeReasonEnum>;
};


export type HabilitationInfoStatutChangeReasonsArgs = {
  where?: InputMaybe<ConsultantHabilitationStatutChangeReasonEnumOperationFilterInput>;
};

export type HabilitationInscription = {
  __typename?: 'HabilitationInscription';
  actif: Scalars['Boolean']['output'];
  dateAnniversaire?: Maybe<Scalars['DateTime']['output']>;
  dateFin?: Maybe<Scalars['DateTime']['output']>;
  dateFinFixe?: Maybe<Scalars['DateTime']['output']>;
  dureeValidite?: Maybe<Scalars['Int']['output']>;
  habilitation?: Maybe<Habilitation>;
  habilitationId?: Maybe<Scalars['Long']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  obligatoire?: Maybe<Scalars['Boolean']['output']>;
  organismeDefautCode?: Maybe<Scalars['String']['output']>;
  organismeDefautCodeNavigation?: Maybe<Organisme>;
};

export type HabilitationInscriptionCategorie = {
  __typename?: 'HabilitationInscriptionCategorie';
  code?: Maybe<Scalars['String']['output']>;
  consultantHabilitationInscriptionCategorie: Array<ConsultantHabilitationInscriptionCategorie>;
  id: Scalars['Int']['output'];
  libelle?: Maybe<Scalars['String']['output']>;
  mandataire?: Maybe<Scalars['String']['output']>;
};


export type HabilitationInscriptionCategorieConsultantHabilitationInscriptionCategorieArgs = {
  where?: InputMaybe<ConsultantHabilitationInscriptionCategorieFilterInput>;
};

export type HabilitationInscriptionCategorieFilterInput = {
  and?: InputMaybe<Array<HabilitationInscriptionCategorieFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  consultantHabilitationInscriptionCategorie?: InputMaybe<ListFilterInputTypeOfConsultantHabilitationInscriptionCategorieFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  mandataire?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<HabilitationInscriptionCategorieFilterInput>>;
};

export type HabilitationInscriptionFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<HabilitationInscriptionFilterInput>>;
  dateAnniversaire?: InputMaybe<DateTimeOperationFilterInput>;
  dateFin?: InputMaybe<DateTimeOperationFilterInput>;
  dateFinFixe?: InputMaybe<DateTimeOperationFilterInput>;
  dureeValidite?: InputMaybe<IntOperationFilterInput>;
  habilitation?: InputMaybe<HabilitationFilterInput>;
  habilitationId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  obligatoire?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<HabilitationInscriptionFilterInput>>;
  organismeDefautCode?: InputMaybe<StringOperationFilterInput>;
  organismeDefautCodeNavigation?: InputMaybe<OrganismeFilterInput>;
};

export type HabilitationRcp = {
  __typename?: 'HabilitationRcp';
  actif?: Maybe<Scalars['Boolean']['output']>;
  dateAnniversaire?: Maybe<Scalars['DateTime']['output']>;
  habilitation: Habilitation;
  habilitationId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  obligatoire?: Maybe<Scalars['Boolean']['output']>;
  typeRcpCode: Scalars['String']['output'];
  typeRcpCodeNavigation: TypeRcp;
};

export type HabilitationRcpFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<HabilitationRcpFilterInput>>;
  dateAnniversaire?: InputMaybe<DateTimeOperationFilterInput>;
  habilitation?: InputMaybe<HabilitationFilterInput>;
  habilitationId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  obligatoire?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<HabilitationRcpFilterInput>>;
  typeRcpCode?: InputMaybe<StringOperationFilterInput>;
  typeRcpCodeNavigation?: InputMaybe<TypeRcpFilterInput>;
};

export type HabilitationSortInput = {
  actif?: InputMaybe<SortEnumType>;
  associationProNom?: InputMaybe<SortEnumType>;
  cifPartenaireCode?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  dateDebut?: InputMaybe<SortEnumType>;
  dateFin?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  garantAdresse?: InputMaybe<SortEnumType>;
  garantNom?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  idSource?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
  mediateur?: InputMaybe<SortEnumType>;
  origineHabilitation?: InputMaybe<SortEnumType>;
  partenaireCourtierFinancement1?: InputMaybe<SortEnumType>;
  partenaireCourtierFinancement2?: InputMaybe<SortEnumType>;
};

export type HabilitationStatusOverrideInput = {
  consultantHabilitationId: Scalars['Long']['input'];
  consultantHabilitationTempStatut: Scalars['Boolean']['input'];
  dateEcheance?: InputMaybe<Scalars['DateTime']['input']>;
};

export type HabilitationStatusStopOverrideInput = {
  consultantHabilitationId: Scalars['Long']['input'];
};

export type HorizonPlacement = {
  __typename?: 'HorizonPlacement';
  horizonRetraite?: Maybe<Scalars['Decimal']['output']>;
  justification?: Maybe<Scalars['String']['output']>;
  value?: Maybe<HorizonPlacementEnum>;
};

export enum HorizonPlacementEnum {
  De0A3Ans = 'DE0A3ANS',
  De3A5Ans = 'DE3A5ANS',
  De5A8Ans = 'DE5A8ANS',
  De8A10Ans = 'DE8A10ANS',
  Retraite = 'RETRAITE',
  Sup10Ans = 'SUP10ANS'
}

export type HorizonPlacementFilterInput = {
  and?: InputMaybe<Array<HorizonPlacementFilterInput>>;
  horizonRetraite?: InputMaybe<DecimalOperationFilterInput>;
  justification?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<HorizonPlacementFilterInput>>;
  value?: InputMaybe<NullableOfHorizonPlacementEnumOperationFilterInput>;
};

export type HorizonPlacementInput = {
  horizonRetraite?: InputMaybe<Scalars['Decimal']['input']>;
  justification?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<HorizonPlacementEnum>;
};

export type HorizonPlacementSortInput = {
  horizonRetraite?: InputMaybe<SortEnumType>;
  justification?: InputMaybe<SortEnumType>;
  value?: InputMaybe<SortEnumType>;
};

export type InscriptionCycleCourt = {
  __typename?: 'InscriptionCycleCourt';
  codeEtat?: Maybe<Scalars['Byte']['output']>;
  codeEtatNavigation?: Maybe<FormationEtat>;
  codeMotifAbandon?: Maybe<Scalars['Byte']['output']>;
  codeMotifAbandonNavigation?: Maybe<FormationMotifAbandon>;
  codeNature?: Maybe<Scalars['Byte']['output']>;
  codeNatureNavigation?: Maybe<FormationNature>;
  codeOrigine?: Maybe<Scalars['String']['output']>;
  codeOrigineNavigation?: Maybe<FormationOrigine>;
  consultant: Consultant;
  consultantId: Scalars['Long']['output'];
  creationDate: Scalars['DateTime']['output'];
  cycleCourt?: Maybe<CycleCourt>;
  cycleCourtId?: Maybe<Scalars['Long']['output']>;
  dateAbandon?: Maybe<Scalars['DateTime']['output']>;
  dateDebutElearning?: Maybe<Scalars['DateTime']['output']>;
  dateFacture?: Maybe<Scalars['DateTime']['output']>;
  dateInscription?: Maybe<Scalars['DateTime']['output']>;
  dateValidationQCM?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  formationValide?: Maybe<Scalars['Byte']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['Long']['output']>;
  montantFacture?: Maybe<Scalars['Decimal']['output']>;
  numeroFacture?: Maybe<Scalars['String']['output']>;
};

export type InscriptionCycleCourtFilterInput = {
  and?: InputMaybe<Array<InscriptionCycleCourtFilterInput>>;
  codeEtat?: InputMaybe<ByteOperationFilterInput>;
  codeEtatNavigation?: InputMaybe<FormationEtatFilterInput>;
  codeMotifAbandon?: InputMaybe<ByteOperationFilterInput>;
  codeMotifAbandonNavigation?: InputMaybe<FormationMotifAbandonFilterInput>;
  codeNature?: InputMaybe<ByteOperationFilterInput>;
  codeNatureNavigation?: InputMaybe<FormationNatureFilterInput>;
  codeOrigine?: InputMaybe<StringOperationFilterInput>;
  codeOrigineNavigation?: InputMaybe<FormationOrigineFilterInput>;
  consultant?: InputMaybe<ConsultantFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  cycleCourt?: InputMaybe<CycleCourtFilterInput>;
  cycleCourtId?: InputMaybe<LongOperationFilterInput>;
  dateAbandon?: InputMaybe<DateTimeOperationFilterInput>;
  dateDebutElearning?: InputMaybe<DateTimeOperationFilterInput>;
  dateFacture?: InputMaybe<DateTimeOperationFilterInput>;
  dateInscription?: InputMaybe<DateTimeOperationFilterInput>;
  dateValidationQCM?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  formationValide?: InputMaybe<ByteOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<LongOperationFilterInput>;
  montantFacture?: InputMaybe<DecimalOperationFilterInput>;
  numeroFacture?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<InscriptionCycleCourtFilterInput>>;
};

export type InscriptionImmoInput = {
  dateDebut: Scalars['DateTime']['input'];
  dateDepot: Scalars['DateTime']['input'];
  dateFin: Scalars['DateTime']['input'];
  idStatutJuridique: Scalars['Long']['input'];
  numeroCarteT?: InputMaybe<Scalars['String']['input']>;
  organisme: Scalars['String']['input'];
};

export type InscriptionSession = {
  __typename?: 'InscriptionSession';
  codeEtat?: Maybe<Scalars['Byte']['output']>;
  codeEtatNavigation?: Maybe<FormationEtat>;
  codeNature?: Maybe<Scalars['Byte']['output']>;
  codeNatureNavigation?: Maybe<FormationNature>;
  consultant: Consultant;
  consultantId: Scalars['Long']['output'];
  creationDate: Scalars['DateTime']['output'];
  dateInscription?: Maybe<Scalars['DateTime']['output']>;
  dateValidationFormation?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  formationValide?: Maybe<Scalars['Byte']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['Long']['output']>;
  session?: Maybe<Session>;
  sessionId?: Maybe<Scalars['Long']['output']>;
};

export type InscriptionSessionFilterInput = {
  and?: InputMaybe<Array<InscriptionSessionFilterInput>>;
  codeEtat?: InputMaybe<ByteOperationFilterInput>;
  codeEtatNavigation?: InputMaybe<FormationEtatFilterInput>;
  codeNature?: InputMaybe<ByteOperationFilterInput>;
  codeNatureNavigation?: InputMaybe<FormationNatureFilterInput>;
  consultant?: InputMaybe<ConsultantFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateInscription?: InputMaybe<DateTimeOperationFilterInput>;
  dateValidationFormation?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  formationValide?: InputMaybe<ByteOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<InscriptionSessionFilterInput>>;
  session?: InputMaybe<SessionFilterInput>;
  sessionId?: InputMaybe<LongOperationFilterInput>;
};

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  ngt?: InputMaybe<Scalars['Int']['input']>;
  ngte?: InputMaybe<Scalars['Int']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  nlt?: InputMaybe<Scalars['Int']['input']>;
  nlte?: InputMaybe<Scalars['Int']['input']>;
};

export type Investisseur = {
  __typename?: 'Investisseur';
  arianeId?: Maybe<Scalars['Long']['output']>;
  cessionHistoInvestisseur: Array<CessionHistoInvestisseur>;
  civiliteCode?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  dateConnaissance?: Maybe<Scalars['LocalDate']['output']>;
  dateDernierScanAccuity?: Maybe<Scalars['LocalDate']['output']>;
  dateEntreeRelation?: Maybe<Scalars['LocalDate']['output']>;
  dateMajScanAccuityRequis?: Maybe<Scalars['LocalDate']['output']>;
  dateNaissance?: Maybe<Scalars['Date']['output']>;
  dateSuppression?: Maybe<Scalars['DateTime']['output']>;
  denomination?: Maybe<Scalars['String']['output']>;
  detenteurPatrimoineActif: Array<DetenteurPatrimoineActif>;
  detenteurPatrimoineChargeRevenu: Array<DetenteurPatrimoineChargeRevenu>;
  detenteurPatrimoinePassif: Array<DetenteurPatrimoinePassif>;
  displayName?: Maybe<Scalars['String']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  filesMetadata: Array<FileMetadata>;
  gdaBackOffice?: Maybe<Scalars['Boolean']['output']>;
  gerePar: AppReference;
  id: Scalars['Long']['output'];
  idSourceAramis?: Maybe<Scalars['String']['output']>;
  idSourceDiapason?: Maybe<Scalars['String']['output']>;
  inverseRecommandePar: Array<Investisseur>;
  investisseurCommande: Array<InvestisseurCommande>;
  investisseurConsultant: Array<InvestisseurConsultant>;
  investisseurConsultantRelations?: Maybe<Array<InvestisseurRelationConsultant>>;
  investisseurEntite?: Maybe<InvestisseurEntite>;
  investisseurObjectif: Array<InvestisseurObjectif>;
  investisseurQpi?: Maybe<InvestisseurQpi>;
  logiqueSuppression?: Maybe<Scalars['Boolean']['output']>;
  modeCommunication?: Maybe<Scalars['String']['output']>;
  modeCommunicationNavigation?: Maybe<ModeCommunication>;
  mouvement: Array<Mouvement>;
  nom?: Maybe<Scalars['String']['output']>;
  note: Array<Note>;
  objectifMontantEpargneMensuel?: Maybe<Scalars['Decimal']['output']>;
  objectifMontantEpargnePrecaution?: Maybe<Scalars['Decimal']['output']>;
  origineContactCode?: Maybe<Scalars['String']['output']>;
  origineContactCodeNavigation?: Maybe<OrigineContact>;
  origineSaisie?: Maybe<Scalars['Byte']['output']>;
  origineSaisieNavigation?: Maybe<OrigineData>;
  patrimoineFiscalite?: Maybe<PatrimoineFiscalite>;
  personneMorale: Array<PersonneMorale>;
  personnePhysique: Array<PersonnePhysique>;
  ppeBackOffice?: Maybe<Scalars['Boolean']['output']>;
  prenom?: Maybe<Scalars['String']['output']>;
  profil?: Maybe<ProfilInvestisseurFiche>;
  profilInvestisseur: Array<ProfilInvestisseur>;
  recommandePar?: Maybe<Investisseur>;
  recommandeParId?: Maybe<Scalars['Long']['output']>;
  recommandeParNom?: Maybe<Scalars['String']['output']>;
  scanAccuityRequis?: Maybe<Scalars['Boolean']['output']>;
  situationPersonnelle?: Maybe<SituationPersonnelle>;
  statutCode: Scalars['String']['output'];
  statutCodeNavigation?: Maybe<TypeStatutInvestisseur>;
};


export type InvestisseurCessionHistoInvestisseurArgs = {
  where?: InputMaybe<CessionHistoInvestisseurFilterInput>;
};


export type InvestisseurDetenteurPatrimoineActifArgs = {
  where?: InputMaybe<DetenteurPatrimoineActifFilterInput>;
};


export type InvestisseurDetenteurPatrimoineChargeRevenuArgs = {
  where?: InputMaybe<DetenteurPatrimoineChargeRevenuFilterInput>;
};


export type InvestisseurDetenteurPatrimoinePassifArgs = {
  where?: InputMaybe<DetenteurPatrimoinePassifFilterInput>;
};


export type InvestisseurInvestisseurCommandeArgs = {
  where?: InputMaybe<InvestisseurCommandeFilterInput>;
};


export type InvestisseurInvestisseurConsultantArgs = {
  where?: InputMaybe<InvestisseurConsultantFilterInput>;
};


export type InvestisseurInvestisseurObjectifArgs = {
  where?: InputMaybe<InvestisseurObjectifFilterInput>;
};


export type InvestisseurMouvementArgs = {
  where?: InputMaybe<MouvementFilterInput>;
};


export type InvestisseurNoteArgs = {
  where?: InputMaybe<NoteFilterInput>;
};


export type InvestisseurPersonneMoraleArgs = {
  where?: InputMaybe<PersonneMoraleFilterInput>;
};


export type InvestisseurPersonnePhysiqueArgs = {
  where?: InputMaybe<PersonnePhysiqueFilterInput>;
};


export type InvestisseurProfilInvestisseurArgs = {
  where?: InputMaybe<ProfilInvestisseurFilterInput>;
};

export type InvestisseurArianeUpdaterInput = {
  arianeId: Scalars['Long']['input'];
  code: Scalars['String']['input'];
  emailArianeId?: InputMaybe<Scalars['Long']['input']>;
  telephoneArianeId?: InputMaybe<Scalars['Long']['input']>;
};

export type InvestisseurCommande = {
  __typename?: 'InvestisseurCommande';
  commande: Commande;
  commandeId: Scalars['Long']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  investisseur?: Maybe<Investisseur>;
  investisseurId?: Maybe<Scalars['Long']['output']>;
  ordre: Scalars['Byte']['output'];
};

export type InvestisseurCommandeFilterInput = {
  and?: InputMaybe<Array<InvestisseurCommandeFilterInput>>;
  commande?: InputMaybe<CommandeFilterInput>;
  commandeId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  investisseur?: InputMaybe<InvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<InvestisseurCommandeFilterInput>>;
  ordre?: InputMaybe<ByteOperationFilterInput>;
};

export type InvestisseurConsultant = {
  __typename?: 'InvestisseurConsultant';
  actif: Scalars['Int']['output'];
  arianeId?: Maybe<Scalars['Long']['output']>;
  batchDateUpdate?: Maybe<Scalars['DateTime']['output']>;
  consultant?: Maybe<Consultant>;
  consultantId: Scalars['Long']['output'];
  creationDate: Scalars['DateTime']['output'];
  dateActivation: Scalars['DateTime']['output'];
  dateDesactivation?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['Long']['output']>;
  investisseur: Investisseur;
  investisseurId: Scalars['Long']['output'];
  typeRelationInvestisseurConsultantCode: Scalars['String']['output'];
  typeRelationInvestisseurConsultantCodeNavigation: TypeRelationInvestisseurConsultant;
};

export type InvestisseurConsultantFilterInput = {
  actif?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<InvestisseurConsultantFilterInput>>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  batchDateUpdate?: InputMaybe<DateTimeOperationFilterInput>;
  consultant?: InputMaybe<ConsultantFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateActivation?: InputMaybe<DateTimeOperationFilterInput>;
  dateDesactivation?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<LongOperationFilterInput>;
  investisseur?: InputMaybe<InvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<InvestisseurConsultantFilterInput>>;
  typeRelationInvestisseurConsultantCode?: InputMaybe<StringOperationFilterInput>;
  typeRelationInvestisseurConsultantCodeNavigation?: InputMaybe<TypeRelationInvestisseurConsultantFilterInput>;
};

/** A segment of a collection. */
export type InvestisseurConsultantPaginatedCollectionSegment = {
  __typename?: 'InvestisseurConsultantPaginatedCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<InvestisseurConsultant>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvestisseurConsultantSortInput = {
  actif?: InputMaybe<SortEnumType>;
  arianeId?: InputMaybe<SortEnumType>;
  batchDateUpdate?: InputMaybe<SortEnumType>;
  consultant?: InputMaybe<ConsultantSortInput>;
  consultantId?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  dateActivation?: InputMaybe<SortEnumType>;
  dateDesactivation?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  idSource?: InputMaybe<SortEnumType>;
  investisseur?: InputMaybe<InvestisseurSortInput>;
  investisseurId?: InputMaybe<SortEnumType>;
  typeRelationInvestisseurConsultantCode?: InputMaybe<SortEnumType>;
  typeRelationInvestisseurConsultantCodeNavigation?: InputMaybe<TypeRelationInvestisseurConsultantSortInput>;
};

export type InvestisseurContactInput = {
  civilite?: InputMaybe<Scalars['String']['input']>;
  consultantApporteurAffaireId?: InputMaybe<Scalars['Long']['input']>;
  consultantPrincipalId?: InputMaybe<Scalars['Long']['input']>;
  dateNaissance: Scalars['DateTime']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  nom: Scalars['String']['input'];
  origineSaisie: Scalars['Byte']['input'];
  prenom: Scalars['String']['input'];
  telephone?: InputMaybe<Scalars['String']['input']>;
};

export type InvestisseurCreationArianeUpdateInput = {
  investisseur1: InvestisseurArianeUpdaterInput;
  investisseur2?: InputMaybe<InvestisseurArianeUpdaterInput>;
  relationArianeId?: InputMaybe<Scalars['Long']['input']>;
};

export type InvestisseurCreationInput = {
  investisseur1: InvestisseurContactInput;
  investisseur2?: InputMaybe<InvestisseurContactInput>;
  investisseur2Id?: InputMaybe<Scalars['Long']['input']>;
  typeRelationCode?: InputMaybe<Scalars['String']['input']>;
};

export type InvestisseurEntite = {
  __typename?: 'InvestisseurEntite';
  code: Scalars['String']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  personneMorale?: Maybe<PersonneMorale>;
  personnePhysique?: Maybe<PersonnePhysique>;
  type: InvestisseurType;
};

export type InvestisseurFicheObjectif = {
  __typename?: 'InvestisseurFicheObjectif';
  categorieCode?: Maybe<Scalars['String']['output']>;
  categorieLibelle: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isSelected: Scalars['Boolean']['output'];
  objectifCode?: Maybe<Scalars['String']['output']>;
  objectifLibelle: Scalars['String']['output'];
};

export type InvestisseurFicheObjectifFilterInput = {
  and?: InputMaybe<Array<InvestisseurFicheObjectifFilterInput>>;
  categorieCode?: InputMaybe<StringOperationFilterInput>;
  categorieLibelle?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isSelected?: InputMaybe<BooleanOperationFilterInput>;
  objectifCode?: InputMaybe<StringOperationFilterInput>;
  objectifLibelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<InvestisseurFicheObjectifFilterInput>>;
};

export type InvestisseurFicheObjectifInput = {
  categorieCode?: InputMaybe<Scalars['String']['input']>;
  categorieLibelle: Scalars['String']['input'];
  id: Scalars['String']['input'];
  isSelected: Scalars['Boolean']['input'];
  objectifCode?: InputMaybe<Scalars['String']['input']>;
  objectifLibelle: Scalars['String']['input'];
};

export type InvestisseurFilterInput = {
  and?: InputMaybe<Array<InvestisseurFilterInput>>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  cessionHistoInvestisseur?: InputMaybe<ListFilterInputTypeOfCessionHistoInvestisseurFilterInput>;
  civiliteCode?: InputMaybe<StringOperationFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateConnaissance?: InputMaybe<LocalDateOperationFilterInput>;
  dateDernierScanAccuity?: InputMaybe<LocalDateOperationFilterInput>;
  dateEntreeRelation?: InputMaybe<LocalDateOperationFilterInput>;
  dateMajScanAccuityRequis?: InputMaybe<LocalDateOperationFilterInput>;
  dateNaissance?: InputMaybe<DateOperationFilterInput>;
  dateSuppression?: InputMaybe<DateTimeOperationFilterInput>;
  denomination?: InputMaybe<StringOperationFilterInput>;
  detenteurPatrimoineActif?: InputMaybe<ListFilterInputTypeOfDetenteurPatrimoineActifFilterInput>;
  detenteurPatrimoineChargeRevenu?: InputMaybe<ListFilterInputTypeOfDetenteurPatrimoineChargeRevenuFilterInput>;
  detenteurPatrimoinePassif?: InputMaybe<ListFilterInputTypeOfDetenteurPatrimoinePassifFilterInput>;
  displayName?: InputMaybe<StringOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  gdaBackOffice?: InputMaybe<BooleanOperationFilterInput>;
  gerePar?: InputMaybe<AppReferenceOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSourceAramis?: InputMaybe<StringOperationFilterInput>;
  idSourceDiapason?: InputMaybe<StringOperationFilterInput>;
  inverseRecommandePar?: InputMaybe<ListFilterInputTypeOfInvestisseurFilterInput>;
  investisseurCommande?: InputMaybe<ListFilterInputTypeOfInvestisseurCommandeFilterInput>;
  investisseurConsultant?: InputMaybe<ListFilterInputTypeOfInvestisseurConsultantFilterInput>;
  investisseurObjectif?: InputMaybe<ListFilterInputTypeOfInvestisseurObjectifFilterInput>;
  investisseurQpi?: InputMaybe<InvestisseurQpiFilterInput>;
  logiqueSuppression?: InputMaybe<BooleanOperationFilterInput>;
  modeCommunication?: InputMaybe<StringOperationFilterInput>;
  modeCommunicationNavigation?: InputMaybe<ModeCommunicationFilterInput>;
  mouvement?: InputMaybe<ListFilterInputTypeOfMouvementFilterInput>;
  nom?: InputMaybe<StringOperationFilterInput>;
  note?: InputMaybe<ListFilterInputTypeOfNoteFilterInput>;
  objectifMontantEpargneMensuel?: InputMaybe<DecimalOperationFilterInput>;
  objectifMontantEpargnePrecaution?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<InvestisseurFilterInput>>;
  origineContactCode?: InputMaybe<StringOperationFilterInput>;
  origineContactCodeNavigation?: InputMaybe<OrigineContactFilterInput>;
  origineSaisie?: InputMaybe<ByteOperationFilterInput>;
  origineSaisieNavigation?: InputMaybe<OrigineDataFilterInput>;
  patrimoineFiscalite?: InputMaybe<PatrimoineFiscaliteFilterInput>;
  personneMorale?: InputMaybe<ListFilterInputTypeOfPersonneMoraleFilterInput>;
  personnePhysique?: InputMaybe<ListFilterInputTypeOfPersonnePhysiqueFilterInput>;
  ppeBackOffice?: InputMaybe<BooleanOperationFilterInput>;
  prenom?: InputMaybe<StringOperationFilterInput>;
  profil?: InputMaybe<ProfilInvestisseurFicheFilterInput>;
  profilInvestisseur?: InputMaybe<ListFilterInputTypeOfProfilInvestisseurFilterInput>;
  recommandePar?: InputMaybe<InvestisseurFilterInput>;
  recommandeParId?: InputMaybe<LongOperationFilterInput>;
  recommandeParNom?: InputMaybe<StringOperationFilterInput>;
  scanAccuityRequis?: InputMaybe<BooleanOperationFilterInput>;
  situationPersonnelle?: InputMaybe<SituationPersonnelleFilterInput>;
  statutCode?: InputMaybe<StringOperationFilterInput>;
  statutCodeNavigation?: InputMaybe<TypeStatutInvestisseurFilterInput>;
};

export type InvestisseurInput = {
  civiliteCode?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  creationDate?: InputMaybe<Scalars['DateTime']['input']>;
  dateNaissance?: InputMaybe<Scalars['Date']['input']>;
  denomination?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Long']['input'];
  nom?: InputMaybe<Scalars['String']['input']>;
  prenom?: InputMaybe<Scalars['String']['input']>;
  profil?: InputMaybe<ProfilInvestisseurFicheInput>;
  situationPersonnelle?: InputMaybe<SituationPersonnelleInput>;
  statutCodeNavigation?: InputMaybe<TypeStatutInvestisseurInput>;
};

export type InvestisseurObjectif = {
  __typename?: 'InvestisseurObjectif';
  arianeId?: Maybe<Scalars['Long']['output']>;
  commun?: Maybe<Scalars['UUID']['output']>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  horizonDelais?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Long']['output'];
  investisseur: Investisseur;
  investisseurId: Scalars['Long']['output'];
  montant?: Maybe<Scalars['Decimal']['output']>;
  precisions?: Maybe<Scalars['String']['output']>;
  priorite: Scalars['Int']['output'];
  typeObjectifInvestisseurCode: Scalars['String']['output'];
  typeObjectifInvestisseurCodeNavigation: TypeObjectifInvestisseur;
};

export type InvestisseurObjectifFilterInput = {
  and?: InputMaybe<Array<InvestisseurObjectifFilterInput>>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  commun?: InputMaybe<UuidOperationFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  horizonDelais?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  investisseur?: InputMaybe<InvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  montant?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<InvestisseurObjectifFilterInput>>;
  precisions?: InputMaybe<StringOperationFilterInput>;
  priorite?: InputMaybe<IntOperationFilterInput>;
  typeObjectifInvestisseurCode?: InputMaybe<StringOperationFilterInput>;
  typeObjectifInvestisseurCodeNavigation?: InputMaybe<TypeObjectifInvestisseurFilterInput>;
};

export type InvestisseurObjectifRecueil = {
  __typename?: 'InvestisseurObjectifRecueil';
  categorieCode: Scalars['String']['output'];
  categorieLibelle: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  objectifCode: Scalars['String']['output'];
  objectifLibelle: Scalars['String']['output'];
};

export type InvestisseurObjectifSortInput = {
  arianeId?: InputMaybe<SortEnumType>;
  commun?: InputMaybe<SortEnumType>;
  createurId?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editeurId?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  horizonDelais?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  investisseur?: InputMaybe<InvestisseurSortInput>;
  investisseurId?: InputMaybe<SortEnumType>;
  montant?: InputMaybe<SortEnumType>;
  precisions?: InputMaybe<SortEnumType>;
  priorite?: InputMaybe<SortEnumType>;
  typeObjectifInvestisseurCode?: InputMaybe<SortEnumType>;
  typeObjectifInvestisseurCodeNavigation?: InputMaybe<TypeObjectifInvestisseurSortInput>;
};

export type InvestisseurQpi = {
  __typename?: 'InvestisseurQpi';
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  dateCalcul?: Maybe<Scalars['DateTime']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  idSource?: Maybe<Scalars['String']['output']>;
  investisseur: Investisseur;
  investisseurId: Scalars['Long']['output'];
  motivationDerogation?: Maybe<Scalars['String']['output']>;
  profilCalculCode?: Maybe<Scalars['String']['output']>;
  profilCalculCodeNavigation?: Maybe<ProfilQpi>;
  profilDerogationCode?: Maybe<Scalars['String']['output']>;
  profilDerogationCodeNavigation?: Maybe<ProfilQpi>;
  srriCalcul?: Maybe<Scalars['Int']['output']>;
  srriDerogation?: Maybe<Scalars['Int']['output']>;
};

export type InvestisseurQpiFilterInput = {
  and?: InputMaybe<Array<InvestisseurQpiFilterInput>>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateCalcul?: InputMaybe<DateTimeOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  investisseur?: InputMaybe<InvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  motivationDerogation?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<InvestisseurQpiFilterInput>>;
  profilCalculCode?: InputMaybe<StringOperationFilterInput>;
  profilCalculCodeNavigation?: InputMaybe<ProfilQpiFilterInput>;
  profilDerogationCode?: InputMaybe<StringOperationFilterInput>;
  profilDerogationCodeNavigation?: InputMaybe<ProfilQpiFilterInput>;
  srriCalcul?: InputMaybe<IntOperationFilterInput>;
  srriDerogation?: InputMaybe<IntOperationFilterInput>;
};

export type InvestisseurQpiSortInput = {
  createurId?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  dateCalcul?: InputMaybe<SortEnumType>;
  editeurId?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  idSource?: InputMaybe<SortEnumType>;
  investisseur?: InputMaybe<InvestisseurSortInput>;
  investisseurId?: InputMaybe<SortEnumType>;
  motivationDerogation?: InputMaybe<SortEnumType>;
  profilCalculCode?: InputMaybe<SortEnumType>;
  profilCalculCodeNavigation?: InputMaybe<ProfilQpiSortInput>;
  profilDerogationCode?: InputMaybe<SortEnumType>;
  profilDerogationCodeNavigation?: InputMaybe<ProfilQpiSortInput>;
  srriCalcul?: InputMaybe<SortEnumType>;
  srriDerogation?: InputMaybe<SortEnumType>;
};

export type InvestisseurRelationAutreInput = {
  adresse?: InputMaybe<AdressePersonneInput>;
  arianeId?: InputMaybe<Scalars['Long']['input']>;
  /** Identifiant dans Ariane du consultant qui sera responsable de la relation si elle est créée */
  attachedConsultantId?: InputMaybe<Scalars['Long']['input']>;
  civilite?: InputMaybe<Scalars['String']['input']>;
  dateNaissance?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<EmailInput>;
  nom: Scalars['String']['input'];
  origineSaisie: Scalars['Byte']['input'];
  /** Carefull here you must set the related user and not the user you want to apply a relation */
  personnePhysiqueId?: InputMaybe<Scalars['Long']['input']>;
  prenom: Scalars['String']['input'];
  relationId?: InputMaybe<Scalars['Long']['input']>;
  relationPersonneIdToDelete?: InputMaybe<Scalars['Long']['input']>;
  relationPersonneIds: Array<Scalars['Long']['input']>;
  targetPersonneArianeId?: InputMaybe<Scalars['Long']['input']>;
  telephone?: InputMaybe<TelephonePersonneInput>;
  typeRelation: Scalars['String']['input'];
};

export type InvestisseurRelationConsultant = {
  __typename?: 'InvestisseurRelationConsultant';
  consultantCode?: Maybe<Scalars['String']['output']>;
  consultantId: Scalars['Long']['output'];
  nom?: Maybe<Scalars['String']['output']>;
  prenom?: Maybe<Scalars['String']['output']>;
  typeRelationInvestisseurConsultantCode?: Maybe<Scalars['String']['output']>;
};

export type InvestisseurRelationFamilleInput = {
  aChargeRelationPersonneIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  adopte: Scalars['Boolean']['input'];
  allRelationPersonneIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  arianeId?: InputMaybe<Scalars['Long']['input']>;
  /** Identifiant dans Ariane du consultant qui sera responsable de la relation si elle est créée */
  attachedConsultantId?: InputMaybe<Scalars['Long']['input']>;
  autoriteParentaleRelationPersonneIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  civilite?: InputMaybe<Scalars['String']['input']>;
  commentaire?: InputMaybe<Scalars['String']['input']>;
  dateFinChargeFiscale?: InputMaybe<Scalars['DateTime']['input']>;
  dateNaissance?: InputMaybe<Scalars['DateTime']['input']>;
  deuxiemePrenom?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<EmailInput>;
  estTypeRelationPersonneIds: Array<Scalars['Long']['input']>;
  gardeAlternee: Scalars['Boolean']['input'];
  niveauEtude?: InputMaybe<Scalars['String']['input']>;
  nom: Scalars['String']['input'];
  origineSaisie: Scalars['Byte']['input'];
  /** Carefull here you must set the related user and not the user you want to apply a relation */
  personnePhysiqueId?: InputMaybe<Scalars['Long']['input']>;
  prenom: Scalars['String']['input'];
  relationPersonneIdToDelete?: InputMaybe<Scalars['Long']['input']>;
  relationPersonneIds: Array<Scalars['Long']['input']>;
  targetPersonneArianeId?: InputMaybe<Scalars['Long']['input']>;
  telephone?: InputMaybe<TelephonePersonneInput>;
  troisiemePrenom?: InputMaybe<Scalars['String']['input']>;
  typeRelationFamilleCode: Scalars['String']['input'];
};

export type InvestisseurSortInput = {
  arianeId?: InputMaybe<SortEnumType>;
  civiliteCode?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  createurId?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  dateConnaissance?: InputMaybe<SortEnumType>;
  dateDernierScanAccuity?: InputMaybe<SortEnumType>;
  dateEntreeRelation?: InputMaybe<SortEnumType>;
  dateMajScanAccuityRequis?: InputMaybe<SortEnumType>;
  dateNaissance?: InputMaybe<SortEnumType>;
  dateSuppression?: InputMaybe<SortEnumType>;
  denomination?: InputMaybe<SortEnumType>;
  displayName?: InputMaybe<SortEnumType>;
  editeurId?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  gdaBackOffice?: InputMaybe<SortEnumType>;
  gerePar?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  idSourceAramis?: InputMaybe<SortEnumType>;
  idSourceDiapason?: InputMaybe<SortEnumType>;
  investisseurQpi?: InputMaybe<InvestisseurQpiSortInput>;
  logiqueSuppression?: InputMaybe<SortEnumType>;
  modeCommunication?: InputMaybe<SortEnumType>;
  modeCommunicationNavigation?: InputMaybe<ModeCommunicationSortInput>;
  nom?: InputMaybe<SortEnumType>;
  objectifMontantEpargneMensuel?: InputMaybe<SortEnumType>;
  objectifMontantEpargnePrecaution?: InputMaybe<SortEnumType>;
  origineContactCode?: InputMaybe<SortEnumType>;
  origineContactCodeNavigation?: InputMaybe<OrigineContactSortInput>;
  origineSaisie?: InputMaybe<SortEnumType>;
  origineSaisieNavigation?: InputMaybe<OrigineDataSortInput>;
  patrimoineFiscalite?: InputMaybe<PatrimoineFiscaliteSortInput>;
  ppeBackOffice?: InputMaybe<SortEnumType>;
  prenom?: InputMaybe<SortEnumType>;
  profil?: InputMaybe<ProfilInvestisseurFicheSortInput>;
  recommandePar?: InputMaybe<InvestisseurSortInput>;
  recommandeParId?: InputMaybe<SortEnumType>;
  recommandeParNom?: InputMaybe<SortEnumType>;
  scanAccuityRequis?: InputMaybe<SortEnumType>;
  situationPersonnelle?: InputMaybe<SituationPersonnelleSortInput>;
  statutCode?: InputMaybe<SortEnumType>;
  statutCodeNavigation?: InputMaybe<TypeStatutInvestisseurSortInput>;
};

export enum InvestisseurType {
  PersonneMorale = 'PERSONNE_MORALE',
  PersonnePhysique = 'PERSONNE_PHYSIQUE'
}

export type InvestisseurTypeOperationFilterInput = {
  eq?: InputMaybe<InvestisseurType>;
  in?: InputMaybe<Array<InvestisseurType>>;
  neq?: InputMaybe<InvestisseurType>;
  nin?: InputMaybe<Array<InvestisseurType>>;
};

/** A segment of a collection. */
export type InvestisseursByNamePaginatedCollectionSegment = {
  __typename?: 'InvestisseursByNamePaginatedCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Investisseur>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type InvestisseursPaginatedCollectionSegment = {
  __typename?: 'InvestisseursPaginatedCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Investisseur>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type InvestisseursPersonnesMoralesByNamePaginatedCollectionSegment = {
  __typename?: 'InvestisseursPersonnesMoralesByNamePaginatedCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Investisseur>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type InvestisseursPersonnesPhysiquesByNamePaginatedCollectionSegment = {
  __typename?: 'InvestisseursPersonnesPhysiquesByNamePaginatedCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Investisseur>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type KeyValuePairOfStringAndObject = {
  __typename?: 'KeyValuePairOfStringAndObject';
  key: Scalars['String']['output'];
};

export type LienConsultantStatutJuridiqueTypeHabilitation = {
  __typename?: 'LienConsultantStatutJuridiqueTypeHabilitation';
  consultantStatutJuridique: ConsultantStatutJuridique;
  consultantStatutJuridiqueId: Scalars['Long']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  typeHabilitation: Habilitation;
  typeHabilitationId: Scalars['Long']['output'];
};

export type LienConsultantStatutJuridiqueTypeHabilitationFilterInput = {
  and?: InputMaybe<Array<LienConsultantStatutJuridiqueTypeHabilitationFilterInput>>;
  consultantStatutJuridique?: InputMaybe<ConsultantStatutJuridiqueFilterInput>;
  consultantStatutJuridiqueId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<LienConsultantStatutJuridiqueTypeHabilitationFilterInput>>;
  typeHabilitation?: InputMaybe<HabilitationFilterInput>;
  typeHabilitationId?: InputMaybe<LongOperationFilterInput>;
};

export type ListFilterInputTypeOfAbonnementConsultantFilterInput = {
  all?: InputMaybe<AbonnementConsultantFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AbonnementConsultantFilterInput>;
  some?: InputMaybe<AbonnementConsultantFilterInput>;
};

export type ListFilterInputTypeOfActionDeFormationFilterInput = {
  all?: InputMaybe<ActionDeFormationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ActionDeFormationFilterInput>;
  some?: InputMaybe<ActionDeFormationFilterInput>;
};

export type ListFilterInputTypeOfActionDeFormationSessionFilterInput = {
  all?: InputMaybe<ActionDeFormationSessionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ActionDeFormationSessionFilterInput>;
  some?: InputMaybe<ActionDeFormationSessionFilterInput>;
};

export type ListFilterInputTypeOfAdhesionConsultantFilterInput = {
  all?: InputMaybe<AdhesionConsultantFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AdhesionConsultantFilterInput>;
  some?: InputMaybe<AdhesionConsultantFilterInput>;
};

export type ListFilterInputTypeOfAdresseFilterInput = {
  all?: InputMaybe<AdresseFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AdresseFilterInput>;
  some?: InputMaybe<AdresseFilterInput>;
};

export type ListFilterInputTypeOfCategorieSocioProfessionnelleFilterInput = {
  all?: InputMaybe<CategorieSocioProfessionnelleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CategorieSocioProfessionnelleFilterInput>;
  some?: InputMaybe<CategorieSocioProfessionnelleFilterInput>;
};

export type ListFilterInputTypeOfCessionHistoCommandeFilterInput = {
  all?: InputMaybe<CessionHistoCommandeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CessionHistoCommandeFilterInput>;
  some?: InputMaybe<CessionHistoCommandeFilterInput>;
};

export type ListFilterInputTypeOfCessionHistoInvestisseurFilterInput = {
  all?: InputMaybe<CessionHistoInvestisseurFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CessionHistoInvestisseurFilterInput>;
  some?: InputMaybe<CessionHistoInvestisseurFilterInput>;
};

export type ListFilterInputTypeOfCommandeFilterInput = {
  all?: InputMaybe<CommandeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CommandeFilterInput>;
  some?: InputMaybe<CommandeFilterInput>;
};

export type ListFilterInputTypeOfConseillerCommandeFilterInput = {
  all?: InputMaybe<ConseillerCommandeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConseillerCommandeFilterInput>;
  some?: InputMaybe<ConseillerCommandeFilterInput>;
};

export type ListFilterInputTypeOfConsultantCarteDemarchageFilterInput = {
  all?: InputMaybe<ConsultantCarteDemarchageFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantCarteDemarchageFilterInput>;
  some?: InputMaybe<ConsultantCarteDemarchageFilterInput>;
};

export type ListFilterInputTypeOfConsultantCommissionAdiFilterInput = {
  all?: InputMaybe<ConsultantCommissionAdiFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantCommissionAdiFilterInput>;
  some?: InputMaybe<ConsultantCommissionAdiFilterInput>;
};

export type ListFilterInputTypeOfConsultantContratFilterInput = {
  all?: InputMaybe<ConsultantContratFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantContratFilterInput>;
  some?: InputMaybe<ConsultantContratFilterInput>;
};

export type ListFilterInputTypeOfConsultantDistinctionFilterInput = {
  all?: InputMaybe<ConsultantDistinctionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantDistinctionFilterInput>;
  some?: InputMaybe<ConsultantDistinctionFilterInput>;
};

export type ListFilterInputTypeOfConsultantFilterInput = {
  all?: InputMaybe<ConsultantFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantFilterInput>;
  some?: InputMaybe<ConsultantFilterInput>;
};

export type ListFilterInputTypeOfConsultantHabilitationActionBackOfficeFilterInput = {
  all?: InputMaybe<ConsultantHabilitationActionBackOfficeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantHabilitationActionBackOfficeFilterInput>;
  some?: InputMaybe<ConsultantHabilitationActionBackOfficeFilterInput>;
};

export type ListFilterInputTypeOfConsultantHabilitationExpirationFilterInput = {
  all?: InputMaybe<ConsultantHabilitationExpirationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantHabilitationExpirationFilterInput>;
  some?: InputMaybe<ConsultantHabilitationExpirationFilterInput>;
};

export type ListFilterInputTypeOfConsultantHabilitationFilterInput = {
  all?: InputMaybe<ConsultantHabilitationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantHabilitationFilterInput>;
  some?: InputMaybe<ConsultantHabilitationFilterInput>;
};

export type ListFilterInputTypeOfConsultantHabilitationInscriptionCategorieFilterInput = {
  all?: InputMaybe<ConsultantHabilitationInscriptionCategorieFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantHabilitationInscriptionCategorieFilterInput>;
  some?: InputMaybe<ConsultantHabilitationInscriptionCategorieFilterInput>;
};

export type ListFilterInputTypeOfConsultantHabilitationInscriptionCategorieMandantFilterInput = {
  all?: InputMaybe<ConsultantHabilitationInscriptionCategorieMandantFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantHabilitationInscriptionCategorieMandantFilterInput>;
  some?: InputMaybe<ConsultantHabilitationInscriptionCategorieMandantFilterInput>;
};

export type ListFilterInputTypeOfConsultantHabilitationInscriptionFilterInput = {
  all?: InputMaybe<ConsultantHabilitationInscriptionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantHabilitationInscriptionFilterInput>;
  some?: InputMaybe<ConsultantHabilitationInscriptionFilterInput>;
};

export type ListFilterInputTypeOfConsultantHabilitationInvalidityReasonFilterInput = {
  all?: InputMaybe<ConsultantHabilitationInvalidityReasonFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantHabilitationInvalidityReasonFilterInput>;
  some?: InputMaybe<ConsultantHabilitationInvalidityReasonFilterInput>;
};

export type ListFilterInputTypeOfConsultantHabilitationStatutChangeFilterInput = {
  all?: InputMaybe<ConsultantHabilitationStatutChangeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantHabilitationStatutChangeFilterInput>;
  some?: InputMaybe<ConsultantHabilitationStatutChangeFilterInput>;
};

export type ListFilterInputTypeOfConsultantHabilitationsFictivesFilterInput = {
  all?: InputMaybe<ConsultantHabilitationsFictivesFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantHabilitationsFictivesFilterInput>;
  some?: InputMaybe<ConsultantHabilitationsFictivesFilterInput>;
};

export type ListFilterInputTypeOfConsultantMouvementFilterInput = {
  all?: InputMaybe<ConsultantMouvementFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantMouvementFilterInput>;
  some?: InputMaybe<ConsultantMouvementFilterInput>;
};

export type ListFilterInputTypeOfConsultantOrganisationFilterInput = {
  all?: InputMaybe<ConsultantOrganisationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantOrganisationFilterInput>;
  some?: InputMaybe<ConsultantOrganisationFilterInput>;
};

export type ListFilterInputTypeOfConsultantRcpFilterInput = {
  all?: InputMaybe<ConsultantRcpFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantRcpFilterInput>;
  some?: InputMaybe<ConsultantRcpFilterInput>;
};

export type ListFilterInputTypeOfConsultantStatutCommercialFilterInput = {
  all?: InputMaybe<ConsultantStatutCommercialFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantStatutCommercialFilterInput>;
  some?: InputMaybe<ConsultantStatutCommercialFilterInput>;
};

export type ListFilterInputTypeOfConsultantStatutJuridiqueChangeFilterInput = {
  all?: InputMaybe<ConsultantStatutJuridiqueChangeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantStatutJuridiqueChangeFilterInput>;
  some?: InputMaybe<ConsultantStatutJuridiqueChangeFilterInput>;
};

export type ListFilterInputTypeOfConsultantStatutJuridiqueFilterInput = {
  all?: InputMaybe<ConsultantStatutJuridiqueFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConsultantStatutJuridiqueFilterInput>;
  some?: InputMaybe<ConsultantStatutJuridiqueFilterInput>;
};

export type ListFilterInputTypeOfContactFilterInput = {
  all?: InputMaybe<ContactFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ContactFilterInput>;
  some?: InputMaybe<ContactFilterInput>;
};

export type ListFilterInputTypeOfCursusCycleCourtFilterInput = {
  all?: InputMaybe<CursusCycleCourtFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CursusCycleCourtFilterInput>;
  some?: InputMaybe<CursusCycleCourtFilterInput>;
};

export type ListFilterInputTypeOfCursusFilterInput = {
  all?: InputMaybe<CursusFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CursusFilterInput>;
  some?: InputMaybe<CursusFilterInput>;
};

export type ListFilterInputTypeOfCursusFormationFilterInput = {
  all?: InputMaybe<CursusFormationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CursusFormationFilterInput>;
  some?: InputMaybe<CursusFormationFilterInput>;
};

export type ListFilterInputTypeOfCycleCourtFilterInput = {
  all?: InputMaybe<CycleCourtFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CycleCourtFilterInput>;
  some?: InputMaybe<CycleCourtFilterInput>;
};

export type ListFilterInputTypeOfDetenteurPatrimoineActifFilterInput = {
  all?: InputMaybe<DetenteurPatrimoineActifFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DetenteurPatrimoineActifFilterInput>;
  some?: InputMaybe<DetenteurPatrimoineActifFilterInput>;
};

export type ListFilterInputTypeOfDetenteurPatrimoineChargeRevenuFilterInput = {
  all?: InputMaybe<DetenteurPatrimoineChargeRevenuFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DetenteurPatrimoineChargeRevenuFilterInput>;
  some?: InputMaybe<DetenteurPatrimoineChargeRevenuFilterInput>;
};

export type ListFilterInputTypeOfDetenteurPatrimoinePassifFilterInput = {
  all?: InputMaybe<DetenteurPatrimoinePassifFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DetenteurPatrimoinePassifFilterInput>;
  some?: InputMaybe<DetenteurPatrimoinePassifFilterInput>;
};

export type ListFilterInputTypeOfDisponibiliteEpargneOptionFilterInput = {
  all?: InputMaybe<DisponibiliteEpargneOptionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DisponibiliteEpargneOptionFilterInput>;
  some?: InputMaybe<DisponibiliteEpargneOptionFilterInput>;
};

export type ListFilterInputTypeOfDispositionFilterInput = {
  all?: InputMaybe<DispositionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DispositionFilterInput>;
  some?: InputMaybe<DispositionFilterInput>;
};

export type ListFilterInputTypeOfDistinctionFilterInput = {
  all?: InputMaybe<DistinctionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DistinctionFilterInput>;
  some?: InputMaybe<DistinctionFilterInput>;
};

export type ListFilterInputTypeOfEditionFilterInput = {
  all?: InputMaybe<EditionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<EditionFilterInput>;
  some?: InputMaybe<EditionFilterInput>;
};

export type ListFilterInputTypeOfEmailFilterInput = {
  all?: InputMaybe<EmailFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<EmailFilterInput>;
  some?: InputMaybe<EmailFilterInput>;
};

export type ListFilterInputTypeOfEnveloppeProduitFilterInput = {
  all?: InputMaybe<EnveloppeProduitFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<EnveloppeProduitFilterInput>;
  some?: InputMaybe<EnveloppeProduitFilterInput>;
};

export type ListFilterInputTypeOfEquivalenceDeFormationFilterInput = {
  all?: InputMaybe<EquivalenceDeFormationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<EquivalenceDeFormationFilterInput>;
  some?: InputMaybe<EquivalenceDeFormationFilterInput>;
};

export type ListFilterInputTypeOfEtatCivilFilterInput = {
  all?: InputMaybe<EtatCivilFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<EtatCivilFilterInput>;
  some?: InputMaybe<EtatCivilFilterInput>;
};

export type ListFilterInputTypeOfFactureFilterInput = {
  all?: InputMaybe<FactureFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FactureFilterInput>;
  some?: InputMaybe<FactureFilterInput>;
};

export type ListFilterInputTypeOfFieldConfigFilterInput = {
  all?: InputMaybe<FieldConfigFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FieldConfigFilterInput>;
  some?: InputMaybe<FieldConfigFilterInput>;
};

export type ListFilterInputTypeOfFieldValidatorConfigFilterInput = {
  all?: InputMaybe<FieldValidatorConfigFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FieldValidatorConfigFilterInput>;
  some?: InputMaybe<FieldValidatorConfigFilterInput>;
};

export type ListFilterInputTypeOfFieldValidatorConfigParameterFilterInput = {
  all?: InputMaybe<FieldValidatorConfigParameterFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FieldValidatorConfigParameterFilterInput>;
  some?: InputMaybe<FieldValidatorConfigParameterFilterInput>;
};

export type ListFilterInputTypeOfFondsEvenementielConseilFilterInput = {
  all?: InputMaybe<FondsEvenementielConseilFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FondsEvenementielConseilFilterInput>;
  some?: InputMaybe<FondsEvenementielConseilFilterInput>;
};

export type ListFilterInputTypeOfFormationFilterInput = {
  all?: InputMaybe<FormationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FormationFilterInput>;
  some?: InputMaybe<FormationFilterInput>;
};

export type ListFilterInputTypeOfFormeJuridiqueFilterInput = {
  all?: InputMaybe<FormeJuridiqueFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FormeJuridiqueFilterInput>;
  some?: InputMaybe<FormeJuridiqueFilterInput>;
};

export type ListFilterInputTypeOfGammeProduitFilterInput = {
  all?: InputMaybe<GammeProduitFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<GammeProduitFilterInput>;
  some?: InputMaybe<GammeProduitFilterInput>;
};

export type ListFilterInputTypeOfGedTypeDocumentFilterInput = {
  all?: InputMaybe<GedTypeDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<GedTypeDocumentFilterInput>;
  some?: InputMaybe<GedTypeDocumentFilterInput>;
};

export type ListFilterInputTypeOfHabilitationInscriptionFilterInput = {
  all?: InputMaybe<HabilitationInscriptionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<HabilitationInscriptionFilterInput>;
  some?: InputMaybe<HabilitationInscriptionFilterInput>;
};

export type ListFilterInputTypeOfHabilitationRcpFilterInput = {
  all?: InputMaybe<HabilitationRcpFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<HabilitationRcpFilterInput>;
  some?: InputMaybe<HabilitationRcpFilterInput>;
};

export type ListFilterInputTypeOfInscriptionCycleCourtFilterInput = {
  all?: InputMaybe<InscriptionCycleCourtFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<InscriptionCycleCourtFilterInput>;
  some?: InputMaybe<InscriptionCycleCourtFilterInput>;
};

export type ListFilterInputTypeOfInscriptionSessionFilterInput = {
  all?: InputMaybe<InscriptionSessionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<InscriptionSessionFilterInput>;
  some?: InputMaybe<InscriptionSessionFilterInput>;
};

export type ListFilterInputTypeOfInvestisseurCommandeFilterInput = {
  all?: InputMaybe<InvestisseurCommandeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<InvestisseurCommandeFilterInput>;
  some?: InputMaybe<InvestisseurCommandeFilterInput>;
};

export type ListFilterInputTypeOfInvestisseurConsultantFilterInput = {
  all?: InputMaybe<InvestisseurConsultantFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<InvestisseurConsultantFilterInput>;
  some?: InputMaybe<InvestisseurConsultantFilterInput>;
};

export type ListFilterInputTypeOfInvestisseurFicheObjectifFilterInput = {
  all?: InputMaybe<InvestisseurFicheObjectifFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<InvestisseurFicheObjectifFilterInput>;
  some?: InputMaybe<InvestisseurFicheObjectifFilterInput>;
};

export type ListFilterInputTypeOfInvestisseurFilterInput = {
  all?: InputMaybe<InvestisseurFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<InvestisseurFilterInput>;
  some?: InputMaybe<InvestisseurFilterInput>;
};

export type ListFilterInputTypeOfInvestisseurObjectifFilterInput = {
  all?: InputMaybe<InvestisseurObjectifFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<InvestisseurObjectifFilterInput>;
  some?: InputMaybe<InvestisseurObjectifFilterInput>;
};

export type ListFilterInputTypeOfInvestisseurQpiFilterInput = {
  all?: InputMaybe<InvestisseurQpiFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<InvestisseurQpiFilterInput>;
  some?: InputMaybe<InvestisseurQpiFilterInput>;
};

export type ListFilterInputTypeOfLienConsultantStatutJuridiqueTypeHabilitationFilterInput = {
  all?: InputMaybe<LienConsultantStatutJuridiqueTypeHabilitationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<LienConsultantStatutJuridiqueTypeHabilitationFilterInput>;
  some?: InputMaybe<LienConsultantStatutJuridiqueTypeHabilitationFilterInput>;
};

export type ListFilterInputTypeOfModeDeGestionConfigFilterInput = {
  all?: InputMaybe<ModeDeGestionConfigFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ModeDeGestionConfigFilterInput>;
  some?: InputMaybe<ModeDeGestionConfigFilterInput>;
};

export type ListFilterInputTypeOfMotifAnnulationCommandeFilterInput = {
  all?: InputMaybe<MotifAnnulationCommandeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MotifAnnulationCommandeFilterInput>;
  some?: InputMaybe<MotifAnnulationCommandeFilterInput>;
};

export type ListFilterInputTypeOfMotifCessionFilterInput = {
  all?: InputMaybe<MotifCessionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MotifCessionFilterInput>;
  some?: InputMaybe<MotifCessionFilterInput>;
};

export type ListFilterInputTypeOfMouvementFilterInput = {
  all?: InputMaybe<MouvementFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MouvementFilterInput>;
  some?: InputMaybe<MouvementFilterInput>;
};

export type ListFilterInputTypeOfNoteFilterInput = {
  all?: InputMaybe<NoteFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<NoteFilterInput>;
  some?: InputMaybe<NoteFilterInput>;
};

export type ListFilterInputTypeOfOptionAutomatiqueConseilFilterInput = {
  all?: InputMaybe<OptionAutomatiqueConseilFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OptionAutomatiqueConseilFilterInput>;
  some?: InputMaybe<OptionAutomatiqueConseilFilterInput>;
};

export type ListFilterInputTypeOfOrganismeFilterInput = {
  all?: InputMaybe<OrganismeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OrganismeFilterInput>;
  some?: InputMaybe<OrganismeFilterInput>;
};

export type ListFilterInputTypeOfPartenaireFilterInput = {
  all?: InputMaybe<PartenaireFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PartenaireFilterInput>;
  some?: InputMaybe<PartenaireFilterInput>;
};

export type ListFilterInputTypeOfPatrimoineActifFilterInput = {
  all?: InputMaybe<PatrimoineActifFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PatrimoineActifFilterInput>;
  some?: InputMaybe<PatrimoineActifFilterInput>;
};

export type ListFilterInputTypeOfPatrimoineChargeRevenuFilterInput = {
  all?: InputMaybe<PatrimoineChargeRevenuFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PatrimoineChargeRevenuFilterInput>;
  some?: InputMaybe<PatrimoineChargeRevenuFilterInput>;
};

export type ListFilterInputTypeOfPatrimoinePassifFilterInput = {
  all?: InputMaybe<PatrimoinePassifFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PatrimoinePassifFilterInput>;
  some?: InputMaybe<PatrimoinePassifFilterInput>;
};

export type ListFilterInputTypeOfPaysFilterInput = {
  all?: InputMaybe<PaysFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PaysFilterInput>;
  some?: InputMaybe<PaysFilterInput>;
};

export type ListFilterInputTypeOfPersonneMoraleAdresseFilterInput = {
  all?: InputMaybe<PersonneMoraleAdresseFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PersonneMoraleAdresseFilterInput>;
  some?: InputMaybe<PersonneMoraleAdresseFilterInput>;
};

export type ListFilterInputTypeOfPersonneMoraleFilterInput = {
  all?: InputMaybe<PersonneMoraleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PersonneMoraleFilterInput>;
  some?: InputMaybe<PersonneMoraleFilterInput>;
};

export type ListFilterInputTypeOfPersonneMoraleTelephoneFilterInput = {
  all?: InputMaybe<PersonneMoraleTelephoneFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PersonneMoraleTelephoneFilterInput>;
  some?: InputMaybe<PersonneMoraleTelephoneFilterInput>;
};

export type ListFilterInputTypeOfPersonnePhysiqueDocumentFilterInput = {
  all?: InputMaybe<PersonnePhysiqueDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PersonnePhysiqueDocumentFilterInput>;
  some?: InputMaybe<PersonnePhysiqueDocumentFilterInput>;
};

export type ListFilterInputTypeOfPersonnePhysiqueFilterInput = {
  all?: InputMaybe<PersonnePhysiqueFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PersonnePhysiqueFilterInput>;
  some?: InputMaybe<PersonnePhysiqueFilterInput>;
};

export type ListFilterInputTypeOfPieceJointeConsultantFilterInput = {
  all?: InputMaybe<PieceJointeConsultantFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PieceJointeConsultantFilterInput>;
  some?: InputMaybe<PieceJointeConsultantFilterInput>;
};

export type ListFilterInputTypeOfProduitFilterInput = {
  all?: InputMaybe<ProduitFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProduitFilterInput>;
  some?: InputMaybe<ProduitFilterInput>;
};

export type ListFilterInputTypeOfProduitSpecificConfigFilterInput = {
  all?: InputMaybe<ProduitSpecificConfigFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProduitSpecificConfigFilterInput>;
  some?: InputMaybe<ProduitSpecificConfigFilterInput>;
};

export type ListFilterInputTypeOfProfilInvestisseurFilterInput = {
  all?: InputMaybe<ProfilInvestisseurFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProfilInvestisseurFilterInput>;
  some?: InputMaybe<ProfilInvestisseurFilterInput>;
};

export type ListFilterInputTypeOfReglementaireFilterInput = {
  all?: InputMaybe<ReglementaireFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ReglementaireFilterInput>;
  some?: InputMaybe<ReglementaireFilterInput>;
};

export type ListFilterInputTypeOfRelationAutreFilterInput = {
  all?: InputMaybe<RelationAutreFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RelationAutreFilterInput>;
  some?: InputMaybe<RelationAutreFilterInput>;
};

export type ListFilterInputTypeOfRelationCoupleFilterInput = {
  all?: InputMaybe<RelationCoupleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RelationCoupleFilterInput>;
  some?: InputMaybe<RelationCoupleFilterInput>;
};

export type ListFilterInputTypeOfRelationFamilleFilterInput = {
  all?: InputMaybe<RelationFamilleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RelationFamilleFilterInput>;
  some?: InputMaybe<RelationFamilleFilterInput>;
};

export type ListFilterInputTypeOfResiliationPaiementB2SFilterInput = {
  all?: InputMaybe<ResiliationPaiementB2SFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ResiliationPaiementB2SFilterInput>;
  some?: InputMaybe<ResiliationPaiementB2SFilterInput>;
};

export type ListFilterInputTypeOfSeanceSessionFilterInput = {
  all?: InputMaybe<SeanceSessionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SeanceSessionFilterInput>;
  some?: InputMaybe<SeanceSessionFilterInput>;
};

export type ListFilterInputTypeOfSessionFilterInput = {
  all?: InputMaybe<SessionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SessionFilterInput>;
  some?: InputMaybe<SessionFilterInput>;
};

export type ListFilterInputTypeOfSituationProfessionnelleFilterInput = {
  all?: InputMaybe<SituationProfessionnelleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SituationProfessionnelleFilterInput>;
  some?: InputMaybe<SituationProfessionnelleFilterInput>;
};

export type ListFilterInputTypeOfTelephoneFilterInput = {
  all?: InputMaybe<TelephoneFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TelephoneFilterInput>;
  some?: InputMaybe<TelephoneFilterInput>;
};

export type ListFilterInputTypeOfTestamentFilterInput = {
  all?: InputMaybe<TestamentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TestamentFilterInput>;
  some?: InputMaybe<TestamentFilterInput>;
};

export type ListFilterInputTypeOfToleranceRisqueOptionFilterInput = {
  all?: InputMaybe<ToleranceRisqueOptionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ToleranceRisqueOptionFilterInput>;
  some?: InputMaybe<ToleranceRisqueOptionFilterInput>;
};

export type ListFilterInputTypeOfTransfertClientFilterInput = {
  all?: InputMaybe<TransfertClientFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TransfertClientFilterInput>;
  some?: InputMaybe<TransfertClientFilterInput>;
};

export type ListFilterInputTypeOfType2ProduitFilterInput = {
  all?: InputMaybe<Type2ProduitFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Type2ProduitFilterInput>;
  some?: InputMaybe<Type2ProduitFilterInput>;
};

export type ListFilterInputTypeOfTypeEditionFilterInput = {
  all?: InputMaybe<TypeEditionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TypeEditionFilterInput>;
  some?: InputMaybe<TypeEditionFilterInput>;
};

export type ListFilterInputTypeOfTypeObjectifInvestisseurFilterInput = {
  all?: InputMaybe<TypeObjectifInvestisseurFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TypeObjectifInvestisseurFilterInput>;
  some?: InputMaybe<TypeObjectifInvestisseurFilterInput>;
};

export type ListFilterInputTypeOfTypePieceJointeFilterInput = {
  all?: InputMaybe<TypePieceJointeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TypePieceJointeFilterInput>;
  some?: InputMaybe<TypePieceJointeFilterInput>;
};

export type ListFilterInputTypeOfTypeRelationAutreFilterInput = {
  all?: InputMaybe<TypeRelationAutreFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TypeRelationAutreFilterInput>;
  some?: InputMaybe<TypeRelationAutreFilterInput>;
};

export type ListFilterInputTypeOfTypeRelationFamilleFilterInput = {
  all?: InputMaybe<TypeRelationFamilleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TypeRelationFamilleFilterInput>;
  some?: InputMaybe<TypeRelationFamilleFilterInput>;
};

export type ListLongOperationFilterInput = {
  all?: InputMaybe<LongOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<LongOperationFilterInput>;
  some?: InputMaybe<LongOperationFilterInput>;
};

export type ListStringOperationFilterInput = {
  all?: InputMaybe<StringOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<StringOperationFilterInput>;
  some?: InputMaybe<StringOperationFilterInput>;
};

export type ListTypeHabilitationOperationFilterInput = {
  all?: InputMaybe<TypeHabilitationOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TypeHabilitationOperationFilterInput>;
  some?: InputMaybe<TypeHabilitationOperationFilterInput>;
};

export type LocalDateOperationFilterInput = {
  eq?: InputMaybe<Scalars['LocalDate']['input']>;
  gt?: InputMaybe<Scalars['LocalDate']['input']>;
  gte?: InputMaybe<Scalars['LocalDate']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['LocalDate']['input']>>>;
  lt?: InputMaybe<Scalars['LocalDate']['input']>;
  lte?: InputMaybe<Scalars['LocalDate']['input']>;
  neq?: InputMaybe<Scalars['LocalDate']['input']>;
  ngt?: InputMaybe<Scalars['LocalDate']['input']>;
  ngte?: InputMaybe<Scalars['LocalDate']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['LocalDate']['input']>>>;
  nlt?: InputMaybe<Scalars['LocalDate']['input']>;
  nlte?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type LongOperationFilterInput = {
  eq?: InputMaybe<Scalars['Long']['input']>;
  gt?: InputMaybe<Scalars['Long']['input']>;
  gte?: InputMaybe<Scalars['Long']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  lt?: InputMaybe<Scalars['Long']['input']>;
  lte?: InputMaybe<Scalars['Long']['input']>;
  neq?: InputMaybe<Scalars['Long']['input']>;
  ngt?: InputMaybe<Scalars['Long']['input']>;
  ngte?: InputMaybe<Scalars['Long']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  nlt?: InputMaybe<Scalars['Long']['input']>;
  nlte?: InputMaybe<Scalars['Long']['input']>;
};

export type MinotaureImportProgress = {
  __typename?: 'MinotaureImportProgress';
  minotaureInvestisseurs: Scalars['Long']['output'];
  totalInvestisseurs: Scalars['Long']['output'];
};

export type ModeCommunication = {
  __typename?: 'ModeCommunication';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  creationDate: Scalars['DateTime']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  investisseur: Array<Investisseur>;
  libelle: Scalars['String']['output'];
};


export type ModeCommunicationInvestisseurArgs = {
  where?: InputMaybe<InvestisseurFilterInput>;
};

export type ModeCommunicationFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<ModeCommunicationFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  investisseur?: InputMaybe<ListFilterInputTypeOfInvestisseurFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ModeCommunicationFilterInput>>;
};

export type ModeCommunicationSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type ModeDeGestion = {
  __typename?: 'ModeDeGestion';
  code: Scalars['String']['output'];
  libelle: Scalars['String']['output'];
};

export type ModeDeGestionConfig = {
  __typename?: 'ModeDeGestionConfig';
  code: Scalars['String']['output'];
  conditionVersementComplementaire?: Maybe<ConditionVersementComplementaire>;
  conditionVersementInitial?: Maybe<ConditionVersementInitial>;
  conditionVersementProgramme?: Maybe<ConditionVersementProgramme>;
  id: Scalars['String']['output'];
  libelle: Scalars['String']['output'];
};

export type ModeDeGestionConfigFilterInput = {
  and?: InputMaybe<Array<ModeDeGestionConfigFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  conditionVersementComplementaire?: InputMaybe<ConditionVersementComplementaireFilterInput>;
  conditionVersementInitial?: InputMaybe<ConditionVersementInitialFilterInput>;
  conditionVersementProgramme?: InputMaybe<ConditionVersementProgrammeFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ModeDeGestionConfigFilterInput>>;
};

export type ModeDeGestionFilterInput = {
  and?: InputMaybe<Array<ModeDeGestionFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ModeDeGestionFilterInput>>;
};

export type ModeDeGestionInput = {
  code: Scalars['String']['input'];
  libelle: Scalars['String']['input'];
};

export type ModeDeGestionSortInput = {
  code?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type ModeLogement = {
  __typename?: 'ModeLogement';
  actif?: Maybe<Scalars['Boolean']['output']>;
  adresse: Array<Adresse>;
  code: Scalars['String']['output'];
  creationDate: Scalars['DateTime']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};


export type ModeLogementAdresseArgs = {
  where?: InputMaybe<AdresseFilterInput>;
};

export type ModeLogementFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  adresse?: InputMaybe<ListFilterInputTypeOfAdresseFilterInput>;
  and?: InputMaybe<Array<ModeLogementFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ModeLogementFilterInput>>;
};

export type ModeReponseReadhesion = {
  __typename?: 'ModeReponseReadhesion';
  adhesionConsultant: Array<AdhesionConsultant>;
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};


export type ModeReponseReadhesionAdhesionConsultantArgs = {
  where?: InputMaybe<AdhesionConsultantFilterInput>;
};

export type ModeReponseReadhesionFilterInput = {
  adhesionConsultant?: InputMaybe<ListFilterInputTypeOfAdhesionConsultantFilterInput>;
  and?: InputMaybe<Array<ModeReponseReadhesionFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ModeReponseReadhesionFilterInput>>;
};

export type ModeSortieCommande = {
  __typename?: 'ModeSortieCommande';
  code: Scalars['Byte']['output'];
  commande: Array<Commande>;
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};

export type ModeSortieCommandeFilterInput = {
  and?: InputMaybe<Array<ModeSortieCommandeFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  commande?: InputMaybe<ListFilterInputTypeOfCommandeFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ModeSortieCommandeFilterInput>>;
};

export type ModeSortieCommandeSortInput = {
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type MotifAnnulationCommande = {
  __typename?: 'MotifAnnulationCommande';
  code: Scalars['Byte']['output'];
  commande: Array<Commande>;
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  mouvement: Array<Mouvement>;
  typeMotif: Scalars['Byte']['output'];
  typeMotifNavigation: TypeMotifAnnulationMouvement;
};


export type MotifAnnulationCommandeMouvementArgs = {
  where?: InputMaybe<MouvementFilterInput>;
};

export type MotifAnnulationCommandeFilterInput = {
  and?: InputMaybe<Array<MotifAnnulationCommandeFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  commande?: InputMaybe<ListFilterInputTypeOfCommandeFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  mouvement?: InputMaybe<ListFilterInputTypeOfMouvementFilterInput>;
  or?: InputMaybe<Array<MotifAnnulationCommandeFilterInput>>;
  typeMotif?: InputMaybe<ByteOperationFilterInput>;
  typeMotifNavigation?: InputMaybe<TypeMotifAnnulationMouvementFilterInput>;
};

export type MotifAnnulationCommandeSortInput = {
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
  typeMotif?: InputMaybe<SortEnumType>;
  typeMotifNavigation?: InputMaybe<TypeMotifAnnulationMouvementSortInput>;
};

export type MotifCession = {
  __typename?: 'MotifCession';
  cessionHistoCommande: Array<CessionHistoCommande>;
  cessionHistoInvestisseur: Array<CessionHistoInvestisseur>;
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  type: Scalars['Byte']['output'];
  typeNavigation: TypeMotifCession;
};


export type MotifCessionCessionHistoCommandeArgs = {
  where?: InputMaybe<CessionHistoCommandeFilterInput>;
};


export type MotifCessionCessionHistoInvestisseurArgs = {
  where?: InputMaybe<CessionHistoInvestisseurFilterInput>;
};

export type MotifCessionFilterInput = {
  and?: InputMaybe<Array<MotifCessionFilterInput>>;
  cessionHistoCommande?: InputMaybe<ListFilterInputTypeOfCessionHistoCommandeFilterInput>;
  cessionHistoInvestisseur?: InputMaybe<ListFilterInputTypeOfCessionHistoInvestisseurFilterInput>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MotifCessionFilterInput>>;
  type?: InputMaybe<ByteOperationFilterInput>;
  typeNavigation?: InputMaybe<TypeMotifCessionFilterInput>;
};

export type MotifCessionSortInput = {
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  typeNavigation?: InputMaybe<TypeMotifCessionSortInput>;
};

export type MotifResiliationConsultant = {
  __typename?: 'MotifResiliationConsultant';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  consultant: Array<Consultant>;
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};


export type MotifResiliationConsultantConsultantArgs = {
  where?: InputMaybe<ConsultantFilterInput>;
};

export type MotifResiliationConsultantFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<MotifResiliationConsultantFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  consultant?: InputMaybe<ListFilterInputTypeOfConsultantFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MotifResiliationConsultantFilterInput>>;
};

export type MotifResiliationConsultantSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type Mouvement = {
  __typename?: 'Mouvement';
  avecCorrespondant: Scalars['Boolean']['output'];
  baseCommission?: Maybe<Scalars['Decimal']['output']>;
  commande: Commande;
  commandeId: Scalars['Long']['output'];
  consultantMouvement: Array<ConsultantMouvement>;
  creationDate: Scalars['DateTime']['output'];
  dateActe?: Maybe<Scalars['DateTime']['output']>;
  dateAnnulation?: Maybe<Scalars['DateTime']['output']>;
  dateDebutMouvement?: Maybe<Scalars['DateTime']['output']>;
  dateFinMouvement?: Maybe<Scalars['DateTime']['output']>;
  dateTraitement?: Maybe<Scalars['DateTime']['output']>;
  dateValeur?: Maybe<Scalars['DateTime']['output']>;
  dateValidationComptable?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  etatMouvement: EtatMouvement;
  etatMouvementId: Scalars['Byte']['output'];
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['Long']['output']>;
  investisseur: Investisseur;
  investisseurId: Scalars['Long']['output'];
  montantFraisReels?: Maybe<Scalars['Decimal']['output']>;
  montantVersement?: Maybe<Scalars['Decimal']['output']>;
  motifAnnulation?: Maybe<MotifAnnulationCommande>;
  motifAnnulationId?: Maybe<Scalars['Byte']['output']>;
  natureMouvement: NatureMouvement;
  natureMouvementId: Scalars['Byte']['output'];
  nouveauxFrais?: Maybe<Scalars['Decimal']['output']>;
  periodicite?: Maybe<PeriodiciteMouvement>;
  periodiciteId?: Maybe<Scalars['Byte']['output']>;
  pointValeurStrategique?: Maybe<Scalars['Decimal']['output']>;
  reductionLignee: Scalars['Boolean']['output'];
  tauxFraisProduit?: Maybe<Scalars['Decimal']['output']>;
};


export type MouvementConsultantMouvementArgs = {
  where?: InputMaybe<ConsultantMouvementFilterInput>;
};

export type MouvementFilterInput = {
  and?: InputMaybe<Array<MouvementFilterInput>>;
  avecCorrespondant?: InputMaybe<BooleanOperationFilterInput>;
  baseCommission?: InputMaybe<DecimalOperationFilterInput>;
  commande?: InputMaybe<CommandeFilterInput>;
  commandeId?: InputMaybe<LongOperationFilterInput>;
  consultantMouvement?: InputMaybe<ListFilterInputTypeOfConsultantMouvementFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateActe?: InputMaybe<DateTimeOperationFilterInput>;
  dateAnnulation?: InputMaybe<DateTimeOperationFilterInput>;
  dateDebutMouvement?: InputMaybe<DateTimeOperationFilterInput>;
  dateFinMouvement?: InputMaybe<DateTimeOperationFilterInput>;
  dateTraitement?: InputMaybe<DateTimeOperationFilterInput>;
  dateValeur?: InputMaybe<DateTimeOperationFilterInput>;
  dateValidationComptable?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  etatMouvement?: InputMaybe<EtatMouvementFilterInput>;
  etatMouvementId?: InputMaybe<ByteOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<LongOperationFilterInput>;
  investisseur?: InputMaybe<InvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  montantFraisReels?: InputMaybe<DecimalOperationFilterInput>;
  montantVersement?: InputMaybe<DecimalOperationFilterInput>;
  motifAnnulation?: InputMaybe<MotifAnnulationCommandeFilterInput>;
  motifAnnulationId?: InputMaybe<ByteOperationFilterInput>;
  natureMouvement?: InputMaybe<NatureMouvementFilterInput>;
  natureMouvementId?: InputMaybe<ByteOperationFilterInput>;
  nouveauxFrais?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<MouvementFilterInput>>;
  periodicite?: InputMaybe<PeriodiciteMouvementFilterInput>;
  periodiciteId?: InputMaybe<ByteOperationFilterInput>;
  pointValeurStrategique?: InputMaybe<DecimalOperationFilterInput>;
  reductionLignee?: InputMaybe<BooleanOperationFilterInput>;
  tauxFraisProduit?: InputMaybe<DecimalOperationFilterInput>;
};

export type MouvementSortInput = {
  avecCorrespondant?: InputMaybe<SortEnumType>;
  baseCommission?: InputMaybe<SortEnumType>;
  commande?: InputMaybe<CommandeSortInput>;
  commandeId?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  dateActe?: InputMaybe<SortEnumType>;
  dateAnnulation?: InputMaybe<SortEnumType>;
  dateDebutMouvement?: InputMaybe<SortEnumType>;
  dateFinMouvement?: InputMaybe<SortEnumType>;
  dateTraitement?: InputMaybe<SortEnumType>;
  dateValeur?: InputMaybe<SortEnumType>;
  dateValidationComptable?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  etatMouvement?: InputMaybe<EtatMouvementSortInput>;
  etatMouvementId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  idSource?: InputMaybe<SortEnumType>;
  investisseur?: InputMaybe<InvestisseurSortInput>;
  investisseurId?: InputMaybe<SortEnumType>;
  montantFraisReels?: InputMaybe<SortEnumType>;
  montantVersement?: InputMaybe<SortEnumType>;
  motifAnnulation?: InputMaybe<MotifAnnulationCommandeSortInput>;
  motifAnnulationId?: InputMaybe<SortEnumType>;
  natureMouvement?: InputMaybe<NatureMouvementSortInput>;
  natureMouvementId?: InputMaybe<SortEnumType>;
  nouveauxFrais?: InputMaybe<SortEnumType>;
  periodicite?: InputMaybe<PeriodiciteMouvementSortInput>;
  periodiciteId?: InputMaybe<SortEnumType>;
  pointValeurStrategique?: InputMaybe<SortEnumType>;
  reductionLignee?: InputMaybe<SortEnumType>;
  tauxFraisProduit?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type MouvementsPaginatedCollectionSegment = {
  __typename?: 'MouvementsPaginatedCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Mouvement>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  activateDraftConseilConfig?: Maybe<ConseilConfig>;
  /** Add or update Carte de démarchage */
  addOrUpdateCarteDemarchage: Scalars['Boolean']['output'];
  /** Add or update Pièce Justificative */
  addOrUpdatePieceJustificative: Scalars['Boolean']['output'];
  /** Add or update ProfilInvestisseur data */
  addOrUpdateProfilInvestisseur?: Maybe<ProfilInvestisseur>;
  /** Add or update RCP */
  addOrUpdateRcp: Scalars['Boolean']['output'];
  /** Creates a RelationCouple */
  addRelationCouple: Scalars['Boolean']['output'];
  /** Turns the Consultant state from 'Prospect' to 'Affilié' */
  affiliationConsultant: ConsultantId;
  /** Cancel the signatures */
  cancelSignatures: Array<Scalars['String']['output']>;
  /** Technical operation : compute habilitations for one Statut Juridique */
  computeHabilitations: Array<HabilitationInfo>;
  /** Technical operation : compute habilitations for a batch of Statuts Juridiques */
  computeHabilitationsBatch: Array<HabilitationInfo>;
  /** Technical operation : compute latest habilitation changes */
  computeLatestHabilitationChanges: Scalars['String']['output'];
  createArbitrageFicheFromSource?: Maybe<FicheConseil>;
  createConsultantFileMetadata: FileMetadata;
  /** Creates a new Consultant */
  createConsultantProspect: ConsultantId;
  createDraftConseilConfig?: Maybe<ConseilConfig>;
  createFicheConseil?: Maybe<FicheConseil>;
  createFicheConseilFromOldFiche?: Maybe<FicheConseil>;
  createFicheConseilStorageFile: StorageFile;
  createFileMetadata: FileMetadata;
  /** Creates a new Investisseur or a couple of Investisseurs */
  createInvestisseur: Array<Investisseur>;
  createNewLegacyDocumentConfig?: Maybe<ConseilConfig>;
  /** Create the signature document */
  createSignatures: Array<Scalars['String']['output']>;
  createTemporaryStorageFile: StorageFile;
  /** Deletes a Consultant Prospect */
  deleteConsultantProspect: ConsultantId;
  /** Deletes a document (sets metadata.Actif to false) */
  deleteDocument: Scalars['Boolean']['output'];
  deleteDraftConseilConfig: Scalars['String']['output'];
  deleteFiches: Scalars['Boolean']['output'];
  /** Delete the RelationAutre of an Investor */
  deleteRelationAutre?: Maybe<Scalars['Int']['output']>;
  /** Delete the RelationCouple of an Investor */
  deleteRelationCouple: Scalars['Boolean']['output'];
  /** Delete the RelationFamille of an Investor */
  deleteRelationFamille?: Maybe<Scalars['Int']['output']>;
  deprecateStorageFile: Array<StorageFile>;
  /** Technical operation : evaluate de forthcoming expirations of habilitations */
  evaluateHabilitationExpirations: Scalars['Boolean']['output'];
  fichePDF?: Maybe<StorageFile>;
  fichePDFPreview?: Maybe<StorageFile>;
  forceRefreshUserAccessRight: UserAccessRight;
  /** Refresh consultant cache from technical or backoffice action */
  forceRefreshUserAccessRightByConsultantCode?: Maybe<UserAccessRight>;
  /** BackOffice action in order to override an habilitation status */
  overrideHabilitationStatus: Scalars['Boolean']['output'];
  purgeObseleteFiches: Scalars['Int']['output'];
  /** Technical operation : refresh statuts commerciaux & habilitations flags and  */
  refreshStatutsCommerciauxAndHabilitationFlags: Scalars['Boolean']['output'];
  /** Technical operation : register an IMMO inscription */
  registerInscriptionImmo: Scalars['Boolean']['output'];
  /** Relance signatures */
  relanceSignatures: Scalars['Boolean']['output'];
  /** Résiliation Consultant */
  resiliationConsultant: Scalars['Boolean']['output'];
  /** Reverts the reference application for a Consultant to Ariane */
  revertReferenceAppToArianeForConsultant: Scalars['Boolean']['output'];
  /** Reverts the reference application for a Consultant and all his primary investisseurs to Ariane. returns the list of reverted investisseurs' ids */
  revertReferenceAppToArianeForConsultantAndAllHisInvestisseurs: Array<Scalars['Long']['output']>;
  /** Reverts the reference application for an Investisseur to Ariane */
  revertReferenceAppToArianeForInvestisseur: Scalars['Boolean']['output'];
  runInvestisseurTransferProcess: Scalars['Int']['output'];
  /** Set all the actuelCommissionAdiType according to the commissionAdi type chosen by the consultants */
  setActuelByChoixCommissionAdi: Scalars['Boolean']['output'];
  /** Sets batch the reference application for an Investisseur to given value */
  setReferenceAppForInvestisseursBatch: Scalars['Boolean']['output'];
  /** Sets the reference application for a Consultant to Minotaure */
  setReferenceAppToMinotaureForConsultant: Scalars['Boolean']['output'];
  /** Sets the reference application for an Investisseur to Minotaure */
  setReferenceAppToMinotaureForInvestisseur: Scalars['Boolean']['output'];
  /** Set a Consultant's SouhaiteCollaborerAvecStelliumFi */
  setSouhaiteCollaborerAvecStelliumFiConsultant: Consultant;
  /** BackOffice action in order to stop overriding an habilitation status */
  stopOverridingHabilitationStatus: Scalars['Boolean']['output'];
  /** Transfer Investisseur(s) from one Consultant to another */
  transfertClients: Scalars['Boolean']['output'];
  updateAllocationStorageFile: Allocation;
  /** Updates ArianeIds for a newly created Investisseur or a couple of newly created Investisseurs */
  updateArianeIdsForCreatedInvestisseur: Scalars['Boolean']['output'];
  /** Update a CommissionAdiType as chosen by the consultant */
  updateChoixConsultantCommissionAdi: ConsultantCommissionAdi;
  /** Update a Consultant's DateDemission */
  updateDateDemissionConsultant: Consultant;
  /** Update a Consultant's DateFinValiditeAffiliation */
  updateDateFinValiditeAffiliationConsultant: Consultant;
  updateFicheConseil?: Maybe<FicheConseil>;
  updateFileMetadata?: Maybe<FileMetadata>;
  /** Update an investor Donation */
  updateInvestisseurDonation: Scalars['Boolean']['output'];
  /** Update an investor with his SituationPersonnelle */
  updateInvestisseurSituationPersonnelle: Scalars['Boolean']['output'];
  uploadTemplateFile: Scalars['String']['output'];
  /** Creates or update an Investor with his RelationAutre */
  upsertInvestisseurRelationAutre: Scalars['Long']['output'];
  /** Creates or update an Investor with his RelationFamille */
  upsertInvestisseurRelationFamille: Scalars['Long']['output'];
};


export type MutationActivateDraftConseilConfigArgs = {
  conseilConfigId: Scalars['String']['input'];
};


export type MutationAddOrUpdateCarteDemarchageArgs = {
  carteDemarchageData: CarteDemarchageInput;
};


export type MutationAddOrUpdatePieceJustificativeArgs = {
  pjData: PieceJustificativeInput;
};


export type MutationAddOrUpdateProfilInvestisseurArgs = {
  data: ProfilInvestisseurInput;
};


export type MutationAddOrUpdateRcpArgs = {
  rcpData: PieceJustificativeRcpInput;
};


export type MutationAddRelationCoupleArgs = {
  forceDeleteExistingRelationCouple?: InputMaybe<Scalars['Boolean']['input']>;
  input: RelationCoupleInput;
};


export type MutationAffiliationConsultantArgs = {
  consultantData: FilleulDataInput;
};


export type MutationCancelSignaturesArgs = {
  documentIds: Array<Scalars['String']['input']>;
};


export type MutationComputeHabilitationsArgs = {
  idStatutJuridique: Scalars['Long']['input'];
  updateHabilitationFlags: Scalars['Boolean']['input'];
};


export type MutationComputeHabilitationsBatchArgs = {
  idsStatutsJuridiques: Array<Scalars['Long']['input']>;
  updateHabilitationFlags: Scalars['Boolean']['input'];
};


export type MutationComputeLatestHabilitationChangesArgs = {
  applyCciChanges: Scalars['Boolean']['input'];
  applyOriasChanges: Scalars['Boolean']['input'];
  updateHabilitationFlags: Scalars['Boolean']['input'];
};


export type MutationCreateArbitrageFicheFromSourceArgs = {
  ficheId: Scalars['String']['input'];
};


export type MutationCreateConsultantFileMetadataArgs = {
  consultantId: Scalars['Long']['input'];
  dateDeDebutValidite?: InputMaybe<Scalars['DateTime']['input']>;
  dateFinValidite?: InputMaybe<Scalars['DateTime']['input']>;
  denomination: Scalars['String']['input'];
  nomDeFichier: Scalars['String']['input'];
  typeCode: Scalars['String']['input'];
};


export type MutationCreateDraftConseilConfigArgs = {
  input: CreateDraftConseilConfigInput;
};


export type MutationCreateFicheConseilArgs = {
  input: CreateFicheConseilInput;
};


export type MutationCreateFicheConseilFromOldFicheArgs = {
  ficheId: Scalars['String']['input'];
};


export type MutationCreateFicheConseilStorageFileArgs = {
  input: CreateStorageFileInput;
};


export type MutationCreateFileMetadataArgs = {
  categorieCode?: InputMaybe<GedCategory>;
  dateDeReference?: InputMaybe<Scalars['LocalDate']['input']>;
  dateFinValidite?: InputMaybe<Scalars['DateTime']['input']>;
  dateSignature?: InputMaybe<Scalars['DateTime']['input']>;
  denomination: Scalars['String']['input'];
  documentType?: InputMaybe<GedDocumentType>;
  investisseurId: Scalars['Long']['input'];
  investisseurIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  isHandwrittenSignature?: InputMaybe<Scalars['Boolean']['input']>;
  nomDeFichier: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  typeCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateInvestisseurArgs = {
  input: InvestisseurCreationInput;
};


export type MutationCreateNewLegacyDocumentConfigArgs = {
  coaId: Scalars['String']['input'];
  commentaireDeVersion?: InputMaybe<Scalars['String']['input']>;
  libelle?: InputMaybe<Scalars['String']['input']>;
  storageFilesIds: Array<Scalars['String']['input']>;
};


export type MutationCreateSignaturesArgs = {
  input: Array<DocumentSignatureInput>;
};


export type MutationCreateTemporaryStorageFileArgs = {
  input: CreateStorageFileInput;
};


export type MutationDeleteConsultantProspectArgs = {
  consultantCode: Scalars['String']['input'];
};


export type MutationDeleteDocumentArgs = {
  documentId: Scalars['String']['input'];
};


export type MutationDeleteDraftConseilConfigArgs = {
  conseilConfigId: Scalars['String']['input'];
};


export type MutationDeleteFichesArgs = {
  fichesIds: Array<Scalars['String']['input']>;
};


export type MutationDeleteRelationAutreArgs = {
  input: DeleteRelationInput;
};


export type MutationDeleteRelationCoupleArgs = {
  input: DeleteRelationInput;
  shouldUpdateFoyerFiscal?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationDeleteRelationFamilleArgs = {
  input: DeleteRelationInput;
};


export type MutationDeprecateStorageFileArgs = {
  storageFileId: Scalars['String']['input'];
};


export type MutationEvaluateHabilitationExpirationsArgs = {
  timeBeforeHabilitationLossDueToFormationContinueOrInscription: Scalars['TimeSpan']['input'];
  timeBeforeHabilitationLossDueToRcpExpiry: Scalars['TimeSpan']['input'];
};


export type MutationFichePdfArgs = {
  ficheId: Scalars['String']['input'];
};


export type MutationFichePdfPreviewArgs = {
  ficheConseil: FicheConseilInput;
};


export type MutationForceRefreshUserAccessRightByConsultantCodeArgs = {
  consultantCode: Scalars['String']['input'];
};


export type MutationOverrideHabilitationStatusArgs = {
  backOfficeAction: HabilitationStatusOverrideInput;
};


export type MutationPurgeObseleteFichesArgs = {
  batchSize?: Scalars['Int']['input'];
};


export type MutationRefreshStatutsCommerciauxAndHabilitationFlagsArgs = {
  consultantId?: InputMaybe<Scalars['Long']['input']>;
};


export type MutationRegisterInscriptionImmoArgs = {
  computeHabilitationAndApplyChanges: Scalars['Boolean']['input'];
  inscriptionImmo: InscriptionImmoInput;
};


export type MutationRelanceSignaturesArgs = {
  documentIds: Array<Scalars['String']['input']>;
};


export type MutationResiliationConsultantArgs = {
  codeConsultant: Scalars['String']['input'];
};


export type MutationRevertReferenceAppToArianeForConsultantArgs = {
  consultantId: Scalars['Long']['input'];
};


export type MutationRevertReferenceAppToArianeForConsultantAndAllHisInvestisseursArgs = {
  consultantId: Scalars['Long']['input'];
};


export type MutationRevertReferenceAppToArianeForInvestisseurArgs = {
  investisseurId: Scalars['Long']['input'];
};


export type MutationRunInvestisseurTransferProcessArgs = {
  dateTime?: InputMaybe<Scalars['DateTime']['input']>;
  delayInHours?: Scalars['Float']['input'];
  skip?: Scalars['Int']['input'];
};


export type MutationSetReferenceAppForInvestisseursBatchArgs = {
  appReference: AppReference;
  investisseurIds: Array<Scalars['Long']['input']>;
};


export type MutationSetReferenceAppToMinotaureForConsultantArgs = {
  consultantId: Scalars['Long']['input'];
};


export type MutationSetReferenceAppToMinotaureForInvestisseurArgs = {
  investisseurId: Scalars['Long']['input'];
  withWarning?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSetSouhaiteCollaborerAvecStelliumFiConsultantArgs = {
  consultantCode: Scalars['String']['input'];
  souhaiteCollaborerAvecStelliumFi: Scalars['Boolean']['input'];
};


export type MutationStopOverridingHabilitationStatusArgs = {
  backOfficeAction: HabilitationStatusStopOverrideInput;
};


export type MutationTransfertClientsArgs = {
  transfertData: TransfertClientDataInput;
};


export type MutationUpdateAllocationStorageFileArgs = {
  allocationId: Scalars['String']['input'];
  storageFileId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateArianeIdsForCreatedInvestisseurArgs = {
  arianeInput: InvestisseurCreationArianeUpdateInput;
};


export type MutationUpdateChoixConsultantCommissionAdiArgs = {
  choixTypeCommissionAdiCode: Scalars['Int']['input'];
  consultantId: Scalars['Long']['input'];
  dateChoixTypeCommissionAdi: Scalars['LocalDate']['input'];
};


export type MutationUpdateDateDemissionConsultantArgs = {
  consultantCode: Scalars['String']['input'];
  dateDemission: Scalars['LocalDate']['input'];
};


export type MutationUpdateDateFinValiditeAffiliationConsultantArgs = {
  consultantCode: Scalars['String']['input'];
  dateFinValiditeAffiliation: Scalars['LocalDate']['input'];
};


export type MutationUpdateFicheConseilArgs = {
  newFiche: FicheConseilInput;
};


export type MutationUpdateFileMetadataArgs = {
  fileId: Scalars['String']['input'];
  newMetadata?: InputMaybe<UpdateDocumentMetadatasCommandInput>;
  newValue?: InputMaybe<FileMetadataUpdateInput>;
};


export type MutationUpdateInvestisseurDonationArgs = {
  input: DonationInput;
  investisseurId: Scalars['Long']['input'];
};


export type MutationUpdateInvestisseurSituationPersonnelleArgs = {
  input: UpdateSituationPersonnelleInput;
};


export type MutationUploadTemplateFileArgs = {
  templateName: Scalars['String']['input'];
  templateUrl: Scalars['String']['input'];
};


export type MutationUpsertInvestisseurRelationAutreArgs = {
  input: InvestisseurRelationAutreInput;
};


export type MutationUpsertInvestisseurRelationFamilleArgs = {
  input: InvestisseurRelationFamilleInput;
};

export type NatureMouvement = {
  __typename?: 'NatureMouvement';
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  mouvement: Array<Mouvement>;
};


export type NatureMouvementMouvementArgs = {
  where?: InputMaybe<MouvementFilterInput>;
};

export type NatureMouvementFilterInput = {
  and?: InputMaybe<Array<NatureMouvementFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  mouvement?: InputMaybe<ListFilterInputTypeOfMouvementFilterInput>;
  or?: InputMaybe<Array<NatureMouvementFilterInput>>;
};

export type NatureMouvementSortInput = {
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type NatureOperation = {
  __typename?: 'NatureOperation';
  categorieNavigation: NatureOperationCategorie;
  id: Scalars['Int']['output'];
  libelle: Scalars['String']['output'];
  natureOperationCategorieId: Scalars['Int']['output'];
};

export type NatureOperationCategorie = {
  __typename?: 'NatureOperationCategorie';
  id: Scalars['Int']['output'];
  libelle: Scalars['String']['output'];
};

export type NatureOperationCategorieFilterInput = {
  and?: InputMaybe<Array<NatureOperationCategorieFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<NatureOperationCategorieFilterInput>>;
};

export type NatureOperationFilterInput = {
  and?: InputMaybe<Array<NatureOperationFilterInput>>;
  categorieNavigation?: InputMaybe<NatureOperationCategorieFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  natureOperationCategorieId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<NatureOperationFilterInput>>;
};

export type NatureOperationSortInput = {
  id?: InputMaybe<SortEnumType>;
};

export type NatureOperationWithLibelle = {
  __typename?: 'NatureOperationWithLibelle';
  id: Scalars['Int']['output'];
  libelle: Scalars['String']['output'];
};

export type NatureOperationWithLibelleFilterInput = {
  and?: InputMaybe<Array<NatureOperationWithLibelleFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<NatureOperationWithLibelleFilterInput>>;
};

export type NatureOperationWithLibelleInput = {
  id: Scalars['Int']['input'];
  libelle: Scalars['String']['input'];
};

export type NatureOperationWithLibelleSortInput = {
  id?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type NaturePatrimoine = {
  __typename?: 'NaturePatrimoine';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  creationDate: Scalars['DateTime']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  patrimoineActif: Array<PatrimoineActif>;
  patrimoineChargeRevenu: Array<PatrimoineChargeRevenu>;
  patrimoinePassif: Array<PatrimoinePassif>;
  type: Scalars['String']['output'];
};


export type NaturePatrimoinePatrimoineActifArgs = {
  where?: InputMaybe<PatrimoineActifFilterInput>;
};


export type NaturePatrimoinePatrimoineChargeRevenuArgs = {
  where?: InputMaybe<PatrimoineChargeRevenuFilterInput>;
};


export type NaturePatrimoinePatrimoinePassifArgs = {
  where?: InputMaybe<PatrimoinePassifFilterInput>;
};

export type NaturePatrimoineFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<NaturePatrimoineFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<NaturePatrimoineFilterInput>>;
  patrimoineActif?: InputMaybe<ListFilterInputTypeOfPatrimoineActifFilterInput>;
  patrimoineChargeRevenu?: InputMaybe<ListFilterInputTypeOfPatrimoineChargeRevenuFilterInput>;
  patrimoinePassif?: InputMaybe<ListFilterInputTypeOfPatrimoinePassifFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
};

export type NatureRelationAutre = {
  __typename?: 'NatureRelationAutre';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  typeRelationAutre: Array<TypeRelationAutre>;
};


export type NatureRelationAutreTypeRelationAutreArgs = {
  where?: InputMaybe<TypeRelationAutreFilterInput>;
};

export type NatureRelationAutreFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<NatureRelationAutreFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<NatureRelationAutreFilterInput>>;
  typeRelationAutre?: InputMaybe<ListFilterInputTypeOfTypeRelationAutreFilterInput>;
};

export type NatureRelationAutreSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export enum NiveauDeRisque {
  Dynamique = 'DYNAMIQUE',
  Equilibre = 'EQUILIBRE',
  Offensif = 'OFFENSIF',
  Prudent = 'PRUDENT',
  Securise = 'SECURISE'
}

export type NiveauDeRisqueOperationFilterInput = {
  eq?: InputMaybe<NiveauDeRisque>;
  in?: InputMaybe<Array<NiveauDeRisque>>;
  neq?: InputMaybe<NiveauDeRisque>;
  nin?: InputMaybe<Array<NiveauDeRisque>>;
};

export type NiveauEtude = {
  __typename?: 'NiveauEtude';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  creationDate: Scalars['DateTime']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  relationFamille: Array<RelationFamille>;
};


export type NiveauEtudeRelationFamilleArgs = {
  where?: InputMaybe<RelationFamilleFilterInput>;
};

export type NiveauEtudeFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<NiveauEtudeFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<NiveauEtudeFilterInput>>;
  relationFamille?: InputMaybe<ListFilterInputTypeOfRelationFamilleFilterInput>;
};

export type Note = {
  __typename?: 'Note';
  adresse: Array<Adresse>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  disposition: Array<Disposition>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  email: Array<Email>;
  etatCivils: Array<EtatCivil>;
  facture: Array<Facture>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  investisseur: Array<Investisseur>;
  note1: Scalars['String']['output'];
  relationCouples: Array<RelationCouple>;
  relationFamilles: Array<RelationFamille>;
  situationProfessionnelle: Array<SituationProfessionnelle>;
  telephone: Array<Telephone>;
  testaments: Array<Testament>;
};


export type NoteAdresseArgs = {
  where?: InputMaybe<AdresseFilterInput>;
};


export type NoteDispositionArgs = {
  where?: InputMaybe<DispositionFilterInput>;
};


export type NoteEmailArgs = {
  where?: InputMaybe<EmailFilterInput>;
};


export type NoteEtatCivilsArgs = {
  where?: InputMaybe<EtatCivilFilterInput>;
};


export type NoteFactureArgs = {
  where?: InputMaybe<FactureFilterInput>;
};


export type NoteInvestisseurArgs = {
  where?: InputMaybe<InvestisseurFilterInput>;
};


export type NoteRelationCouplesArgs = {
  where?: InputMaybe<RelationCoupleFilterInput>;
};


export type NoteRelationFamillesArgs = {
  where?: InputMaybe<RelationFamilleFilterInput>;
};


export type NoteSituationProfessionnelleArgs = {
  where?: InputMaybe<SituationProfessionnelleFilterInput>;
};


export type NoteTelephoneArgs = {
  where?: InputMaybe<TelephoneFilterInput>;
};


export type NoteTestamentsArgs = {
  where?: InputMaybe<TestamentFilterInput>;
};

export type NoteFilterInput = {
  adresse?: InputMaybe<ListFilterInputTypeOfAdresseFilterInput>;
  and?: InputMaybe<Array<NoteFilterInput>>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  disposition?: InputMaybe<ListFilterInputTypeOfDispositionFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  email?: InputMaybe<ListFilterInputTypeOfEmailFilterInput>;
  etatCivils?: InputMaybe<ListFilterInputTypeOfEtatCivilFilterInput>;
  facture?: InputMaybe<ListFilterInputTypeOfFactureFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  investisseur?: InputMaybe<ListFilterInputTypeOfInvestisseurFilterInput>;
  note1?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<NoteFilterInput>>;
  relationCouples?: InputMaybe<ListFilterInputTypeOfRelationCoupleFilterInput>;
  relationFamilles?: InputMaybe<ListFilterInputTypeOfRelationFamilleFilterInput>;
  situationProfessionnelle?: InputMaybe<ListFilterInputTypeOfSituationProfessionnelleFilterInput>;
  telephone?: InputMaybe<ListFilterInputTypeOfTelephoneFilterInput>;
  testaments?: InputMaybe<ListFilterInputTypeOfTestamentFilterInput>;
};

export type NoteSortInput = {
  createurId?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editeurId?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  idSource?: InputMaybe<SortEnumType>;
  note1?: InputMaybe<SortEnumType>;
};

export type NullableOfAllocationPartenaireStatutOperationFilterInput = {
  eq?: InputMaybe<AllocationPartenaireStatut>;
  in?: InputMaybe<Array<InputMaybe<AllocationPartenaireStatut>>>;
  neq?: InputMaybe<AllocationPartenaireStatut>;
  nin?: InputMaybe<Array<InputMaybe<AllocationPartenaireStatut>>>;
};

export type NullableOfAllocationTransfertOptionOperationFilterInput = {
  eq?: InputMaybe<AllocationTransfertOption>;
  in?: InputMaybe<Array<InputMaybe<AllocationTransfertOption>>>;
  neq?: InputMaybe<AllocationTransfertOption>;
  nin?: InputMaybe<Array<InputMaybe<AllocationTransfertOption>>>;
};

export type NullableOfAllocationVersementOptionOperationFilterInput = {
  eq?: InputMaybe<AllocationVersementOption>;
  in?: InputMaybe<Array<InputMaybe<AllocationVersementOption>>>;
  neq?: InputMaybe<AllocationVersementOption>;
  nin?: InputMaybe<Array<InputMaybe<AllocationVersementOption>>>;
};

export type NullableOfDisponibiliteEpargneOperationFilterInput = {
  eq?: InputMaybe<DisponibiliteEpargne>;
  in?: InputMaybe<Array<InputMaybe<DisponibiliteEpargne>>>;
  neq?: InputMaybe<DisponibiliteEpargne>;
  nin?: InputMaybe<Array<InputMaybe<DisponibiliteEpargne>>>;
};

export type NullableOfFileStorageStatusOperationFilterInput = {
  eq?: InputMaybe<FileStorageStatus>;
  in?: InputMaybe<Array<InputMaybe<FileStorageStatus>>>;
  neq?: InputMaybe<FileStorageStatus>;
  nin?: InputMaybe<Array<InputMaybe<FileStorageStatus>>>;
};

export type NullableOfFrequenceVersementOperationFilterInput = {
  eq?: InputMaybe<FrequenceVersement>;
  in?: InputMaybe<Array<InputMaybe<FrequenceVersement>>>;
  neq?: InputMaybe<FrequenceVersement>;
  nin?: InputMaybe<Array<InputMaybe<FrequenceVersement>>>;
};

export type NullableOfGedCategoryOperationFilterInput = {
  eq?: InputMaybe<GedCategory>;
  in?: InputMaybe<Array<InputMaybe<GedCategory>>>;
  neq?: InputMaybe<GedCategory>;
  nin?: InputMaybe<Array<InputMaybe<GedCategory>>>;
};

export type NullableOfGedDocumentTypeOperationFilterInput = {
  eq?: InputMaybe<GedDocumentType>;
  in?: InputMaybe<Array<InputMaybe<GedDocumentType>>>;
  neq?: InputMaybe<GedDocumentType>;
  nin?: InputMaybe<Array<InputMaybe<GedDocumentType>>>;
};

export type NullableOfHorizonPlacementEnumOperationFilterInput = {
  eq?: InputMaybe<HorizonPlacementEnum>;
  in?: InputMaybe<Array<InputMaybe<HorizonPlacementEnum>>>;
  neq?: InputMaybe<HorizonPlacementEnum>;
  nin?: InputMaybe<Array<InputMaybe<HorizonPlacementEnum>>>;
};

export type NullableOfNiveauDeRisqueOperationFilterInput = {
  eq?: InputMaybe<NiveauDeRisque>;
  in?: InputMaybe<Array<InputMaybe<NiveauDeRisque>>>;
  neq?: InputMaybe<NiveauDeRisque>;
  nin?: InputMaybe<Array<InputMaybe<NiveauDeRisque>>>;
};

export type NullableOfPermissionOperationFilterInput = {
  eq?: InputMaybe<Permission>;
  in?: InputMaybe<Array<InputMaybe<Permission>>>;
  neq?: InputMaybe<Permission>;
  nin?: InputMaybe<Array<InputMaybe<Permission>>>;
};

export type NullableOfPortefeuilleOptionOperationFilterInput = {
  eq?: InputMaybe<PortefeuilleOption>;
  in?: InputMaybe<Array<InputMaybe<PortefeuilleOption>>>;
  neq?: InputMaybe<PortefeuilleOption>;
  nin?: InputMaybe<Array<InputMaybe<PortefeuilleOption>>>;
};

export type NullableOfSignatureStateOperationFilterInput = {
  eq?: InputMaybe<SignatureState>;
  in?: InputMaybe<Array<InputMaybe<SignatureState>>>;
  neq?: InputMaybe<SignatureState>;
  nin?: InputMaybe<Array<InputMaybe<SignatureState>>>;
};

export type NullableOfToleranceRisqueOperationFilterInput = {
  eq?: InputMaybe<ToleranceRisque>;
  in?: InputMaybe<Array<InputMaybe<ToleranceRisque>>>;
  neq?: InputMaybe<ToleranceRisque>;
  nin?: InputMaybe<Array<InputMaybe<ToleranceRisque>>>;
};

export type NullableOfVpModeOptionsOperationFilterInput = {
  eq?: InputMaybe<VpModeOptions>;
  in?: InputMaybe<Array<InputMaybe<VpModeOptions>>>;
  neq?: InputMaybe<VpModeOptions>;
  nin?: InputMaybe<Array<InputMaybe<VpModeOptions>>>;
};

export type ObjectifReferentielFiche = {
  __typename?: 'ObjectifReferentielFiche';
  actif?: Maybe<Scalars['Boolean']['output']>;
  categorieCode: Scalars['String']['output'];
  categorieLibelle: Scalars['String']['output'];
  code: Scalars['String']['output'];
  libelle: Scalars['String']['output'];
};

export type OptionAutomatique = {
  __typename?: 'OptionAutomatique';
  id: Scalars['String']['output'];
  libelle: Scalars['String']['output'];
  modeDeGestionCode: Scalars['String']['output'];
  ordre: Scalars['Int']['output'];
  produits: Array<Produit>;
};

export type OptionAutomatiqueConseil = {
  __typename?: 'OptionAutomatiqueConseil';
  id: Scalars['String']['output'];
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  libelle: Scalars['String']['output'];
};

export type OptionAutomatiqueConseilFilterInput = {
  and?: InputMaybe<Array<OptionAutomatiqueConseilFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  isSelected?: InputMaybe<BooleanOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OptionAutomatiqueConseilFilterInput>>;
};

export type OptionAutomatiqueConseilInput = {
  id: Scalars['String']['input'];
  isSelected?: InputMaybe<Scalars['Boolean']['input']>;
  libelle: Scalars['String']['input'];
};

export type OptionAutomatiqueFilterInput = {
  and?: InputMaybe<Array<OptionAutomatiqueFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  modeDeGestionCode?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OptionAutomatiqueFilterInput>>;
  ordre?: InputMaybe<IntOperationFilterInput>;
  produits?: InputMaybe<ListFilterInputTypeOfProduitFilterInput>;
};

export type OptionAutomatiqueSortInput = {
  id?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
  modeDeGestionCode?: InputMaybe<SortEnumType>;
  ordre?: InputMaybe<SortEnumType>;
};

export type Organisme = {
  __typename?: 'Organisme';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  consultantHabilitationInscription: Array<ConsultantHabilitationInscription>;
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  departementCci?: Maybe<Scalars['String']['output']>;
  departementCciNavigation?: Maybe<Departement>;
  habilitationInscription: Array<HabilitationInscription>;
  libelle?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
};


export type OrganismeConsultantHabilitationInscriptionArgs = {
  where?: InputMaybe<ConsultantHabilitationInscriptionFilterInput>;
};


export type OrganismeHabilitationInscriptionArgs = {
  where?: InputMaybe<HabilitationInscriptionFilterInput>;
};

export type OrganismeAssureurRcp = {
  __typename?: 'OrganismeAssureurRCP';
  adresse?: Maybe<Scalars['String']['output']>;
  consultantRcp: Array<ConsultantRcp>;
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  nom: Scalars['String']['output'];
};


export type OrganismeAssureurRcpConsultantRcpArgs = {
  where?: InputMaybe<ConsultantRcpFilterInput>;
};

export type OrganismeAssureurRcpFilterInput = {
  adresse?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<OrganismeAssureurRcpFilterInput>>;
  consultantRcp?: InputMaybe<ListFilterInputTypeOfConsultantRcpFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  nom?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OrganismeAssureurRcpFilterInput>>;
};

export type OrganismeFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<OrganismeFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  consultantHabilitationInscription?: InputMaybe<ListFilterInputTypeOfConsultantHabilitationInscriptionFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  departementCci?: InputMaybe<StringOperationFilterInput>;
  departementCciNavigation?: InputMaybe<DepartementFilterInput>;
  habilitationInscription?: InputMaybe<ListFilterInputTypeOfHabilitationInscriptionFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OrganismeFilterInput>>;
  type?: InputMaybe<IntOperationFilterInput>;
};

export type OrigineContact = {
  __typename?: 'OrigineContact';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  investisseur: Array<Investisseur>;
  libelle: Scalars['String']['output'];
};


export type OrigineContactInvestisseurArgs = {
  where?: InputMaybe<InvestisseurFilterInput>;
};

export type OrigineContactFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<OrigineContactFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  investisseur?: InputMaybe<ListFilterInputTypeOfInvestisseurFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OrigineContactFilterInput>>;
};

export type OrigineContactSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type OrigineData = {
  __typename?: 'OrigineData';
  actionDeFormation: Array<ActionDeFormation>;
  code: Scalars['Byte']['output'];
  consultant: Array<Consultant>;
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  investisseur: Array<Investisseur>;
  libelle: Scalars['String']['output'];
};


export type OrigineDataActionDeFormationArgs = {
  where?: InputMaybe<ActionDeFormationFilterInput>;
};


export type OrigineDataConsultantArgs = {
  where?: InputMaybe<ConsultantFilterInput>;
};


export type OrigineDataInvestisseurArgs = {
  where?: InputMaybe<InvestisseurFilterInput>;
};

export type OrigineDataFilterInput = {
  actionDeFormation?: InputMaybe<ListFilterInputTypeOfActionDeFormationFilterInput>;
  and?: InputMaybe<Array<OrigineDataFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  consultant?: InputMaybe<ListFilterInputTypeOfConsultantFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  investisseur?: InputMaybe<ListFilterInputTypeOfInvestisseurFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OrigineDataFilterInput>>;
};

export type OrigineDataSortInput = {
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type PaginatedResultOfFileMetadata = {
  __typename?: 'PaginatedResultOfFileMetadata';
  continuationToken?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<FileMetadata>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};


export type PaginatedResultOfFileMetadataDataArgs = {
  where?: InputMaybe<FileMetadataFilterInput>;
};

export type Partenaire = {
  __typename?: 'Partenaire';
  activiteRattachement?: Maybe<Scalars['Byte']['output']>;
  activiteRattachementNavigation?: Maybe<ActiviteRattachPartenaire>;
  codePartenaire?: Maybe<Scalars['String']['output']>;
  contact: Array<Contact>;
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['Long']['output']>;
  nom: Scalars['String']['output'];
  nomComplet?: Maybe<Scalars['String']['output']>;
  produit: Array<Produit>;
};


export type PartenaireContactArgs = {
  where?: InputMaybe<ContactFilterInput>;
};


export type PartenaireProduitArgs = {
  where?: InputMaybe<ProduitFilterInput>;
};

export type PartenaireFilterInput = {
  activiteRattachement?: InputMaybe<ByteOperationFilterInput>;
  activiteRattachementNavigation?: InputMaybe<ActiviteRattachPartenaireFilterInput>;
  and?: InputMaybe<Array<PartenaireFilterInput>>;
  codePartenaire?: InputMaybe<StringOperationFilterInput>;
  contact?: InputMaybe<ListFilterInputTypeOfContactFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<LongOperationFilterInput>;
  nom?: InputMaybe<StringOperationFilterInput>;
  nomComplet?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PartenaireFilterInput>>;
  produit?: InputMaybe<ListFilterInputTypeOfProduitFilterInput>;
};

export type PartenaireSortInput = {
  activiteRattachement?: InputMaybe<SortEnumType>;
  activiteRattachementNavigation?: InputMaybe<ActiviteRattachPartenaireSortInput>;
  codePartenaire?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  idSource?: InputMaybe<SortEnumType>;
  nom?: InputMaybe<SortEnumType>;
  nomComplet?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type PartenairesPaginatedCollectionSegment = {
  __typename?: 'PartenairesPaginatedCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Partenaire>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type PatrimoineActif = {
  __typename?: 'PatrimoineActif';
  arianeId?: Maybe<Scalars['Long']['output']>;
  autresChampsJson?: Maybe<Scalars['String']['output']>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  date?: Maybe<Scalars['LocalDate']['output']>;
  dateNaissanceUsufruitier?: Maybe<Scalars['LocalDate']['output']>;
  designation?: Maybe<Scalars['String']['output']>;
  detenteurPatrimoineActif: Array<DetenteurPatrimoineActif>;
  detentionCode?: Maybe<Scalars['String']['output']>;
  detentionCodeNavigation?: Maybe<Detention>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  montant?: Maybe<Scalars['Decimal']['output']>;
  natureCode: Scalars['String']['output'];
  natureCodeNavigation: NaturePatrimoine;
  note?: Maybe<Scalars['String']['output']>;
  patrimoinePassif: Array<PatrimoinePassif>;
};


export type PatrimoineActifDetenteurPatrimoineActifArgs = {
  where?: InputMaybe<DetenteurPatrimoineActifFilterInput>;
};


export type PatrimoineActifPatrimoinePassifArgs = {
  where?: InputMaybe<PatrimoinePassifFilterInput>;
};

export type PatrimoineActifFilterInput = {
  and?: InputMaybe<Array<PatrimoineActifFilterInput>>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  autresChampsJson?: InputMaybe<StringOperationFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  date?: InputMaybe<LocalDateOperationFilterInput>;
  dateNaissanceUsufruitier?: InputMaybe<LocalDateOperationFilterInput>;
  designation?: InputMaybe<StringOperationFilterInput>;
  detenteurPatrimoineActif?: InputMaybe<ListFilterInputTypeOfDetenteurPatrimoineActifFilterInput>;
  detentionCode?: InputMaybe<StringOperationFilterInput>;
  detentionCodeNavigation?: InputMaybe<DetentionFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  montant?: InputMaybe<DecimalOperationFilterInput>;
  natureCode?: InputMaybe<StringOperationFilterInput>;
  natureCodeNavigation?: InputMaybe<NaturePatrimoineFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PatrimoineActifFilterInput>>;
  patrimoinePassif?: InputMaybe<ListFilterInputTypeOfPatrimoinePassifFilterInput>;
};

export type PatrimoineChargeRevenu = {
  __typename?: 'PatrimoineChargeRevenu';
  arianeId?: Maybe<Scalars['Long']['output']>;
  autresChampsJson?: Maybe<Scalars['String']['output']>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  designation?: Maybe<Scalars['String']['output']>;
  detenteurPatrimoineChargeRevenu: Array<DetenteurPatrimoineChargeRevenu>;
  detentionCode?: Maybe<Scalars['String']['output']>;
  detentionCodeNavigation?: Maybe<Detention>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  investisseurId?: Maybe<Scalars['Long']['output']>;
  montant?: Maybe<Scalars['Decimal']['output']>;
  natureCode: Scalars['String']['output'];
  natureCodeNavigation: NaturePatrimoine;
  note?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};


export type PatrimoineChargeRevenuDetenteurPatrimoineChargeRevenuArgs = {
  where?: InputMaybe<DetenteurPatrimoineChargeRevenuFilterInput>;
};

export type PatrimoineChargeRevenuFilterInput = {
  and?: InputMaybe<Array<PatrimoineChargeRevenuFilterInput>>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  autresChampsJson?: InputMaybe<StringOperationFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  designation?: InputMaybe<StringOperationFilterInput>;
  detenteurPatrimoineChargeRevenu?: InputMaybe<ListFilterInputTypeOfDetenteurPatrimoineChargeRevenuFilterInput>;
  detentionCode?: InputMaybe<StringOperationFilterInput>;
  detentionCodeNavigation?: InputMaybe<DetentionFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  montant?: InputMaybe<DecimalOperationFilterInput>;
  natureCode?: InputMaybe<StringOperationFilterInput>;
  natureCodeNavigation?: InputMaybe<NaturePatrimoineFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PatrimoineChargeRevenuFilterInput>>;
  type?: InputMaybe<StringOperationFilterInput>;
};

export type PatrimoineFiscalite = {
  __typename?: 'PatrimoineFiscalite';
  annee?: Maybe<Scalars['Int']['output']>;
  baseImposable?: Maybe<Scalars['Decimal']['output']>;
  chargesDeductibles?: Maybe<Scalars['Decimal']['output']>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  csAutresChampsJson?: Maybe<Scalars['String']['output']>;
  csTotalPrelevSociauxNet?: Maybe<Scalars['Decimal']['output']>;
  csgDeductible?: Maybe<Scalars['Decimal']['output']>;
  decote?: Maybe<Scalars['Decimal']['output']>;
  deficitFoncier?: Maybe<Scalars['Decimal']['output']>;
  disponibleFiscal?: Maybe<Scalars['Decimal']['output']>;
  droitsImmo?: Maybe<Scalars['Decimal']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  idSource?: Maybe<Scalars['String']['output']>;
  ifiAutresChampsJson?: Maybe<Scalars['String']['output']>;
  ifiNetAPayer?: Maybe<Scalars['Decimal']['output']>;
  ifiReduction?: Maybe<Scalars['Decimal']['output']>;
  ifiTmi?: Maybe<Scalars['Decimal']['output']>;
  immBatis?: Maybe<Scalars['Decimal']['output']>;
  immNonBatis?: Maybe<Scalars['Decimal']['output']>;
  investisseur: Investisseur;
  investisseurId: Scalars['Long']['output'];
  irAutresChampsJson?: Maybe<Scalars['String']['output']>;
  irNbParts?: Maybe<Scalars['Decimal']['output']>;
  irNetAvantCorrections?: Maybe<Scalars['Decimal']['output']>;
  irPlafondRetraite?: Maybe<Scalars['Decimal']['output']>;
  irRevenuImposable?: Maybe<Scalars['Decimal']['output']>;
  irSoumis?: Maybe<Scalars['Decimal']['output']>;
  irTauxImposition?: Maybe<Scalars['Decimal']['output']>;
  irTmi?: Maybe<Scalars['Decimal']['output']>;
  irTotalImpotNet?: Maybe<Scalars['Decimal']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  passifDeductible?: Maybe<Scalars['Decimal']['output']>;
  revenuBrutGlobal?: Maybe<Scalars['Decimal']['output']>;
  revenuFiscalDeRef?: Maybe<Scalars['Decimal']['output']>;
  totalCreditImpot?: Maybe<Scalars['Decimal']['output']>;
  totalReduImpots?: Maybe<Scalars['Decimal']['output']>;
  totalSalaireAssimile?: Maybe<Scalars['Decimal']['output']>;
};

export type PatrimoineFiscaliteFilterInput = {
  and?: InputMaybe<Array<PatrimoineFiscaliteFilterInput>>;
  annee?: InputMaybe<IntOperationFilterInput>;
  baseImposable?: InputMaybe<DecimalOperationFilterInput>;
  chargesDeductibles?: InputMaybe<DecimalOperationFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  csAutresChampsJson?: InputMaybe<StringOperationFilterInput>;
  csTotalPrelevSociauxNet?: InputMaybe<DecimalOperationFilterInput>;
  csgDeductible?: InputMaybe<DecimalOperationFilterInput>;
  decote?: InputMaybe<DecimalOperationFilterInput>;
  deficitFoncier?: InputMaybe<DecimalOperationFilterInput>;
  disponibleFiscal?: InputMaybe<DecimalOperationFilterInput>;
  droitsImmo?: InputMaybe<DecimalOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  ifiAutresChampsJson?: InputMaybe<StringOperationFilterInput>;
  ifiNetAPayer?: InputMaybe<DecimalOperationFilterInput>;
  ifiReduction?: InputMaybe<DecimalOperationFilterInput>;
  ifiTmi?: InputMaybe<DecimalOperationFilterInput>;
  immBatis?: InputMaybe<DecimalOperationFilterInput>;
  immNonBatis?: InputMaybe<DecimalOperationFilterInput>;
  investisseur?: InputMaybe<InvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  irAutresChampsJson?: InputMaybe<StringOperationFilterInput>;
  irNbParts?: InputMaybe<DecimalOperationFilterInput>;
  irNetAvantCorrections?: InputMaybe<DecimalOperationFilterInput>;
  irPlafondRetraite?: InputMaybe<DecimalOperationFilterInput>;
  irRevenuImposable?: InputMaybe<DecimalOperationFilterInput>;
  irSoumis?: InputMaybe<DecimalOperationFilterInput>;
  irTauxImposition?: InputMaybe<DecimalOperationFilterInput>;
  irTmi?: InputMaybe<DecimalOperationFilterInput>;
  irTotalImpotNet?: InputMaybe<DecimalOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PatrimoineFiscaliteFilterInput>>;
  passifDeductible?: InputMaybe<DecimalOperationFilterInput>;
  revenuBrutGlobal?: InputMaybe<DecimalOperationFilterInput>;
  revenuFiscalDeRef?: InputMaybe<DecimalOperationFilterInput>;
  totalCreditImpot?: InputMaybe<DecimalOperationFilterInput>;
  totalReduImpots?: InputMaybe<DecimalOperationFilterInput>;
  totalSalaireAssimile?: InputMaybe<DecimalOperationFilterInput>;
};

export type PatrimoineFiscaliteSortInput = {
  annee?: InputMaybe<SortEnumType>;
  baseImposable?: InputMaybe<SortEnumType>;
  chargesDeductibles?: InputMaybe<SortEnumType>;
  createurId?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  csAutresChampsJson?: InputMaybe<SortEnumType>;
  csTotalPrelevSociauxNet?: InputMaybe<SortEnumType>;
  csgDeductible?: InputMaybe<SortEnumType>;
  decote?: InputMaybe<SortEnumType>;
  deficitFoncier?: InputMaybe<SortEnumType>;
  disponibleFiscal?: InputMaybe<SortEnumType>;
  droitsImmo?: InputMaybe<SortEnumType>;
  editeurId?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  idSource?: InputMaybe<SortEnumType>;
  ifiAutresChampsJson?: InputMaybe<SortEnumType>;
  ifiNetAPayer?: InputMaybe<SortEnumType>;
  ifiReduction?: InputMaybe<SortEnumType>;
  ifiTmi?: InputMaybe<SortEnumType>;
  immBatis?: InputMaybe<SortEnumType>;
  immNonBatis?: InputMaybe<SortEnumType>;
  investisseur?: InputMaybe<InvestisseurSortInput>;
  investisseurId?: InputMaybe<SortEnumType>;
  irAutresChampsJson?: InputMaybe<SortEnumType>;
  irNbParts?: InputMaybe<SortEnumType>;
  irNetAvantCorrections?: InputMaybe<SortEnumType>;
  irPlafondRetraite?: InputMaybe<SortEnumType>;
  irRevenuImposable?: InputMaybe<SortEnumType>;
  irSoumis?: InputMaybe<SortEnumType>;
  irTauxImposition?: InputMaybe<SortEnumType>;
  irTmi?: InputMaybe<SortEnumType>;
  irTotalImpotNet?: InputMaybe<SortEnumType>;
  note?: InputMaybe<SortEnumType>;
  passifDeductible?: InputMaybe<SortEnumType>;
  revenuBrutGlobal?: InputMaybe<SortEnumType>;
  revenuFiscalDeRef?: InputMaybe<SortEnumType>;
  totalCreditImpot?: InputMaybe<SortEnumType>;
  totalReduImpots?: InputMaybe<SortEnumType>;
  totalSalaireAssimile?: InputMaybe<SortEnumType>;
};

export type PatrimoinePassif = {
  __typename?: 'PatrimoinePassif';
  actifLie?: Maybe<PatrimoineActif>;
  actifLieId?: Maybe<Scalars['Long']['output']>;
  arianeId?: Maybe<Scalars['Long']['output']>;
  autresChampsJson?: Maybe<Scalars['String']['output']>;
  capitalRestantDu?: Maybe<Scalars['Decimal']['output']>;
  commun?: Maybe<Scalars['UUID']['output']>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  dateSouscription?: Maybe<Scalars['LocalDate']['output']>;
  designation?: Maybe<Scalars['String']['output']>;
  detenteurPatrimoinePassif: Array<DetenteurPatrimoinePassif>;
  detentionCode?: Maybe<Scalars['String']['output']>;
  detentionCodeNavigation?: Maybe<Detention>;
  duree?: Maybe<Scalars['Int']['output']>;
  dureeRestante?: Maybe<Scalars['Int']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  investisseurId?: Maybe<Scalars['Long']['output']>;
  mensualiteAdi?: Maybe<Scalars['Decimal']['output']>;
  montant?: Maybe<Scalars['Decimal']['output']>;
  natureCode: Scalars['String']['output'];
  natureCodeNavigation: NaturePatrimoine;
  note?: Maybe<Scalars['String']['output']>;
  quotePartAdi?: Maybe<Scalars['Decimal']['output']>;
  tauxAdi?: Maybe<Scalars['Decimal']['output']>;
  tauxDetention?: Maybe<Scalars['Decimal']['output']>;
  typeCredit?: Maybe<Scalars['String']['output']>;
  typeCreditNavigation?: Maybe<TypeCredit>;
};


export type PatrimoinePassifDetenteurPatrimoinePassifArgs = {
  where?: InputMaybe<DetenteurPatrimoinePassifFilterInput>;
};

export type PatrimoinePassifFilterInput = {
  actifLie?: InputMaybe<PatrimoineActifFilterInput>;
  actifLieId?: InputMaybe<LongOperationFilterInput>;
  and?: InputMaybe<Array<PatrimoinePassifFilterInput>>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  autresChampsJson?: InputMaybe<StringOperationFilterInput>;
  capitalRestantDu?: InputMaybe<DecimalOperationFilterInput>;
  commun?: InputMaybe<UuidOperationFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateSouscription?: InputMaybe<LocalDateOperationFilterInput>;
  designation?: InputMaybe<StringOperationFilterInput>;
  detenteurPatrimoinePassif?: InputMaybe<ListFilterInputTypeOfDetenteurPatrimoinePassifFilterInput>;
  detentionCode?: InputMaybe<StringOperationFilterInput>;
  detentionCodeNavigation?: InputMaybe<DetentionFilterInput>;
  duree?: InputMaybe<IntOperationFilterInput>;
  dureeRestante?: InputMaybe<IntOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  mensualiteAdi?: InputMaybe<DecimalOperationFilterInput>;
  montant?: InputMaybe<DecimalOperationFilterInput>;
  natureCode?: InputMaybe<StringOperationFilterInput>;
  natureCodeNavigation?: InputMaybe<NaturePatrimoineFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PatrimoinePassifFilterInput>>;
  quotePartAdi?: InputMaybe<DecimalOperationFilterInput>;
  tauxAdi?: InputMaybe<DecimalOperationFilterInput>;
  tauxDetention?: InputMaybe<DecimalOperationFilterInput>;
  typeCredit?: InputMaybe<StringOperationFilterInput>;
  typeCreditNavigation?: InputMaybe<TypeCreditFilterInput>;
};

export type Pays = {
  __typename?: 'Pays';
  actif?: Maybe<Scalars['Boolean']['output']>;
  adresse: Array<Adresse>;
  code: Scalars['String']['output'];
  creationDate: Scalars['DateTime']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  etatCivil: Array<EtatCivil>;
  inverseNationaliteCodeNavigation: Array<Pays>;
  libelle: Scalars['String']['output'];
  nationalite?: Maybe<Scalars['String']['output']>;
  nationaliteCode: Scalars['String']['output'];
  nationaliteCodeNavigation: Pays;
  personnePhysiqueCodePaysNaissanceNavigation: Array<PersonnePhysique>;
  personnePhysiqueCodePaysNationaliteNavigation: Array<PersonnePhysique>;
  personnePhysiqueCodePaysNationaliteSecondaireNavigation: Array<PersonnePhysique>;
  reglementaireCodePaysFactaResidenceFiscaleNavigation: Array<Reglementaire>;
  reglementaireCodePaysPpeNavigation: Array<Reglementaire>;
};


export type PaysAdresseArgs = {
  where?: InputMaybe<AdresseFilterInput>;
};


export type PaysEtatCivilArgs = {
  where?: InputMaybe<EtatCivilFilterInput>;
};


export type PaysInverseNationaliteCodeNavigationArgs = {
  where?: InputMaybe<PaysFilterInput>;
};


export type PaysPersonnePhysiqueCodePaysNaissanceNavigationArgs = {
  where?: InputMaybe<PersonnePhysiqueFilterInput>;
};


export type PaysPersonnePhysiqueCodePaysNationaliteNavigationArgs = {
  where?: InputMaybe<PersonnePhysiqueFilterInput>;
};


export type PaysPersonnePhysiqueCodePaysNationaliteSecondaireNavigationArgs = {
  where?: InputMaybe<PersonnePhysiqueFilterInput>;
};


export type PaysReglementaireCodePaysFactaResidenceFiscaleNavigationArgs = {
  where?: InputMaybe<ReglementaireFilterInput>;
};


export type PaysReglementaireCodePaysPpeNavigationArgs = {
  where?: InputMaybe<ReglementaireFilterInput>;
};

export type PaysFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  adresse?: InputMaybe<ListFilterInputTypeOfAdresseFilterInput>;
  and?: InputMaybe<Array<PaysFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  etatCivil?: InputMaybe<ListFilterInputTypeOfEtatCivilFilterInput>;
  inverseNationaliteCodeNavigation?: InputMaybe<ListFilterInputTypeOfPaysFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  nationalite?: InputMaybe<StringOperationFilterInput>;
  nationaliteCode?: InputMaybe<StringOperationFilterInput>;
  nationaliteCodeNavigation?: InputMaybe<PaysFilterInput>;
  or?: InputMaybe<Array<PaysFilterInput>>;
  personnePhysiqueCodePaysNaissanceNavigation?: InputMaybe<ListFilterInputTypeOfPersonnePhysiqueFilterInput>;
  personnePhysiqueCodePaysNationaliteNavigation?: InputMaybe<ListFilterInputTypeOfPersonnePhysiqueFilterInput>;
  personnePhysiqueCodePaysNationaliteSecondaireNavigation?: InputMaybe<ListFilterInputTypeOfPersonnePhysiqueFilterInput>;
  reglementaireCodePaysFactaResidenceFiscaleNavigation?: InputMaybe<ListFilterInputTypeOfReglementaireFilterInput>;
  reglementaireCodePaysPpeNavigation?: InputMaybe<ListFilterInputTypeOfReglementaireFilterInput>;
};

export type PaysSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
  nationalite?: InputMaybe<SortEnumType>;
  nationaliteCode?: InputMaybe<SortEnumType>;
  nationaliteCodeNavigation?: InputMaybe<PaysSortInput>;
};

export type PeriodiciteMouvement = {
  __typename?: 'PeriodiciteMouvement';
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  mouvement: Array<Mouvement>;
};


export type PeriodiciteMouvementMouvementArgs = {
  where?: InputMaybe<MouvementFilterInput>;
};

export type PeriodiciteMouvementFilterInput = {
  and?: InputMaybe<Array<PeriodiciteMouvementFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  mouvement?: InputMaybe<ListFilterInputTypeOfMouvementFilterInput>;
  or?: InputMaybe<Array<PeriodiciteMouvementFilterInput>>;
};

export type PeriodiciteMouvementSortInput = {
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export enum Permission {
  Read = 'READ',
  ReadWrite = 'READ_WRITE'
}

export type PersonneMorale = {
  __typename?: 'PersonneMorale';
  codeNafApe?: Maybe<Scalars['String']['output']>;
  contact: Array<Contact>;
  creationDate: Scalars['DateTime']['output'];
  denomination?: Maybe<Scalars['String']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  formeJuridique?: Maybe<FormeJuridique>;
  formeJuridiqueId?: Maybe<Scalars['Byte']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['Long']['output']>;
  investisseur: Investisseur;
  investisseurId: Scalars['Long']['output'];
  personneMoraleAdresse: Array<PersonneMoraleAdresse>;
  personneMoraleTelephone: Array<PersonneMoraleTelephone>;
  siretSiren?: Maybe<Scalars['String']['output']>;
  siteInternet?: Maybe<Scalars['String']['output']>;
};


export type PersonneMoraleContactArgs = {
  where?: InputMaybe<ContactFilterInput>;
};


export type PersonneMoralePersonneMoraleAdresseArgs = {
  where?: InputMaybe<PersonneMoraleAdresseFilterInput>;
};


export type PersonneMoralePersonneMoraleTelephoneArgs = {
  where?: InputMaybe<PersonneMoraleTelephoneFilterInput>;
};

export type PersonneMoraleAdresse = {
  __typename?: 'PersonneMoraleAdresse';
  adresse: Adresse;
  adresseId: Scalars['Long']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  personneMorale: PersonneMorale;
  personneMoraleId: Scalars['Long']['output'];
};

export type PersonneMoraleAdresseFilterInput = {
  adresse?: InputMaybe<AdresseFilterInput>;
  adresseId?: InputMaybe<LongOperationFilterInput>;
  and?: InputMaybe<Array<PersonneMoraleAdresseFilterInput>>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<PersonneMoraleAdresseFilterInput>>;
  personneMorale?: InputMaybe<PersonneMoraleFilterInput>;
  personneMoraleId?: InputMaybe<LongOperationFilterInput>;
};

export type PersonneMoraleFilterInput = {
  and?: InputMaybe<Array<PersonneMoraleFilterInput>>;
  codeNafApe?: InputMaybe<StringOperationFilterInput>;
  contact?: InputMaybe<ListFilterInputTypeOfContactFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  denomination?: InputMaybe<StringOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  formeJuridique?: InputMaybe<FormeJuridiqueFilterInput>;
  formeJuridiqueId?: InputMaybe<ByteOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<LongOperationFilterInput>;
  investisseur?: InputMaybe<InvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<PersonneMoraleFilterInput>>;
  personneMoraleAdresse?: InputMaybe<ListFilterInputTypeOfPersonneMoraleAdresseFilterInput>;
  personneMoraleTelephone?: InputMaybe<ListFilterInputTypeOfPersonneMoraleTelephoneFilterInput>;
  siretSiren?: InputMaybe<StringOperationFilterInput>;
  siteInternet?: InputMaybe<StringOperationFilterInput>;
};

export type PersonneMoraleTelephone = {
  __typename?: 'PersonneMoraleTelephone';
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  personneMorale: PersonneMorale;
  personneMoraleId: Scalars['Long']['output'];
  telephone: Telephone;
  telephoneId: Scalars['Long']['output'];
};

export type PersonneMoraleTelephoneFilterInput = {
  and?: InputMaybe<Array<PersonneMoraleTelephoneFilterInput>>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<PersonneMoraleTelephoneFilterInput>>;
  personneMorale?: InputMaybe<PersonneMoraleFilterInput>;
  personneMoraleId?: InputMaybe<LongOperationFilterInput>;
  telephone?: InputMaybe<TelephoneFilterInput>;
  telephoneId?: InputMaybe<LongOperationFilterInput>;
};

export type PersonnePhysique = {
  __typename?: 'PersonnePhysique';
  adresse: Array<Adresse>;
  arianeId?: Maybe<Scalars['Long']['output']>;
  civiliteCode: Scalars['String']['output'];
  civiliteCodeNavigation: Civilite;
  code?: Maybe<Scalars['String']['output']>;
  codePaysNaissance?: Maybe<Scalars['String']['output']>;
  codePaysNaissanceNavigation?: Maybe<Pays>;
  codePaysNationalite?: Maybe<Scalars['String']['output']>;
  codePaysNationaliteNavigation?: Maybe<Pays>;
  codePaysNationaliteSecondaire?: Maybe<Scalars['String']['output']>;
  codePaysNationaliteSecondaireNavigation?: Maybe<Pays>;
  codePostaleNaissance?: Maybe<Scalars['String']['output']>;
  consultant: Array<Consultant>;
  contact: Array<Contact>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  dateNaissance?: Maybe<Scalars['LocalDate']['output']>;
  departementNaissance?: Maybe<Scalars['String']['output']>;
  departementNaissanceNavigation?: Maybe<Departement>;
  detenteurPatrimoineActif: Array<DetenteurPatrimoineActif>;
  deuxiemePrenom?: Maybe<Scalars['String']['output']>;
  disposition?: Maybe<Disposition>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  email: Array<Email>;
  etatCivil?: Maybe<EtatCivil>;
  fullNameSearchText?: Maybe<Scalars['String']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  investisseur: Array<Investisseur>;
  login?: Maybe<Scalars['String']['output']>;
  mesureProtectionDate?: Maybe<Scalars['LocalDate']['output']>;
  nom: Scalars['String']['output'];
  nomCompletDeuxiemeParent?: Maybe<Scalars['String']['output']>;
  nomCompletPremierParent?: Maybe<Scalars['String']['output']>;
  nomNaissance?: Maybe<Scalars['String']['output']>;
  nomNaissanceUniformise?: Maybe<Scalars['String']['output']>;
  nomUniformise: Scalars['String']['output'];
  personnePhysiqueDocument: Array<PersonnePhysiqueDocument>;
  prenom: Scalars['String']['output'];
  prenomUniformise: Scalars['String']['output'];
  reglementaire?: Maybe<Reglementaire>;
  relationAutrePersonnePhysique: Array<RelationAutreSimple>;
  relationAutrePersonnePhysique1: Array<RelationAutre>;
  relationAutrePersonnePhysique2: Array<RelationAutre>;
  relationAutrePersonnePhysiqueUnaccesible: Array<RelationSimpleUnaccesible>;
  relationCouplePersonnePhysique?: Maybe<RelationCoupleSimple>;
  relationCouplePersonnePhysique1: Array<RelationCouple>;
  relationCouplePersonnePhysique2: Array<RelationCouple>;
  relationCouplePersonnePhysiqueUnaccesible?: Maybe<RelationSimpleUnaccesible>;
  relationFamillePersonnePhysique: Array<RelationFamilleSimple>;
  relationFamillePersonnePhysique1: Array<RelationFamille>;
  relationFamillePersonnePhysique2: Array<RelationFamille>;
  relationFamillePersonnePhysiqueUnaccesible: Array<RelationSimpleUnaccesible>;
  situationProfessionnelle?: Maybe<SituationProfessionnelle>;
  telephone: Array<Telephone>;
  testament?: Maybe<Testament>;
  troisiemePrenom?: Maybe<Scalars['String']['output']>;
  typeMesureProtectionCode?: Maybe<Scalars['String']['output']>;
  typeMesureProtectionCodeNavigation?: Maybe<TypeMesureProtection>;
  villeNaissanceNom?: Maybe<Scalars['String']['output']>;
};


export type PersonnePhysiqueAdresseArgs = {
  where?: InputMaybe<AdresseFilterInput>;
};


export type PersonnePhysiqueConsultantArgs = {
  where?: InputMaybe<ConsultantFilterInput>;
};


export type PersonnePhysiqueContactArgs = {
  where?: InputMaybe<ContactFilterInput>;
};


export type PersonnePhysiqueDetenteurPatrimoineActifArgs = {
  where?: InputMaybe<DetenteurPatrimoineActifFilterInput>;
};


export type PersonnePhysiqueEmailArgs = {
  where?: InputMaybe<EmailFilterInput>;
};


export type PersonnePhysiqueInvestisseurArgs = {
  where?: InputMaybe<InvestisseurFilterInput>;
};


export type PersonnePhysiquePersonnePhysiqueDocumentArgs = {
  where?: InputMaybe<PersonnePhysiqueDocumentFilterInput>;
};


export type PersonnePhysiqueRelationAutrePersonnePhysique1Args = {
  where?: InputMaybe<RelationAutreFilterInput>;
};


export type PersonnePhysiqueRelationAutrePersonnePhysique2Args = {
  where?: InputMaybe<RelationAutreFilterInput>;
};


export type PersonnePhysiqueRelationCouplePersonnePhysique1Args = {
  where?: InputMaybe<RelationCoupleFilterInput>;
};


export type PersonnePhysiqueRelationCouplePersonnePhysique2Args = {
  where?: InputMaybe<RelationCoupleFilterInput>;
};


export type PersonnePhysiqueRelationFamillePersonnePhysique1Args = {
  where?: InputMaybe<RelationFamilleFilterInput>;
};


export type PersonnePhysiqueRelationFamillePersonnePhysique2Args = {
  where?: InputMaybe<RelationFamilleFilterInput>;
};


export type PersonnePhysiqueTelephoneArgs = {
  where?: InputMaybe<TelephoneFilterInput>;
};

export type PersonnePhysiqueDocument = {
  __typename?: 'PersonnePhysiqueDocument';
  codeTypeDocument: Scalars['String']['output'];
  codeTypeDocumentNavigation: GedTypeDocument;
  dateDebutValidite?: Maybe<Scalars['DateTime']['output']>;
  dateFinValidite?: Maybe<Scalars['DateTime']['output']>;
  documentId?: Maybe<Scalars['UUID']['output']>;
  id: Scalars['Long']['output'];
  person: PersonnePhysique;
  personId: Scalars['Long']['output'];
};

export type PersonnePhysiqueDocumentFilterInput = {
  and?: InputMaybe<Array<PersonnePhysiqueDocumentFilterInput>>;
  codeTypeDocument?: InputMaybe<StringOperationFilterInput>;
  codeTypeDocumentNavigation?: InputMaybe<GedTypeDocumentFilterInput>;
  dateDebutValidite?: InputMaybe<DateTimeOperationFilterInput>;
  dateFinValidite?: InputMaybe<DateTimeOperationFilterInput>;
  documentId?: InputMaybe<UuidOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<PersonnePhysiqueDocumentFilterInput>>;
  person?: InputMaybe<PersonnePhysiqueFilterInput>;
  personId?: InputMaybe<LongOperationFilterInput>;
};

export type PersonnePhysiqueFilterInput = {
  adresse?: InputMaybe<ListFilterInputTypeOfAdresseFilterInput>;
  and?: InputMaybe<Array<PersonnePhysiqueFilterInput>>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  civiliteCode?: InputMaybe<StringOperationFilterInput>;
  civiliteCodeNavigation?: InputMaybe<CiviliteFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  codePaysNaissance?: InputMaybe<StringOperationFilterInput>;
  codePaysNaissanceNavigation?: InputMaybe<PaysFilterInput>;
  codePaysNationalite?: InputMaybe<StringOperationFilterInput>;
  codePaysNationaliteNavigation?: InputMaybe<PaysFilterInput>;
  codePaysNationaliteSecondaire?: InputMaybe<StringOperationFilterInput>;
  codePaysNationaliteSecondaireNavigation?: InputMaybe<PaysFilterInput>;
  codePostaleNaissance?: InputMaybe<StringOperationFilterInput>;
  consultant?: InputMaybe<ListFilterInputTypeOfConsultantFilterInput>;
  contact?: InputMaybe<ListFilterInputTypeOfContactFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateNaissance?: InputMaybe<LocalDateOperationFilterInput>;
  departementNaissance?: InputMaybe<StringOperationFilterInput>;
  departementNaissanceNavigation?: InputMaybe<DepartementFilterInput>;
  detenteurPatrimoineActif?: InputMaybe<ListFilterInputTypeOfDetenteurPatrimoineActifFilterInput>;
  deuxiemePrenom?: InputMaybe<StringOperationFilterInput>;
  disposition?: InputMaybe<DispositionFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  email?: InputMaybe<ListFilterInputTypeOfEmailFilterInput>;
  etatCivil?: InputMaybe<EtatCivilFilterInput>;
  fullNameSearchText?: InputMaybe<StringOperationFilterInput>;
  genre?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  investisseur?: InputMaybe<ListFilterInputTypeOfInvestisseurFilterInput>;
  login?: InputMaybe<StringOperationFilterInput>;
  mesureProtectionDate?: InputMaybe<LocalDateOperationFilterInput>;
  nom?: InputMaybe<StringOperationFilterInput>;
  nomCompletDeuxiemeParent?: InputMaybe<StringOperationFilterInput>;
  nomCompletPremierParent?: InputMaybe<StringOperationFilterInput>;
  nomNaissance?: InputMaybe<StringOperationFilterInput>;
  nomNaissanceUniformise?: InputMaybe<StringOperationFilterInput>;
  nomUniformise?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PersonnePhysiqueFilterInput>>;
  personnePhysiqueDocument?: InputMaybe<ListFilterInputTypeOfPersonnePhysiqueDocumentFilterInput>;
  prenom?: InputMaybe<StringOperationFilterInput>;
  prenomUniformise?: InputMaybe<StringOperationFilterInput>;
  reglementaire?: InputMaybe<ReglementaireFilterInput>;
  relationAutrePersonnePhysique1?: InputMaybe<ListFilterInputTypeOfRelationAutreFilterInput>;
  relationAutrePersonnePhysique2?: InputMaybe<ListFilterInputTypeOfRelationAutreFilterInput>;
  relationCouplePersonnePhysique1?: InputMaybe<ListFilterInputTypeOfRelationCoupleFilterInput>;
  relationCouplePersonnePhysique2?: InputMaybe<ListFilterInputTypeOfRelationCoupleFilterInput>;
  relationFamillePersonnePhysique1?: InputMaybe<ListFilterInputTypeOfRelationFamilleFilterInput>;
  relationFamillePersonnePhysique2?: InputMaybe<ListFilterInputTypeOfRelationFamilleFilterInput>;
  situationProfessionnelle?: InputMaybe<SituationProfessionnelleFilterInput>;
  telephone?: InputMaybe<ListFilterInputTypeOfTelephoneFilterInput>;
  testament?: InputMaybe<TestamentFilterInput>;
  troisiemePrenom?: InputMaybe<StringOperationFilterInput>;
  typeMesureProtectionCode?: InputMaybe<StringOperationFilterInput>;
  typeMesureProtectionCodeNavigation?: InputMaybe<TypeMesureProtectionFilterInput>;
  villeNaissanceNom?: InputMaybe<StringOperationFilterInput>;
};

export type PersonnePhysiqueSortInput = {
  arianeId?: InputMaybe<SortEnumType>;
  civiliteCode?: InputMaybe<SortEnumType>;
  civiliteCodeNavigation?: InputMaybe<CiviliteSortInput>;
  code?: InputMaybe<SortEnumType>;
  codePaysNaissance?: InputMaybe<SortEnumType>;
  codePaysNaissanceNavigation?: InputMaybe<PaysSortInput>;
  codePaysNationalite?: InputMaybe<SortEnumType>;
  codePaysNationaliteNavigation?: InputMaybe<PaysSortInput>;
  codePaysNationaliteSecondaire?: InputMaybe<SortEnumType>;
  codePaysNationaliteSecondaireNavigation?: InputMaybe<PaysSortInput>;
  codePostaleNaissance?: InputMaybe<SortEnumType>;
  createurId?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  dateNaissance?: InputMaybe<SortEnumType>;
  departementNaissance?: InputMaybe<SortEnumType>;
  departementNaissanceNavigation?: InputMaybe<DepartementSortInput>;
  deuxiemePrenom?: InputMaybe<SortEnumType>;
  disposition?: InputMaybe<DispositionSortInput>;
  editeurId?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  etatCivil?: InputMaybe<EtatCivilSortInput>;
  fullNameSearchText?: InputMaybe<SortEnumType>;
  genre?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  idSource?: InputMaybe<SortEnumType>;
  login?: InputMaybe<SortEnumType>;
  mesureProtectionDate?: InputMaybe<SortEnumType>;
  nom?: InputMaybe<SortEnumType>;
  nomCompletDeuxiemeParent?: InputMaybe<SortEnumType>;
  nomCompletPremierParent?: InputMaybe<SortEnumType>;
  nomNaissance?: InputMaybe<SortEnumType>;
  nomNaissanceUniformise?: InputMaybe<SortEnumType>;
  nomUniformise?: InputMaybe<SortEnumType>;
  prenom?: InputMaybe<SortEnumType>;
  prenomUniformise?: InputMaybe<SortEnumType>;
  reglementaire?: InputMaybe<ReglementaireSortInput>;
  situationProfessionnelle?: InputMaybe<SituationProfessionnelleSortInput>;
  testament?: InputMaybe<TestamentSortInput>;
  troisiemePrenom?: InputMaybe<SortEnumType>;
  typeMesureProtectionCode?: InputMaybe<SortEnumType>;
  typeMesureProtectionCodeNavigation?: InputMaybe<TypeMesureProtectionSortInput>;
  villeNaissanceNom?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type PersonnePhysiquesPaginatedCollectionSegment = {
  __typename?: 'PersonnePhysiquesPaginatedCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PersonnePhysique>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type PersonneSituationPersonnelleInput = {
  adressses: Array<AdressePersonneInput>;
  civilite?: InputMaybe<Scalars['String']['input']>;
  codePostaleNaissance?: InputMaybe<Scalars['String']['input']>;
  commentaire?: InputMaybe<Scalars['String']['input']>;
  dateNaissance?: InputMaybe<Scalars['DateTime']['input']>;
  departementNaissance?: InputMaybe<Scalars['String']['input']>;
  deuxiemeNationalite?: InputMaybe<Scalars['String']['input']>;
  deuxiemePrenom?: InputMaybe<Scalars['String']['input']>;
  donation: DonationInput;
  emails?: InputMaybe<Array<EmailInput>>;
  etatCivil: EtatCivilInput;
  investisseurId: Scalars['Long']['input'];
  mesureProtection?: InputMaybe<Scalars['String']['input']>;
  mesureProtectionDate?: InputMaybe<Scalars['LocalDate']['input']>;
  nationalite?: InputMaybe<Scalars['String']['input']>;
  nom: Scalars['String']['input'];
  nomNaissance?: InputMaybe<Scalars['String']['input']>;
  origineContact?: InputMaybe<Scalars['String']['input']>;
  origineContactDateRecommandation?: InputMaybe<Scalars['DateTime']['input']>;
  origineContactInvestisseurId?: InputMaybe<Scalars['Long']['input']>;
  origineContactNom?: InputMaybe<Scalars['String']['input']>;
  origineSaisie: Scalars['Byte']['input'];
  paysNaissance?: InputMaybe<Scalars['String']['input']>;
  personnePhysiqueId: Scalars['Long']['input'];
  prenom: Scalars['String']['input'];
  reglementaire: ReglementaireInput;
  shouldIgnoreTelephonesEmailsAndAdresses?: InputMaybe<Scalars['Boolean']['input']>;
  situationProfessionnelle: ProfessionnelleInput;
  telephones?: InputMaybe<Array<TelephonePersonneInput>>;
  testament?: InputMaybe<TestamentInput>;
  troisiemePrenom?: InputMaybe<Scalars['String']['input']>;
  villeNaissance?: InputMaybe<Scalars['String']['input']>;
};

export type PieceJointeConsultant = {
  __typename?: 'PieceJointeConsultant';
  consultantContrat: Array<ConsultantContrat>;
  consultantHabilitationInscription: Array<ConsultantHabilitationInscription>;
  dateDebutValidite: Scalars['DateTime']['output'];
  dateFinValidite: Scalars['DateTime']['output'];
  id: Scalars['Long']['output'];
  lienGed?: Maybe<Scalars['String']['output']>;
  typePieceJointeCode: Scalars['String']['output'];
  typePieceJointeCodeNavigation: TypePieceJointe;
};


export type PieceJointeConsultantConsultantContratArgs = {
  where?: InputMaybe<ConsultantContratFilterInput>;
};


export type PieceJointeConsultantConsultantHabilitationInscriptionArgs = {
  where?: InputMaybe<ConsultantHabilitationInscriptionFilterInput>;
};

export type PieceJointeConsultantFilterInput = {
  and?: InputMaybe<Array<PieceJointeConsultantFilterInput>>;
  consultantContrat?: InputMaybe<ListFilterInputTypeOfConsultantContratFilterInput>;
  consultantHabilitationInscription?: InputMaybe<ListFilterInputTypeOfConsultantHabilitationInscriptionFilterInput>;
  dateDebutValidite?: InputMaybe<DateTimeOperationFilterInput>;
  dateFinValidite?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  lienGed?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PieceJointeConsultantFilterInput>>;
  typePieceJointeCode?: InputMaybe<StringOperationFilterInput>;
  typePieceJointeCodeNavigation?: InputMaybe<TypePieceJointeFilterInput>;
};

export type PieceJustificativeInput = {
  consultantId: Scalars['Long']['input'];
  documentId: Scalars['String']['input'];
  statutJuridiqueId?: InputMaybe<Scalars['Long']['input']>;
};

export type PieceJustificativeRcpInput = {
  consultantId: Scalars['Long']['input'];
  documentId: Scalars['String']['input'];
  organismeAssureurId: Scalars['Long']['input'];
  rcpGarantieMontantParSinistre: Scalars['Decimal']['input'];
  rcpOrganismeAssureurAdresse: Scalars['String']['input'];
  statutJuridiqueId?: InputMaybe<Scalars['Long']['input']>;
  typeRcp: TypeRcpCode;
};

export enum PortefeuilleOption {
  AvecAnnexe = 'AVEC_ANNEXE',
  SansAnnexe = 'SANS_ANNEXE'
}

export type PresettedConsultant = {
  __typename?: 'PresettedConsultant';
  civiliteCode?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  dateNaissance?: Maybe<Scalars['LocalDate']['output']>;
  habilitationCodes?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Long']['output'];
  nom?: Maybe<Scalars['String']['output']>;
  prenom?: Maybe<Scalars['String']['output']>;
  qualificationCode?: Maybe<Scalars['String']['output']>;
  qualificationLibelle?: Maybe<Scalars['String']['output']>;
};

export type PresettedInvestisseur = {
  __typename?: 'PresettedInvestisseur';
  civiliteCode?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  dateNaissance?: Maybe<Scalars['LocalDate']['output']>;
  denomination?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  nom?: Maybe<Scalars['String']['output']>;
  prenom?: Maybe<Scalars['String']['output']>;
  type: InvestisseurType;
};

export type PresettedPartenaire = {
  __typename?: 'PresettedPartenaire';
  activiteRattachementCode?: Maybe<Scalars['Byte']['output']>;
  activiteRattachementLibelle?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  nom: Scalars['String']['output'];
};

export type PresettedProduit = {
  __typename?: 'PresettedProduit';
  enveloppeCode?: Maybe<Scalars['Byte']['output']>;
  enveloppeLibelle?: Maybe<Scalars['String']['output']>;
  etatCode?: Maybe<Scalars['Byte']['output']>;
  etatLibelle?: Maybe<Scalars['String']['output']>;
  habilitationCode?: Maybe<Scalars['String']['output']>;
  habilitationLibelle?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  nom: Scalars['String']['output'];
  nomTechniqueProduitBox?: Maybe<Scalars['String']['output']>;
  partenaireId?: Maybe<Scalars['Long']['output']>;
  partenaireLibelle?: Maybe<Scalars['String']['output']>;
};

export type Produit = {
  __typename?: 'Produit';
  commande: Array<Commande>;
  creationDate: Scalars['DateTime']['output'];
  dateCloture?: Maybe<Scalars['DateTime']['output']>;
  dateInitialisation?: Maybe<Scalars['DateTime']['output']>;
  dateLancementInterne?: Maybe<Scalars['DateTime']['output']>;
  dateOuverture?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  enveloppe?: Maybe<Scalars['Byte']['output']>;
  enveloppeNavigation?: Maybe<EnveloppeProduit>;
  etat?: Maybe<Scalars['Byte']['output']>;
  etatNavigation?: Maybe<EtatProduit>;
  filialeFacturation?: Maybe<Scalars['Byte']['output']>;
  filialeFacturationNavigation?: Maybe<FilialeFacturation>;
  fondEvenementielExtension: FondsEvenementielExtension;
  gestionPossibles?: Maybe<Array<ModeDeGestionConfig>>;
  habilitation?: Maybe<Scalars['Long']['output']>;
  habilitationNavigation?: Maybe<Habilitation>;
  id: Scalars['Long']['output'];
  idPartenaire?: Maybe<Scalars['Long']['output']>;
  idPartenaireNavigation?: Maybe<Partenaire>;
  idSource?: Maybe<Scalars['Long']['output']>;
  nom: Scalars['String']['output'];
  nomTechniqueProduitBox?: Maybe<Scalars['String']['output']>;
  produitExtension: ProduitExtension;
  typeProduit: Scalars['Byte']['output'];
  typeProduitNavigation: TypeProduit;
};

export type ProduitConseil = {
  __typename?: 'ProduitConseil';
  id: Scalars['Long']['output'];
  libelle?: Maybe<Scalars['String']['output']>;
  partenaireId?: Maybe<Scalars['Long']['output']>;
  partenaireNom?: Maybe<Scalars['String']['output']>;
};

export type ProduitConseilFilterInput = {
  and?: InputMaybe<Array<ProduitConseilFilterInput>>;
  id?: InputMaybe<LongOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProduitConseilFilterInput>>;
  partenaireId?: InputMaybe<LongOperationFilterInput>;
  partenaireNom?: InputMaybe<StringOperationFilterInput>;
};

export type ProduitConseilInput = {
  id: Scalars['Long']['input'];
  libelle?: InputMaybe<Scalars['String']['input']>;
  partenaireId?: InputMaybe<Scalars['Long']['input']>;
  partenaireNom?: InputMaybe<Scalars['String']['input']>;
};

export type ProduitConseilSortInput = {
  id?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
  partenaireId?: InputMaybe<SortEnumType>;
  partenaireNom?: InputMaybe<SortEnumType>;
};

export type ProduitExtension = {
  __typename?: 'ProduitExtension';
  id: Scalars['Long']['output'];
};

export type ProduitFilterInput = {
  and?: InputMaybe<Array<ProduitFilterInput>>;
  commande?: InputMaybe<ListFilterInputTypeOfCommandeFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateCloture?: InputMaybe<DateTimeOperationFilterInput>;
  dateInitialisation?: InputMaybe<DateTimeOperationFilterInput>;
  dateLancementInterne?: InputMaybe<DateTimeOperationFilterInput>;
  dateOuverture?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  enveloppe?: InputMaybe<ByteOperationFilterInput>;
  enveloppeNavigation?: InputMaybe<EnveloppeProduitFilterInput>;
  etat?: InputMaybe<ByteOperationFilterInput>;
  etatNavigation?: InputMaybe<EtatProduitFilterInput>;
  filialeFacturation?: InputMaybe<ByteOperationFilterInput>;
  filialeFacturationNavigation?: InputMaybe<FilialeFacturationFilterInput>;
  gestionPossibles?: InputMaybe<ListFilterInputTypeOfModeDeGestionConfigFilterInput>;
  habilitation?: InputMaybe<LongOperationFilterInput>;
  habilitationNavigation?: InputMaybe<HabilitationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idPartenaire?: InputMaybe<LongOperationFilterInput>;
  idPartenaireNavigation?: InputMaybe<PartenaireFilterInput>;
  idSource?: InputMaybe<LongOperationFilterInput>;
  nom?: InputMaybe<StringOperationFilterInput>;
  nomTechniqueProduitBox?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProduitFilterInput>>;
  typeProduit?: InputMaybe<ByteOperationFilterInput>;
  typeProduitNavigation?: InputMaybe<TypeProduitFilterInput>;
};

export type ProduitSortInput = {
  creationDate?: InputMaybe<SortEnumType>;
  dateCloture?: InputMaybe<SortEnumType>;
  dateInitialisation?: InputMaybe<SortEnumType>;
  dateLancementInterne?: InputMaybe<SortEnumType>;
  dateOuverture?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  enveloppe?: InputMaybe<SortEnumType>;
  enveloppeNavigation?: InputMaybe<EnveloppeProduitSortInput>;
  etat?: InputMaybe<SortEnumType>;
  etatNavigation?: InputMaybe<EtatProduitSortInput>;
  filialeFacturation?: InputMaybe<SortEnumType>;
  filialeFacturationNavigation?: InputMaybe<FilialeFacturationSortInput>;
  habilitation?: InputMaybe<SortEnumType>;
  habilitationNavigation?: InputMaybe<HabilitationSortInput>;
  id?: InputMaybe<SortEnumType>;
  idPartenaire?: InputMaybe<SortEnumType>;
  idPartenaireNavigation?: InputMaybe<PartenaireSortInput>;
  idSource?: InputMaybe<SortEnumType>;
  nom?: InputMaybe<SortEnumType>;
  nomTechniqueProduitBox?: InputMaybe<SortEnumType>;
  typeProduit?: InputMaybe<SortEnumType>;
  typeProduitNavigation?: InputMaybe<TypeProduitSortInput>;
};

export type ProduitSpecificConfig = {
  __typename?: 'ProduitSpecificConfig';
  config: AdequationConfig;
  gestionPossibles?: Maybe<Array<ModeDeGestionConfig>>;
  id: Scalars['String']['output'];
  produit?: Maybe<Produit>;
};

export type ProduitSpecificConfigFilterInput = {
  and?: InputMaybe<Array<ProduitSpecificConfigFilterInput>>;
  config?: InputMaybe<AdequationConfigFilterInput>;
  gestionPossibles?: InputMaybe<ListFilterInputTypeOfModeDeGestionConfigFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProduitSpecificConfigFilterInput>>;
  produit?: InputMaybe<ProduitFilterInput>;
};

/** A segment of a collection. */
export type ProduitsPaginatedCollectionSegment = {
  __typename?: 'ProduitsPaginatedCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Produit>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProfessionLiberaleInput = {
  numeroTva: Scalars['String']['input'];
  siret: Scalars['String']['input'];
  villeSiret: Scalars['String']['input'];
};

export type ProfessionnelleInput = {
  categorieSocioProfessionnelleCodeAtlas?: InputMaybe<Scalars['Byte']['input']>;
  commentaire?: InputMaybe<Scalars['String']['input']>;
  dateDebut?: InputMaybe<Scalars['DateTime']['input']>;
  dateDepartRetraite?: InputMaybe<Scalars['DateTime']['input']>;
  nomSociete?: InputMaybe<Scalars['String']['input']>;
  origineRevenus?: InputMaybe<Scalars['String']['input']>;
  profession?: InputMaybe<Scalars['String']['input']>;
  regimeActivite?: InputMaybe<Scalars['Int']['input']>;
  secteurActivite?: InputMaybe<Scalars['Int']['input']>;
  situation?: InputMaybe<Scalars['Int']['input']>;
  statut?: InputMaybe<Scalars['Int']['input']>;
};

export type ProfilEsg = {
  __typename?: 'ProfilESG';
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Byte']['output'];
  libelle: Scalars['String']['output'];
  profilInvestisseur: Array<ProfilInvestisseur>;
};


export type ProfilEsgProfilInvestisseurArgs = {
  where?: InputMaybe<ProfilInvestisseurFilterInput>;
};

export type ProfilEsgFilterInput = {
  and?: InputMaybe<Array<ProfilEsgFilterInput>>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<ByteOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProfilEsgFilterInput>>;
  profilInvestisseur?: InputMaybe<ListFilterInputTypeOfProfilInvestisseurFilterInput>;
};

export type ProfilInvestisseur = {
  __typename?: 'ProfilInvestisseur';
  capacitePerteSupportee?: Maybe<Scalars['Boolean']['output']>;
  connaissanceExperience?: Maybe<ConnaissanceExperience>;
  connaissanceExperienceId?: Maybe<Scalars['Byte']['output']>;
  creationDate: Scalars['DateTime']['output'];
  dateDerniereActualisation?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  investisseur: Investisseur;
  investisseurId: Scalars['Long']['output'];
  profilESG?: Maybe<ProfilEsg>;
  profilESGId?: Maybe<Scalars['Byte']['output']>;
  typeInvestisseur?: Maybe<TypeInvestisseur>;
  typeInvestisseurId?: Maybe<Scalars['Byte']['output']>;
};

export type ProfilInvestisseurFiche = {
  __typename?: 'ProfilInvestisseurFiche';
  hasTolerancePerte?: Maybe<Scalars['Boolean']['output']>;
  profilQpiCode?: Maybe<Scalars['String']['output']>;
  profilQpiLibelle?: Maybe<Scalars['String']['output']>;
};

export type ProfilInvestisseurFicheFilterInput = {
  and?: InputMaybe<Array<ProfilInvestisseurFicheFilterInput>>;
  hasTolerancePerte?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<ProfilInvestisseurFicheFilterInput>>;
  profilQpiCode?: InputMaybe<StringOperationFilterInput>;
  profilQpiLibelle?: InputMaybe<StringOperationFilterInput>;
};

export type ProfilInvestisseurFicheInput = {
  hasTolerancePerte?: InputMaybe<Scalars['Boolean']['input']>;
  profilQpiCode?: InputMaybe<Scalars['String']['input']>;
  profilQpiLibelle?: InputMaybe<Scalars['String']['input']>;
};

export type ProfilInvestisseurFicheSortInput = {
  hasTolerancePerte?: InputMaybe<SortEnumType>;
  profilQpiCode?: InputMaybe<SortEnumType>;
  profilQpiLibelle?: InputMaybe<SortEnumType>;
};

export type ProfilInvestisseurFilterInput = {
  and?: InputMaybe<Array<ProfilInvestisseurFilterInput>>;
  capacitePerteSupportee?: InputMaybe<BooleanOperationFilterInput>;
  connaissanceExperience?: InputMaybe<ConnaissanceExperienceFilterInput>;
  connaissanceExperienceId?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateDerniereActualisation?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  investisseur?: InputMaybe<InvestisseurFilterInput>;
  investisseurId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<ProfilInvestisseurFilterInput>>;
  profilESG?: InputMaybe<ProfilEsgFilterInput>;
  profilESGId?: InputMaybe<ByteOperationFilterInput>;
  typeInvestisseur?: InputMaybe<TypeInvestisseurFilterInput>;
  typeInvestisseurId?: InputMaybe<ByteOperationFilterInput>;
};

export type ProfilInvestisseurInput = {
  arianeInvestisseurId: Scalars['Long']['input'];
  capacitePerteSupportee?: InputMaybe<Scalars['Boolean']['input']>;
  connaissanceExperienceId?: InputMaybe<Scalars['Byte']['input']>;
  creationDate?: InputMaybe<Scalars['DateTime']['input']>;
  dateDerniereActualisation?: InputMaybe<Scalars['DateTime']['input']>;
  editionDate?: InputMaybe<Scalars['DateTime']['input']>;
  profilESGId?: InputMaybe<Scalars['Byte']['input']>;
  typeInvestisseurId?: InputMaybe<Scalars['Byte']['input']>;
};

export type ProfilQpi = {
  __typename?: 'ProfilQpi';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  creationDate: Scalars['DateTime']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  investisseurQpiProfilCalculCodeNavigation: Array<InvestisseurQpi>;
  investisseurQpiProfilDerogationCodeNavigation: Array<InvestisseurQpi>;
  libelle: Scalars['String']['output'];
  libelleAlternatif?: Maybe<Scalars['String']['output']>;
};

export type ProfilQpiFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<ProfilQpiFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  investisseurQpiProfilCalculCodeNavigation?: InputMaybe<ListFilterInputTypeOfInvestisseurQpiFilterInput>;
  investisseurQpiProfilDerogationCodeNavigation?: InputMaybe<ListFilterInputTypeOfInvestisseurQpiFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  libelleAlternatif?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProfilQpiFilterInput>>;
};

export type ProfilQpiSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
  libelleAlternatif?: InputMaybe<SortEnumType>;
};

export enum Provider {
  Fake = 'FAKE',
  Signatureit = 'SIGNATUREIT',
  UniversignU1 = 'UNIVERSIGN_U1'
}

export type ProviderSettingsInput = {
  providerContextId: Scalars['String']['input'];
  providerId: Provider;
};

export type Qcm = {
  __typename?: 'Qcm';
  codeFamille?: Maybe<Scalars['Byte']['output']>;
  consultantId: Scalars['Long']['output'];
  cursus: Scalars['String']['output'];
  dateValidationFormation?: Maybe<Scalars['DateTime']['output']>;
  formationValide?: Maybe<Scalars['Byte']['output']>;
  nomADF: Scalars['String']['output'];
  nomSession: Scalars['String']['output'];
  referenceActionDeFormation: Scalars['String']['output'];
};

export type QcmFilterInput = {
  and?: InputMaybe<Array<QcmFilterInput>>;
  codeFamille?: InputMaybe<ByteOperationFilterInput>;
  consultantId?: InputMaybe<LongOperationFilterInput>;
  cursus?: InputMaybe<StringOperationFilterInput>;
  dateValidationFormation?: InputMaybe<DateTimeOperationFilterInput>;
  formationValide?: InputMaybe<ByteOperationFilterInput>;
  nomADF?: InputMaybe<StringOperationFilterInput>;
  nomSession?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<QcmFilterInput>>;
  referenceActionDeFormation?: InputMaybe<StringOperationFilterInput>;
};

export type QcmSortInput = {
  codeFamille?: InputMaybe<SortEnumType>;
  consultantId?: InputMaybe<SortEnumType>;
  cursus?: InputMaybe<SortEnumType>;
  dateValidationFormation?: InputMaybe<SortEnumType>;
  formationValide?: InputMaybe<SortEnumType>;
  nomADF?: InputMaybe<SortEnumType>;
  nomSession?: InputMaybe<SortEnumType>;
  referenceActionDeFormation?: InputMaybe<SortEnumType>;
};

export type QualificationConsultant = {
  __typename?: 'QualificationConsultant';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  consultant: Array<Consultant>;
  consultantOrganisation: Array<ConsultantOrganisation>;
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};


export type QualificationConsultantConsultantArgs = {
  where?: InputMaybe<ConsultantFilterInput>;
};


export type QualificationConsultantConsultantOrganisationArgs = {
  where?: InputMaybe<ConsultantOrganisationFilterInput>;
};

export type QualificationConsultantFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<QualificationConsultantFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  consultant?: InputMaybe<ListFilterInputTypeOfConsultantFilterInput>;
  consultantOrganisation?: InputMaybe<ListFilterInputTypeOfConsultantOrganisationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<QualificationConsultantFilterInput>>;
};

export type QualificationConsultantSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type Query = {
  __typename?: 'Query';
  activeConseilConfigs: Array<ConseilConfig>;
  allConseilConfigs: Array<ConseilConfig>;
  allocations: Array<Allocation>;
  allocationsByProduit: Array<Allocation>;
  categorieSocioProfessionnelles: Array<CategorieSocioProfessionnelle>;
  cessionHistoInvestisseurPaginated?: Maybe<CessionHistoInvestisseurPaginatedCollectionSegment>;
  checkDoublonInvestisseur?: Maybe<DoublonInvestisseurCheckResult>;
  commandeById?: Maybe<Commande>;
  commandesByIds?: Maybe<Array<Commande>>;
  commandesFinancieresPaginated?: Maybe<CommandesFinancieresPaginatedCollectionSegment>;
  /** Atlas Commande paginated. Max page size is 100. If no order is specified in query, result are sorted by Id. If you provide an order in query, this order should be desterministic because DB request is splitted to avoid cartesian explosion. */
  commandesPaginated?: Maybe<CommandesPaginatedCollectionSegment>;
  conseilConfigPaginated?: Maybe<ConseilConfigPaginatedCollectionSegment>;
  conseilConfigs: Array<ConseilConfig>;
  conseilConfigsById?: Maybe<ConseilConfig>;
  conseilConfigsByIds: Array<ConseilConfig>;
  consultantByCode?: Maybe<Consultant>;
  consultantById?: Maybe<Consultant>;
  consultantFiles: Array<FileMetadata>;
  consultantHabilitationActionsBackOffice: Array<ConsultantHabilitationActionBackOffice>;
  consultantHabilitationStatutChanges: Array<ConsultantHabilitationStatutChange>;
  consultantStatutJuridiqueChanges: Array<ConsultantStatutJuridiqueChange>;
  consultants: Array<Consultant>;
  consultantsByIds: Array<Consultant>;
  consultantsByName: Array<Consultant>;
  /** Atlas search consultants by free text. Search use fulltext index on FullNameSearchText field of PersonnePhysique.Max page size is 100. If no order is specified in query, result are sorted by Id.If you provide an order in query, this order should be desterministic because DB request is splitted to avoid cartesian explosion. */
  consultantsByNamePaginated?: Maybe<ConsultantsByNamePaginatedCollectionSegment>;
  consultantsPaginated?: Maybe<ConsultantsPaginatedCollectionSegment>;
  enveloppeProduitById?: Maybe<EnveloppeProduit>;
  enveloppeProduits: Array<EnveloppeProduit>;
  enveloppeProduitsByIds?: Maybe<Array<EnveloppeProduit>>;
  enveloppeServiceMapping: Array<ServiceByEnveloppeCode>;
  equivalencesFormationsContinues: Array<EquivalenceFormationContinue>;
  ficheById?: Maybe<FicheConseil>;
  fichesByIds: Array<FicheConseil>;
  fichesPaginated?: Maybe<FichesPaginatedCollectionSegment>;
  /** Get files metadata by filters. Access rules are applied. Backoffice and technical users can see all documents. Consultants can only see documents they have created. */
  fileMetadataByFilters: Array<FileMetadata>;
  /** Get files metadata by filters paginated. Access rules are applied. Backoffice and technical users can see all documents. Consultants can only see documents they have created. */
  fileMetadataByFiltersPaginated: PaginatedResultOfFileMetadata;
  fileMetadataById?: Maybe<FileMetadata>;
  /** Get number of files metadata by filters. Access rules are applied. Backoffice and technical users can see all documents. Consultants can only see documents they have created. */
  fileMetadataCountByFilters: Scalars['Int']['output'];
  fileUploadUriById: Scalars['String']['output'];
  fondsEvenementiels: Array<FondsEvenementiel>;
  fondsEvenementielsByProduit: Array<FondsEvenementiel>;
  formationsContinues: Array<FormationContinue>;
  formationsHabilitantes: Array<FormationHabilitante>;
  formeJuridiqueByCode?: Maybe<FormeJuridique>;
  formeJuridiques: Array<FormeJuridique>;
  gedCategories: Array<GedCategorie>;
  gedTypeDocumentByCode?: Maybe<GedTypeDocument>;
  gedTypeDocuments: Array<GedTypeDocument>;
  habilitationById?: Maybe<Habilitation>;
  habilitations: Array<Habilitation>;
  habilitationsByIds: Array<Habilitation>;
  /** Atlas investisseurs Duplicates (same Nom, Prenom and DateNaissance (2 out 3 criteria) ) of the given Investisseur (investisseurId), in respect of access rules, including the given Investisseur. */
  investisseurAndDuplicatesById?: Maybe<Array<Investisseur>>;
  investisseurByArianeId?: Maybe<Investisseur>;
  investisseurByCode?: Maybe<Investisseur>;
  investisseurById?: Maybe<Investisseur>;
  investisseurConsultantPaginated?: Maybe<InvestisseurConsultantPaginatedCollectionSegment>;
  investisseurFiles: Array<FileMetadata>;
  investisseurObjectifsByInvestisseurId: Array<InvestisseurObjectif>;
  investisseurs: Array<Investisseur>;
  investisseursByIds?: Maybe<Array<Investisseur>>;
  investisseursByName: Array<Investisseur>;
  investisseursByNameOrCode: Array<Investisseur>;
  /** Atlas search investisseurs by free text. if searchText contains one word, return all investisseur with first or last name starting with this word.if searchText contains N  words, return all investisseurs with first or last name starting with the N-1 first words and last /repectively first name contains the last word.. Search is case insensitive. Max page size is 100. If no order is specified in query, result are sorted by Id. If you provide an order in query, this order should be desterministic because DB request is splitted to avoid cartesian explosion. */
  investisseursByNamePaginated?: Maybe<InvestisseursByNamePaginatedCollectionSegment>;
  /** Atlas investisseurs paginated. Max page size is 100. If no order is specified in query, result are sorted by Id. If you provide an order in query, this order should be desterministic because DB request is splitted to avoid cartesian explosion. */
  investisseursPaginated?: Maybe<InvestisseursPaginatedCollectionSegment>;
  /** Atlas search investisseurs by free text. if searchText contains one word, return all investisseur with first or last name starting with this word.if searchText contains N  words, return all investisseurs with first or last name starting with the N-1 first words and last /repectively first name contains the last word.. Search is case insensitive. Max page size is 100. If no order is specified in query, result are sorted by Id. If you provide an order in query, this order should be desterministic because DB request is splitted to avoid cartesian explosion. */
  investisseursPersonnesMoralesByNamePaginated?: Maybe<InvestisseursPersonnesMoralesByNamePaginatedCollectionSegment>;
  /** Atlas search investisseurs by free text. if searchText contains one word, return all investisseur with first or last name starting with this word.if searchText contains N  words, return all investisseurs with first or last name starting with the N-1 first words and last /repectively first name contains the last word.. Search is case insensitive. Max page size is 100. If no order is specified in query, result are sorted by Id. If you provide an order in query, this order should be desterministic because DB request is splitted to avoid cartesian explosion. */
  investisseursPersonnesPhysiquesByNamePaginated?: Maybe<InvestisseursPersonnesPhysiquesByNamePaginatedCollectionSegment>;
  isConfigFormulaireUpdatedInReferentiel: Scalars['Boolean']['output'];
  /** Technical operation : get latest habilitation changes computation state */
  latestHabilitationChangesComputationState: Scalars['String']['output'];
  minotaureInvestisseurObjectifs: Array<InvestisseurObjectifRecueil>;
  minotaureObjectifsReferentiel: Array<ObjectifReferentielFiche>;
  minotaureProfilInvestisseur?: Maybe<ProfilInvestisseurFiche>;
  mouvementById?: Maybe<Mouvement>;
  mouvementsPaginated?: Maybe<MouvementsPaginatedCollectionSegment>;
  natureOperationById?: Maybe<NatureOperation>;
  natureOperations: Array<NatureOperation>;
  natureOperationsByIds: Array<NatureOperation>;
  objectifsReferentiel: Array<TypeObjectifInvestisseur>;
  optionsAutomatiques: Array<OptionAutomatique>;
  optionsAutomatiquesByProduit: Array<OptionAutomatique>;
  partenaireById?: Maybe<Partenaire>;
  partenaires: Array<Partenaire>;
  partenairesPaginated?: Maybe<PartenairesPaginatedCollectionSegment>;
  pays: Array<Pays>;
  personnePhysiquesPaginated?: Maybe<PersonnePhysiquesPaginatedCollectionSegment>;
  presettedConsultantById?: Maybe<PresettedConsultant>;
  presettedInvestisseurById?: Maybe<PresettedInvestisseur>;
  presettedInvestisseursByIds: Array<Maybe<PresettedInvestisseur>>;
  presettedPartenaireById?: Maybe<PresettedPartenaire>;
  presettedProduitById?: Maybe<PresettedProduit>;
  produitById?: Maybe<Produit>;
  produits: Array<Produit>;
  produitsByIds?: Maybe<Array<Produit>>;
  produitsPaginated?: Maybe<ProduitsPaginatedCollectionSegment>;
  pruduitById?: Maybe<Produit>;
  qcms: Array<Qcm>;
  referentielConfigsToAddAsConseilConfig: Array<ReferentielConfig>;
  regimeActivites: Array<RegimeActivite>;
  secteurActivites: Array<SecteurActivite>;
  /** Get signature document filter values. Consultants can only see documents they have created. */
  signatureDocumentFilterValues: SignatureDocumentFilterValues;
  storageFile?: Maybe<StorageFile>;
  templateFileByName: StorageFile;
  transfertClients: Array<TransfertClient>;
  typeAvantageMatrimoniaux: Array<TypeAvantageMatrimonial>;
  typePpeMotifs: Array<TypePpeMotif>;
  typePpeRelations: Array<TypePpeRelation>;
  typeRelationAutres: Array<TypeRelationAutre>;
  typeSituationProfessionnelles: Array<TypeSituationProfessionnelle>;
  typeStatutProfessionnels: Array<TypeStatutProfessionnel>;
  userAccessRight: UserAccessRight;
};


export type QueryActiveConseilConfigsArgs = {
  order?: InputMaybe<Array<ConseilConfigSortInput>>;
  where?: InputMaybe<ConseilConfigFilterInput>;
};


export type QueryAllConseilConfigsArgs = {
  order?: InputMaybe<Array<ConseilConfigSortInput>>;
  where?: InputMaybe<ConseilConfigFilterInput>;
};


export type QueryAllocationsArgs = {
  order?: InputMaybe<Array<AllocationSortInput>>;
  where?: InputMaybe<AllocationFilterInput>;
};


export type QueryAllocationsByProduitArgs = {
  order?: InputMaybe<Array<AllocationSortInput>>;
  produitId: Scalars['Long']['input'];
  where?: InputMaybe<AllocationFilterInput>;
};


export type QueryCategorieSocioProfessionnellesArgs = {
  order?: InputMaybe<Array<CategorieSocioProfessionnelleSortInput>>;
  where?: InputMaybe<CategorieSocioProfessionnelleFilterInput>;
};


export type QueryCessionHistoInvestisseurPaginatedArgs = {
  order?: InputMaybe<Array<CessionHistoInvestisseurSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CessionHistoInvestisseurFilterInput>;
};


export type QueryCheckDoublonInvestisseurArgs = {
  consultantId?: InputMaybe<Scalars['Long']['input']>;
  dateNaissance: Scalars['LocalDate']['input'];
  editedInvestisseurId?: InputMaybe<Scalars['Long']['input']>;
  nom: Scalars['String']['input'];
  prenom: Scalars['String']['input'];
};


export type QueryCommandeByIdArgs = {
  id?: InputMaybe<Scalars['Long']['input']>;
};


export type QueryCommandesByIdsArgs = {
  ids: Array<Scalars['Long']['input']>;
};


export type QueryCommandesFinancieresPaginatedArgs = {
  order?: InputMaybe<Array<CommandeSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommandeFilterInput>;
};


export type QueryCommandesPaginatedArgs = {
  order?: InputMaybe<Array<CommandeSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommandeFilterInput>;
};


export type QueryConseilConfigPaginatedArgs = {
  order?: InputMaybe<Array<ConseilConfigSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ConseilConfigFilterInput>;
};


export type QueryConseilConfigsArgs = {
  order?: InputMaybe<Array<ConseilConfigSortInput>>;
  where?: InputMaybe<ConseilConfigFilterInput>;
};


export type QueryConseilConfigsByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryConseilConfigsByIdsArgs = {
  ids: Array<Scalars['String']['input']>;
  order?: InputMaybe<Array<ConseilConfigSortInput>>;
  where?: InputMaybe<ConseilConfigFilterInput>;
};


export type QueryConsultantByCodeArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
};


export type QueryConsultantByIdArgs = {
  id?: InputMaybe<Scalars['Long']['input']>;
};


export type QueryConsultantFilesArgs = {
  consultantId: Scalars['Long']['input'];
  where?: InputMaybe<FileMetadataFilterInput>;
};


export type QueryConsultantHabilitationActionsBackOfficeArgs = {
  where?: InputMaybe<ConsultantHabilitationActionBackOfficeFilterInput>;
};


export type QueryConsultantHabilitationStatutChangesArgs = {
  where?: InputMaybe<ConsultantHabilitationStatutChangeFilterInput>;
};


export type QueryConsultantStatutJuridiqueChangesArgs = {
  where?: InputMaybe<ConsultantStatutJuridiqueChangeFilterInput>;
};


export type QueryConsultantsArgs = {
  order?: InputMaybe<Array<ConsultantSortInput>>;
  where?: InputMaybe<ConsultantFilterInput>;
};


export type QueryConsultantsByIdsArgs = {
  ids: Array<Scalars['Long']['input']>;
};


export type QueryConsultantsByNameArgs = {
  order?: InputMaybe<Array<ConsultantSortInput>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ConsultantFilterInput>;
};


export type QueryConsultantsByNamePaginatedArgs = {
  order?: InputMaybe<Array<ConsultantSortInput>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ConsultantFilterInput>;
};


export type QueryConsultantsPaginatedArgs = {
  order?: InputMaybe<Array<ConsultantSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ConsultantFilterInput>;
};


export type QueryEnveloppeProduitByIdArgs = {
  code: Scalars['Byte']['input'];
};


export type QueryEnveloppeProduitsArgs = {
  where?: InputMaybe<EnveloppeProduitFilterInput>;
};


export type QueryEnveloppeProduitsByIdsArgs = {
  codes: Array<Scalars['Byte']['input']>;
};


export type QueryEnveloppeServiceMappingArgs = {
  where?: InputMaybe<ServiceByEnveloppeCodeFilterInput>;
};


export type QueryEquivalencesFormationsContinuesArgs = {
  consultantCode: Scalars['String']['input'];
  millesime: Scalars['Int']['input'];
  order?: InputMaybe<Array<EquivalenceFormationContinueSortInput>>;
  where?: InputMaybe<EquivalenceFormationContinueFilterInput>;
};


export type QueryFicheByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryFichesByIdsArgs = {
  ids: Array<Scalars['String']['input']>;
  order?: InputMaybe<Array<FicheConseilSortInput>>;
  where?: InputMaybe<FicheConseilFilterInput>;
};


export type QueryFichesPaginatedArgs = {
  order?: InputMaybe<Array<FicheConseilSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FicheConseilFilterInput>;
};


export type QueryFileMetadataByFiltersArgs = {
  documentFilterConfiguration: DocumentFilterConfigurationInput;
};


export type QueryFileMetadataByFiltersPaginatedArgs = {
  documentFilterConfiguration: DocumentFilterConfigurationInput;
};


export type QueryFileMetadataByIdArgs = {
  fileId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFileMetadataCountByFiltersArgs = {
  documentFilterConfiguration: DocumentFilterConfigurationInput;
};


export type QueryFileUploadUriByIdArgs = {
  fileId: Scalars['String']['input'];
};


export type QueryFondsEvenementielsArgs = {
  order?: InputMaybe<Array<FondsEvenementielSortInput>>;
  where?: InputMaybe<FondsEvenementielFilterInput>;
};


export type QueryFondsEvenementielsByProduitArgs = {
  order?: InputMaybe<Array<FondsEvenementielSortInput>>;
  produitId: Scalars['Long']['input'];
  where?: InputMaybe<FondsEvenementielFilterInput>;
};


export type QueryFormationsContinuesArgs = {
  consultantCode: Scalars['String']['input'];
  millesime: Scalars['Int']['input'];
  order?: InputMaybe<Array<FormationContinueSortInput>>;
  where?: InputMaybe<FormationContinueFilterInput>;
};


export type QueryFormationsHabilitantesArgs = {
  consultantCode: Scalars['String']['input'];
  order?: InputMaybe<Array<FormationHabilitanteSortInput>>;
  where?: InputMaybe<FormationHabilitanteFilterInput>;
};


export type QueryFormeJuridiqueByCodeArgs = {
  code: Scalars['Byte']['input'];
};


export type QueryFormeJuridiquesArgs = {
  where?: InputMaybe<FormeJuridiqueFilterInput>;
};


export type QueryGedCategoriesArgs = {
  where?: InputMaybe<GedCategorieFilterInput>;
};


export type QueryGedTypeDocumentByCodeArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGedTypeDocumentsArgs = {
  where?: InputMaybe<GedTypeDocumentFilterInput>;
};


export type QueryHabilitationByIdArgs = {
  id: Scalars['Long']['input'];
};


export type QueryHabilitationsArgs = {
  where?: InputMaybe<HabilitationFilterInput>;
};


export type QueryHabilitationsByIdsArgs = {
  ids: Array<Scalars['Long']['input']>;
};


export type QueryInvestisseurAndDuplicatesByIdArgs = {
  investisseurId: Scalars['Long']['input'];
};


export type QueryInvestisseurByArianeIdArgs = {
  arianeId: Scalars['Long']['input'];
};


export type QueryInvestisseurByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryInvestisseurByIdArgs = {
  id?: InputMaybe<Scalars['Long']['input']>;
};


export type QueryInvestisseurConsultantPaginatedArgs = {
  order?: InputMaybe<Array<InvestisseurConsultantSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<InvestisseurConsultantFilterInput>;
};


export type QueryInvestisseurFilesArgs = {
  investisseurId: Scalars['Long']['input'];
  order?: InputMaybe<Array<FileMetadataSortInput>>;
  where?: InputMaybe<FileMetadataFilterInput>;
};


export type QueryInvestisseurObjectifsByInvestisseurIdArgs = {
  investisseurId: Scalars['Long']['input'];
  order?: InputMaybe<Array<InvestisseurObjectifSortInput>>;
  where?: InputMaybe<InvestisseurObjectifFilterInput>;
};


export type QueryInvestisseursArgs = {
  order?: InputMaybe<Array<InvestisseurSortInput>>;
  where?: InputMaybe<InvestisseurFilterInput>;
};


export type QueryInvestisseursByIdsArgs = {
  ids: Array<Scalars['Long']['input']>;
};


export type QueryInvestisseursByNameArgs = {
  order?: InputMaybe<Array<InvestisseurSortInput>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<InvestisseurFilterInput>;
};


export type QueryInvestisseursByNameOrCodeArgs = {
  order?: InputMaybe<Array<InvestisseurSortInput>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<InvestisseurFilterInput>;
};


export type QueryInvestisseursByNamePaginatedArgs = {
  order?: InputMaybe<Array<InvestisseurSortInput>>;
  searchText: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<InvestisseurFilterInput>;
};


export type QueryInvestisseursPaginatedArgs = {
  order?: InputMaybe<Array<InvestisseurSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<InvestisseurFilterInput>;
};


export type QueryInvestisseursPersonnesMoralesByNamePaginatedArgs = {
  order?: InputMaybe<Array<InvestisseurSortInput>>;
  searchText: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<InvestisseurFilterInput>;
};


export type QueryInvestisseursPersonnesPhysiquesByNamePaginatedArgs = {
  order?: InputMaybe<Array<InvestisseurSortInput>>;
  searchText: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<InvestisseurFilterInput>;
};


export type QueryIsConfigFormulaireUpdatedInReferentielArgs = {
  coaId: Scalars['String']['input'];
};


export type QueryLatestHabilitationChangesComputationStateArgs = {
  id: Scalars['String']['input'];
};


export type QueryMinotaureInvestisseurObjectifsArgs = {
  investisseurId: Scalars['Long']['input'];
};


export type QueryMinotaureProfilInvestisseurArgs = {
  investisseurId: Scalars['Long']['input'];
};


export type QueryMouvementByIdArgs = {
  id?: InputMaybe<Scalars['Long']['input']>;
};


export type QueryMouvementsPaginatedArgs = {
  order?: InputMaybe<Array<MouvementSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MouvementFilterInput>;
};


export type QueryNatureOperationByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryNatureOperationsArgs = {
  where?: InputMaybe<NatureOperationFilterInput>;
};


export type QueryNatureOperationsByIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryObjectifsReferentielArgs = {
  order?: InputMaybe<Array<TypeObjectifInvestisseurSortInput>>;
  where?: InputMaybe<TypeObjectifInvestisseurFilterInput>;
};


export type QueryOptionsAutomatiquesArgs = {
  order?: InputMaybe<Array<OptionAutomatiqueSortInput>>;
  where?: InputMaybe<OptionAutomatiqueFilterInput>;
};


export type QueryOptionsAutomatiquesByProduitArgs = {
  order?: InputMaybe<Array<OptionAutomatiqueSortInput>>;
  produitId: Scalars['Long']['input'];
  where?: InputMaybe<OptionAutomatiqueFilterInput>;
};


export type QueryPartenaireByIdArgs = {
  id?: InputMaybe<Scalars['Long']['input']>;
};


export type QueryPartenairesArgs = {
  order?: InputMaybe<Array<PartenaireSortInput>>;
  where?: InputMaybe<PartenaireFilterInput>;
};


export type QueryPartenairesPaginatedArgs = {
  order?: InputMaybe<Array<PartenaireSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PartenaireFilterInput>;
};


export type QueryPaysArgs = {
  order?: InputMaybe<Array<PaysSortInput>>;
  where?: InputMaybe<PaysFilterInput>;
};


export type QueryPersonnePhysiquesPaginatedArgs = {
  order?: InputMaybe<Array<PersonnePhysiqueSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PersonnePhysiqueFilterInput>;
};


export type QueryPresettedConsultantByIdArgs = {
  id?: InputMaybe<Scalars['Long']['input']>;
};


export type QueryPresettedInvestisseurByIdArgs = {
  id?: InputMaybe<Scalars['Long']['input']>;
};


export type QueryPresettedInvestisseursByIdsArgs = {
  ids: Array<InputMaybe<Scalars['Long']['input']>>;
};


export type QueryPresettedPartenaireByIdArgs = {
  id?: InputMaybe<Scalars['Long']['input']>;
};


export type QueryPresettedProduitByIdArgs = {
  id?: InputMaybe<Scalars['Long']['input']>;
};


export type QueryProduitByIdArgs = {
  id?: InputMaybe<Scalars['Long']['input']>;
};


export type QueryProduitsArgs = {
  order?: InputMaybe<Array<ProduitSortInput>>;
  where?: InputMaybe<ProduitFilterInput>;
};


export type QueryProduitsByIdsArgs = {
  ids: Array<Scalars['Long']['input']>;
};


export type QueryProduitsPaginatedArgs = {
  order?: InputMaybe<Array<ProduitSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProduitFilterInput>;
};


export type QueryPruduitByIdArgs = {
  id: Scalars['Long']['input'];
};


export type QueryQcmsArgs = {
  consultantCode: Scalars['String']['input'];
  order?: InputMaybe<Array<QcmSortInput>>;
  where?: InputMaybe<QcmFilterInput>;
};


export type QueryReferentielConfigsToAddAsConseilConfigArgs = {
  order?: InputMaybe<Array<ReferentielConfigSortInput>>;
  where?: InputMaybe<ReferentielConfigFilterInput>;
};


export type QueryRegimeActivitesArgs = {
  order?: InputMaybe<Array<RegimeActiviteSortInput>>;
  where?: InputMaybe<RegimeActiviteFilterInput>;
};


export type QuerySecteurActivitesArgs = {
  order?: InputMaybe<Array<SecteurActiviteSortInput>>;
  where?: InputMaybe<SecteurActiviteFilterInput>;
};


export type QuerySignatureDocumentFilterValuesArgs = {
  documentFilterConfiguration: DocumentFilterConfigurationInput;
};


export type QueryStorageFileArgs = {
  storageFileId: Scalars['String']['input'];
};


export type QueryTemplateFileByNameArgs = {
  templateName: Scalars['String']['input'];
};


export type QueryTransfertClientsArgs = {
  order?: InputMaybe<Array<TransfertClientSortInput>>;
  where?: InputMaybe<TransfertClientFilterInput>;
};


export type QueryTypeAvantageMatrimoniauxArgs = {
  order?: InputMaybe<Array<TypeAvantageMatrimonialSortInput>>;
  where?: InputMaybe<TypeAvantageMatrimonialFilterInput>;
};


export type QueryTypePpeMotifsArgs = {
  order?: InputMaybe<Array<TypePpeMotifSortInput>>;
  where?: InputMaybe<TypePpeMotifFilterInput>;
};


export type QueryTypePpeRelationsArgs = {
  order?: InputMaybe<Array<TypePpeRelationSortInput>>;
  where?: InputMaybe<TypePpeRelationFilterInput>;
};


export type QueryTypeRelationAutresArgs = {
  order?: InputMaybe<Array<TypeRelationAutreSortInput>>;
  where?: InputMaybe<TypeRelationAutreFilterInput>;
};


export type QueryTypeSituationProfessionnellesArgs = {
  order?: InputMaybe<Array<TypeSituationProfessionnelleSortInput>>;
  where?: InputMaybe<TypeSituationProfessionnelleFilterInput>;
};


export type QueryTypeStatutProfessionnelsArgs = {
  order?: InputMaybe<Array<TypeStatutProfessionnelSortInput>>;
  where?: InputMaybe<TypeStatutProfessionnelFilterInput>;
};

export type ReferentielConfig = {
  __typename?: 'ReferentielConfig';
  applicableConfiguration?: Maybe<ConfigFormulaire>;
  conditionsOfApplicability: ConditionsOfApplicability;
  id: Scalars['String']['output'];
  libelle: Scalars['String']['output'];
};

export type ReferentielConfigFilterInput = {
  and?: InputMaybe<Array<ReferentielConfigFilterInput>>;
  applicableConfiguration?: InputMaybe<ConfigFormulaireFilterInput>;
  conditionsOfApplicability?: InputMaybe<ConditionsOfApplicabilityFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ReferentielConfigFilterInput>>;
};

export type ReferentielConfigSortInput = {
  applicableConfiguration?: InputMaybe<ConfigFormulaireSortInput>;
  conditionsOfApplicability?: InputMaybe<ConditionsOfApplicabilitySortInput>;
  id?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type RegimeActivite = {
  __typename?: 'RegimeActivite';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['Int']['output'];
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  situationProfessionnelles: Array<SituationProfessionnelle>;
};


export type RegimeActiviteSituationProfessionnellesArgs = {
  where?: InputMaybe<SituationProfessionnelleFilterInput>;
};

export type RegimeActiviteFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<RegimeActiviteFilterInput>>;
  code?: InputMaybe<IntOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RegimeActiviteFilterInput>>;
  situationProfessionnelles?: InputMaybe<ListFilterInputTypeOfSituationProfessionnelleFilterInput>;
};

export type RegimeActiviteSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type Reglementaire = {
  __typename?: 'Reglementaire';
  codePaysFactaResidenceFiscale?: Maybe<Scalars['String']['output']>;
  codePaysFactaResidenceFiscaleNavigation?: Maybe<Pays>;
  codePaysPpe?: Maybe<Scalars['String']['output']>;
  codePaysPpeNavigation?: Maybe<Pays>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  factaStatut?: Maybe<Scalars['Boolean']['output']>;
  factaTinCode?: Maybe<Scalars['String']['output']>;
  idSource?: Maybe<Scalars['String']['output']>;
  nifCode?: Maybe<Scalars['String']['output']>;
  personnePhysique: PersonnePhysique;
  personnePhysiqueId: Scalars['Long']['output'];
  ppeAnciennete?: Maybe<Scalars['LocalDate']['output']>;
  ppeStatut?: Maybe<Scalars['Boolean']['output']>;
  typePpeMotifCode?: Maybe<Scalars['String']['output']>;
  typePpeMotifCodeNavigation?: Maybe<TypePpeMotif>;
  typePpeRelationCode?: Maybe<Scalars['String']['output']>;
  typePpeRelationCodeNavigation?: Maybe<TypePpeRelation>;
};

export type ReglementaireFilterInput = {
  and?: InputMaybe<Array<ReglementaireFilterInput>>;
  codePaysFactaResidenceFiscale?: InputMaybe<StringOperationFilterInput>;
  codePaysFactaResidenceFiscaleNavigation?: InputMaybe<PaysFilterInput>;
  codePaysPpe?: InputMaybe<StringOperationFilterInput>;
  codePaysPpeNavigation?: InputMaybe<PaysFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  factaStatut?: InputMaybe<BooleanOperationFilterInput>;
  factaTinCode?: InputMaybe<StringOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  nifCode?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ReglementaireFilterInput>>;
  personnePhysique?: InputMaybe<PersonnePhysiqueFilterInput>;
  personnePhysiqueId?: InputMaybe<LongOperationFilterInput>;
  ppeAnciennete?: InputMaybe<LocalDateOperationFilterInput>;
  ppeStatut?: InputMaybe<BooleanOperationFilterInput>;
  typePpeMotifCode?: InputMaybe<StringOperationFilterInput>;
  typePpeMotifCodeNavigation?: InputMaybe<TypePpeMotifFilterInput>;
  typePpeRelationCode?: InputMaybe<StringOperationFilterInput>;
  typePpeRelationCodeNavigation?: InputMaybe<TypePpeRelationFilterInput>;
};

export type ReglementaireInput = {
  codeNIF?: InputMaybe<Scalars['String']['input']>;
  codePaysResidentFiscal?: InputMaybe<Scalars['String']['input']>;
  codeTIN?: InputMaybe<Scalars['String']['input']>;
  dateDebutExercice?: InputMaybe<Scalars['DateTime']['input']>;
  exposePolitique: Scalars['Boolean']['input'];
  fonction?: InputMaybe<Scalars['String']['input']>;
  paysExercice?: InputMaybe<Scalars['String']['input']>;
  typePpeRelationCode?: InputMaybe<Scalars['String']['input']>;
};

export type ReglementaireSortInput = {
  codePaysFactaResidenceFiscale?: InputMaybe<SortEnumType>;
  codePaysFactaResidenceFiscaleNavigation?: InputMaybe<PaysSortInput>;
  codePaysPpe?: InputMaybe<SortEnumType>;
  codePaysPpeNavigation?: InputMaybe<PaysSortInput>;
  createurId?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editeurId?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  factaStatut?: InputMaybe<SortEnumType>;
  factaTinCode?: InputMaybe<SortEnumType>;
  idSource?: InputMaybe<SortEnumType>;
  nifCode?: InputMaybe<SortEnumType>;
  personnePhysique?: InputMaybe<PersonnePhysiqueSortInput>;
  personnePhysiqueId?: InputMaybe<SortEnumType>;
  ppeAnciennete?: InputMaybe<SortEnumType>;
  ppeStatut?: InputMaybe<SortEnumType>;
  typePpeMotifCode?: InputMaybe<SortEnumType>;
  typePpeMotifCodeNavigation?: InputMaybe<TypePpeMotifSortInput>;
  typePpeRelationCode?: InputMaybe<SortEnumType>;
  typePpeRelationCodeNavigation?: InputMaybe<TypePpeRelationSortInput>;
};

export type RelationAutre = {
  __typename?: 'RelationAutre';
  arianeId?: Maybe<Scalars['Long']['output']>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['Long']['output']>;
  personnePhysique1: PersonnePhysique;
  personnePhysique1Id: Scalars['Long']['output'];
  personnePhysique2: PersonnePhysique;
  personnePhysique2Id: Scalars['Long']['output'];
  typeRelationAutre?: Maybe<Scalars['String']['output']>;
  typeRelationAutreCode: Scalars['String']['output'];
  typeRelationAutreCodeNavigation: TypeRelationAutre;
  typeRelationAutreCodeRev: Scalars['String']['output'];
  typeRelationAutreCodeRevNavigation: TypeRelationAutre;
};

export type RelationAutreFilterInput = {
  and?: InputMaybe<Array<RelationAutreFilterInput>>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<RelationAutreFilterInput>>;
  personnePhysique1?: InputMaybe<PersonnePhysiqueFilterInput>;
  personnePhysique1Id?: InputMaybe<LongOperationFilterInput>;
  personnePhysique2?: InputMaybe<PersonnePhysiqueFilterInput>;
  personnePhysique2Id?: InputMaybe<LongOperationFilterInput>;
  typeRelationAutre?: InputMaybe<StringOperationFilterInput>;
  typeRelationAutreCode?: InputMaybe<StringOperationFilterInput>;
  typeRelationAutreCodeNavigation?: InputMaybe<TypeRelationAutreFilterInput>;
  typeRelationAutreCodeRev?: InputMaybe<StringOperationFilterInput>;
  typeRelationAutreCodeRevNavigation?: InputMaybe<TypeRelationAutreFilterInput>;
};

export type RelationAutreSimple = {
  __typename?: 'RelationAutreSimple';
  arianeId?: Maybe<Scalars['Long']['output']>;
  autrePersonnePhysique?: Maybe<PersonnePhysique>;
  autrePersonnePhysiqueId?: Maybe<Scalars['Long']['output']>;
  /** Indique si l’utilisateur est autorisé à accéder aux données de l’investisseur associé. */
  clientCanAccessData?: Maybe<Scalars['Boolean']['output']>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['Long']['output']>;
  typeRelationAutre?: Maybe<Scalars['String']['output']>;
  typeRelationAutreCode: Scalars['String']['output'];
  typeRelationAutreCodeNavigation: TypeRelationAutre;
};

export type RelationCouple = {
  __typename?: 'RelationCouple';
  arianeId?: Maybe<Scalars['Long']['output']>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  idSource?: Maybe<Scalars['Long']['output']>;
  note?: Maybe<Note>;
  noteId?: Maybe<Scalars['Long']['output']>;
  personnePhysique1: PersonnePhysique;
  personnePhysique1Id: Scalars['Long']['output'];
  personnePhysique2: PersonnePhysique;
  personnePhysique2Id: Scalars['Long']['output'];
  typeRelationCoupleCode: Scalars['String']['output'];
  typeRelationCoupleCodeNavigation: TypeRelationCouple;
};

export type RelationCoupleFilterInput = {
  and?: InputMaybe<Array<RelationCoupleFilterInput>>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  idSource?: InputMaybe<LongOperationFilterInput>;
  note?: InputMaybe<NoteFilterInput>;
  noteId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<RelationCoupleFilterInput>>;
  personnePhysique1?: InputMaybe<PersonnePhysiqueFilterInput>;
  personnePhysique1Id?: InputMaybe<LongOperationFilterInput>;
  personnePhysique2?: InputMaybe<PersonnePhysiqueFilterInput>;
  personnePhysique2Id?: InputMaybe<LongOperationFilterInput>;
  typeRelationCoupleCode?: InputMaybe<StringOperationFilterInput>;
  typeRelationCoupleCodeNavigation?: InputMaybe<TypeRelationCoupleFilterInput>;
};

export type RelationCoupleInput = {
  arianeId?: InputMaybe<Scalars['Long']['input']>;
  personnePhysique1Id: Scalars['Long']['input'];
  personnePhysique2Id: Scalars['Long']['input'];
  typeRelationCoupleCode: Scalars['String']['input'];
};

export type RelationCoupleSimple = {
  __typename?: 'RelationCoupleSimple';
  arianeId?: Maybe<Scalars['Long']['output']>;
  autrePersonnePhysique?: Maybe<PersonnePhysique>;
  autrePersonnePhysiqueId?: Maybe<Scalars['Long']['output']>;
  /** Indique si l’utilisateur est autorisé à accéder aux données de l’investisseur associé. */
  clientCanAccessData?: Maybe<Scalars['Boolean']['output']>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  idSource?: Maybe<Scalars['Long']['output']>;
  note?: Maybe<Note>;
  noteId?: Maybe<Scalars['Long']['output']>;
  typeRelationCoupleCode: Scalars['String']['output'];
  typeRelationCoupleCodeNavigation: TypeRelationCouple;
};

export type RelationFamille = {
  __typename?: 'RelationFamille';
  arianeId?: Maybe<Scalars['Long']['output']>;
  autoriteParentale: Scalars['Boolean']['output'];
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  dateFinChargeFiscale?: Maybe<Scalars['LocalDate']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  enfantACharge?: Maybe<Scalars['Boolean']['output']>;
  enfantAdopte?: Maybe<Scalars['Boolean']['output']>;
  estTypeRelation: Scalars['Boolean']['output'];
  gardeAlternee?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['Long']['output']>;
  niveauEtudeCode?: Maybe<Scalars['String']['output']>;
  niveauEtudeCodeNavigation?: Maybe<NiveauEtude>;
  note?: Maybe<Note>;
  noteId?: Maybe<Scalars['Long']['output']>;
  personnePhysique1: PersonnePhysique;
  personnePhysique1Id: Scalars['Long']['output'];
  personnePhysique2: PersonnePhysique;
  personnePhysique2Id: Scalars['Long']['output'];
  typeAdoptionCode?: Maybe<Scalars['String']['output']>;
  typeAdoptionCodeNavigation?: Maybe<TypeAdoption>;
  typeRelationFamilleCode: Scalars['String']['output'];
  typeRelationFamilleCodeNavigation: TypeRelationFamille;
  typeRelationFamilleCodeRev: Scalars['String']['output'];
  typeRelationFamilleCodeRevNavigation: TypeRelationFamille;
};

export type RelationFamilleFilterInput = {
  and?: InputMaybe<Array<RelationFamilleFilterInput>>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  autoriteParentale?: InputMaybe<BooleanOperationFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateFinChargeFiscale?: InputMaybe<LocalDateOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  enfantACharge?: InputMaybe<BooleanOperationFilterInput>;
  enfantAdopte?: InputMaybe<BooleanOperationFilterInput>;
  estTypeRelation?: InputMaybe<BooleanOperationFilterInput>;
  gardeAlternee?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<LongOperationFilterInput>;
  niveauEtudeCode?: InputMaybe<StringOperationFilterInput>;
  niveauEtudeCodeNavigation?: InputMaybe<NiveauEtudeFilterInput>;
  note?: InputMaybe<NoteFilterInput>;
  noteId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<RelationFamilleFilterInput>>;
  personnePhysique1?: InputMaybe<PersonnePhysiqueFilterInput>;
  personnePhysique1Id?: InputMaybe<LongOperationFilterInput>;
  personnePhysique2?: InputMaybe<PersonnePhysiqueFilterInput>;
  personnePhysique2Id?: InputMaybe<LongOperationFilterInput>;
  typeAdoptionCode?: InputMaybe<StringOperationFilterInput>;
  typeAdoptionCodeNavigation?: InputMaybe<TypeAdoptionFilterInput>;
  typeRelationFamilleCode?: InputMaybe<StringOperationFilterInput>;
  typeRelationFamilleCodeNavigation?: InputMaybe<TypeRelationFamilleFilterInput>;
  typeRelationFamilleCodeRev?: InputMaybe<StringOperationFilterInput>;
  typeRelationFamilleCodeRevNavigation?: InputMaybe<TypeRelationFamilleFilterInput>;
};

export type RelationFamilleSimple = {
  __typename?: 'RelationFamilleSimple';
  arianeId?: Maybe<Scalars['Long']['output']>;
  autoriteParentale?: Maybe<Scalars['Boolean']['output']>;
  autrePersonnePhysique?: Maybe<PersonnePhysique>;
  autrePersonnePhysiqueId?: Maybe<Scalars['Long']['output']>;
  /** Indique si l’utilisateur est autorisé à accéder aux données de l’investisseur associé. */
  clientCanAccessData?: Maybe<Scalars['Boolean']['output']>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  dateFinChargeFiscale?: Maybe<Scalars['LocalDate']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  enfantACharge?: Maybe<Scalars['Boolean']['output']>;
  enfantAdopte?: Maybe<Scalars['Boolean']['output']>;
  estTypeRelation?: Maybe<Scalars['Boolean']['output']>;
  gardeAlternee?: Maybe<Scalars['Boolean']['output']>;
  idSource?: Maybe<Scalars['Long']['output']>;
  niveauEtudeCode?: Maybe<Scalars['String']['output']>;
  niveauEtudeCodeNavigation?: Maybe<NiveauEtude>;
  note?: Maybe<Note>;
  noteId?: Maybe<Scalars['Long']['output']>;
  typeAdoptionCode?: Maybe<Scalars['String']['output']>;
  typeAdoptionCodeNavigation?: Maybe<TypeAdoption>;
  typeRelationFamilleCode: Scalars['String']['output'];
  typeRelationFamilleCodeNavigation: TypeRelationFamille;
};

export type RelationSimpleUnaccesible = {
  __typename?: 'RelationSimpleUnaccesible';
  nom?: Maybe<Scalars['String']['output']>;
  prenom?: Maybe<Scalars['String']['output']>;
  typeRelationCode: Scalars['String']['output'];
  typeRelationLibelle: Scalars['String']['output'];
};

export type ReponseReadhesion = {
  __typename?: 'ReponseReadhesion';
  adhesionConsultant: Array<AdhesionConsultant>;
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};


export type ReponseReadhesionAdhesionConsultantArgs = {
  where?: InputMaybe<AdhesionConsultantFilterInput>;
};

export type ReponseReadhesionFilterInput = {
  adhesionConsultant?: InputMaybe<ListFilterInputTypeOfAdhesionConsultantFilterInput>;
  and?: InputMaybe<Array<ReponseReadhesionFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ReponseReadhesionFilterInput>>;
};

export type ResiliationPaiementB2S = {
  __typename?: 'ResiliationPaiementB2S';
  creationDate: Scalars['DateTime']['output'];
  dateProchainPaiement?: Maybe<Scalars['DateTime']['output']>;
  editionDate: Scalars['DateTime']['output'];
  etat: Scalars['String']['output'];
  etatNavigation: EtatResiliationB2S;
  id: Scalars['Long']['output'];
  idConsultant: Scalars['Long']['output'];
  idConsultantNavigation: Consultant;
  messageRetour?: Maybe<Scalars['String']['output']>;
};

export type ResiliationPaiementB2SFilterInput = {
  and?: InputMaybe<Array<ResiliationPaiementB2SFilterInput>>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateProchainPaiement?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  etat?: InputMaybe<StringOperationFilterInput>;
  etatNavigation?: InputMaybe<EtatResiliationB2SFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idConsultant?: InputMaybe<LongOperationFilterInput>;
  idConsultantNavigation?: InputMaybe<ConsultantFilterInput>;
  messageRetour?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ResiliationPaiementB2SFilterInput>>;
};

export type SeanceSession = {
  __typename?: 'SeanceSession';
  codeEtat?: Maybe<Scalars['Byte']['output']>;
  codeEtatNavigation?: Maybe<SeanceSessionEtat>;
  creationDate: Scalars['DateTime']['output'];
  dateDebut?: Maybe<Scalars['DateTime']['output']>;
  dateFin?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['Long']['output']>;
  nombreHeures?: Maybe<Scalars['Decimal']['output']>;
  session?: Maybe<Session>;
  sessionId?: Maybe<Scalars['Long']['output']>;
};

export type SeanceSessionEtat = {
  __typename?: 'SeanceSessionEtat';
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  seanceSession: Array<SeanceSession>;
};


export type SeanceSessionEtatSeanceSessionArgs = {
  where?: InputMaybe<SeanceSessionFilterInput>;
};

export type SeanceSessionEtatFilterInput = {
  and?: InputMaybe<Array<SeanceSessionEtatFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SeanceSessionEtatFilterInput>>;
  seanceSession?: InputMaybe<ListFilterInputTypeOfSeanceSessionFilterInput>;
};

export type SeanceSessionFilterInput = {
  and?: InputMaybe<Array<SeanceSessionFilterInput>>;
  codeEtat?: InputMaybe<ByteOperationFilterInput>;
  codeEtatNavigation?: InputMaybe<SeanceSessionEtatFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateDebut?: InputMaybe<DateTimeOperationFilterInput>;
  dateFin?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<LongOperationFilterInput>;
  nombreHeures?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<SeanceSessionFilterInput>>;
  session?: InputMaybe<SessionFilterInput>;
  sessionId?: InputMaybe<LongOperationFilterInput>;
};

export type SecteurActivite = {
  __typename?: 'SecteurActivite';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['Int']['output'];
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  situationProfessionnelles: Array<SituationProfessionnelle>;
};


export type SecteurActiviteSituationProfessionnellesArgs = {
  where?: InputMaybe<SituationProfessionnelleFilterInput>;
};

export type SecteurActiviteFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<SecteurActiviteFilterInput>>;
  code?: InputMaybe<IntOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SecteurActiviteFilterInput>>;
  situationProfessionnelles?: InputMaybe<ListFilterInputTypeOfSituationProfessionnelleFilterInput>;
};

export type SecteurActiviteSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type ServiceByEnveloppeCode = {
  __typename?: 'ServiceByEnveloppeCode';
  enveloppeCode: Scalars['Byte']['output'];
  service: BackOfficeService;
};

export type ServiceByEnveloppeCodeFilterInput = {
  and?: InputMaybe<Array<ServiceByEnveloppeCodeFilterInput>>;
  enveloppeCode?: InputMaybe<ByteOperationFilterInput>;
  or?: InputMaybe<Array<ServiceByEnveloppeCodeFilterInput>>;
  service?: InputMaybe<BackOfficeServiceOperationFilterInput>;
};

export type Session = {
  __typename?: 'Session';
  actionDeFormationSession: Array<ActionDeFormationSession>;
  codeEtat?: Maybe<Scalars['Byte']['output']>;
  codeEtatNavigation?: Maybe<SessionEtat>;
  codeGenre?: Maybe<Scalars['Byte']['output']>;
  codeGenreNavigation?: Maybe<SessionGenre>;
  creationDate: Scalars['DateTime']['output'];
  dateDebut?: Maybe<Scalars['DateTime']['output']>;
  dateFin?: Maybe<Scalars['DateTime']['output']>;
  dureeHeure?: Maybe<Scalars['Decimal']['output']>;
  dureeJour?: Maybe<Scalars['Decimal']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['Long']['output']>;
  inscriptionSession: Array<InscriptionSession>;
  nom: Scalars['String']['output'];
  seanceSession: Array<SeanceSession>;
};


export type SessionActionDeFormationSessionArgs = {
  where?: InputMaybe<ActionDeFormationSessionFilterInput>;
};


export type SessionInscriptionSessionArgs = {
  where?: InputMaybe<InscriptionSessionFilterInput>;
};


export type SessionSeanceSessionArgs = {
  where?: InputMaybe<SeanceSessionFilterInput>;
};

export type SessionEtat = {
  __typename?: 'SessionEtat';
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  cycleCourt: Array<CycleCourt>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  session: Array<Session>;
};


export type SessionEtatCycleCourtArgs = {
  where?: InputMaybe<CycleCourtFilterInput>;
};


export type SessionEtatSessionArgs = {
  where?: InputMaybe<SessionFilterInput>;
};

export type SessionEtatFilterInput = {
  and?: InputMaybe<Array<SessionEtatFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  cycleCourt?: InputMaybe<ListFilterInputTypeOfCycleCourtFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SessionEtatFilterInput>>;
  session?: InputMaybe<ListFilterInputTypeOfSessionFilterInput>;
};

export type SessionFilterInput = {
  actionDeFormationSession?: InputMaybe<ListFilterInputTypeOfActionDeFormationSessionFilterInput>;
  and?: InputMaybe<Array<SessionFilterInput>>;
  codeEtat?: InputMaybe<ByteOperationFilterInput>;
  codeEtatNavigation?: InputMaybe<SessionEtatFilterInput>;
  codeGenre?: InputMaybe<ByteOperationFilterInput>;
  codeGenreNavigation?: InputMaybe<SessionGenreFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateDebut?: InputMaybe<DateTimeOperationFilterInput>;
  dateFin?: InputMaybe<DateTimeOperationFilterInput>;
  dureeHeure?: InputMaybe<DecimalOperationFilterInput>;
  dureeJour?: InputMaybe<DecimalOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<LongOperationFilterInput>;
  inscriptionSession?: InputMaybe<ListFilterInputTypeOfInscriptionSessionFilterInput>;
  nom?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SessionFilterInput>>;
  seanceSession?: InputMaybe<ListFilterInputTypeOfSeanceSessionFilterInput>;
};

export type SessionGenre = {
  __typename?: 'SessionGenre';
  code: Scalars['Byte']['output'];
  codeSource: Scalars['String']['output'];
  creationDate: Scalars['DateTime']['output'];
  cycleCourt: Array<CycleCourt>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  session: Array<Session>;
};


export type SessionGenreCycleCourtArgs = {
  where?: InputMaybe<CycleCourtFilterInput>;
};


export type SessionGenreSessionArgs = {
  where?: InputMaybe<SessionFilterInput>;
};

export type SessionGenreFilterInput = {
  and?: InputMaybe<Array<SessionGenreFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  codeSource?: InputMaybe<StringOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  cycleCourt?: InputMaybe<ListFilterInputTypeOfCycleCourtFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SessionGenreFilterInput>>;
  session?: InputMaybe<ListFilterInputTypeOfSessionFilterInput>;
};

export type SignataireInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  internalId?: InputMaybe<Scalars['Int']['input']>;
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  type: SignataireType;
};

export enum SignataireType {
  Consultant = 'CONSULTANT',
  Investisseur = 'INVESTISSEUR',
  None = 'NONE'
}

export type SignatureDocumentFilterValues = {
  __typename?: 'SignatureDocumentFilterValues';
  etatSignatures: Array<SignatureState>;
  typeDocumentCodes: Array<Scalars['String']['output']>;
};


export type SignatureDocumentFilterValuesEtatSignaturesArgs = {
  where?: InputMaybe<SignatureStateOperationFilterInput>;
};


export type SignatureDocumentFilterValuesTypeDocumentCodesArgs = {
  where?: InputMaybe<StringOperationFilterInput>;
};

export enum SignatureState {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Ready = 'READY',
  ValeurNonSupportee = 'VALEUR_NON_SUPPORTEE'
}

export type SignatureStateOperationFilterInput = {
  eq?: InputMaybe<SignatureState>;
  in?: InputMaybe<Array<SignatureState>>;
  neq?: InputMaybe<SignatureState>;
  nin?: InputMaybe<Array<SignatureState>>;
};

export enum SignerStateStatusEnum {
  Failure = 'FAILURE',
  NotFound = 'NOT_FOUND',
  Processing = 'PROCESSING',
  Success = 'SUCCESS'
}

export type SignerStates = {
  __typename?: 'SignerStates';
  actionDate: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  internalId?: Maybe<Scalars['Int']['output']>;
  lastName: Scalars['String']['output'];
  signatureState: SignerStatus;
  type?: Maybe<SignataireType>;
};

export type SignerStatesResponse = {
  __typename?: 'SignerStatesResponse';
  documentIds: Array<Scalars['String']['output']>;
  requestStatus: SignerStateStatusEnum;
  states?: Maybe<Array<SignerStates>>;
};

export enum SignerStatus {
  Accessed = 'ACCESSED',
  Canceled = 'CANCELED',
  CodeSent = 'CODE_SENT',
  Failed = 'FAILED',
  PendingIdDocs = 'PENDING_ID_DOCS',
  PendingValidation = 'PENDING_VALIDATION',
  Ready = 'READY',
  Signed = 'SIGNED',
  Unknown = 'UNKNOWN',
  Waiting = 'WAITING'
}

export type SituationPersonnelle = {
  __typename?: 'SituationPersonnelle';
  categorieSocioProfessionnelleCode?: Maybe<Scalars['String']['output']>;
  dateMiseAJourAtlas?: Maybe<Scalars['DateTime']['output']>;
  enfantACharge?: Maybe<Scalars['Int']['output']>;
  etatCivilDisplay?: Maybe<Scalars['String']['output']>;
  etatCivilTypeCode?: Maybe<Scalars['String']['output']>;
  etatCivilTypeLibelle?: Maybe<Scalars['String']['output']>;
  etatCivilTypeRegimeCode?: Maybe<Scalars['String']['output']>;
  etatCivilTypeRegimeLibelle?: Maybe<Scalars['String']['output']>;
  profession?: Maybe<Scalars['String']['output']>;
};

export type SituationPersonnelleFilterInput = {
  and?: InputMaybe<Array<SituationPersonnelleFilterInput>>;
  categorieSocioProfessionnelleCode?: InputMaybe<StringOperationFilterInput>;
  dateMiseAJourAtlas?: InputMaybe<DateTimeOperationFilterInput>;
  enfantACharge?: InputMaybe<IntOperationFilterInput>;
  etatCivilDisplay?: InputMaybe<StringOperationFilterInput>;
  etatCivilTypeCode?: InputMaybe<StringOperationFilterInput>;
  etatCivilTypeLibelle?: InputMaybe<StringOperationFilterInput>;
  etatCivilTypeRegimeCode?: InputMaybe<StringOperationFilterInput>;
  etatCivilTypeRegimeLibelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SituationPersonnelleFilterInput>>;
  profession?: InputMaybe<StringOperationFilterInput>;
};

export type SituationPersonnelleInput = {
  categorieSocioProfessionnelleCode?: InputMaybe<Scalars['String']['input']>;
  dateMiseAJourAtlas?: InputMaybe<Scalars['DateTime']['input']>;
  enfantACharge?: InputMaybe<Scalars['Int']['input']>;
  etatCivilDisplay?: InputMaybe<Scalars['String']['input']>;
  etatCivilTypeCode?: InputMaybe<Scalars['String']['input']>;
  etatCivilTypeLibelle?: InputMaybe<Scalars['String']['input']>;
  etatCivilTypeRegimeCode?: InputMaybe<Scalars['String']['input']>;
  etatCivilTypeRegimeLibelle?: InputMaybe<Scalars['String']['input']>;
  profession?: InputMaybe<Scalars['String']['input']>;
};

export type SituationPersonnelleSortInput = {
  categorieSocioProfessionnelleCode?: InputMaybe<SortEnumType>;
  dateMiseAJourAtlas?: InputMaybe<SortEnumType>;
  enfantACharge?: InputMaybe<SortEnumType>;
  etatCivilDisplay?: InputMaybe<SortEnumType>;
  etatCivilTypeCode?: InputMaybe<SortEnumType>;
  etatCivilTypeLibelle?: InputMaybe<SortEnumType>;
  etatCivilTypeRegimeCode?: InputMaybe<SortEnumType>;
  etatCivilTypeRegimeLibelle?: InputMaybe<SortEnumType>;
  profession?: InputMaybe<SortEnumType>;
};

export type SituationProfessionnelle = {
  __typename?: 'SituationProfessionnelle';
  anciennete?: Maybe<Scalars['LocalDate']['output']>;
  categorieSocioProfessionnelleCode?: Maybe<Scalars['String']['output']>;
  categorieSocioProfessionnelleCodeAtlas?: Maybe<Scalars['Byte']['output']>;
  categorieSocioProfessionnelleCodeAtlasNavigation?: Maybe<CategorieSocioProfessionnelle>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  dateDepartRetraite?: Maybe<Scalars['LocalDate']['output']>;
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  idSource?: Maybe<Scalars['String']['output']>;
  nomSociete?: Maybe<Scalars['String']['output']>;
  note: Array<Note>;
  origineRevenus?: Maybe<Scalars['String']['output']>;
  personnePhysique: PersonnePhysique;
  personnePhysiqueId: Scalars['Long']['output'];
  profession?: Maybe<Scalars['String']['output']>;
  regimeActiviteCode?: Maybe<Scalars['Int']['output']>;
  regimeActiviteCodeNavigation?: Maybe<RegimeActivite>;
  secteurActiviteCode?: Maybe<Scalars['Int']['output']>;
  secteurActiviteCodeNavigation?: Maybe<SecteurActivite>;
  typeSituationProfessionnelleCode?: Maybe<Scalars['Int']['output']>;
  typeSituationProfessionnelleCodeNavigation?: Maybe<TypeSituationProfessionnelle>;
  typeStatutProfessionnelCode?: Maybe<Scalars['Int']['output']>;
  typeStatutProfessionnelCodeNavigation?: Maybe<TypeStatutProfessionnel>;
};


export type SituationProfessionnelleNoteArgs = {
  where?: InputMaybe<NoteFilterInput>;
};

export type SituationProfessionnelleFilterInput = {
  anciennete?: InputMaybe<LocalDateOperationFilterInput>;
  and?: InputMaybe<Array<SituationProfessionnelleFilterInput>>;
  categorieSocioProfessionnelleCode?: InputMaybe<StringOperationFilterInput>;
  categorieSocioProfessionnelleCodeAtlas?: InputMaybe<ByteOperationFilterInput>;
  categorieSocioProfessionnelleCodeAtlasNavigation?: InputMaybe<CategorieSocioProfessionnelleFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateDepartRetraite?: InputMaybe<LocalDateOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  nomSociete?: InputMaybe<StringOperationFilterInput>;
  note?: InputMaybe<ListFilterInputTypeOfNoteFilterInput>;
  or?: InputMaybe<Array<SituationProfessionnelleFilterInput>>;
  origineRevenus?: InputMaybe<StringOperationFilterInput>;
  personnePhysique?: InputMaybe<PersonnePhysiqueFilterInput>;
  personnePhysiqueId?: InputMaybe<LongOperationFilterInput>;
  profession?: InputMaybe<StringOperationFilterInput>;
  regimeActiviteCode?: InputMaybe<IntOperationFilterInput>;
  regimeActiviteCodeNavigation?: InputMaybe<RegimeActiviteFilterInput>;
  secteurActiviteCode?: InputMaybe<IntOperationFilterInput>;
  secteurActiviteCodeNavigation?: InputMaybe<SecteurActiviteFilterInput>;
  typeSituationProfessionnelleCode?: InputMaybe<IntOperationFilterInput>;
  typeSituationProfessionnelleCodeNavigation?: InputMaybe<TypeSituationProfessionnelleFilterInput>;
  typeStatutProfessionnelCode?: InputMaybe<IntOperationFilterInput>;
  typeStatutProfessionnelCodeNavigation?: InputMaybe<TypeStatutProfessionnelFilterInput>;
};

export type SituationProfessionnelleSortInput = {
  anciennete?: InputMaybe<SortEnumType>;
  categorieSocioProfessionnelleCode?: InputMaybe<SortEnumType>;
  categorieSocioProfessionnelleCodeAtlas?: InputMaybe<SortEnumType>;
  categorieSocioProfessionnelleCodeAtlasNavigation?: InputMaybe<CategorieSocioProfessionnelleSortInput>;
  createurId?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  dateDepartRetraite?: InputMaybe<SortEnumType>;
  editeurId?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  idSource?: InputMaybe<SortEnumType>;
  nomSociete?: InputMaybe<SortEnumType>;
  origineRevenus?: InputMaybe<SortEnumType>;
  personnePhysique?: InputMaybe<PersonnePhysiqueSortInput>;
  personnePhysiqueId?: InputMaybe<SortEnumType>;
  profession?: InputMaybe<SortEnumType>;
  regimeActiviteCode?: InputMaybe<SortEnumType>;
  regimeActiviteCodeNavigation?: InputMaybe<RegimeActiviteSortInput>;
  secteurActiviteCode?: InputMaybe<SortEnumType>;
  secteurActiviteCodeNavigation?: InputMaybe<SecteurActiviteSortInput>;
  typeSituationProfessionnelleCode?: InputMaybe<SortEnumType>;
  typeSituationProfessionnelleCodeNavigation?: InputMaybe<TypeSituationProfessionnelleSortInput>;
  typeStatutProfessionnelCode?: InputMaybe<SortEnumType>;
  typeStatutProfessionnelCodeNavigation?: InputMaybe<TypeStatutProfessionnelSortInput>;
};

export type SocieteInput = {
  adresse: AdresseInput;
  numeroImmatriculationRCS: Scalars['String']['input'];
  numeroTva: Scalars['String']['input'];
  raisonSociale: Scalars['String']['input'];
  siret: Scalars['String']['input'];
  typeStatutJuridique: Scalars['String']['input'];
  villeSiret: Scalars['String']['input'];
};

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StatutCommercial = {
  __typename?: 'StatutCommercial';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  consultantStatutCommercial: Array<ConsultantStatutCommercial>;
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};


export type StatutCommercialConsultantStatutCommercialArgs = {
  where?: InputMaybe<ConsultantStatutCommercialFilterInput>;
};

export type StatutCommercialFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<StatutCommercialFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  consultantStatutCommercial?: InputMaybe<ListFilterInputTypeOfConsultantStatutCommercialFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<StatutCommercialFilterInput>>;
};

export type StatutConsultant = {
  __typename?: 'StatutConsultant';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  consultant: Array<Consultant>;
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};


export type StatutConsultantConsultantArgs = {
  where?: InputMaybe<ConsultantFilterInput>;
};

export type StatutConsultantFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<StatutConsultantFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  consultant?: InputMaybe<ListFilterInputTypeOfConsultantFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<StatutConsultantFilterInput>>;
};

export type StatutConsultantSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type StatutDistinction = {
  __typename?: 'StatutDistinction';
  code: Scalars['Byte']['output'];
  consultantDistinction: Array<ConsultantDistinction>;
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};


export type StatutDistinctionConsultantDistinctionArgs = {
  where?: InputMaybe<ConsultantDistinctionFilterInput>;
};

export type StatutDistinctionFilterInput = {
  and?: InputMaybe<Array<StatutDistinctionFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  consultantDistinction?: InputMaybe<ListFilterInputTypeOfConsultantDistinctionFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<StatutDistinctionFilterInput>>;
};

export type StatutJuridique = {
  __typename?: 'StatutJuridique';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  consultantStatutJuridique: Array<ConsultantStatutJuridique>;
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};


export type StatutJuridiqueConsultantStatutJuridiqueArgs = {
  where?: InputMaybe<ConsultantStatutJuridiqueFilterInput>;
};

export type StatutJuridiqueFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<StatutJuridiqueFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  consultantStatutJuridique?: InputMaybe<ListFilterInputTypeOfConsultantStatutJuridiqueFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<StatutJuridiqueFilterInput>>;
};

export type StorageFile = {
  __typename?: 'StorageFile';
  consultantCode?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  denomination?: Maybe<Scalars['String']['output']>;
  fileConnectionInfo?: Maybe<StorageFileConnectionInfo>;
  fileExtension: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  fileNameWithExtension?: Maybe<Scalars['String']['output']>;
  fileType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isBlob: Scalars['Boolean']['output'];
  isTemporary?: Maybe<Scalars['Boolean']['output']>;
  lastModificationDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<FileStorageStatus>;
};

export type StorageFileConnectionInfo = {
  __typename?: 'StorageFileConnectionInfo';
  blobFileId: Scalars['String']['output'];
  expiration: Scalars['DateTime']['output'];
  permissions: Array<BlobFilesPermissionDs>;
  sasUrl: Scalars['String']['output'];
};

export type StorageFileFilterInput = {
  and?: InputMaybe<Array<StorageFileFilterInput>>;
  consultantCode?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  denomination?: InputMaybe<StringOperationFilterInput>;
  fileExtension?: InputMaybe<StringOperationFilterInput>;
  fileName?: InputMaybe<StringOperationFilterInput>;
  fileType?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  isBlob?: InputMaybe<BooleanOperationFilterInput>;
  isTemporary?: InputMaybe<BooleanOperationFilterInput>;
  lastModificationDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<StorageFileFilterInput>>;
  status?: InputMaybe<NullableOfFileStorageStatusOperationFilterInput>;
};

export type StorageFileInput = {
  consultantCode?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  denomination?: InputMaybe<Scalars['String']['input']>;
  fileExtension: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  id: Scalars['String']['input'];
  isBlob: Scalars['Boolean']['input'];
  isTemporary?: InputMaybe<Scalars['Boolean']['input']>;
  lastModificationDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<FileStorageStatus>;
};

export type StorageFileSortInput = {
  consultantCode?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  denomination?: InputMaybe<SortEnumType>;
  fileExtension?: InputMaybe<SortEnumType>;
  fileName?: InputMaybe<SortEnumType>;
  fileType?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isBlob?: InputMaybe<SortEnumType>;
  isTemporary?: InputMaybe<SortEnumType>;
  lastModificationDate?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
};

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ncontains?: InputMaybe<Scalars['String']['input']>;
  nendsWith?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nstartsWith?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type TauxRemunerationConsultant = {
  __typename?: 'TauxRemunerationConsultant';
  actif?: Maybe<Scalars['Boolean']['output']>;
  consultantOrganisation: Array<ConsultantOrganisation>;
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  libelle: Scalars['String']['output'];
};


export type TauxRemunerationConsultantConsultantOrganisationArgs = {
  where?: InputMaybe<ConsultantOrganisationFilterInput>;
};

export type TauxRemunerationConsultantFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TauxRemunerationConsultantFilterInput>>;
  consultantOrganisation?: InputMaybe<ListFilterInputTypeOfConsultantOrganisationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TauxRemunerationConsultantFilterInput>>;
};

export type TauxRemunerationConsultantSortInput = {
  actif?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type Telephone = {
  __typename?: 'Telephone';
  arianeId?: Maybe<Scalars['Long']['output']>;
  consultant: Array<Consultant>;
  contact: Array<Contact>;
  createurId?: Maybe<Scalars['Long']['output']>;
  creationDate: Scalars['DateTime']['output'];
  editeurId?: Maybe<Scalars['Long']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  estNumeroCorrespondance?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Long']['output'];
  idSource?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Note>;
  noteId?: Maybe<Scalars['Long']['output']>;
  numero: Scalars['String']['output'];
  personneMoraleTelephone: Array<PersonneMoraleTelephone>;
  personnePhysique: Array<PersonnePhysique>;
  prefixe?: Maybe<Scalars['String']['output']>;
  typeTelephoneCode: Scalars['String']['output'];
  typeTelephoneCodeNavigation: TypeTelephone;
};


export type TelephoneConsultantArgs = {
  where?: InputMaybe<ConsultantFilterInput>;
};


export type TelephoneContactArgs = {
  where?: InputMaybe<ContactFilterInput>;
};


export type TelephonePersonneMoraleTelephoneArgs = {
  where?: InputMaybe<PersonneMoraleTelephoneFilterInput>;
};


export type TelephonePersonnePhysiqueArgs = {
  where?: InputMaybe<PersonnePhysiqueFilterInput>;
};

export type TelephoneFilterInput = {
  and?: InputMaybe<Array<TelephoneFilterInput>>;
  arianeId?: InputMaybe<LongOperationFilterInput>;
  consultant?: InputMaybe<ListFilterInputTypeOfConsultantFilterInput>;
  contact?: InputMaybe<ListFilterInputTypeOfContactFilterInput>;
  createurId?: InputMaybe<LongOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editeurId?: InputMaybe<LongOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  estNumeroCorrespondance?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idSource?: InputMaybe<StringOperationFilterInput>;
  note?: InputMaybe<NoteFilterInput>;
  noteId?: InputMaybe<LongOperationFilterInput>;
  numero?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TelephoneFilterInput>>;
  personneMoraleTelephone?: InputMaybe<ListFilterInputTypeOfPersonneMoraleTelephoneFilterInput>;
  personnePhysique?: InputMaybe<ListFilterInputTypeOfPersonnePhysiqueFilterInput>;
  prefixe?: InputMaybe<StringOperationFilterInput>;
  typeTelephoneCode?: InputMaybe<StringOperationFilterInput>;
  typeTelephoneCodeNavigation?: InputMaybe<TypeTelephoneFilterInput>;
};

export type TelephoneInput = {
  numero: Scalars['String']['input'];
  prefix: Scalars['String']['input'];
};

export type TelephonePersonneInput = {
  estNumeroCorrespondance?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  numero: Scalars['String']['input'];
  typeTelephoneCode?: InputMaybe<Scalars['String']['input']>;
};

export type Testament = {
  __typename?: 'Testament';
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  note?: Maybe<Note>;
  noteId?: Maybe<Scalars['Long']['output']>;
  personnePhysique: PersonnePhysique;
  personnePhysiqueId: Scalars['Long']['output'];
  testamentRedige?: Maybe<Scalars['Boolean']['output']>;
};

export type TestamentFilterInput = {
  and?: InputMaybe<Array<TestamentFilterInput>>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  note?: InputMaybe<NoteFilterInput>;
  noteId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<TestamentFilterInput>>;
  personnePhysique?: InputMaybe<PersonnePhysiqueFilterInput>;
  personnePhysiqueId?: InputMaybe<LongOperationFilterInput>;
  testamentRedige?: InputMaybe<BooleanOperationFilterInput>;
};

export type TestamentInput = {
  commentaire?: InputMaybe<Scalars['String']['input']>;
  testamentRedige: Scalars['Boolean']['input'];
};

export type TestamentSortInput = {
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  note?: InputMaybe<NoteSortInput>;
  noteId?: InputMaybe<SortEnumType>;
  personnePhysique?: InputMaybe<PersonnePhysiqueSortInput>;
  personnePhysiqueId?: InputMaybe<SortEnumType>;
  testamentRedige?: InputMaybe<SortEnumType>;
};

export type TitreConsultant = {
  __typename?: 'TitreConsultant';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  consultant: Array<Consultant>;
  consultantOrganisation: Array<ConsultantOrganisation>;
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};


export type TitreConsultantConsultantArgs = {
  where?: InputMaybe<ConsultantFilterInput>;
};


export type TitreConsultantConsultantOrganisationArgs = {
  where?: InputMaybe<ConsultantOrganisationFilterInput>;
};

export type TitreConsultantFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TitreConsultantFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  consultant?: InputMaybe<ListFilterInputTypeOfConsultantFilterInput>;
  consultantOrganisation?: InputMaybe<ListFilterInputTypeOfConsultantOrganisationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TitreConsultantFilterInput>>;
};

export type TitreConsultantSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export enum ToleranceRisque {
  Dynamique = 'DYNAMIQUE',
  Equilibre = 'EQUILIBRE',
  Offensif = 'OFFENSIF',
  Prudent = 'PRUDENT',
  Securise = 'SECURISE'
}

export type ToleranceRisqueOperationFilterInput = {
  eq?: InputMaybe<ToleranceRisque>;
  in?: InputMaybe<Array<ToleranceRisque>>;
  neq?: InputMaybe<ToleranceRisque>;
  nin?: InputMaybe<Array<ToleranceRisque>>;
};

export type ToleranceRisqueOption = {
  __typename?: 'ToleranceRisqueOption';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  value: ToleranceRisque;
};

export type ToleranceRisqueOptionFilterInput = {
  and?: InputMaybe<Array<ToleranceRisqueOptionFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  label?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ToleranceRisqueOptionFilterInput>>;
  value?: InputMaybe<ToleranceRisqueOperationFilterInput>;
};

export type ToleranceRisqueOptionInput = {
  id: Scalars['String']['input'];
  label: Scalars['String']['input'];
  value: ToleranceRisque;
};

export enum TransactionPersonnelleEnum {
  AutoSouscription = 'AUTO_SOUSCRIPTION',
  AutoSouscriptionAvecProches = 'AUTO_SOUSCRIPTION_AVEC_PROCHES',
  Non = 'NON',
  PourProches = 'POUR_PROCHES',
  PourSalaries = 'POUR_SALARIES'
}

export type TransactionPersonnelleEnumOperationFilterInput = {
  eq?: InputMaybe<TransactionPersonnelleEnum>;
  in?: InputMaybe<Array<TransactionPersonnelleEnum>>;
  neq?: InputMaybe<TransactionPersonnelleEnum>;
  nin?: InputMaybe<Array<TransactionPersonnelleEnum>>;
};

export type TransfertClient = {
  __typename?: 'TransfertClient';
  consultantBeneficiaireCode: Scalars['String']['output'];
  consultantSourceCode: Scalars['String']['output'];
  dateDemande: Scalars['DateTime']['output'];
  detailsErreur?: Maybe<Scalars['String']['output']>;
  etatTransfertCode: Scalars['String']['output'];
  etatTransfertCodeNavigation: EtatTransfertClient;
  id: Scalars['Long']['output'];
  investisseurCode: Scalars['String']['output'];
  typeTransfertCode: Scalars['String']['output'];
  typeTransfertCodeNavigation: TypeTransfertClient;
};

export type TransfertClientDataInput = {
  consultantBeneficiaireCode: Scalars['String']['input'];
  consultantSourceCode: Scalars['String']['input'];
  investisseurCode?: InputMaybe<Scalars['String']['input']>;
  isResiliation: Scalars['Boolean']['input'];
};

export type TransfertClientFilterInput = {
  and?: InputMaybe<Array<TransfertClientFilterInput>>;
  consultantBeneficiaireCode?: InputMaybe<StringOperationFilterInput>;
  consultantSourceCode?: InputMaybe<StringOperationFilterInput>;
  dateDemande?: InputMaybe<DateTimeOperationFilterInput>;
  detailsErreur?: InputMaybe<StringOperationFilterInput>;
  etatTransfertCode?: InputMaybe<StringOperationFilterInput>;
  etatTransfertCodeNavigation?: InputMaybe<EtatTransfertClientFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  investisseurCode?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TransfertClientFilterInput>>;
  typeTransfertCode?: InputMaybe<StringOperationFilterInput>;
  typeTransfertCodeNavigation?: InputMaybe<TypeTransfertClientFilterInput>;
};

export type TransfertClientSortInput = {
  consultantBeneficiaireCode?: InputMaybe<SortEnumType>;
  consultantSourceCode?: InputMaybe<SortEnumType>;
  dateDemande?: InputMaybe<SortEnumType>;
  detailsErreur?: InputMaybe<SortEnumType>;
  etatTransfertCode?: InputMaybe<SortEnumType>;
  etatTransfertCodeNavigation?: InputMaybe<EtatTransfertClientSortInput>;
  id?: InputMaybe<SortEnumType>;
  investisseurCode?: InputMaybe<SortEnumType>;
  typeTransfertCode?: InputMaybe<SortEnumType>;
  typeTransfertCodeNavigation?: InputMaybe<TypeTransfertClientSortInput>;
};

export type Type2Produit = {
  __typename?: 'Type2Produit';
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  enveloppeProduit: Array<EnveloppeProduit>;
  gamme: Scalars['Byte']['output'];
  gammeNavigation: GammeProduit;
  libelle: Scalars['String']['output'];
};

export type Type2ProduitFilterInput = {
  and?: InputMaybe<Array<Type2ProduitFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  enveloppeProduit?: InputMaybe<ListFilterInputTypeOfEnveloppeProduitFilterInput>;
  gamme?: InputMaybe<ByteOperationFilterInput>;
  gammeNavigation?: InputMaybe<GammeProduitFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Type2ProduitFilterInput>>;
};

export type Type2ProduitSortInput = {
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  gamme?: InputMaybe<SortEnumType>;
  gammeNavigation?: InputMaybe<GammeProduitSortInput>;
  libelle?: InputMaybe<SortEnumType>;
};

export type TypeAdoption = {
  __typename?: 'TypeAdoption';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  relationFamille: Array<RelationFamille>;
};


export type TypeAdoptionRelationFamilleArgs = {
  where?: InputMaybe<RelationFamilleFilterInput>;
};

export type TypeAdoptionFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeAdoptionFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeAdoptionFilterInput>>;
  relationFamille?: InputMaybe<ListFilterInputTypeOfRelationFamilleFilterInput>;
};

export type TypeAdresse = {
  __typename?: 'TypeAdresse';
  actif?: Maybe<Scalars['Boolean']['output']>;
  adresse: Array<Adresse>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};


export type TypeAdresseAdresseArgs = {
  where?: InputMaybe<AdresseFilterInput>;
};

export type TypeAdresseFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  adresse?: InputMaybe<ListFilterInputTypeOfAdresseFilterInput>;
  and?: InputMaybe<Array<TypeAdresseFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeAdresseFilterInput>>;
};

export type TypeAvantageMatrimonial = {
  __typename?: 'TypeAvantageMatrimonial';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  etatCivil: Array<EtatCivil>;
  libelle: Scalars['String']['output'];
};


export type TypeAvantageMatrimonialEtatCivilArgs = {
  where?: InputMaybe<EtatCivilFilterInput>;
};

export type TypeAvantageMatrimonialFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeAvantageMatrimonialFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  etatCivil?: InputMaybe<ListFilterInputTypeOfEtatCivilFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeAvantageMatrimonialFilterInput>>;
};

export type TypeAvantageMatrimonialSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type TypeCategorieObjectifInvestisseur = {
  __typename?: 'TypeCategorieObjectifInvestisseur';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  typeObjectifInvestisseur: Array<TypeObjectifInvestisseur>;
};


export type TypeCategorieObjectifInvestisseurTypeObjectifInvestisseurArgs = {
  where?: InputMaybe<TypeObjectifInvestisseurFilterInput>;
};

export type TypeCategorieObjectifInvestisseurFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeCategorieObjectifInvestisseurFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeCategorieObjectifInvestisseurFilterInput>>;
  typeObjectifInvestisseur?: InputMaybe<ListFilterInputTypeOfTypeObjectifInvestisseurFilterInput>;
};

export type TypeCategorieObjectifInvestisseurSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type TypeCommande = {
  __typename?: 'TypeCommande';
  code: Scalars['Byte']['output'];
  commande: Array<Commande>;
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};

export type TypeCommandeFilterInput = {
  and?: InputMaybe<Array<TypeCommandeFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  commande?: InputMaybe<ListFilterInputTypeOfCommandeFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeCommandeFilterInput>>;
};

export type TypeCommandeSortInput = {
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type TypeConseillerCommande = {
  __typename?: 'TypeConseillerCommande';
  code: Scalars['Byte']['output'];
  conseillerCommande: Array<ConseillerCommande>;
  consultantMouvement: Array<ConsultantMouvement>;
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};


export type TypeConseillerCommandeConseillerCommandeArgs = {
  where?: InputMaybe<ConseillerCommandeFilterInput>;
};


export type TypeConseillerCommandeConsultantMouvementArgs = {
  where?: InputMaybe<ConsultantMouvementFilterInput>;
};

export type TypeConseillerCommandeFilterInput = {
  and?: InputMaybe<Array<TypeConseillerCommandeFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  conseillerCommande?: InputMaybe<ListFilterInputTypeOfConseillerCommandeFilterInput>;
  consultantMouvement?: InputMaybe<ListFilterInputTypeOfConsultantMouvementFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeConseillerCommandeFilterInput>>;
};

export type TypeContrat = {
  __typename?: 'TypeContrat';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  consultantContrat: Array<ConsultantContrat>;
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
};


export type TypeContratConsultantContratArgs = {
  where?: InputMaybe<ConsultantContratFilterInput>;
};

export type TypeContratFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeContratFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  consultantContrat?: InputMaybe<ListFilterInputTypeOfConsultantContratFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeContratFilterInput>>;
};

export type TypeCredit = {
  __typename?: 'TypeCredit';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  patrimoinePassif: Array<PatrimoinePassif>;
};


export type TypeCreditPatrimoinePassifArgs = {
  where?: InputMaybe<PatrimoinePassifFilterInput>;
};

export type TypeCreditFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeCreditFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeCreditFilterInput>>;
  patrimoinePassif?: InputMaybe<ListFilterInputTypeOfPatrimoinePassifFilterInput>;
};

export type TypeEdition = {
  __typename?: 'TypeEdition';
  actif: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  commune: Scalars['Boolean']['output'];
  dateMaj: Scalars['DateTime']['output'];
  domaine: Scalars['String']['output'];
  domaineNavigation: TypeEditionDomaine;
  edition: Array<Edition>;
  frequenceMaj?: Maybe<Scalars['Int']['output']>;
  libelle: Scalars['String']['output'];
  libelleFichier: Scalars['String']['output'];
  ordre?: Maybe<Scalars['Int']['output']>;
};


export type TypeEditionEditionArgs = {
  where?: InputMaybe<EditionFilterInput>;
};

export type TypeEditionDomaine = {
  __typename?: 'TypeEditionDomaine';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  typeEdition: Array<TypeEdition>;
};


export type TypeEditionDomaineTypeEditionArgs = {
  where?: InputMaybe<TypeEditionFilterInput>;
};

export type TypeEditionDomaineFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeEditionDomaineFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeEditionDomaineFilterInput>>;
  typeEdition?: InputMaybe<ListFilterInputTypeOfTypeEditionFilterInput>;
};

export type TypeEditionFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeEditionFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  commune?: InputMaybe<BooleanOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  domaine?: InputMaybe<StringOperationFilterInput>;
  domaineNavigation?: InputMaybe<TypeEditionDomaineFilterInput>;
  edition?: InputMaybe<ListFilterInputTypeOfEditionFilterInput>;
  frequenceMaj?: InputMaybe<IntOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  libelleFichier?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeEditionFilterInput>>;
  ordre?: InputMaybe<IntOperationFilterInput>;
};

export type TypeEmail = {
  __typename?: 'TypeEmail';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  email: Array<Email>;
  libelle: Scalars['String']['output'];
};


export type TypeEmailEmailArgs = {
  where?: InputMaybe<EmailFilterInput>;
};

export type TypeEmailFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeEmailFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  email?: InputMaybe<ListFilterInputTypeOfEmailFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeEmailFilterInput>>;
};

export type TypeFormeJuridique = {
  __typename?: 'TypeFormeJuridique';
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  formeJuridique: Array<FormeJuridique>;
  libelle: Scalars['String']['output'];
};


export type TypeFormeJuridiqueFormeJuridiqueArgs = {
  where?: InputMaybe<FormeJuridiqueFilterInput>;
};

export type TypeFormeJuridiqueFilterInput = {
  and?: InputMaybe<Array<TypeFormeJuridiqueFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  formeJuridique?: InputMaybe<ListFilterInputTypeOfFormeJuridiqueFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeFormeJuridiqueFilterInput>>;
};

export enum TypeHabilitation {
  Alpsi = 'ALPSI',
  Assu = 'ASSU',
  Cif = 'CIF',
  Epa = 'EPA',
  Finan = 'FINAN',
  Immo = 'IMMO',
  Iob = 'IOB'
}

export type TypeHabilitationOperationFilterInput = {
  eq?: InputMaybe<TypeHabilitation>;
  in?: InputMaybe<Array<TypeHabilitation>>;
  neq?: InputMaybe<TypeHabilitation>;
  nin?: InputMaybe<Array<TypeHabilitation>>;
};

export type TypeInvestisseur = {
  __typename?: 'TypeInvestisseur';
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Byte']['output'];
  libelle: Scalars['String']['output'];
  profilInvestisseur: Array<ProfilInvestisseur>;
};


export type TypeInvestisseurProfilInvestisseurArgs = {
  where?: InputMaybe<ProfilInvestisseurFilterInput>;
};

export type TypeInvestisseurFilterInput = {
  and?: InputMaybe<Array<TypeInvestisseurFilterInput>>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<ByteOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeInvestisseurFilterInput>>;
  profilInvestisseur?: InputMaybe<ListFilterInputTypeOfProfilInvestisseurFilterInput>;
};

export type TypeJustificationFormation = {
  __typename?: 'TypeJustificationFormation';
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  equivalenceDeFormation: Array<EquivalenceDeFormation>;
  libelle: Scalars['String']['output'];
};


export type TypeJustificationFormationEquivalenceDeFormationArgs = {
  where?: InputMaybe<EquivalenceDeFormationFilterInput>;
};

export type TypeJustificationFormationFilterInput = {
  and?: InputMaybe<Array<TypeJustificationFormationFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  equivalenceDeFormation?: InputMaybe<ListFilterInputTypeOfEquivalenceDeFormationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeJustificationFormationFilterInput>>;
};

export type TypeMesureProtection = {
  __typename?: 'TypeMesureProtection';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  personnePhysique: Array<PersonnePhysique>;
};


export type TypeMesureProtectionPersonnePhysiqueArgs = {
  where?: InputMaybe<PersonnePhysiqueFilterInput>;
};

export type TypeMesureProtectionFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeMesureProtectionFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeMesureProtectionFilterInput>>;
  personnePhysique?: InputMaybe<ListFilterInputTypeOfPersonnePhysiqueFilterInput>;
};

export type TypeMesureProtectionSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type TypeMotifAnnulationMouvement = {
  __typename?: 'TypeMotifAnnulationMouvement';
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  motifAnnulationCommande: Array<MotifAnnulationCommande>;
};


export type TypeMotifAnnulationMouvementMotifAnnulationCommandeArgs = {
  where?: InputMaybe<MotifAnnulationCommandeFilterInput>;
};

export type TypeMotifAnnulationMouvementFilterInput = {
  and?: InputMaybe<Array<TypeMotifAnnulationMouvementFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  motifAnnulationCommande?: InputMaybe<ListFilterInputTypeOfMotifAnnulationCommandeFilterInput>;
  or?: InputMaybe<Array<TypeMotifAnnulationMouvementFilterInput>>;
};

export type TypeMotifAnnulationMouvementSortInput = {
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type TypeMotifCession = {
  __typename?: 'TypeMotifCession';
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  motifCession: Array<MotifCession>;
};


export type TypeMotifCessionMotifCessionArgs = {
  where?: InputMaybe<MotifCessionFilterInput>;
};

export type TypeMotifCessionFilterInput = {
  and?: InputMaybe<Array<TypeMotifCessionFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  motifCession?: InputMaybe<ListFilterInputTypeOfMotifCessionFilterInput>;
  or?: InputMaybe<Array<TypeMotifCessionFilterInput>>;
};

export type TypeMotifCessionSortInput = {
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type TypeObjectifInvestisseur = {
  __typename?: 'TypeObjectifInvestisseur';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  typeCategorieObjectifInvestisseurCode: Scalars['String']['output'];
  typeCategorieObjectifInvestisseurCodeNavigation: TypeCategorieObjectifInvestisseur;
};

export type TypeObjectifInvestisseurFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeObjectifInvestisseurFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  investisseurObjectif?: InputMaybe<ListFilterInputTypeOfInvestisseurObjectifFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeObjectifInvestisseurFilterInput>>;
  typeCategorieObjectifInvestisseurCode?: InputMaybe<StringOperationFilterInput>;
  typeCategorieObjectifInvestisseurCodeNavigation?: InputMaybe<TypeCategorieObjectifInvestisseurFilterInput>;
};

export type TypeObjectifInvestisseurSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
  typeCategorieObjectifInvestisseurCode?: InputMaybe<SortEnumType>;
  typeCategorieObjectifInvestisseurCodeNavigation?: InputMaybe<TypeCategorieObjectifInvestisseurSortInput>;
};

export type TypePieceJointe = {
  __typename?: 'TypePieceJointe';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expirationCode: Scalars['String']['output'];
  expirationCodeNavigation: Expiration;
  libelle: Scalars['String']['output'];
  pieceJointeConsultant: Array<PieceJointeConsultant>;
  type: Scalars['Int']['output'];
};


export type TypePieceJointePieceJointeConsultantArgs = {
  where?: InputMaybe<PieceJointeConsultantFilterInput>;
};

export type TypePieceJointeFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypePieceJointeFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  expirationCode?: InputMaybe<StringOperationFilterInput>;
  expirationCodeNavigation?: InputMaybe<ExpirationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypePieceJointeFilterInput>>;
  pieceJointeConsultant?: InputMaybe<ListFilterInputTypeOfPieceJointeConsultantFilterInput>;
  type?: InputMaybe<IntOperationFilterInput>;
};

export type TypePpeMotif = {
  __typename?: 'TypePpeMotif';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  reglementaire: Array<Reglementaire>;
};


export type TypePpeMotifReglementaireArgs = {
  where?: InputMaybe<ReglementaireFilterInput>;
};

export type TypePpeMotifFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypePpeMotifFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypePpeMotifFilterInput>>;
  reglementaire?: InputMaybe<ListFilterInputTypeOfReglementaireFilterInput>;
};

export type TypePpeMotifSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type TypePpeRelation = {
  __typename?: 'TypePpeRelation';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  reglementaire: Array<Reglementaire>;
};


export type TypePpeRelationReglementaireArgs = {
  where?: InputMaybe<ReglementaireFilterInput>;
};

export type TypePpeRelationFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypePpeRelationFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypePpeRelationFilterInput>>;
  reglementaire?: InputMaybe<ListFilterInputTypeOfReglementaireFilterInput>;
};

export type TypePpeRelationSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type TypeProduit = {
  __typename?: 'TypeProduit';
  code: Scalars['Byte']['output'];
  creationDate: Scalars['DateTime']['output'];
  editionDate: Scalars['DateTime']['output'];
  libelle: Scalars['String']['output'];
  produit: Array<Produit>;
};


export type TypeProduitProduitArgs = {
  where?: InputMaybe<ProduitFilterInput>;
};

export type TypeProduitFilterInput = {
  and?: InputMaybe<Array<TypeProduitFilterInput>>;
  code?: InputMaybe<ByteOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeProduitFilterInput>>;
  produit?: InputMaybe<ListFilterInputTypeOfProduitFilterInput>;
};

export type TypeProduitSortInput = {
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type TypeRcp = {
  __typename?: 'TypeRcp';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  consultantRcp: Array<ConsultantRcp>;
  creationDate: Scalars['DateTime']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  habilitationRcp: Array<HabilitationRcp>;
  libelle?: Maybe<Scalars['String']['output']>;
};


export type TypeRcpConsultantRcpArgs = {
  where?: InputMaybe<ConsultantRcpFilterInput>;
};


export type TypeRcpHabilitationRcpArgs = {
  where?: InputMaybe<HabilitationRcpFilterInput>;
};

export enum TypeRcpCode {
  GarantieFinanciereImmobilier = 'GARANTIE_FINANCIERE_IMMOBILIER',
  RcpAssurance = 'RCP_ASSURANCE',
  RcpCif = 'RCP_CIF',
  RcpImmobilier = 'RCP_IMMOBILIER',
  RcpIob = 'RCP_IOB'
}

export type TypeRcpFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeRcpFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  consultantRcp?: InputMaybe<ListFilterInputTypeOfConsultantRcpFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  habilitationRcp?: InputMaybe<ListFilterInputTypeOfHabilitationRcpFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeRcpFilterInput>>;
};

export type TypeRegimeSituationEtatCivil = {
  __typename?: 'TypeRegimeSituationEtatCivil';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  etatCivil: Array<EtatCivil>;
  libelle: Scalars['String']['output'];
  type: Scalars['String']['output'];
};


export type TypeRegimeSituationEtatCivilEtatCivilArgs = {
  where?: InputMaybe<EtatCivilFilterInput>;
};

export type TypeRegimeSituationEtatCivilFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeRegimeSituationEtatCivilFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  etatCivil?: InputMaybe<ListFilterInputTypeOfEtatCivilFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeRegimeSituationEtatCivilFilterInput>>;
  type?: InputMaybe<StringOperationFilterInput>;
};

export type TypeRegimeSituationEtatCivilSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

export type TypeRelationAutre = {
  __typename?: 'TypeRelationAutre';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  codeRev: Scalars['String']['output'];
  codeRevNavigation: TypeRelationAutre;
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  inverseCodeRevNavigation: Array<TypeRelationAutre>;
  libelle: Scalars['String']['output'];
  natureRelationAutreCode: Scalars['String']['output'];
  natureRelationAutreCodeNavigation: NatureRelationAutre;
  relationAutreTypeRelationAutreCodeNavigation: Array<RelationAutre>;
  relationAutreTypeRelationAutreCodeRevNavigation: Array<RelationAutre>;
};


export type TypeRelationAutreInverseCodeRevNavigationArgs = {
  where?: InputMaybe<TypeRelationAutreFilterInput>;
};


export type TypeRelationAutreRelationAutreTypeRelationAutreCodeNavigationArgs = {
  where?: InputMaybe<RelationAutreFilterInput>;
};


export type TypeRelationAutreRelationAutreTypeRelationAutreCodeRevNavigationArgs = {
  where?: InputMaybe<RelationAutreFilterInput>;
};

export type TypeRelationAutreFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeRelationAutreFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  codeRev?: InputMaybe<StringOperationFilterInput>;
  codeRevNavigation?: InputMaybe<TypeRelationAutreFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  inverseCodeRevNavigation?: InputMaybe<ListFilterInputTypeOfTypeRelationAutreFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  natureRelationAutreCode?: InputMaybe<StringOperationFilterInput>;
  natureRelationAutreCodeNavigation?: InputMaybe<NatureRelationAutreFilterInput>;
  or?: InputMaybe<Array<TypeRelationAutreFilterInput>>;
  relationAutreTypeRelationAutreCodeNavigation?: InputMaybe<ListFilterInputTypeOfRelationAutreFilterInput>;
  relationAutreTypeRelationAutreCodeRevNavigation?: InputMaybe<ListFilterInputTypeOfRelationAutreFilterInput>;
};

export type TypeRelationAutreSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  codeRev?: InputMaybe<SortEnumType>;
  codeRevNavigation?: InputMaybe<TypeRelationAutreSortInput>;
  dateMaj?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
  natureRelationAutreCode?: InputMaybe<SortEnumType>;
  natureRelationAutreCodeNavigation?: InputMaybe<NatureRelationAutreSortInput>;
};

export type TypeRelationCouple = {
  __typename?: 'TypeRelationCouple';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  relationCouple: Array<RelationCouple>;
};


export type TypeRelationCoupleRelationCoupleArgs = {
  where?: InputMaybe<RelationCoupleFilterInput>;
};

export type TypeRelationCoupleFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeRelationCoupleFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeRelationCoupleFilterInput>>;
  relationCouple?: InputMaybe<ListFilterInputTypeOfRelationCoupleFilterInput>;
};

export type TypeRelationFamille = {
  __typename?: 'TypeRelationFamille';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  codeRev: Scalars['String']['output'];
  codeRevNavigation: TypeRelationFamille;
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  inverseCodeRevNavigation: Array<TypeRelationFamille>;
  libelle: Scalars['String']['output'];
  relationEnfant: Scalars['Boolean']['output'];
  relationFamilleTypeRelationFamilleCodeNavigation: Array<RelationFamille>;
  relationFamilleTypeRelationFamilleCodeRevNavigation: Array<RelationFamille>;
};


export type TypeRelationFamilleInverseCodeRevNavigationArgs = {
  where?: InputMaybe<TypeRelationFamilleFilterInput>;
};


export type TypeRelationFamilleRelationFamilleTypeRelationFamilleCodeNavigationArgs = {
  where?: InputMaybe<RelationFamilleFilterInput>;
};


export type TypeRelationFamilleRelationFamilleTypeRelationFamilleCodeRevNavigationArgs = {
  where?: InputMaybe<RelationFamilleFilterInput>;
};

export type TypeRelationFamilleFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeRelationFamilleFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  codeRev?: InputMaybe<StringOperationFilterInput>;
  codeRevNavigation?: InputMaybe<TypeRelationFamilleFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  inverseCodeRevNavigation?: InputMaybe<ListFilterInputTypeOfTypeRelationFamilleFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeRelationFamilleFilterInput>>;
  relationEnfant?: InputMaybe<BooleanOperationFilterInput>;
  relationFamilleTypeRelationFamilleCodeNavigation?: InputMaybe<ListFilterInputTypeOfRelationFamilleFilterInput>;
  relationFamilleTypeRelationFamilleCodeRevNavigation?: InputMaybe<ListFilterInputTypeOfRelationFamilleFilterInput>;
};

export type TypeRelationInvestisseurConsultant = {
  __typename?: 'TypeRelationInvestisseurConsultant';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  investisseurConsultant: Array<InvestisseurConsultant>;
  libelle: Scalars['String']['output'];
};


export type TypeRelationInvestisseurConsultantInvestisseurConsultantArgs = {
  where?: InputMaybe<InvestisseurConsultantFilterInput>;
};

export type TypeRelationInvestisseurConsultantFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeRelationInvestisseurConsultantFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  investisseurConsultant?: InputMaybe<ListFilterInputTypeOfInvestisseurConsultantFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeRelationInvestisseurConsultantFilterInput>>;
};

export type TypeRelationInvestisseurConsultantSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type TypeSituationEtatCivil = {
  __typename?: 'TypeSituationEtatCivil';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  etatCivil: Array<EtatCivil>;
  libelle: Scalars['String']['output'];
};


export type TypeSituationEtatCivilEtatCivilArgs = {
  where?: InputMaybe<EtatCivilFilterInput>;
};

export type TypeSituationEtatCivilFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeSituationEtatCivilFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  etatCivil?: InputMaybe<ListFilterInputTypeOfEtatCivilFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeSituationEtatCivilFilterInput>>;
};

export type TypeSituationEtatCivilSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type TypeSituationProfessionnelle = {
  __typename?: 'TypeSituationProfessionnelle';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['Int']['output'];
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  situationProfessionnelles: Array<SituationProfessionnelle>;
};


export type TypeSituationProfessionnelleSituationProfessionnellesArgs = {
  where?: InputMaybe<SituationProfessionnelleFilterInput>;
};

export type TypeSituationProfessionnelleFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeSituationProfessionnelleFilterInput>>;
  code?: InputMaybe<IntOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeSituationProfessionnelleFilterInput>>;
  situationProfessionnelles?: InputMaybe<ListFilterInputTypeOfSituationProfessionnelleFilterInput>;
};

export type TypeSituationProfessionnelleSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type TypeSociete = {
  __typename?: 'TypeSociete';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  consultantStatutJuridique: Array<ConsultantStatutJuridique>;
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle?: Maybe<Scalars['String']['output']>;
};


export type TypeSocieteConsultantStatutJuridiqueArgs = {
  where?: InputMaybe<ConsultantStatutJuridiqueFilterInput>;
};

export type TypeSocieteFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeSocieteFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  consultantStatutJuridique?: InputMaybe<ListFilterInputTypeOfConsultantStatutJuridiqueFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeSocieteFilterInput>>;
};

export type TypeStatutInvestisseur = {
  __typename?: 'TypeStatutInvestisseur';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  investisseur: Array<Investisseur>;
  libelle: Scalars['String']['output'];
};


export type TypeStatutInvestisseurInvestisseurArgs = {
  where?: InputMaybe<InvestisseurFilterInput>;
};

export type TypeStatutInvestisseurFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeStatutInvestisseurFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  investisseur?: InputMaybe<ListFilterInputTypeOfInvestisseurFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeStatutInvestisseurFilterInput>>;
};

export type TypeStatutInvestisseurInput = {
  code: Scalars['String']['input'];
  libelle: Scalars['String']['input'];
};

export type TypeStatutInvestisseurSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  dateMaj?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export enum TypeStatutJuridique {
  AgentCommercial = 'AGENT_COMMERCIAL',
  ProfessionLiberale = 'PROFESSION_LIBERALE',
  Societe = 'SOCIETE'
}

export type TypeStatutProfessionnel = {
  __typename?: 'TypeStatutProfessionnel';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['Int']['output'];
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  editionDate?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  situationProfessionnelles: Array<SituationProfessionnelle>;
};


export type TypeStatutProfessionnelSituationProfessionnellesArgs = {
  where?: InputMaybe<SituationProfessionnelleFilterInput>;
};

export type TypeStatutProfessionnelFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeStatutProfessionnelFilterInput>>;
  code?: InputMaybe<IntOperationFilterInput>;
  creationDate?: InputMaybe<DateTimeOperationFilterInput>;
  editionDate?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeStatutProfessionnelFilterInput>>;
  situationProfessionnelles?: InputMaybe<ListFilterInputTypeOfSituationProfessionnelleFilterInput>;
};

export type TypeStatutProfessionnelSortInput = {
  actif?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  editionDate?: InputMaybe<SortEnumType>;
  libelle?: InputMaybe<SortEnumType>;
};

export type TypeTelephone = {
  __typename?: 'TypeTelephone';
  actif?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  dateMaj?: Maybe<Scalars['DateTime']['output']>;
  libelle: Scalars['String']['output'];
  telephone: Array<Telephone>;
};


export type TypeTelephoneTelephoneArgs = {
  where?: InputMaybe<TelephoneFilterInput>;
};

export type TypeTelephoneFilterInput = {
  actif?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TypeTelephoneFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  dateMaj?: InputMaybe<DateTimeOperationFilterInput>;
  libelle?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeTelephoneFilterInput>>;
  telephone?: InputMaybe<ListFilterInputTypeOfTelephoneFilterInput>;
};

export type TypeTransfertClient = {
  __typename?: 'TypeTransfertClient';
  code: Scalars['String']['output'];
  transfertClient: Array<TransfertClient>;
};


export type TypeTransfertClientTransfertClientArgs = {
  where?: InputMaybe<TransfertClientFilterInput>;
};

export type TypeTransfertClientFilterInput = {
  and?: InputMaybe<Array<TypeTransfertClientFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TypeTransfertClientFilterInput>>;
  transfertClient?: InputMaybe<ListFilterInputTypeOfTransfertClientFilterInput>;
};

export type TypeTransfertClientSortInput = {
  code?: InputMaybe<SortEnumType>;
};

export type UpdateDocumentMetadatasCommandInput = {
  clearContratId?: InputMaybe<Scalars['Boolean']['input']>;
  clearPatrimoineId?: InputMaybe<Scalars['Boolean']['input']>;
  contratId?: InputMaybe<Scalars['String']['input']>;
  dateDeDebutValidite?: InputMaybe<Scalars['DateTime']['input']>;
  dateDeFinValidite?: InputMaybe<Scalars['DateTime']['input']>;
  dateDeReference?: InputMaybe<Scalars['LocalDate']['input']>;
  dateSignature?: InputMaybe<Scalars['DateTime']['input']>;
  denomination?: InputMaybe<Scalars['String']['input']>;
  derniereModificationPar: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
  extension?: InputMaybe<Scalars['String']['input']>;
  investisseurId?: InputMaybe<Scalars['String']['input']>;
  investisseurIds?: InputMaybe<Array<Scalars['String']['input']>>;
  isHandwrittenSignature?: InputMaybe<Scalars['Boolean']['input']>;
  nomDeFichier?: InputMaybe<Scalars['String']['input']>;
  patrimoineId?: InputMaybe<Scalars['String']['input']>;
  signatureState?: InputMaybe<SignatureState>;
  statutJuridiqueId?: InputMaybe<Scalars['Int']['input']>;
  subTypeCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  typeDocumentCode?: InputMaybe<GedDocumentType>;
};

export type UpdateSituationPersonnelleInput = {
  personne1: PersonneSituationPersonnelleInput;
  personne2?: InputMaybe<PersonneSituationPersonnelleInput>;
};

export type UserAccessRight = {
  __typename?: 'UserAccessRight';
  authorizedConsultantIds: Array<Scalars['Long']['output']>;
  authorizedInvestisseurIds: Array<Scalars['Long']['output']>;
  consultantHabilitationIds: Array<Scalars['Long']['output']>;
  consultantHabilitations: Array<Maybe<Scalars['String']['output']>>;
  consultantId?: Maybe<Scalars['Long']['output']>;
  hasFullAccess: Scalars['Boolean']['output'];
};

export type UuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']['input']>;
  gt?: InputMaybe<Scalars['UUID']['input']>;
  gte?: InputMaybe<Scalars['UUID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  lt?: InputMaybe<Scalars['UUID']['input']>;
  lte?: InputMaybe<Scalars['UUID']['input']>;
  neq?: InputMaybe<Scalars['UUID']['input']>;
  ngt?: InputMaybe<Scalars['UUID']['input']>;
  ngte?: InputMaybe<Scalars['UUID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  nlt?: InputMaybe<Scalars['UUID']['input']>;
  nlte?: InputMaybe<Scalars['UUID']['input']>;
};

export type Versement = {
  __typename?: 'Versement';
  fraisVersement?: Maybe<Scalars['Decimal']['output']>;
  montantBrut?: Maybe<Scalars['Decimal']['output']>;
  niveauDeRisque?: Maybe<NiveauDeRisque>;
};

export type VersementFilterInput = {
  and?: InputMaybe<Array<VersementFilterInput>>;
  fraisVersement?: InputMaybe<DecimalOperationFilterInput>;
  montantBrut?: InputMaybe<DecimalOperationFilterInput>;
  niveauDeRisque?: InputMaybe<NullableOfNiveauDeRisqueOperationFilterInput>;
  or?: InputMaybe<Array<VersementFilterInput>>;
};

export type VersementInput = {
  fraisVersement?: InputMaybe<Scalars['Decimal']['input']>;
  montantBrut?: InputMaybe<Scalars['Decimal']['input']>;
  niveauDeRisque?: InputMaybe<NiveauDeRisque>;
};

export type VersementProgramme = {
  __typename?: 'VersementProgramme';
  avecChangementAllocation?: Maybe<Scalars['Boolean']['output']>;
  avecChangementCoordonneesBancaires?: Maybe<Scalars['Boolean']['output']>;
  frequence?: Maybe<FrequenceVersement>;
  isFraisVersementEditable?: Maybe<Scalars['Boolean']['output']>;
  isFrequenceEditable?: Maybe<Scalars['Boolean']['output']>;
  isMontantBrutEditable?: Maybe<Scalars['Boolean']['output']>;
  versement: Versement;
};

export type VersementProgrammeFilterInput = {
  and?: InputMaybe<Array<VersementProgrammeFilterInput>>;
  avecChangementAllocation?: InputMaybe<BooleanOperationFilterInput>;
  avecChangementCoordonneesBancaires?: InputMaybe<BooleanOperationFilterInput>;
  frequence?: InputMaybe<NullableOfFrequenceVersementOperationFilterInput>;
  isFraisVersementEditable?: InputMaybe<BooleanOperationFilterInput>;
  isFrequenceEditable?: InputMaybe<BooleanOperationFilterInput>;
  isMontantBrutEditable?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<VersementProgrammeFilterInput>>;
  versement?: InputMaybe<VersementFilterInput>;
};

export type VersementProgrammeInput = {
  avecChangementAllocation?: InputMaybe<Scalars['Boolean']['input']>;
  avecChangementCoordonneesBancaires?: InputMaybe<Scalars['Boolean']['input']>;
  frequence?: InputMaybe<FrequenceVersement>;
  isFraisVersementEditable?: InputMaybe<Scalars['Boolean']['input']>;
  isFrequenceEditable?: InputMaybe<Scalars['Boolean']['input']>;
  isMontantBrutEditable?: InputMaybe<Scalars['Boolean']['input']>;
  versement: VersementInput;
};

export type VersementProgrammeSortInput = {
  avecChangementAllocation?: InputMaybe<SortEnumType>;
  avecChangementCoordonneesBancaires?: InputMaybe<SortEnumType>;
  frequence?: InputMaybe<SortEnumType>;
  isFraisVersementEditable?: InputMaybe<SortEnumType>;
  isFrequenceEditable?: InputMaybe<SortEnumType>;
  isMontantBrutEditable?: InputMaybe<SortEnumType>;
  versement?: InputMaybe<VersementSortInput>;
};

export type VersementSortInput = {
  fraisVersement?: InputMaybe<SortEnumType>;
  montantBrut?: InputMaybe<SortEnumType>;
  niveauDeRisque?: InputMaybe<SortEnumType>;
};

export type Versements = {
  __typename?: 'Versements';
  avecVersementProgramme: Scalars['Boolean']['output'];
  souscriptionAvecTransfert?: Maybe<Scalars['Boolean']['output']>;
  versementComplementaire?: Maybe<Versement>;
  versementInitial?: Maybe<Versement>;
  versementProgramme?: Maybe<VersementProgramme>;
};

export type VersementsFilterInput = {
  and?: InputMaybe<Array<VersementsFilterInput>>;
  avecVersementProgramme?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<VersementsFilterInput>>;
  souscriptionAvecTransfert?: InputMaybe<BooleanOperationFilterInput>;
  versementComplementaire?: InputMaybe<VersementFilterInput>;
  versementInitial?: InputMaybe<VersementFilterInput>;
  versementProgramme?: InputMaybe<VersementProgrammeFilterInput>;
};

export type VersementsInput = {
  avecVersementProgramme: Scalars['Boolean']['input'];
  souscriptionAvecTransfert?: InputMaybe<Scalars['Boolean']['input']>;
  versementComplementaire?: InputMaybe<VersementInput>;
  versementInitial?: InputMaybe<VersementInput>;
  versementProgramme?: InputMaybe<VersementProgrammeInput>;
};

export type VersementsSortInput = {
  avecVersementProgramme?: InputMaybe<SortEnumType>;
  souscriptionAvecTransfert?: InputMaybe<SortEnumType>;
  versementComplementaire?: InputMaybe<VersementSortInput>;
  versementInitial?: InputMaybe<VersementSortInput>;
  versementProgramme?: InputMaybe<VersementProgrammeSortInput>;
};

export enum VpModeOptions {
  MiseEnPlace = 'MISE_EN_PLACE',
  Modification = 'MODIFICATION'
}
